import { html } from "lit";
const Account = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 3.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M7.25 7a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0M12 14.75a6.25 6.25 0 0 0-5.998 4.488.67.67 0 0 0 .162.666c.182.2.486.346.836.346h10c.35 0 .654-.146.837-.346a.67.67 0 0 0 .161-.666A6.25 6.25 0 0 0 12 14.75m-7.438 4.065a7.753 7.753 0 0 1 14.876 0 2.16 2.16 0 0 1-.495 2.102A2.64 2.64 0 0 1 17 21.75H7a2.64 2.64 0 0 1-1.943-.833 2.16 2.16 0 0 1-.495-2.102" clip-rule="evenodd"/>
  </svg>
`;
const AccountBan = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6.75 7a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0m4.75-3.25a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5" clip-rule="evenodd"/><path fill='currentColor' d="M12.003 13.978a.75.75 0 0 1-.723.776 6.25 6.25 0 0 0-5.778 4.484.67.67 0 0 0 .161.666c.183.2.486.346.837.346h4.754a.75.75 0 0 1 0 1.5H6.5a2.64 2.64 0 0 1-1.943-.833 2.16 2.16 0 0 1-.495-2.102 7.75 7.75 0 0 1 7.166-5.56.75.75 0 0 1 .775.723"/><path fill='currentColor' fill-rule="evenodd" d="M12.35 17.5a4.65 4.65 0 1 1 9.3 0 4.65 4.65 0 0 1-9.3 0M17 14.15a3.35 3.35 0 0 0-2.784 5.215l4.649-4.649A3.34 3.34 0 0 0 17 14.15m2.784 1.486-4.648 4.648a3.35 3.35 0 0 0 4.648-4.648" clip-rule="evenodd"/>
  </svg>
`;
const AccountEnable = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M11.5 2.25a4.75 4.75 0 1 0 0 9.5 4.75 4.75 0 0 0 0-9.5M8.25 7a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0" clip-rule="evenodd"/><path fill='currentColor' d="M11.28 14.754a.75.75 0 0 0-.052-1.5 7.75 7.75 0 0 0-7.166 5.561 2.16 2.16 0 0 0 .495 2.102 2.64 2.64 0 0 0 1.943.833h4.754a.75.75 0 0 0 0-1.5H6.5c-.35 0-.654-.146-.837-.346a.67.67 0 0 1-.161-.666 6.25 6.25 0 0 1 5.778-4.484M18.935 15.986a.65.65 0 0 1 0 .92l-2.108 2.108a.65.65 0 0 1-.919 0l-.843-.843a.65.65 0 1 1 .92-.92l.383.384 1.648-1.649a.65.65 0 0 1 .92 0"/><path fill='currentColor' fill-rule="evenodd" d="M12.35 17.5a4.65 4.65 0 1 1 9.3 0 4.65 4.65 0 0 1-9.3 0M17 14.15a3.35 3.35 0 1 0 0 6.7 3.35 3.35 0 0 0 0-6.7" clip-rule="evenodd"/>
  </svg>
`;
const AddCollection = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M8.25 4A.75.75 0 0 1 9 3.25h6a.75.75 0 0 1 0 1.5H9A.75.75 0 0 1 8.25 4M7 6.25a.75.75 0 0 0 0 1.5h10a.75.75 0 0 0 0-1.5zM7 9.25A2.75 2.75 0 0 0 4.25 12v5A2.75 2.75 0 0 0 7 19.75h5.25a.75.75 0 0 0 0-1.5H7c-.69 0-1.25-.56-1.25-1.25v-5c0-.69.56-1.25 1.25-1.25h10c.69 0 1.25.56 1.25 1.25v.14a.75.75 0 0 0 1.5 0V12A2.75 2.75 0 0 0 17 9.25zM19.5 15.75a.75.75 0 0 0-1.5 0V18h-2.25a.75.75 0 0 0 0 1.5H18v2.25a.75.75 0 0 0 1.5 0V19.5h2.25a.75.75 0 0 0 0-1.5H19.5z"/>
  </svg>
`;
const AddComment = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M18.829 4.08a.655.655 0 1 0-1.31 0v1.964h-1.964a.655.655 0 0 0 0 1.31h1.965v1.964a.655.655 0 1 0 1.309 0V7.353h1.964a.655.655 0 0 0 0-1.31H18.83zm1.436 15.397c.192-.12.31-.33.31-.557v-8.075a.655.655 0 0 0-1.31 0v7.016l-1.954-.977-.032-.017c-.19-.094-.338-.169-.497-.222a2.4 2.4 0 0 0-.433-.102c-.167-.024-.333-.023-.544-.023H8.397c-.744 0-1.263 0-1.667-.034-.396-.032-.624-.093-.796-.18a1.96 1.96 0 0 1-.858-.859c-.088-.172-.149-.4-.181-.796-.033-.404-.034-.923-.034-1.667V9.143c0-.744.001-1.263.034-1.667.032-.396.093-.624.18-.796.189-.37.49-.67.859-.858.172-.088.4-.149.796-.181.404-.033.923-.034 1.667-.034h4.758a.655.655 0 0 0 0-1.309H8.369c-.71 0-1.282 0-1.745.038-.478.039-.897.121-1.285.319a3.27 3.27 0 0 0-1.43 1.43c-.198.388-.28.807-.32 1.285-.037.463-.037 1.035-.037 1.745v3.897c0 .71 0 1.282.038 1.745.039.478.121.897.319 1.285a3.27 3.27 0 0 0 1.43 1.43c.388.198.807.28 1.285.32.463.037 1.035.037 1.745.037h7.4c.263 0 .333.002.399.01q.1.015.196.047c.062.02.126.051.361.169l2.902 1.45c.203.102.444.091.638-.028M7.699 8.663a.655.655 0 0 0 0 1.31h6.983a.655.655 0 0 0 0-1.31zm-.655 4.146c0-.361.293-.654.655-.654h4.365a.655.655 0 0 1 0 1.31H7.698a.655.655 0 0 1-.655-.656" clip-rule="evenodd"/>
  </svg>
`;
const AddCursor = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path stroke='currentColor' stroke-linecap="round" stroke-linejoin="round" d="M6 12h12m-6-6v12"/>
  </svg>
`;
const AddCursorDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path stroke="#000" stroke-linecap="round" stroke-linejoin="round" d="M6 12h12m-6-6v12"/>
  </svg>
`;
const AddOrganize = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M5 5.25c-.69 0-1.25.56-1.25 1.25V17c0 .69.56 1.25 1.25 1.25h8.25a.75.75 0 0 1 0 1.5H5A2.75 2.75 0 0 1 2.25 17V6.5A2.75 2.75 0 0 1 5 3.75h4.672c.729 0 1.428.29 1.944.805l1.195 1.195H19a2.75 2.75 0 0 1 2.75 2.75v2.75a.75.75 0 0 1-1.5 0V8.5c0-.69-.56-1.25-1.25-1.25h-6.5a.75.75 0 0 1-.53-.22l-1.415-1.414a1.25 1.25 0 0 0-.883-.366zM20 14.25a.75.75 0 0 1 .75.75v2.25H23a.75.75 0 0 1 0 1.5h-2.25V21a.75.75 0 0 1-1.5 0v-2.25H17a.75.75 0 0 1 0-1.5h2.25V15a.75.75 0 0 1 .75-.75"/>
  </svg>
`;
const AddTag = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M4.564 7.467a3.017 3.017 0 0 1 2.903-2.903l4.606-.17c.323-.013.636.11.864.338L14.5 6.296a.696.696 0 1 0 .984-.984l-1.564-1.564a2.55 2.55 0 0 0-1.9-.746l-4.606.17a4.41 4.41 0 0 0-4.243 4.243l-.17 4.607c-.027.71.244 1.397.746 1.9l6.647 6.647a2.553 2.553 0 0 0 3.61 0l.88-.88a.696.696 0 1 0-.984-.985l-.88.88a1.16 1.16 0 0 1-1.641 0l-6.648-6.647a1.16 1.16 0 0 1-.339-.864z"/><path fill='currentColor' d="M8.262 8.262A.928.928 0 1 0 6.95 6.95a.928.928 0 0 0 1.313 1.313M17.75 9a.75.75 0 0 1 .75.75V12h2.25a.75.75 0 0 1 0 1.5H18.5v2.25a.75.75 0 0 1-1.5 0V13.5h-2.25a.75.75 0 0 1 0-1.5H17V9.75a.75.75 0 0 1 .75-.75"/>
  </svg>
`;
const AddText = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6.25 5A.75.75 0 0 1 7 4.25h14a.75.75 0 0 1 .75.75v2.333a.75.75 0 0 1-1.5 0V5.75h-5.5v12.5h2.75a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1 0-1.5h2.75V5.75h-5.5v1.583a.75.75 0 1 1-1.5 0z" clip-rule="evenodd"/><path fill='currentColor' fill-rule="evenodd" d="M1.25 13a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1-.75-.75" clip-rule="evenodd"/><path fill='currentColor' fill-rule="evenodd" d="M4.5 16.25a.75.75 0 0 1-.75-.75v-5a.75.75 0 0 1 1.5 0v5a.75.75 0 0 1-.75.75" clip-rule="evenodd"/>
  </svg>
`;
const Admin = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6.75 7a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0m4.75-3.25a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5" clip-rule="evenodd"/><path fill='currentColor' d="M12.003 13.978a.75.75 0 0 1-.723.776 6.25 6.25 0 0 0-5.778 4.484.67.67 0 0 0 .161.666c.183.2.486.346.837.346h4.754a.75.75 0 0 1 0 1.5H6.5a2.64 2.64 0 0 1-1.943-.833 2.16 2.16 0 0 1-.495-2.102 7.75 7.75 0 0 1 7.166-5.56.75.75 0 0 1 .775.723"/><path fill='currentColor' fill-rule="evenodd" d="M14.544 17.5a2.162 2.162 0 1 1 4.324 0 2.162 2.162 0 0 1-4.324 0m2.162-.662a.662.662 0 1 0 0 1.324.662.662 0 0 0 0-1.324" clip-rule="evenodd"/><path fill='currentColor' fill-rule="evenodd" d="M14.757 12.75c-.516 0-.994.273-1.255.718l-1.938 3.294a1.46 1.46 0 0 0 0 1.476l1.938 3.294c.261.445.739.718 1.255.718h3.898c.516 0 .993-.273 1.255-.718l1.938-3.294a1.46 1.46 0 0 0 0-1.476l-1.938-3.294a1.46 1.46 0 0 0-1.255-.718zM12.87 17.5l1.912-3.25h3.848l1.912 3.25-1.912 3.25h-3.848z" clip-rule="evenodd"/>
  </svg>
`;
const AfFiNe = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12.893 2.293c-.717-.538-1.769-.31-2.207.48-.35.624-1.413 2.504-2.697 4.775l-.001.001C5.493 11.96 2.166 17.843 1.61 18.865c-.341.838.135 1.831.99 2.075.251.068.512.063.758.059q.152-.005.295 0c2.243.002 5.182 0 8.153 0 3.255-.002 6.55-.004 9.016 0 .137.002.375 0 .576-.059.62-.176 1.082-.78 1.1-1.436a1.6 1.6 0 0 0-.11-.638c-.07-.156-.128-.257-.186-.357l-.066-.117-.476-.844-3.831-6.78-.232-.412L14.03 4.04l-.716-1.267a1.7 1.7 0 0 0-.421-.48m-2.331 3.026 1.11-1.965a.377.377 0 0 1 .656 0c.068.118.199.352.333.592.15.268.305.544.382.675l3.686 6.525 1.834 3.245zM8.826 8.39c-2.458 4.35-5.633 9.971-6.16 10.917-.095.23.078.52.324.524.048.005.335.005.52.004h1.682zm4.007 11.446h8.015c.07 0 .158 0 .162-.005a.2.2 0 0 0 .048-.005q.015-.005.032-.006a.396.396 0 0 0 .245-.513q-.011-.016-.016-.03a1 1 0 0 0-.049-.092l-1.043-1.847-11.472 2.498zm5.932-4.338a12 12 0 0 0-.68-.561l-7.748 3.825-.057.041 9.365-2.371zm-6.711 1.671 5.139-2.836a8 8 0 0 0-.924-.473zm.778-1.433 2.487-2.207a7 7 0 0 0-.406-.097 6 6 0 0 0-.728-.092zm-1.24.749L10.24 14.09l.627 3.301q.145-.15.283-.31.239-.286.442-.597m-1.369-3.866a6 6 0 0 1-.285-.691 7 7 0 0 1-.121-.405l3.11 1.096zm-.599-4.227 7.001 4.866.05.023-6.612-7.02-.145.514a13 13 0 0 0-.294 1.617m.484 9.678-.73-5.662-.044-.118-.179 6.413q.498-.281.953-.633m-1.91 1.108.612-8.473-2.572 9.122.003-.001.09-.023c.639-.163 1.267-.367 1.868-.625m6.24-6.63L9.56 9.48q-.001.518.061 1.032zm-3.65 1.095 1.035 1.83c.08.14.277.14.355 0l1.035-1.83c.079-.14-.02-.315-.177-.315h-2.07c-.158 0-.257.175-.178.315" clip-rule="evenodd"/>
  </svg>
`;
const Ai = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M11.281 5.491a.714.714 0 0 0-1.42-.001c-.27 2.345-.971 3.994-2.102 5.126-1.132 1.131-2.781 1.832-5.127 2.103a.714.714 0 0 0 .002 1.42c2.307.26 3.991.962 5.15 2.099 1.153 1.133 1.87 2.782 2.076 5.11a.714.714 0 0 0 1.423 0c.198-2.291.914-3.975 2.073-5.135 1.16-1.16 2.843-1.875 5.134-2.073a.714.714 0 0 0 .002-1.423c-2.33-.207-3.978-.923-5.111-2.077-1.138-1.158-1.838-2.842-2.1-5.149M18.943 2.247a.278.278 0 0 0-.552-.001c-.105.912-.378 1.554-.818 1.993s-1.082.713-1.994.818a.278.278 0 0 0 0 .552c.898.102 1.553.375 2.003.817.45.44.727 1.082.808 1.987a.278.278 0 0 0 .553 0c.077-.891.356-1.546.807-1.997.45-.45 1.105-.729 1.996-.806a.278.278 0 0 0 0-.553c-.905-.08-1.546-.36-1.987-.808-.442-.45-.715-1.105-.816-2.002"/>
  </svg>
`;
const AiOutline = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M18.667 2c.141 0 .26.106.276.247.101.897.374 1.552.816 2.002.44.449 1.082.727 1.988.808a.278.278 0 0 1 0 .553c-.892.077-1.546.355-1.997.806s-.73 1.106-.806 1.997a.278.278 0 0 1-.554 0c-.08-.905-.359-1.547-.807-1.987-.45-.442-1.106-.715-2.003-.817a.278.278 0 0 1 0-.552c.912-.105 1.553-.378 1.993-.818s.713-1.08.818-1.993A.28.28 0 0 1 18.667 2"/><path fill='currentColor' fill-rule="evenodd" d="m11.3 5.656.02.153.008.053c.292 2.117.977 3.683 2.053 4.778 1.063 1.084 2.582 1.781 4.692 2.034l.06.007.04.004a12 12 0 0 0 .319.032.714.714 0 0 1-.002 1.423 16 16 0 0 0-.418.043c-2.08.246-3.628.943-4.716 2.03-1.088 1.088-1.784 2.637-2.03 4.716a14 14 0 0 0-.043.418.714.714 0 0 1-1.423.002 15 15 0 0 0-.044-.42c-.252-2.109-.95-3.627-2.033-4.691-1.095-1.075-2.66-1.76-4.778-2.053l-.053-.007a12 12 0 0 0-.318-.04.714.714 0 0 1-.002-1.419l.318-.04.054-.007c2.15-.3 3.684-.985 4.755-2.056 1.07-1.07 1.756-2.606 2.056-4.755l.007-.053.04-.318a.714.714 0 0 1 1.42.001q.008.082.019.165m-2.48 6.02c.755-.755 1.33-1.663 1.75-2.72.418 1.055.99 1.972 1.74 2.735a7.7 7.7 0 0 0 2.622 1.736 7.9 7.9 0 0 0-2.636 1.726 7.9 7.9 0 0 0-1.726 2.637 7.7 7.7 0 0 0-1.736-2.622c-.764-.75-1.68-1.323-2.736-1.74 1.058-.42 1.966-.996 2.721-1.751" clip-rule="evenodd"/>
  </svg>
`;
const AiThinking = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M9.551 3.255c.386-.737 1.208-1.005 2.12-1.005.942 0 1.768.321 2.078 1.158.262.708.021 1.505-.279 2.128-.17.354-.39.71-.637 1.053.324.213.67.396 1.028.53.393.148.85.234 1.318.266a6.2 6.2 0 0 1 .288-1.454c.209-.61.592-1.277 1.29-1.531.748-.273 1.5.048 2.146.602.667.572 1.081 1.33.768 2.14-.266.687-.961 1.1-1.593 1.34a6.5 6.5 0 0 1-1.405.345c.035.462.108.933.221 1.384q.061.246.164.476a5.2 5.2 0 0 1 1.425-.981c.653-.29 1.421-.407 2.096-.063.703.358 1.063 1.088 1.15 1.961.096.955-.145 1.789-.835 2.262-.648.444-1.462.406-2.144.195a4.9 4.9 0 0 1-1.696-.958 6.8 6.8 0 0 0-.627 1.464c1.015-.073 1.886.121 2.546.534.647.405 1.089 1.033 1.152 1.783.063.747-.26 1.476-.859 2.075-.56.56-1.26.805-1.967.696-.684-.105-1.273-.522-1.7-1.08-.424-.555-.715-1.276-.815-2.101q-.406.154-.851.375-.623.313-1.107.623c.414.522.7 1.063.843 1.584.17.62.16 1.305-.217 1.86-.39.578-1.05.834-1.781.834-.694 0-1.352-.198-1.81-.657-.48-.48-.636-1.143-.489-1.82.14-.646.549-1.296 1.171-1.912a7 7 0 0 0-.834-.522 4.3 4.3 0 0 0-.715-.308c-.054.791-.26 1.475-.6 2.01-.376.595-.94 1.029-1.64 1.125-.697.096-1.388-.162-1.986-.662-.625-.52-.82-1.245-.617-1.943.187-.64.683-1.18 1.28-1.553a4.5 4.5 0 0 1 1.949-.642 9 9 0 0 0-.275-1.022 5 5 0 0 0-.116-.316c-.502.4-1.064.694-1.603.858-.66.201-1.426.25-2.07-.084-.706-.367-1.066-1.087-1.066-1.98 0-.796.319-1.465.892-1.888.555-.41 1.262-.525 1.945-.413.678.11 1.36.441 1.958.985q.026-.075.044-.152c.102-.405.112-.919.033-1.474a8 8 0 0 1-1.343-.156c-.719-.152-1.511-.453-1.958-1.059a1.68 1.68 0 0 1-.326-1.17c.04-.423.225-.831.5-1.216.256-.36.571-.648.957-.802.4-.16.805-.147 1.172-.016.68.243 1.205.874 1.572 1.509.238.41.442.877.6 1.366.602-.068 1.108-.201 1.433-.364.284-.142.625-.392.973-.72A5.8 5.8 0 0 1 9.687 5.34c-.299-.608-.497-1.395-.136-2.085m2.137 2.355c.171-.245.318-.491.43-.726.263-.543.263-.85.224-.956-.008-.021-.019-.047-.084-.08-.083-.043-.26-.098-.587-.098-.335 0-.54.05-.656.1-.105.046-.128.088-.135.1-.024.047-.075.265.153.728.147.3.373.62.655.932m.16 2.122c-.458.447-.96.838-1.448 1.082-.494.247-1.125.407-1.774.493.078.649.068 1.313-.081 1.91a3.9 3.9 0 0 1-.473 1.106q.265.476.457 1.047.274.827.39 1.589c.492.106.997.287 1.502.56.49.263.93.557 1.32.871q.662-.45 1.52-.882.81-.403 1.562-.631.095-.589.317-1.205a8.2 8.2 0 0 1 .884-1.749 4.6 4.6 0 0 1-.585-1.348 10 10 0 0 1-.266-1.688 6.3 6.3 0 0 1-1.84-.363 6.8 6.8 0 0 1-1.486-.792m-5.143.118a5 5 0 0 0-.307-.629c-.312-.54-.607-.786-.778-.847-.057-.02-.084-.015-.111-.004-.042.016-.148.076-.293.28-.177.248-.22.406-.227.483a.18.18 0 0 0 .04.142c.106.144.43.348 1.061.482q.291.06.615.093m-.527 4.403c-.442-.454-.928-.686-1.332-.752-.373-.06-.65.02-.814.14-.146.108-.282.305-.282.68 0 .475.162.6.258.65.16.083.478.121.941-.02.428-.13.861-.376 1.229-.699m1.324 4.108a3 3 0 0 0-1.275.419c-.393.246-.583.52-.636.702-.037.125-.028.232.137.37.365.305.646.352.822.328.173-.024.384-.136.577-.442.192-.303.341-.767.375-1.377m4.136 2.027-.029.028c-.503.495-.712.904-.771 1.176-.054.248.012.37.084.441.093.094.318.217.749.217.392 0 .506-.125.539-.174.048-.07.112-.259.012-.622-.085-.31-.276-.68-.584-1.066m4.615-2.297c.046.674.264 1.214.538 1.573.251.329.523.476.735.509.188.029.42-.016.679-.274.365-.366.443-.682.425-.89-.017-.203-.137-.439-.453-.637-.378-.236-1.03-.396-1.924-.281m1.707-4.187c.385.344.822.597 1.232.724.47.145.742.077.853 0 .068-.046.257-.222.192-.875-.057-.575-.251-.73-.338-.774-.115-.058-.373-.095-.807.098-.356.158-.75.438-1.132.827m-1.265-4.597a4.7 4.7 0 0 0 .85-.227c.533-.202.701-.412.727-.478V6.6c.002-.004.008-.015-.01-.061-.028-.069-.111-.206-.336-.4-.231-.198-.4-.284-.508-.318-.097-.03-.136-.017-.148-.013-.048.017-.222.134-.384.608a4.4 4.4 0 0 0-.19.89" clip-rule="evenodd"/>
  </svg>
`;
const Alias = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12.574 3.313a.75.75 0 0 1 .81.136l8.125 7.5a.75.75 0 0 1 0 1.102l-8.126 7.5A.75.75 0 0 1 12.125 19v-4.012c-3.68.112-5.78 1.038-6.948 1.89-.626.457-1 .904-1.213 1.22a3 3 0 0 0-.25.45l-.004.012a.75.75 0 0 1-1.46-.242c0-3.999 1.713-6.61 3.934-8.195 1.906-1.361 4.153-1.946 5.94-2.073V4a.75.75 0 0 1 .45-.687m-8.551 12.56q.128-.104.27-.206c1.556-1.136 4.19-2.19 8.581-2.19a.75.75 0 0 1 .75.75v3.06l6.27-5.787-6.27-5.787v3.06a.75.75 0 0 1-.75.75c-1.638 0-3.944.482-5.819 1.82-1.364.975-2.525 2.418-3.032 4.53" clip-rule="evenodd"/>
  </svg>
`;
const AlignBottom = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M15 4a1 1 0 0 1 1 1v12a1 1 0 0 1-.031.25H20a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1 0-1.5h4.031A1 1 0 0 1 8 17v-6a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v6a1 1 0 0 1-.031.25h2.063A1 1 0 0 1 13 17V5a1 1 0 0 1 1-1z" clip-rule="evenodd"/>
  </svg>
`;
const AlignHorizontalCenter = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 3.25a.75.75 0 0 1 .75.75v4H18a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-5.25v2H15a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-2.25v4a.75.75 0 0 1-1.5 0v-4H9a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h2.25v-2H6a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h5.25V4a.75.75 0 0 1 .75-.75" clip-rule="evenodd"/>
  </svg>
`;
const AlignLeft = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5.75 3.25A.75.75 0 0 1 6.5 4v4.031q.12-.03.25-.031h12a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-12a1 1 0 0 1-.25-.031v2.063A1 1 0 0 1 6.75 13h6a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-6a1 1 0 0 1-.25-.031V20A.75.75 0 0 1 5 20V4a.75.75 0 0 1 .75-.75" clip-rule="evenodd"/>
  </svg>
`;
const AlignRight = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M19 3.25a.75.75 0 0 1 .75.75v16a.75.75 0 0 1-1.5 0v-4.031A1 1 0 0 1 18 16h-6a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h6a1 1 0 0 1 .25.031V10.97A1 1 0 0 1 18 11H6a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h12q.13 0 .25.031V4a.75.75 0 0 1 .75-.75" clip-rule="evenodd"/>
  </svg>
`;
const AlignTop = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3 5.75A.75.75 0 0 1 3.75 5h16a.75.75 0 0 1 0 1.5h-4.031a1 1 0 0 1 .031.25v12a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-12a1 1 0 0 1 .031-.25H10.72a1 1 0 0 1 .031.25v6a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-6q0-.13.032-.25H3.75A.75.75 0 0 1 3 5.75" clip-rule="evenodd"/>
  </svg>
`;
const AlignVerticalCenter = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M15 5a1 1 0 0 1 1 1v5.25h4a.75.75 0 0 1 0 1.5h-4V18a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-5.25h-2V15a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-2.25H4a.75.75 0 0 1 0-1.5h4V9a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v2.25h2V6a1 1 0 0 1 1-1z" clip-rule="evenodd"/>
  </svg>
`;
const AllDocs = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M10.167 3.25c-.783 0-1.417.634-1.417 1.417V15.5c0 .782.634 1.417 1.417 1.417h8.666c.783 0 1.417-.635 1.417-1.417V8.125h-2.5a1.833 1.833 0 0 1-1.833-1.833V3.25zm7.25 1.223 1.913 2.152h-1.58a.333.333 0 0 1-.333-.333zM7.25 4.667a2.917 2.917 0 0 1 2.917-2.917h6.5a.75.75 0 0 1 .56.252l4.334 4.875a.75.75 0 0 1 .189.498V15.5a2.917 2.917 0 0 1-2.917 2.917H16.75v.916a2.917 2.917 0 0 1-2.917 2.917H5.708a3.46 3.46 0 0 1-3.458-3.458V8.5a2.917 2.917 0 0 1 2.917-2.917H7.25zm0 2.416H5.167c-.783 0-1.417.635-1.417 1.417v10.292c0 1.081.877 1.958 1.958 1.958h8.125c.783 0 1.417-.634 1.417-1.417v-.916h-5.083A2.917 2.917 0 0 1 7.25 15.5zm4.333-.25a.75.75 0 0 1 .75-.75h1.409a.75.75 0 0 1 0 1.5h-1.409a.75.75 0 0 1-.75-.75m0 3.25a.75.75 0 0 1 .75-.75h4.334a.75.75 0 0 1 0 1.5h-4.334a.75.75 0 0 1-.75-.75m0 3.25a.75.75 0 0 1 .75-.75h3.25a.75.75 0 0 1 0 1.5h-3.25a.75.75 0 0 1-.75-.75" clip-rule="evenodd"/>
  </svg>
`;
const Appearance = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 3.75a8.25 8.25 0 1 0 0 16.5A2.25 2.25 0 0 0 14.25 18v-.659c0-.314 0-.556.034-.771a2.75 2.75 0 0 1 2.286-2.286c.215-.034.457-.034.771-.034H18A2.25 2.25 0 0 0 20.25 12 8.25 8.25 0 0 0 12 3.75M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75A3.75 3.75 0 0 1 18 15.75h-.6c-.4 0-.513.002-.595.015a1.25 1.25 0 0 0-1.04 1.04c-.013.082-.015.195-.015.595v.6A3.75 3.75 0 0 1 12 21.75c-5.385 0-9.75-4.365-9.75-9.75m7-4.5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m5 1a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m-8 3a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"/>
  </svg>
`;
const Apple = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M15.084 4.424c-.72.87-1.923 1.514-2.879 1.514-.118 0-.226-.021-.29-.032-.01-.053-.043-.215-.043-.386 0-1.096.559-2.192 1.171-2.88.763-.902 2.052-1.568 3.126-1.61.021.117.032.268.032.418 0 1.096-.462 2.18-1.117 2.976m.752 1.74c.601 0 2.782.065 4.21 2.116-.128.097-2.287 1.322-2.287 4.05 0 3.147 2.75 4.275 2.836 4.297-.011.075-.44 1.525-1.45 3.018-.914 1.3-1.87 2.622-3.31 2.622-1.45 0-1.825-.849-3.48-.849-1.632 0-2.212.849-3.523.849-1.332 0-2.256-1.193-3.309-2.675C4.288 17.84 3.3 15.123 3.3 12.545c0-4.125 2.685-6.38 5.339-6.38 1.396 0 2.556.977 3.448.977.838 0 2.148-.978 3.749-.978"/>
  </svg>
`;
const AppleDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#000" d="M15.084 4.424c-.72.87-1.923 1.514-2.879 1.514-.118 0-.226-.021-.29-.032-.01-.053-.043-.215-.043-.386 0-1.096.559-2.192 1.171-2.88.763-.902 2.052-1.568 3.126-1.61.021.117.032.268.032.418 0 1.096-.462 2.18-1.117 2.976m.752 1.74c.601 0 2.782.065 4.21 2.116-.128.097-2.287 1.322-2.287 4.05 0 3.147 2.75 4.275 2.836 4.297-.011.075-.44 1.525-1.45 3.018-.914 1.3-1.87 2.622-3.31 2.622-1.45 0-1.825-.849-3.48-.849-1.632 0-2.212.849-3.523.849-1.332 0-2.256-1.193-3.309-2.675C4.288 17.84 3.3 15.123 3.3 12.545c0-4.125 2.685-6.38 5.339-6.38 1.396 0 2.556.977 3.448.977.838 0 2.148-.978 3.749-.978"/>
  </svg>
`;
const ArrowDownBig = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M17.507 13.003a.75.75 0 0 0-1.06.045l-3.697 4.027V5a.75.75 0 0 0-1.5 0v12.075l-3.698-4.027a.75.75 0 1 0-1.104 1.015l5 5.444a.75.75 0 0 0 1.104 0l5-5.444a.75.75 0 0 0-.045-1.06" clip-rule="evenodd"/>
  </svg>
`;
const ArrowDownBigBottom = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12.75 4a.75.75 0 0 0-1.5 0v10.19l-2.72-2.72a.75.75 0 0 0-1.06 1.06l4 4a.75.75 0 0 0 1.06 0l4-4a.75.75 0 1 0-1.06-1.06l-2.72 2.72zM5 19.25a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5z" clip-rule="evenodd"/>
  </svg>
`;
const ArrowDownSmall = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M17.58 8.97a.75.75 0 0 1 0 1.06l-5 5a.75.75 0 0 1-1.06 0l-5-5a.75.75 0 1 1 1.06-1.06l4.47 4.47 4.47-4.47a.75.75 0 0 1 1.06 0" clip-rule="evenodd"/>
  </svg>
`;
const ArrowLeftBig = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M10.997 6.493a.75.75 0 0 1-.045 1.06L6.925 11.25H19a.75.75 0 0 1 0 1.5H6.925l4.027 3.698a.75.75 0 1 1-1.015 1.104l-5.444-5a.75.75 0 0 1 0-1.104l5.444-5a.75.75 0 0 1 1.06.045" clip-rule="evenodd"/>
  </svg>
`;
const ArrowLeftSmall = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M14.53 6.47a.75.75 0 0 1 0 1.06L10.06 12l4.47 4.47a.75.75 0 1 1-1.06 1.06l-5-5a.75.75 0 0 1 0-1.06l5-5a.75.75 0 0 1 1.06 0" clip-rule="evenodd"/>
  </svg>
`;
const ArrowLeftSmallPlus = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M14.707 6.293a1 1 0 0 1 0 1.414L10.414 12l4.293 4.293a1 1 0 0 1-1.414 1.414l-5-5a1 1 0 0 1 0-1.414l5-5a1 1 0 0 1 1.414 0" clip-rule="evenodd"/>
  </svg>
`;
const ArrowRightBig = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M13.003 6.493a.75.75 0 0 0 .045 1.06l4.027 3.697H5a.75.75 0 0 0 0 1.5h12.075l-4.027 3.698a.75.75 0 1 0 1.015 1.104l5.444-5a.75.75 0 0 0 0-1.104l-5.444-5a.75.75 0 0 0-1.06.045" clip-rule="evenodd"/>
  </svg>
`;
const ArrowRightSmall = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8.47 6.47a.75.75 0 0 0 0 1.06L12.94 12l-4.47 4.47a.75.75 0 1 0 1.06 1.06l5-5a.75.75 0 0 0 0-1.06l-5-5a.75.75 0 0 0-1.06 0" clip-rule="evenodd"/>
  </svg>
`;
const ArrowRightSmallPlus = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8.293 6.293a1 1 0 0 0 0 1.414L12.586 12l-4.293 4.293a1 1 0 1 0 1.414 1.414l5-5a1 1 0 0 0 0-1.414l-5-5a1 1 0 0 0-1.414 0" clip-rule="evenodd"/>
  </svg>
`;
const ArrowShape = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M13.345 7.05H3v9.9h10.345V21L21 12l-7.655-9zm1.5.029V8.55H4.5v6.9h10.345v1.471L19.03 12z" clip-rule="evenodd"/>
  </svg>
`;
const ArrowUpBig = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M17.507 10.997a.75.75 0 0 1-1.06-.045L12.75 6.925V19a.75.75 0 0 1-1.5 0V6.925l-3.698 4.027a.75.75 0 1 1-1.104-1.015l5-5.444a.75.75 0 0 1 1.104 0l5 5.444a.75.75 0 0 1-.045 1.06" clip-rule="evenodd"/>
  </svg>
`;
const ArrowUpBigTop = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5 3.25a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5zM12.75 20a.75.75 0 0 1-1.5 0V9.81l-2.72 2.72a.75.75 0 0 1-1.06-1.06l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 1 1-1.06 1.06l-2.72-2.72z" clip-rule="evenodd"/>
  </svg>
`;
const ArrowUpSmall = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M17.58 15.03a.75.75 0 0 0 0-1.06l-5-5a.75.75 0 0 0-1.06 0l-5 5a.75.75 0 1 0 1.06 1.06l4.47-4.47 4.47 4.47a.75.75 0 0 0 1.06 0" clip-rule="evenodd"/>
  </svg>
`;
const ArrowsLeft = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M11.53 7.53a.75.75 0 0 0-1.06-1.06l-5 5a.75.75 0 0 0 0 1.06l5 5a.75.75 0 1 0 1.06-1.06L7.06 12zM18.53 7.53a.75.75 0 0 0-1.06-1.06l-5 5a.75.75 0 0 0 0 1.06l5 5a.75.75 0 1 0 1.06-1.06L14.06 12z"/>
  </svg>
`;
const ArrowsRight = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M5.47 7.53a.75.75 0 0 1 1.06-1.06l5 5a.75.75 0 0 1 0 1.06l-5 5a.75.75 0 0 1-1.06-1.06L9.94 12zM12.47 7.53a.75.75 0 0 1 1.06-1.06l5 5a.75.75 0 0 1 0 1.06l-5 5a.75.75 0 1 1-1.06-1.06L16.94 12z"/>
  </svg>
`;
const At = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 3.75a8.25 8.25 0 1 0 4.125 15.395.75.75 0 0 1 .75 1.299 9.7 9.7 0 0 1-4.925 1.306c-5.362-.027-9.7-4.382-9.7-9.75 0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75v1.5a3.25 3.25 0 0 1-6.108 1.55A4.75 4.75 0 1 1 16.75 12v1.5a1.75 1.75 0 1 0 3.5 0V12A8.25 8.25 0 0 0 12 3.75M15.25 12a3.25 3.25 0 1 0-6.5 0 3.25 3.25 0 0 0 6.5 0" clip-rule="evenodd"/>
  </svg>
`;
const Attachment = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="m12.218 5.608-6.04 6.04a4.65 4.65 0 0 0 0 6.704c1.913 1.864 5.025 1.864 6.939 0l5.89-5.723a.75.75 0 1 1 1.045 1.076l-5.889 5.721c-2.496 2.432-6.536 2.432-9.032 0a6.15 6.15 0 0 1-.004-8.849l6.04-6.04c1.762-1.716 4.61-1.716 6.371 0a4.35 4.35 0 0 1 .004 6.256l-6.04 6.04c-1.027 1-2.683 1-3.71 0a2.55 2.55 0 0 1 0-3.667l6.2-6.037a.75.75 0 0 1 1.046 1.075l-6.199 6.037a1.05 1.05 0 0 0 0 1.518 1.17 1.17 0 0 0 1.613.003l6.04-6.04a2.85 2.85 0 0 0 0-4.11 3.086 3.086 0 0 0-4.275-.004" clip-rule="evenodd"/>
  </svg>
`;
const AutoHeight = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.25 4A.75.75 0 0 1 4 3.25h16a.75.75 0 0 1 0 1.5H4A.75.75 0 0 1 3.25 4M3.25 20a.75.75 0 0 1 .75-.75h16a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75M11.47 5.47a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06L12 7.06 9.53 9.53a.75.75 0 0 1-1.06-1.06zM8.47 14.47a.75.75 0 0 1 1.06 0L12 16.94l2.47-2.47a.75.75 0 1 1 1.06 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/><path fill='currentColor' fill-rule="evenodd" d="M12 5.25a.75.75 0 0 1 .75.75v12a.75.75 0 0 1-1.5 0V6a.75.75 0 0 1 .75-.75" clip-rule="evenodd"/>
  </svg>
`;
const AutoSize = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.25 6A2.75 2.75 0 0 1 6 3.25h2.5a.75.75 0 0 1 0 1.5H6c-.69 0-1.25.56-1.25 1.25v2.5a.75.75 0 0 1-1.5 0zm11.5-2a.75.75 0 0 1 .75-.75H18A2.75 2.75 0 0 1 20.75 6v2.5a.75.75 0 0 1-1.5 0V6c0-.69-.56-1.25-1.25-1.25h-2.5a.75.75 0 0 1-.75-.75M4 14.75a.75.75 0 0 1 .75.75V18c0 .69.56 1.25 1.25 1.25h3a.75.75 0 0 1 0 1.5H6A2.75 2.75 0 0 1 3.25 18v-2.5a.75.75 0 0 1 .75-.75m16 0a.75.75 0 0 1 .75.75V18A2.75 2.75 0 0 1 18 20.75h-3a.75.75 0 0 1 0-1.5h3c.69 0 1.25-.56 1.25-1.25v-2.5a.75.75 0 0 1 .75-.75" clip-rule="evenodd"/>
  </svg>
`;
const AutoTidyUp = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.368 5.55c0-.856.694-1.55 1.55-1.55h5.314c.856 0 1.55.694 1.55 1.55v2.657a1.55 1.55 0 0 1-1.55 1.55H5.918a1.55 1.55 0 0 1-1.55-1.55zm1.55-.221c-.122 0-.221.099-.221.221v2.657c0 .122.099.222.221.222h5.314c.123 0 .222-.1.222-.222V5.55c0-.122-.1-.221-.222-.221zm9.079.221c0-.856.694-1.55 1.55-1.55h1.771c.856 0 1.55.694 1.55 1.55v4.429a1.55 1.55 0 0 1-1.55 1.55h-1.771a1.55 1.55 0 0 1-1.55-1.55zm1.55-.221c-.123 0-.222.099-.222.221v4.429c0 .122.1.221.222.221h1.771c.122 0 .221-.1.221-.221V5.55c0-.122-.099-.221-.221-.221zM4.368 14.407c0-.856.694-1.55 1.55-1.55h2.657c.856 0 1.55.694 1.55 1.55v3.543a1.55 1.55 0 0 1-1.55 1.55H5.918a1.55 1.55 0 0 1-1.55-1.55zm1.55-.221c-.122 0-.221.099-.221.221v3.543c0 .122.099.221.221.221h2.657c.122 0 .222-.099.222-.221v-3.543c0-.122-.1-.221-.222-.221zm6.421.221c0-.856.694-1.55 1.55-1.55h4.429c.856 0 1.55.694 1.55 1.55v2.657a1.55 1.55 0 0 1-1.55 1.55h-4.429a1.55 1.55 0 0 1-1.55-1.55zm1.55-.221c-.122 0-.221.099-.221.221v2.657c0 .123.1.222.222.222h4.428c.122 0 .221-.1.221-.222v-2.657c0-.122-.099-.221-.221-.221z" clip-rule="evenodd"/>
  </svg>
`;
const BackwardPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 13.778v3.995c0 .863-1.02 1.32-1.664.747L3.84 12.747a1 1 0 0 1 0-1.494l6.495-5.774C10.98 4.906 12 5.364 12 6.227v3.995l5.336-4.743C17.98 4.906 19 5.364 19 6.227v11.546c0 .863-1.02 1.32-1.664.747z" clip-rule="evenodd"/>
  </svg>
`;
const BagPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M11.8 2.25A3.25 3.25 0 0 0 8.55 5.5v1h-.794a1.5 1.5 0 0 0-1.477 1.236l-1.964 11A1.5 1.5 0 0 0 5.792 20.5h11.917a1.5 1.5 0 0 0 1.476-1.764l-1.964-11A1.5 1.5 0 0 0 15.744 6.5h-.694v-1a3.25 3.25 0 0 0-3.25-3.25m1.75 4.25v-1a1.75 1.75 0 1 0-3.5 0v1z" clip-rule="evenodd"/>
  </svg>
`;
const Ban = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12M12 3.75a8.25 8.25 0 0 0-6.336 13.533L17.28 5.662A8.22 8.22 0 0 0 12 3.75m6.342 2.973L6.724 18.343a8.25 8.25 0 0 0 11.617-11.62" clip-rule="evenodd"/>
  </svg>
`;
const BaseballPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6.148 6.545A7.97 7.97 0 0 0 4 12c0 2.108.816 4.026 2.148 5.455C6.9 15.927 7.35 14.047 7.35 12S6.9 8.073 6.148 6.545m.998 11.814A7.97 7.97 0 0 0 12 20a7.97 7.97 0 0 0 4.854-1.64c-.95-1.784-1.504-3.989-1.504-6.36s.553-4.576 1.504-6.36A7.97 7.97 0 0 0 12 4a7.97 7.97 0 0 0-4.854 1.64C8.096 7.425 8.65 9.63 8.65 12s-.553 4.576-1.504 6.36M16.65 12c0 2.047.45 3.927 1.202 5.455A7.97 7.97 0 0 0 20 12a7.97 7.97 0 0 0-2.148-5.455C17.1 8.073 16.65 9.953 16.65 12" clip-rule="evenodd"/>
  </svg>
`;
const BasketballPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M11.35 4.026a7.96 7.96 0 0 0-4.204 1.615c.863 1.619 1.399 3.586 1.49 5.709h2.714zm0 8.624H8.636c-.091 2.123-.627 4.09-1.49 5.71a7.96 7.96 0 0 0 4.204 1.614zm1.3 7.324V12.65h2.714c.091 2.123.627 4.09 1.49 5.71a7.96 7.96 0 0 1-4.204 1.614m0-8.624V4.026a7.96 7.96 0 0 1 4.204 1.615c-.863 1.619-1.399 3.586-1.49 5.709zM6.148 6.545a7.97 7.97 0 0 0-2.122 4.805h3.309C7.25 9.555 6.82 7.91 6.148 6.545m0 10.91a7.97 7.97 0 0 1-2.122-4.805h3.309c-.085 1.795-.515 3.44-1.187 4.805m11.704 0c-.671-1.364-1.102-3.01-1.187-4.805h3.31a7.97 7.97 0 0 1-2.123 4.805m-1.187-6.105h3.31a7.97 7.97 0 0 0-2.123-4.805c-.671 1.365-1.102 3.01-1.187 4.805" clip-rule="evenodd"/>
  </svg>
`;
const BitcoinPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M13.238 14.7a1.012 1.012 0 1 0 0-2.025H10.65V14.7zM10.65 9.3h2.588a1.012 1.012 0 1 1 0 2.025H10.65z"/><path fill='currentColor' fill-rule="evenodd" d="M3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0m4.95-4.05V9.3H9.3v5.4H7.95v1.35h3.375v1.35h1.35v-1.35h.563A2.362 2.362 0 0 0 14.89 12a2.362 2.362 0 0 0-1.653-4.05h-.563V6.6h-1.35v1.35z" clip-rule="evenodd"/>
  </svg>
`;
const Block = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M11.7 2.813a.75.75 0 0 1 .6 0l8 3.5c.274.12.45.389.45.687v10a.75.75 0 0 1-.45.687l-8 3.5a.75.75 0 0 1-.6 0l-8-3.5A.75.75 0 0 1 3.25 17V7a.75.75 0 0 1 .45-.687zM4.75 8.147v8.362l6.5 2.844v-8.362zm8 2.844v8.362l6.5-2.844V8.147zM18.129 7 12 9.681 5.871 7 12 4.319z" clip-rule="evenodd"/>
  </svg>
`;
const BlockLink = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.25 6A2.75 2.75 0 0 1 6 3.25h2.5A2.75 2.75 0 0 1 11.25 6v2.5a2.75 2.75 0 0 1-2.75 2.75H6A2.75 2.75 0 0 1 3.25 8.5zM6 4.75c-.69 0-1.25.56-1.25 1.25v2.5c0 .69.56 1.25 1.25 1.25h2.5c.69 0 1.25-.56 1.25-1.25V6c0-.69-.56-1.25-1.25-1.25zM12.75 6a2.75 2.75 0 0 1 2.75-2.75H18A2.75 2.75 0 0 1 20.75 6v2.5A2.75 2.75 0 0 1 18 11.25h-2.5a2.75 2.75 0 0 1-2.75-2.75zm2.75-1.25c-.69 0-1.25.56-1.25 1.25v2.5c0 .69.56 1.25 1.25 1.25H18c.69 0 1.25-.56 1.25-1.25V6c0-.69-.56-1.25-1.25-1.25zM3.25 15.5A2.75 2.75 0 0 1 6 12.75h2.5a2.75 2.75 0 0 1 2.75 2.75V18a2.75 2.75 0 0 1-2.75 2.75H6A2.75 2.75 0 0 1 3.25 18zM6 14.25c-.69 0-1.25.56-1.25 1.25V18c0 .69.56 1.25 1.25 1.25h2.5c.69 0 1.25-.56 1.25-1.25v-2.5c0-.69-.56-1.25-1.25-1.25zm8.25-.75a.75.75 0 0 1 .75-.75h4.9a.85.85 0 0 1 .85.85v4.9a.75.75 0 0 1-1.5 0v-3.19l-5.22 5.22a.75.75 0 1 1-1.06-1.06l5.22-5.22H15a.75.75 0 0 1-.75-.75" clip-rule="evenodd"/>
  </svg>
`;
const Blocksuite = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M20 8.182 14.703 4 4 6.121v9.696L9.298 20 20 17.88zm-6.356-2.65v2.754l1.62-.32v-1.71l2.34 1.846-7.81 1.548-3.398-2.682zM5.62 8.167l3.116 2.459v2.887l1.62-.32V10.86l8.024-1.59v6.564l-3.116-2.46v-2.886l-1.62.32v2.332L5.62 14.73zm4.736 10.301v-2.754l-1.62.321v1.71L6.396 15.9l7.811-1.548 3.397 2.681z"/>
  </svg>
`;
const Bold = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6.25 4A.75.75 0 0 1 7 3.25h5.958c2.67 0 4.875 2.105 4.875 4.75 0 1.515-.723 2.853-1.843 3.72 1.626.764 2.76 2.383 2.76 4.28 0 2.645-2.204 4.75-4.875 4.75H7a.75.75 0 0 1-.75-.75zm1.5 8.75v6.5h6.125c1.886 0 3.375-1.477 3.375-3.25s-1.49-3.25-3.375-3.25zm0-1.5h5.208c1.886 0 3.375-1.477 3.375-3.25s-1.489-3.25-3.375-3.25H7.75z" clip-rule="evenodd"/>
  </svg>
`;
const BookPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6 3a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm1 17v-.5h9.5a1 1 0 0 0 1-1V5h.5a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1" clip-rule="evenodd"/>
  </svg>
`;
const Bookmark = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5 3.25A2.75 2.75 0 0 0 2.25 6v7a.75.75 0 0 0 1.5 0V6c0-.69.56-1.25 1.25-1.25h14c.69 0 1.25.56 1.25 1.25v12c0 .69-.56 1.25-1.25 1.25h-7a.75.75 0 0 0 0 1.5h7A2.75 2.75 0 0 0 21.75 18V6A2.75 2.75 0 0 0 19 3.25zm4.116 9.866a1.25 1.25 0 0 1 1.768 1.768l-2 2a1.25 1.25 0 0 1-1.768 0 .75.75 0 0 0-1.06 1.06 2.75 2.75 0 0 0 3.889 0l2-2a2.75 2.75 0 1 0-3.89-3.889l-.55.55a.75.75 0 1 0 1.061 1.06zm-3 3a1.25 1.25 0 0 1 1.768 0 .75.75 0 0 0 1.06-1.06 2.75 2.75 0 0 0-3.889 0l-2 2a2.75 2.75 0 1 0 3.89 3.889l.55-.551a.75.75 0 0 0-1.06-1.06l-.551.55a1.25 1.25 0 0 1-1.768-1.768z" clip-rule="evenodd"/>
  </svg>
`;
const BrokenImage = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.25 6A2.75 2.75 0 0 1 6 3.25h12A2.75 2.75 0 0 1 20.75 6v5a.75.75 0 0 1-1.5 0V6c0-.69-.56-1.25-1.25-1.25H6c-.69 0-1.25.56-1.25 1.25v8.19l3.305-3.306a2.75 2.75 0 0 1 3.89 0l.585.586a.75.75 0 1 1-1.06 1.06l-.586-.585a1.25 1.25 0 0 0-1.768 0L4.75 16.31V18c0 .69.56 1.25 1.25 1.25h5a.75.75 0 0 1 0 1.5H6A2.75 2.75 0 0 1 3.25 18z" clip-rule="evenodd"/><path fill='currentColor' d="M15 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path fill='currentColor' fill-rule="evenodd" d="M13.47 13.47a.75.75 0 0 1 1.06 0L17 15.94l2.47-2.47a.75.75 0 1 1 1.06 1.06L18.06 17l2.47 2.47a.75.75 0 1 1-1.06 1.06L17 18.06l-2.47 2.47a.75.75 0 1 1-1.06-1.06L15.94 17l-2.47-2.47a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>
  </svg>
`;
const Broom = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M20.777 3.723a.76.76 0 0 1 0 1.075l-6.968 6.968a5.09 5.09 0 0 1 .068 5.946l-2.881 4.1a.663.663 0 0 1-.92.164 29.9 29.9 0 0 1-7.552-7.552.663.663 0 0 1 .164-.92l4.1-2.88a5.09 5.09 0 0 1 5.946.067l6.968-6.968a.76.76 0 0 1 1.075 0M10.25 20.23l2.384-3.393.027-.04c-1.023-.4-2.056-1.083-2.965-1.993-.91-.91-1.592-1.942-1.993-2.965l-.04.027-3.393 2.384a28.3 28.3 0 0 0 5.98 5.98m-1.137-8.962c.313.808.87 1.674 1.658 2.461.787.788 1.653 1.345 2.46 1.658a3.567 3.567 0 0 0-4.118-4.119" clip-rule="evenodd"/>
  </svg>
`;
const Brush = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.25 4.968a.75.75 0 0 1 .782-.717 84 84 0 0 1 7.141.63c1.323.178 2.63.398 3.77.664 1.127.263 2.15.585 2.873.987.228.127.444.275.61.453.164.177.347.461.322.832s-.243.623-.417.766a2.2 2.2 0 0 1-.582.327c-.759.302-2.052.501-3.404.663-.818.098-1.716.187-2.593.275-.594.06-1.178.118-1.723.177q-.416.045-.797.091l.953.142c2.324.342 5.287.777 7.09 1.48.16.064.41.177.585.394a.88.88 0 0 1 .198.551.9.9 0 0 1-.18.532 1.4 1.4 0 0 1-.513.393 4 4 0 0 1-.543.208c-.767.242-1.994.482-3.266.725l-.406.078c-1.175.223-2.39.454-3.412.701a14 14 0 0 0-1.443.413 5 5 0 0 0-.37.15c.295.23.799.507 1.466.801 1.43.631 3.34 1.232 4.669 1.592a.75.75 0 0 1-.393 1.448c-1.361-.37-3.352-.993-4.88-1.668-.75-.33-1.46-.703-1.921-1.102-.222-.192-.478-.467-.58-.828a1.13 1.13 0 0 1 .002-.636c.065-.217.188-.391.327-.527.293-.286.746-.487 1.17-.64a16 16 0 0 1 1.602-.461c1.06-.256 2.312-.494 3.48-.716l.408-.078a75 75 0 0 0 1.951-.392c-1.57-.39-3.545-.681-5.299-.94l-.605-.09c-1.197-.178-2.29-.35-2.908-.545a2.2 2.2 0 0 1-.483-.206c-.098-.06-.459-.292-.473-.755-.015-.48.35-.732.46-.802.159-.102.352-.177.54-.239.76-.247 2.049-.417 3.408-.565.577-.063 1.172-.122 1.767-.182.86-.086 1.722-.171 2.534-.269 1.066-.127 1.954-.264 2.556-.42-.527-.231-1.248-.453-2.12-.657-1.08-.252-2.335-.464-3.63-.64a82 82 0 0 0-7.005-.617.75.75 0 0 1-.717-.78m13.543 8.197-.006-.004zm-.035-.931" clip-rule="evenodd"/>
  </svg>
`;
const Bubble = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M2.25 9A4.75 4.75 0 0 1 7 4.25h10A4.75 4.75 0 0 1 21.75 9v3.798a4.75 4.75 0 0 1-4.75 4.75h-5.873l-3.194 2.999A.75.75 0 0 1 6.67 20v-2.464a4.75 4.75 0 0 1-4.42-4.738zM7 5.75A3.25 3.25 0 0 0 3.75 9v3.798A3.25 3.25 0 0 0 7 16.048h.42a.75.75 0 0 1 .75.75v1.47l2.147-2.017a.75.75 0 0 1 .513-.203H17a3.25 3.25 0 0 0 3.25-3.25V9A3.25 3.25 0 0 0 17 5.75z" clip-rule="evenodd"/>
  </svg>
`;
const BulletedList = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.3 7.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m4.033-1.75a.75.75 0 0 0 0 1.5l11.917.001a.75.75 0 0 0 0-1.5zm0 5.5a.75.75 0 1 0 0 1.5l11.917.002a.75.75 0 1 0 0-1.5zm0 5.5a.75.75 0 1 0 0 1.5l11.917.002a.75.75 0 0 0 0-1.5zM5.3 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 6.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>
  </svg>
`;
const BulletedList01 = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <circle cx="7" cy="12" r="3" fill='currentColor'/>
  </svg>
`;
const BulletedList02 = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M7 14.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5M7 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6" clip-rule="evenodd"/>
  </svg>
`;
const BulletedList03 = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M6.408 9.245a.837.837 0 0 1 1.184 0l2.163 2.163a.837.837 0 0 1 0 1.184l-2.163 2.163a.837.837 0 0 1-1.184 0l-2.163-2.163a.837.837 0 0 1 0-1.184z"/>
  </svg>
`;
const BulletedList04 = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M9.163 12 7 9.837 4.837 12 7 14.163zM7.592 9.245a.837.837 0 0 0-1.184 0l-2.163 2.163a.837.837 0 0 0 0 1.184l2.163 2.163a.837.837 0 0 0 1.184 0l2.163-2.163a.837.837 0 0 0 0-1.184z" clip-rule="evenodd"/>
  </svg>
`;
const CalFullDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#1E96EB" fill-rule="evenodd" d="M12 16.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m0 2.5a7 7 0 1 0 0-14 7 7 0 0 0 0 14" clip-rule="evenodd"/>
  </svg>
`;
const CalTimeDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#1E96EB" d="M10.5 6.5a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0z"/>
  </svg>
`;
const CalendarPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M18.5 10h-13v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zM4 10V6q0-.207.04-.403A2 2 0 0 1 6 4h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z" clip-rule="evenodd"/>
  </svg>
`;
const CalendarXmark = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8 2.75a.75.75 0 0 1 .75.75v.75h6.5V3.5a.75.75 0 0 1 1.5 0v.75H19A2.75 2.75 0 0 1 21.75 7v6a.75.75 0 0 1-1.5 0v-2.75H3.75V19c0 .69.56 1.25 1.25 1.25h6.5a.75.75 0 0 1 0 1.5H5A2.75 2.75 0 0 1 2.25 19V7A2.75 2.75 0 0 1 5 4.25h2.25V3.5A.75.75 0 0 1 8 2.75m-.75 3H5c-.69 0-1.25.56-1.25 1.25v1.75h16.5V7c0-.69-.56-1.25-1.25-1.25h-2.25v.75a.75.75 0 0 1-1.5 0v-.75h-6.5v.75a.75.75 0 0 1-1.5 0zm7.341 10.72a.75.75 0 0 1 1.06 0l1.592 1.59 1.59-1.59a.75.75 0 0 1 1.061 1.06l-1.59 1.591 1.59 1.591a.75.75 0 0 1-1.06 1.061l-1.591-1.591-1.591 1.591a.75.75 0 0 1-1.061-1.06l1.591-1.592-1.591-1.59a.75.75 0 0 1 0-1.061" clip-rule="evenodd"/>
  </svg>
`;
const Camera = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M10.285 5.75c-.35 0-.67.172-.858.45l-.723 1.066a2.54 2.54 0 0 1-2.1 1.109h-.826c-.579 0-1.028.459-1.028 1v7.875c0 .541.449 1 1.028 1h12.444c.579 0 1.028-.459 1.028-1V9.375c0-.541-.449-1-1.028-1h-.826c-.84 0-1.63-.413-2.1-1.109L14.573 6.2a1.03 1.03 0 0 0-.858-.45zm-2.1-.391a2.54 2.54 0 0 1 2.1-1.109h3.43c.84 0 1.63.413 2.1 1.109l.723 1.066c.188.278.509.45.858.45h.826c1.385 0 2.528 1.108 2.528 2.5v7.875c0 1.392-1.143 2.5-2.528 2.5H5.778c-1.385 0-2.528-1.108-2.528-2.5V9.375c0-1.392 1.143-2.5 2.528-2.5h.826c.349 0 .67-.172.858-.45zM12 11c-1.07 0-1.917.85-1.917 1.875S10.93 14.75 12 14.75s1.917-.85 1.917-1.875S13.07 11 12 11m-3.417 1.875C8.583 11 10.124 9.5 12 9.5s3.417 1.5 3.417 3.375S13.876 16.25 12 16.25s-3.417-1.5-3.417-3.375" clip-rule="evenodd"/>
  </svg>
`;
const CameraPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5 6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-2.5l-2.101-2.334a.5.5 0 0 0-.372-.166H9.973a.5.5 0 0 0-.372.166L7.5 6H5m7 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8" clip-rule="evenodd"/>
  </svg>
`;
const CancelWrap = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M16.53 2.47a.75.75 0 1 0-1.06 1.06l2.72 2.72H8a.75.75 0 0 0 0 1.5h10.19l-2.72 2.72a.75.75 0 1 0 1.06 1.06l4-4a.75.75 0 0 0 0-1.06zm-5 9a.75.75 0 1 0-1.06 1.06l2.72 2.72H4.5a.75.75 0 0 0 0 1.5h8.69l-2.72 2.72a.75.75 0 1 0 1.06 1.06l4-4a.75.75 0 0 0 0-1.06z" clip-rule="evenodd"/>
  </svg>
`;
const Caption = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.25 7A2.75 2.75 0 0 1 7 4.25h5A2.75 2.75 0 0 1 14.75 7v3A2.75 2.75 0 0 1 12 12.75H7A2.75 2.75 0 0 1 4.25 10zM7 5.75c-.69 0-1.25.56-1.25 1.25v3c0 .69.56 1.25 1.25 1.25h5c.69 0 1.25-.56 1.25-1.25V7c0-.69-.56-1.25-1.25-1.25zM4.25 15.5a.75.75 0 0 1 .75-.75h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75M5 18.25a.75.75 0 0 0 0 1.5h9a.75.75 0 0 0 0-1.5z" clip-rule="evenodd"/>
  </svg>
`;
const CardPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.5 7.306c0-1.044.846-1.89 1.889-1.89H18.61c1.043 0 1.889.846 1.889 1.89v1.18h-17zm0 2.597h17v7.792a1.89 1.89 0 0 1-1.889 1.888H5.39A1.89 1.89 0 0 1 3.5 17.695zm1.889 7.791h3.778v-1.888H5.389z" clip-rule="evenodd"/>
  </svg>
`;
const Cart2Panel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M10.403 4.913a.5.5 0 0 0-.205-.677l-.881-.472a.5.5 0 0 0-.677.204L5.409 10H2.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h.997l1.412 8h13.576l1.412-8h.603a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-2.515l-3.231-6.032a.5.5 0 0 0-.677-.204l-.881.472a.5.5 0 0 0-.205.677L15.716 10H7.678z" clip-rule="evenodd"/>
  </svg>
`;
const CartPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M2.312 4a.812.812 0 0 0 0 1.624h2.7l1.71 12.486a.81.81 0 0 0 .804.702h2.133a1.419 1.419 0 1 0 1.106 0h5.986a1.419 1.419 0 1 0 1.106 0H21a.812.812 0 1 0 0-1.624H8.234l-.21-1.537 11.185-1.075c.47-.045.858-.391.955-.854L21.52 7.3a1.082 1.082 0 0 0-1.06-1.306H6.703l-.177-1.292A.81.81 0 0 0 5.721 4z"/>
  </svg>
`;
const CategoryPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6 4a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 9a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2zm7-7a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2zm2 7a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2z" clip-rule="evenodd"/>
  </svg>
`;
const CenterPeek = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5 4.75a.25.25 0 0 0-.25.25v2a.75.75 0 0 1-1.5 0V5c0-.966.784-1.75 1.75-1.75h2a.75.75 0 0 1 0 1.5zM16.25 4a.75.75 0 0 1 .75-.75h2c.966 0 1.75.784 1.75 1.75v2a.75.75 0 0 1-1.5 0V5a.25.25 0 0 0-.25-.25h-2a.75.75 0 0 1-.75-.75m-9 5.1c0-.47.38-.85.85-.85h7.8c.47 0 .85.38.85.85v5.8c0 .47-.38.85-.85.85H8.1a.85.85 0 0 1-.85-.85zm1.5.65v4.5h6.5v-4.5zM4 16.25a.75.75 0 0 1 .75.75v2c0 .138.112.25.25.25h2a.75.75 0 0 1 0 1.5H5A1.75 1.75 0 0 1 3.25 19v-2a.75.75 0 0 1 .75-.75m16 0a.75.75 0 0 1 .75.75v2A1.75 1.75 0 0 1 19 20.75h-2a.75.75 0 0 1 0-1.5h2a.25.25 0 0 0 .25-.25v-2a.75.75 0 0 1 .75-.75" clip-rule="evenodd"/>
  </svg>
`;
const ChartPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M20.483 12.03a.506.506 0 0 0-.514-.53H12.53a.53.53 0 0 1-.531-.531V3.53a.506.506 0 0 0-.53-.514 8.5 8.5 0 1 0 9.013 9.014m-6.359-9.01a.5.5 0 0 0-.53.511v5.844c0 .293.238.531.531.531h5.844a.5.5 0 0 0 .51-.53 6.906 6.906 0 0 0-6.354-6.356" clip-rule="evenodd"/>
  </svg>
`;
const ChatPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M6.065 4C4.925 4 4 4.924 4 6.065v7.225c0 1.14.924 2.065 2.065 2.065v3.399c0 .46.555.69.88.365l3.765-3.764h7.742c1.14 0 2.064-.925 2.064-2.065V6.065c0-1.14-.924-2.065-2.064-2.065z"/>
  </svg>
`;
const ChatWithAi = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.755 7.913C2.741 6.996 3.35 5.25 4.765 5.25h14.237c1.18 0 1.878 1.279 1.317 2.278l-6.982 12.447c-.685 1.221-2.484.937-2.792-.408l-1.595-6.96zm6.727 4.667 1.525 6.652.005.016.01.002.006-.009L18.312 8.04zm7.064-5.83H4.761l-.007.013a.1.1 0 0 0-.004.025l.01.012 4.965 4.486z" clip-rule="evenodd"/>
  </svg>
`;
const CheckBoxCheckLinear = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6 3.25A2.75 2.75 0 0 0 3.25 6v12A2.75 2.75 0 0 0 6 20.75h12A2.75 2.75 0 0 0 20.75 18V6A2.75 2.75 0 0 0 18 3.25zM4.75 6c0-.69.56-1.25 1.25-1.25h12c.69 0 1.25.56 1.25 1.25v12c0 .69-.56 1.25-1.25 1.25H6c-.69 0-1.25-.56-1.25-1.25zm11.78 3.53a.75.75 0 0 0-1.06-1.06l-4.97 4.97-1.47-1.47a.75.75 0 0 0-1.06 1.06l2 2a.75.75 0 0 0 1.06 0z" clip-rule="evenodd"/>
  </svg>
`;
const CheckBoxCheckSolid = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.25 6A2.75 2.75 0 0 1 6 3.25h12A2.75 2.75 0 0 1 20.75 6v12A2.75 2.75 0 0 1 18 20.75H6A2.75 2.75 0 0 1 3.25 18zm13.28 3.53a.75.75 0 0 0-1.06-1.06l-4.97 4.97-1.47-1.47a.75.75 0 0 0-1.06 1.06l2 2a.75.75 0 0 0 1.06 0z" clip-rule="evenodd"/>
  </svg>
`;
const CheckBoxIntermediate = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.25 6A2.75 2.75 0 0 1 6 3.25h12A2.75 2.75 0 0 1 20.75 6v12A2.75 2.75 0 0 1 18 20.75H6A2.75 2.75 0 0 1 3.25 18zM8 11.25a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5z" clip-rule="evenodd"/>
  </svg>
`;
const CheckBoxUn = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6 3.25A2.75 2.75 0 0 0 3.25 6v12A2.75 2.75 0 0 0 6 20.75h12A2.75 2.75 0 0 0 20.75 18V6A2.75 2.75 0 0 0 18 3.25zM4.75 6c0-.69.56-1.25 1.25-1.25h12c.69 0 1.25.56 1.25 1.25v12c0 .69-.56 1.25-1.25 1.25H6c-.69 0-1.25-.56-1.25-1.25z" clip-rule="evenodd"/>
  </svg>
`;
const ChemicalPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M16 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8m-5 .5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m7 5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" clip-rule="evenodd"/>
  </svg>
`;
const CirclePanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 20.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17M8.547 12a3.453 3.453 0 1 1 6.906 0 3.453 3.453 0 0 1-6.906 0M12 6.953a5.047 5.047 0 1 0 0 10.094 5.047 5.047 0 0 0 0-10.094" clip-rule="evenodd"/>
  </svg>
`;
const Client = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M7.25 5.5H5a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h2.25zm1.5 0v2.75H19.5V6a.5.5 0 0 0-.5-.5zm0 4.25v8.75H19a.5.5 0 0 0 .5-.5V9.75zm0 10.25H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2z" clip-rule="evenodd"/>
  </svg>
`;
const Close = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>
  </svg>
`;
const CloudBubble = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="m7.704 10.46-3.136.512c-.83.136-1.068.64-1.068 1.028 0 .387.238.892 1.068 1.028l3.136.512-1.912 2.485c-.214.278-.232.488-.21.634.025.174.13.391.35.59.446.401 1.153.55 1.819.135l2.385-1.486.548 2.712c.1.5.558.89 1.316.89s1.215-.39 1.316-.89l.548-2.712 2.385 1.486c.666.415 1.373.266 1.819-.135.22-.199.325-.416.35-.59.022-.146.004-.356-.21-.634l-1.912-2.484 3.136-.513c.83-.136 1.068-.64 1.068-1.028 0-.387-.238-.892-1.068-1.028l-3.136-.512 1.912-2.485c.214-.278.232-.488.21-.634-.025-.174-.13-.391-.35-.59-.446-.401-1.153-.55-1.819-.135l-2.385 1.486-.548-2.712c-.1-.5-.558-.89-1.316-.89s-1.215.39-1.316.89l-.548 2.712-2.385-1.486c-.666-.415-1.373-.266-1.819.135-.22.199-.325.416-.35.59-.022.146-.004.356.21.634zm-4.305-.675q.052-.027.107-.051.366-.167.82-.242l.658-.108-.38-.494A2.6 2.6 0 0 1 4.15 8c-.496-1.829 1.521-3.586 3.556-3.027q.423.114.837.37l.55.342.12-.591a2.5 2.5 0 0 1 .354-.88c1.05-1.618 3.814-1.618 4.864 0 .165.253.287.546.355.88l.12.591.549-.342q.414-.256.837-.37c2.035-.56 4.052 1.198 3.556 3.028-.08.297-.228.597-.452.889l-.38.494.657.108a3.3 3.3 0 0 1 .927.293 2.453 2.453 0 0 1 0 4.43l-.107.051a3.3 3.3 0 0 1-.82.242l-.658.108.38.494c.225.292.373.592.453.89.496 1.829-1.521 3.586-3.556 3.027a3.2 3.2 0 0 1-.837-.37l-.55-.342-.12.591a2.5 2.5 0 0 1-.354.88c-1.05 1.618-3.814 1.618-4.864 0a2.5 2.5 0 0 1-.355-.88l-.12-.591-.549.342a3.2 3.2 0 0 1-.837.37c-2.035.56-4.052-1.198-3.556-3.028.08-.297.228-.597.452-.889l.38-.494-.657-.108a3.3 3.3 0 0 1-.927-.293 2.453 2.453 0 0 1 0-4.43" clip-rule="evenodd"/>
  </svg>
`;
const CloudWorkspace = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M11 5.75a4.25 4.25 0 0 0-4.147 5.183.75.75 0 0 1-.568.896A3.252 3.252 0 0 0 7 18.25h9a4.25 4.25 0 1 0-.085-8.5.75.75 0 0 1-.75-.6A4.25 4.25 0 0 0 11 5.75M5.25 10a5.75 5.75 0 0 1 11.235-1.73A5.75 5.75 0 0 1 16 19.75H7a4.75 4.75 0 0 1-1.722-9.178A6 6 0 0 1 5.25 10" clip-rule="evenodd"/>
  </svg>
`;
const Cloudy2Panel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5.478 18a3.478 3.478 0 1 1 0-6.956 4.348 4.348 0 0 1 8.613-.85 3.044 3.044 0 0 1 2.653 3.51q.228-.051.473-.052a2.174 2.174 0 0 1 0 4.348zM20.5 10A3 3 0 0 1 18 12.96a4 4 0 0 0-3.347-3.906A3.001 3.001 0 0 1 20.5 10" clip-rule="evenodd"/>
  </svg>
`;
const CloudyPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M2 14a4 4 0 0 0 4 4h13.5a2.5 2.5 0 1 0-.544-4.94q.044-.275.044-.56a3.5 3.5 0 0 0-3.095-3.477A5.002 5.002 0 0 0 6 10a4 4 0 0 0-4 4" clip-rule="evenodd"/>
  </svg>
`;
const Code = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M13.982 4.272a.75.75 0 0 1 .546.91l-3.6 14.4a.75.75 0 1 1-1.456-.364l3.6-14.4a.75.75 0 0 1 .91-.546M7.13 8.07a.75.75 0 0 1 0 1.06L4.06 12.2l3.07 3.07a.75.75 0 0 1-1.06 1.06l-3.6-3.6a.75.75 0 0 1 0-1.06l3.6-3.6a.75.75 0 0 1 1.06 0m9.74 0a.75.75 0 0 1 1.06 0l3.6 3.6a.75.75 0 0 1 0 1.06l-3.6 3.6a.75.75 0 1 1-1.06-1.06l3.07-3.07-3.07-3.07a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>
  </svg>
`;
const CodeBlock = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M2.25 6A2.75 2.75 0 0 1 5 3.25h14A2.75 2.75 0 0 1 21.75 6v12A2.75 2.75 0 0 1 19 20.75H5A2.75 2.75 0 0 1 2.25 18zM5 4.75c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V6c0-.69-.56-1.25-1.25-1.25zm5.53 4.62a.75.75 0 0 1 0 1.06l-1.59 1.591 1.59 1.591a.75.75 0 0 1-1.06 1.06l-2.122-2.12a.75.75 0 0 1 0-1.061L9.47 9.37a.75.75 0 0 1 1.06 0m2.94 1.06a.75.75 0 1 1 1.06-1.06l2.122 2.12a.75.75 0 0 1 0 1.062l-2.122 2.12a.75.75 0 1 1-1.06-1.06l1.59-1.59z" clip-rule="evenodd"/>
  </svg>
`;
const CodePanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm1.416 8.376a.75.75 0 1 0-.832 1.248L8.648 15l-2.064 1.376a.75.75 0 1 0 .832 1.248l3-2a.75.75 0 0 0 0-1.248z" clip-rule="evenodd"/>
  </svg>
`;
const CoinPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M13.763 5.754A8.1 8.1 0 0 0 6.911 16.03 6.302 6.302 0 0 1 9.3 3.9a6.28 6.28 0 0 1 4.463 1.854"/><path fill='currentColor' d="M21 13.8a6.3 6.3 0 1 1-12.6 0 6.3 6.3 0 0 1 12.6 0"/>
  </svg>
`;
const Collaboration = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 5.55a1.95 1.95 0 1 0 0 3.9 1.95 1.95 0 0 0 0-3.9M8.55 7.5a3.45 3.45 0 1 1 6.9 0 3.45 3.45 0 0 1-6.9 0M5.7 9.15a1.05 1.05 0 1 0 0 2.1 1.05 1.05 0 0 0 0-2.1M3.15 10.2a2.55 2.55 0 1 1 5.1 0 2.55 2.55 0 0 1-5.1 0M18.3 9.15a1.05 1.05 0 1 0 0 2.1 1.05 1.05 0 0 0 0-2.1m-2.55 1.05a2.55 2.55 0 1 1 5.1 0 2.55 2.55 0 0 1-5.1 0M12 13.65a3.75 3.75 0 0 0-3.75 3.75v1.05h7.5V17.4A3.752 3.752 0 0 0 12 13.65m5.25 4.8h2.85a.15.15 0 0 0 .15-.15v-.9a1.95 1.95 0 0 0-3.213-1.485c.139.471.213.97.213 1.485zm-.857-3.925A5.25 5.25 0 0 0 12 12.15a5.25 5.25 0 0 0-4.393 2.375A3.45 3.45 0 0 0 2.25 17.4v.9c0 .911.739 1.65 1.65 1.65h16.2a1.65 1.65 0 0 0 1.65-1.65v-.9a3.45 3.45 0 0 0-5.357-2.875m-9.43 1.39A1.95 1.95 0 0 0 3.75 17.4v.9c0 .083.067.15.15.15h2.85V17.4c0-.515.074-1.014.213-1.485" clip-rule="evenodd"/>
  </svg>
`;
const Collapse = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M7.53 3.47a.75.75 0 0 0-1.06 1.06l5 5a.75.75 0 0 0 1.06 0l5-5a.75.75 0 0 0-1.06-1.06L12 7.94zm0 17.06a.75.75 0 0 1-1.06-1.06l5-5a.75.75 0 0 1 1.06 0l5 5a.75.75 0 1 1-1.06 1.06L12 16.06z" clip-rule="evenodd"/>
  </svg>
`;
const CollapseTab = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M14.91 5.884a.75.75 0 0 0-.75-.75H4.014a.75.75 0 0 0 0 1.5H14.16a.75.75 0 0 0 .75-.75M14.91 10.196a.75.75 0 0 0-.75-.75H4.014a.75.75 0 0 0 0 1.5H14.16a.75.75 0 0 0 .75-.75M14.16 13.758a.75.75 0 1 1 0 1.5H4.014a.75.75 0 0 1 0-1.5zM9.91 18.82a.75.75 0 0 0-.75-.75H4.06a.75.75 0 0 0 0 1.5H9.16a.75.75 0 0 0 .75-.75M21 10.514v3.597c0 .441-.486.71-.86.476l-2.877-1.798a.562.562 0 0 1 0-.953l2.877-1.798a.562.562 0 0 1 .86.476"/>
  </svg>
`;
const CollectPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M5 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v14.057a1 1 0 0 1-1.581.814L12 16l-5.419 3.87A1 1 0 0 1 5 19.058z"/>
  </svg>
`;
const Collections = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M9 4.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5zM6.25 8A.75.75 0 0 1 7 7.25h10a.75.75 0 0 1 0 1.5H7A.75.75 0 0 1 6.25 8m-2 5A2.75 2.75 0 0 1 7 10.25h10A2.75 2.75 0 0 1 19.75 13v5A2.75 2.75 0 0 1 17 20.75H7A2.75 2.75 0 0 1 4.25 18zM7 11.75c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25v-5c0-.69-.56-1.25-1.25-1.25z" clip-rule="evenodd"/>
  </svg>
`;
const ColorPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M18.5 12a6.5 6.5 0 0 1-6.5 6.5v-13a6.5 6.5 0 0 1 6.5 6.5m2 0a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0" clip-rule="evenodd"/>
  </svg>
`;
const ColorPicker = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M20.607 3.637a2.57 2.57 0 0 0-3.636 0l-1.667 1.666a2.57 2.57 0 0 1-3.251.318c-.23-.154-.544-.16-.74.036l-.656.656a.5.5 0 0 0 0 .708l1.394 1.393-7.39 7.39a2.75 2.75 0 0 0-.456 3.285l-1.043 1.043a.75.75 0 1 0 1.06 1.06l1.043-1.043a2.75 2.75 0 0 0 3.286-.457l7.389-7.389 1.283 1.284a.5.5 0 0 0 .707 0l.657-.657c.195-.195.19-.51.036-.739-.672-1-.567-2.367.317-3.251l1.667-1.667a2.57 2.57 0 0 0 0-3.636M5.722 16.864l7.39-7.389 1.767 1.768-7.389 7.389a1.25 1.25 0 0 1-1.768-1.768" clip-rule="evenodd"/>
  </svg>
`;
const Comment = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12.5 3.75a7.75 7.75 0 0 0-7.022 11.033.85.85 0 0 1 .068.5l-.634 3.805 3.804-.634a.85.85 0 0 1 .5.068A7.75 7.75 0 1 0 12.5 3.75M3.25 11.5a9.25 9.25 0 1 1 5.517 8.466l-4.506.75a.85.85 0 0 1-.978-.977l.751-4.506A9.2 9.2 0 0 1 3.25 11.5" clip-rule="evenodd"/>
  </svg>
`;
const CommentDuodone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#ED3F3F" d="M21.75 5.25a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/><path fill="#7A7A7A" fill-rule="evenodd" d="M21.302 8.649A9.25 9.25 0 0 1 8.767 19.966l-4.506.75a.85.85 0 0 1-.978-.977l.751-4.506A9.25 9.25 0 0 1 15.351 2.698a4.2 4.2 0 0 0-.682 1.36 7.75 7.75 0 0 0-9.192 10.725.85.85 0 0 1 .07.5l-.635 3.805 3.804-.634a.85.85 0 0 1 .5.068A7.75 7.75 0 0 0 19.942 9.33a4.2 4.2 0 0 0 1.361-.681" clip-rule="evenodd"/>
  </svg>
`;
const Compress = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M14.989 9.742a.75.75 0 0 1-.75-.75V4.978a.75.75 0 0 1 1.5 0v2.203l3.736-3.736a.75.75 0 0 1 1.06 1.06L16.8 8.242h2.203a.75.75 0 0 1 0 1.5zm0 4.491a.75.75 0 0 0-.75.75v4.014a.75.75 0 1 0 1.5 0v-2.203l3.736 3.736a.75.75 0 0 0 1.06-1.06L16.8 15.733h2.203a.75.75 0 0 0 0-1.5zm-5.328.75a.75.75 0 0 0-.75-.75H4.898a.75.75 0 0 0 0 1.5h2.203L3.364 19.47a.75.75 0 1 0 1.061 1.06l3.736-3.736v2.203a.75.75 0 1 0 1.5 0zm-.75-5.241a.75.75 0 0 0 .75-.75V4.978a.75.75 0 1 0-1.5 0v2.203L4.425 3.445a.75.75 0 1 0-1.06 1.06L7.1 8.242H4.898a.75.75 0 0 0 0 1.5z" clip-rule="evenodd"/>
  </svg>
`;
const Computer2Panel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm5.85 1a.65.65 0 0 1 .65-.65h3a.65.65 0 1 1 0 1.3h-3A.65.65 0 0 1 9.85 6M4 17.725a.775.775 0 0 0 0 1.55h16a.775.775 0 0 0 0-1.55z" clip-rule="evenodd"/>
  </svg>
`;
const ComputerPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M17.5 6h-11v8h11zm-11-2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm4.42 12.902a.5.5 0 0 1 .49-.402h1.18a.5.5 0 0 1 .49.402l.285 1.422c.618.323 1.046.858 1.123 1.476.013.11-.077.2-.188.2H9.7c-.11 0-.201-.09-.188-.2.077-.618.505-1.153 1.123-1.476z" clip-rule="evenodd"/>
  </svg>
`;
const ConfusePanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m-3-8c.552 0 1-.672 1-1.5S9.552 9 9 9s-1 .672-1 1.5.448 1.5 1 1.5m7-1.5c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5.448-1.5 1-1.5 1 .672 1 1.5m-.803 4.224a.75.75 0 1 0-.394-1.448l-5.5 1.5a.75.75 0 0 0 .394 1.448z" clip-rule="evenodd"/>
  </svg>
`;
const ConnectorC = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M15.97 2.02a.75.75 0 0 1 1.06 0l4.88 4.879a.85.85 0 0 1 0 1.202l-4.88 4.88a.75.75 0 1 1-1.06-1.062l3.67-3.669H18c-3.151 0-4.552.758-5.25 1.662-.745.963-.873 2.28-1.002 3.898l-.008.101c-.119 1.486-.259 3.245-1.303 4.595C9.323 19.946 7.349 20.75 4 20.75a.75.75 0 0 1 0-1.5c3.151 0 4.552-.758 5.25-1.662.745-.963.873-2.28 1.002-3.898l.008-.101c.119-1.486.259-3.245 1.303-4.595C12.677 7.554 14.651 6.75 18 6.75h1.64l-3.67-3.67a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>
  </svg>
`;
const ConnectorE = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M17.03 2.02a.75.75 0 1 0-1.06 1.06l3.67 3.67H14a2.75 2.75 0 0 0-2.75 2.75V18c0 .69-.56 1.25-1.25 1.25H3a.75.75 0 0 0 0 1.5h7A2.75 2.75 0 0 0 12.75 18V9.5c0-.69.56-1.25 1.25-1.25h5.64l-3.67 3.67a.75.75 0 1 0 1.06 1.06l4.88-4.879a.85.85 0 0 0 0-1.202z"/>
  </svg>
`;
const ConnectorL = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M13 3.25a.75.75 0 0 0 0 1.5h5.19L3.47 19.47a.75.75 0 1 0 1.06 1.06L19.25 5.81V11a.75.75 0 0 0 1.5 0V4.1a.85.85 0 0 0-.85-.85z"/>
  </svg>
`;
const ContactWithUs = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M8.5 10.8a1 1 0 1 0 0-2 1 1 0 0 0 0 2M13 9.8a1 1 0 1 1-2 0 1 1 0 0 1 2 0M15.5 10.8a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/><path fill='currentColor' fill-rule="evenodd" d="M6.286 2.964A3.036 3.036 0 0 0 3.25 6v7.5a3.036 3.036 0 0 0 3.036 3.036H7.82v3.821a.75.75 0 0 0 1.28.53l4.352-4.351h4.261A3.036 3.036 0 0 0 20.75 13.5V6a3.036 3.036 0 0 0-3.036-3.036zM4.75 6c0-.848.688-1.536 1.536-1.536h11.428c.848 0 1.536.688 1.536 1.536v7.5c0 .848-.688 1.536-1.536 1.536h-4.571a.75.75 0 0 0-.53.22l-3.292 3.29v-2.76a.75.75 0 0 0-.75-.75H6.286A1.536 1.536 0 0 1 4.75 13.5z" clip-rule="evenodd"/>
  </svg>
`;
const Convert = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8.192 4.25a.75.75 0 1 0 0 1.5h8.539c.69 0 1.25.56 1.25 1.25v7.728l-1.605-1.604a.75.75 0 0 0-1.06 1.06L18.2 17.07a.75.75 0 0 0 1.06 0l2.885-2.885a.75.75 0 0 0-1.06-1.06l-1.605 1.604V7a2.75 2.75 0 0 0-2.75-2.75zm7.231 15.5a.75.75 0 0 0 0-1.5H6.885c-.69 0-1.25-.56-1.25-1.25V9.272l1.604 1.604a.75.75 0 1 0 1.06-1.06L5.416 6.93a.75.75 0 0 0-1.06 0L1.47 9.816a.75.75 0 0 0 1.06 1.06l1.605-1.604V17a2.75 2.75 0 0 0 2.75 2.75z" clip-rule="evenodd"/>
  </svg>
`;
const Copy = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.25 6A2.75 2.75 0 0 1 6 3.25h8A2.75 2.75 0 0 1 16.75 6v1.25H18A2.75 2.75 0 0 1 20.75 10v8A2.75 2.75 0 0 1 18 20.75h-8A2.75 2.75 0 0 1 7.25 18v-1.25H6A2.75 2.75 0 0 1 3.25 14zm5.5 12c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25v-8c0-.69-.56-1.25-1.25-1.25h-8c-.69 0-1.25.56-1.25 1.25zm6.5-10.75H10A2.75 2.75 0 0 0 7.25 10v5.25H6c-.69 0-1.25-.56-1.25-1.25V6c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25z" clip-rule="evenodd"/>
  </svg>
`;
const CopyAsImgae = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M2.75 5A2.25 2.25 0 0 1 5 2.75h9A2.25 2.25 0 0 1 16.25 5v2.75H19A2.25 2.25 0 0 1 21.25 10v9A2.25 2.25 0 0 1 19 21.25h-9A2.25 2.25 0 0 1 7.75 19v-2.75H5A2.25 2.25 0 0 1 2.75 14zm12 0v2.75H10A2.25 2.25 0 0 0 7.75 10v4.75H5a.75.75 0 0 1-.75-.75V5A.75.75 0 0 1 5 4.25h9a.75.75 0 0 1 .75.75m-5.5 12.81V19c0 .414.336.75.75.75h9a.75.75 0 0 0 .75-.75v-2.69l-.97-.969a.75.75 0 0 0-1.06 0l-.66.659.97.97a.75.75 0 1 1-1.06 1.06l-1.5-1.5-1.94-1.939a.75.75 0 0 0-1.06 0zM16 14.94l-1.409-1.41a2.25 2.25 0 0 0-3.182 0L9.25 15.69V10a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 .75.75v4.194a2.25 2.25 0 0 0-3.091.086zm-.15-2.74a.85.85 0 1 0 0-1.7.85.85 0 0 0 0 1.7" clip-rule="evenodd"/>
  </svg>
`;
const Corner = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M4.8 3.25H3.25V4.8h1.5v-.05h.05zM8 3.25H6.4v1.5H8zM9.6 3.25v1.5H16A3.25 3.25 0 0 1 19.25 8v6.4h1.5V8A4.75 4.75 0 0 0 16 3.25zM3.25 6.4V8h1.5V6.4zM3.25 9.6v1.6h1.5V9.6zM3.25 12.8v1.6h1.5v-1.6zM20.75 17.6V16h-1.5v1.6zM3.25 16v1.6h1.5V16zM20.75 20.75V19.2h-1.5v.05h-.05v1.5zM4.75 19.2h-1.5v1.55H4.8v-1.5h-.05zM6.4 20.75H8v-1.5H6.4zM9.6 20.75h1.6v-1.5H9.6zM12.8 20.75h1.6v-1.5h-1.6zM16 20.75h1.6v-1.5H16z"/>
  </svg>
`;
const Created = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8.75 3.5a.75.75 0 0 0-1.5 0v.75H5A2.75 2.75 0 0 0 2.25 7v12A2.75 2.75 0 0 0 5 21.75h6.5a.75.75 0 0 0 0-1.5H5c-.69 0-1.25-.56-1.25-1.25v-8.75h16.5v1.25a.75.75 0 0 0 1.5 0V7A2.75 2.75 0 0 0 19 4.25h-2.25V3.5a.75.75 0 0 0-1.5 0v.75h-6.5zm6.5 3v-.75h-6.5v.75a.75.75 0 0 1-1.5 0v-.75H5c-.69 0-1.25.56-1.25 1.25v1.75h16.5V7c0-.69-.56-1.25-1.25-1.25h-2.25v.75a.75.75 0 0 1-1.5 0m4.78 6.97a.75.75 0 0 0-1.06 0l-5.098 5.098a.75.75 0 0 0-.22.531l.004 2.224a.75.75 0 0 0 .749.75l2.224.003c.2 0 .39-.079.531-.22l5.098-5.098a.75.75 0 0 0 0-1.06zm-4.878 5.938 4.348-4.347 1.167 1.167-4.347 4.347-1.165-.002z" clip-rule="evenodd"/>
  </svg>
`;
const Crop = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6.667 3.25a.75.75 0 0 1 .75.75v10.489c0 .51 0 .848.021 1.106.02.25.057.36.09.427.1.194.256.35.45.45.067.033.176.07.427.09.258.02.596.021 1.106.021h5.156a.75.75 0 0 1 0 1.5H9.48c-.472 0-.871 0-1.199-.026-.342-.028-.672-.09-.985-.25a2.53 2.53 0 0 1-1.105-1.104c-.16-.313-.22-.643-.249-.985a16 16 0 0 1-.026-1.2V7.418H4a.75.75 0 0 1 0-1.5h1.917V4a.75.75 0 0 1 .75-.75m8.929 4.188a15 15 0 0 0-1.107-.021H9.333a.75.75 0 0 1 0-1.5h5.186c.472 0 .871 0 1.199.026.342.028.672.09.985.25.476.242.863.628 1.105 1.104.16.313.22.643.249.985.026.328.026.727.026 1.2v7.101H20a.75.75 0 0 1 0 1.5h-1.917V20a.75.75 0 0 1-1.5 0V9.511c0-.51 0-.848-.021-1.106-.02-.25-.057-.36-.09-.427a1.03 1.03 0 0 0-.45-.45c-.067-.033-.176-.07-.426-.09" clip-rule="evenodd"/>
  </svg>
`;
const CrossedCircle = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5.41 6.47a8.22 8.22 0 0 0-1.91 5.28c0 2.008.717 3.849 1.91 5.28l5.28-5.28zm1.06-1.06 5.28 5.28 5.28-5.28a8.22 8.22 0 0 0-5.28-1.91 8.22 8.22 0 0 0-5.28 1.91m11.62 1.06-5.28 5.28 5.28 5.28A8.22 8.22 0 0 0 20 11.75a8.22 8.22 0 0 0-1.91-5.28m-1.06 11.62-5.28-5.28-5.28 5.28A8.22 8.22 0 0 0 11.75 20a8.22 8.22 0 0 0 5.28-1.91M2 11.75C2 6.365 6.365 2 11.75 2s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2 17.135 2 11.75" clip-rule="evenodd"/>
  </svg>
`;
const CubePanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M11.553 3.106a1 1 0 0 1 .894 0l7.135 3.567a1 1 0 0 1 .553.895v9.81a1 1 0 0 1-.6.916l-7.134 3.122a1 1 0 0 1-.802 0l-7.135-3.122a1 1 0 0 1-.6-.916v-9.81a1 1 0 0 1 .554-.895zm-5.688 6.08v7.538L11 18.971v-7.218zM13 11.753v7.218l5.135-2.247V9.186zm3.899-4.185-4.9 2.45-4.898-2.45L12 5.118z" clip-rule="evenodd"/>
  </svg>
`;
const CurveLine = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12.95 6.066C14.2 4.301 16.353 3.25 20 3.25a.75.75 0 0 1 0 1.5c-3.352 0-4.95.949-5.825 2.184-.933 1.317-1.175 3.11-1.43 5.159l-.013.098c-.24 1.927-.51 4.088-1.682 5.742C9.8 19.7 7.648 20.75 4 20.75a.75.75 0 0 1 0-1.5c3.352 0 4.95-.949 5.825-2.183.933-1.318 1.175-3.11 1.43-5.16l.013-.098c.24-1.927.51-4.088 1.682-5.743" clip-rule="evenodd"/>
  </svg>
`;
const CustomSize = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.25 6A2.75 2.75 0 0 1 6 3.25h2.5a.75.75 0 0 1 0 1.5H6c-.69 0-1.25.56-1.25 1.25v2.5a.75.75 0 0 1-1.5 0zm11.5-2a.75.75 0 0 1 .75-.75H18A2.75 2.75 0 0 1 20.75 6v2.5a.75.75 0 0 1-1.5 0V6c0-.69-.56-1.25-1.25-1.25h-2.5a.75.75 0 0 1-.75-.75M4 14.75a.75.75 0 0 1 .75.75V18c0 .69.56 1.25 1.25 1.25h3a.75.75 0 0 1 0 1.5H6A2.75 2.75 0 0 1 3.25 18v-2.5a.75.75 0 0 1 .75-.75m16 0a.75.75 0 0 1 .75.75V18A2.75 2.75 0 0 1 18 20.75h-3a.75.75 0 0 1 0-1.5h3c.69 0 1.25-.56 1.25-1.25v-2.5a.75.75 0 0 1 .75-.75M7.25 9c0-.966.784-1.75 1.75-1.75h6c.966 0 1.75.784 1.75 1.75v6A1.75 1.75 0 0 1 15 16.75H9A1.75 1.75 0 0 1 7.25 15zM9 8.75a.25.25 0 0 0-.25.25v6c0 .138.112.25.25.25h6a.25.25 0 0 0 .25-.25V9a.25.25 0 0 0-.25-.25z" clip-rule="evenodd"/>
  </svg>
`;
const CustomizedHeight = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.25 12a.75.75 0 0 1 .75-.75h16a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75M12.53 10.53a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 1.06-1.06L12 8.94l2.47-2.47a.75.75 0 1 1 1.06 1.06zM15.53 17.53a.75.75 0 0 1-1.06 0L12 15.06l-2.47 2.47a.75.75 0 0 1-1.06-1.06l3-3a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1 0 1.06" clip-rule="evenodd"/><path fill='currentColor' fill-rule="evenodd" d="M12 2.25a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75M11.25 21v-7h1.5v7a.75.75 0 0 1-1.5 0" clip-rule="evenodd"/>
  </svg>
`;
const Cylinder = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.267 5H19.08l.036.004c.387.037.722.26.983.54.268.288.508.688.71 1.204.402 1.03.691 2.619.691 5.002s-.29 3.973-.692 5.002q-.303.773-.71 1.204c-.26.28-.595.503-.982.54l-.036.004H4.267l-.108-.033c-.337-.104-.624-.351-.853-.642-.238-.304-.46-.71-.65-1.23C2.278 15.557 2 14.005 2 11.75s.277-3.807.657-4.845c.19-.52.41-.926.65-1.23.228-.29.515-.538.852-.642zm14.756 11.91c.104-.12.245-.337.388-.704.31-.79.589-2.173.589-4.456s-.28-3.666-.589-4.456c-.143-.367-.284-.584-.388-.703-.092.108-.219.304-.35.635-.306.776-.587 2.17-.587 4.524s.281 3.748.588 4.524c.13.33.257.527.35.636M17.351 6.5l-.072.174c-.405 1.024-.693 2.63-.693 5.076s.288 4.052.693 5.076q.034.09.072.174H4.576a1 1 0 0 1-.09-.103c-.119-.15-.27-.407-.42-.817-.3-.82-.566-2.184-.566-4.33s.266-3.51.565-4.33c.15-.41.302-.667.42-.817q.056-.07.091-.103z" clip-rule="evenodd"/>
  </svg>
`;
const DarkMode = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M10.33 3.47a.75.75 0 0 1 .187.748 7.425 7.425 0 0 0 9.265 9.265.75.75 0 0 1 .936.934A8.925 8.925 0 1 1 9.582 3.282a.75.75 0 0 1 .747.188M8.772 5.223a7.425 7.425 0 1 0 10.005 10.004A8.925 8.925 0 0 1 8.772 5.223" clip-rule="evenodd"/>
  </svg>
`;
const DashLine = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M20.53 3.53a.75.75 0 0 1 0 1.061l-3.19 3.19a.75.75 0 0 1-1.06-1.061l3.19-3.19a.75.75 0 0 1 1.06 0m-6.375 6.375a.75.75 0 0 1 0 1.061l-3.19 3.19a.75.75 0 0 1-1.06-1.061l3.19-3.19a.75.75 0 0 1 1.06 0M7.78 17.341a.75.75 0 0 0-1.06-1.06L3.53 19.47a.75.75 0 1 0 1.06 1.06z" clip-rule="evenodd"/>
  </svg>
`;
const Data2Panel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M11.53 10.588c4.158 0 7.529-1.475 7.529-3.294 0-1.82-3.371-3.294-7.53-3.294C7.371 4 4 5.475 4 7.294c0 1.82 3.371 3.294 7.53 3.294m6.804 0c-1.208 1.113-3.801 1.883-6.805 1.883s-5.596-.77-6.804-1.883C4.26 11.016 4 11.495 4 12c0 1.82 3.371 3.294 7.53 3.294 4.158 0 7.529-1.475 7.529-3.294 0-.505-.26-.984-.725-1.412m0 4.706c-1.208 1.113-3.801 1.883-6.805 1.883s-5.596-.77-6.804-1.883c-.465.428-.725.907-.725 1.412C4 18.526 7.371 20 11.53 20c4.158 0 7.529-1.475 7.529-3.294 0-.505-.26-.984-.725-1.412" clip-rule="evenodd"/>
  </svg>
`;
const DataPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3 4.714c0-.67.544-1.214 1.214-1.214h14.572c.67 0 1.214.544 1.214 1.214v2.429c0 .67-.544 1.214-1.214 1.214H4.214C3.544 8.357 3 7.813 3 7.143zM4.428 5.93a1 1 0 1 0 2 0 1 1 0 0 0-2 0m-.214 3.643c-.67 0-1.214.543-1.214 1.214v2.428c0 .671.544 1.215 1.214 1.215h14.572c.67 0 1.214-.544 1.214-1.215v-2.428c0-.67-.544-1.214-1.214-1.214zM5.43 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-1.215 2.5c-.67 0-1.214.544-1.214 1.214v2.429c0 .67.544 1.214 1.214 1.214h14.572c.67 0 1.214-.543 1.214-1.214v-2.429c0-.67-.544-1.214-1.214-1.214zm1.215 3.429a1 1 0 1 1 0-2 1 1 0 0 1 0 2" clip-rule="evenodd"/>
  </svg>
`;
const DatabaseKanbanView = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5.5 3.75A1.75 1.75 0 0 0 3.75 5.5V18c0 .966.784 1.75 1.75 1.75h4A1.75 1.75 0 0 0 11.25 18V5.5A1.75 1.75 0 0 0 9.5 3.75zM5.25 5.5a.25.25 0 0 1 .25-.25h4a.25.25 0 0 1 .25.25V18a.25.25 0 0 1-.25.25h-4a.25.25 0 0 1-.25-.25zM14.5 3.75a1.75 1.75 0 0 0-1.75 1.75v7c0 .966.784 1.75 1.75 1.75h4a1.75 1.75 0 0 0 1.75-1.75v-7a1.75 1.75 0 0 0-1.75-1.75zm-.25 1.75a.25.25 0 0 1 .25-.25h4a.25.25 0 0 1 .25.25v7a.25.25 0 0 1-.25.25h-4a.25.25 0 0 1-.25-.25z" clip-rule="evenodd"/>
  </svg>
`;
const DatabaseListView = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5 3.25A2.75 2.75 0 0 0 2.25 6v12A2.75 2.75 0 0 0 5 20.75h14A2.75 2.75 0 0 0 21.75 18V6A2.75 2.75 0 0 0 19 3.25zM3.75 6c0-.69.56-1.25 1.25-1.25h2.25v3.5h-3.5zm3.5 3.75h-3.5v3.5h3.5zm1.5 3.5v-3.5h11.5v3.5zm-1.5 1.5h-3.5V18c0 .69.56 1.25 1.25 1.25h2.25zm1.5 4.5v-4.5h11.5V18c0 .69-.56 1.25-1.25 1.25zm0-11v-3.5H19c.69 0 1.25.56 1.25 1.25v2.25z" clip-rule="evenodd"/>
  </svg>
`;
const DatabaseTableView = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.25 6A2.75 2.75 0 0 1 6 3.25h12A2.75 2.75 0 0 1 20.75 6v12A2.75 2.75 0 0 1 18 20.75H6A2.75 2.75 0 0 1 3.25 18zM6 4.75c-.69 0-1.25.56-1.25 1.25v2.25h14.5V6c0-.69-.56-1.25-1.25-1.25zM4.75 18V9.75h3v9.5H6c-.69 0-1.25-.56-1.25-1.25m4.5 1.25H18c.69 0 1.25-.56 1.25-1.25V9.75h-10z" clip-rule="evenodd"/>
  </svg>
`;
const DateTime = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8.205 2.787c.393 0 .712.319.712.712v.711h6.166V3.5a.712.712 0 0 1 1.423 0v.711h2.135a2.61 2.61 0 0 1 2.609 2.61v11.384a2.61 2.61 0 0 1-2.609 2.609H5.359a2.61 2.61 0 0 1-2.609-2.61V6.82A2.61 2.61 0 0 1 5.359 4.21h2.135V3.5c0-.393.318-.712.711-.712m6.878 2.846v.712a.712.712 0 0 0 1.423 0v-.712h2.135c.655 0 1.186.531 1.186 1.186v1.66H4.173V6.82c0-.655.531-1.186 1.186-1.186h2.135v.712a.712.712 0 1 0 1.423 0v-.712zm-10.91 4.27h15.654v8.3c0 .656-.531 1.187-1.186 1.187H5.359c-.655 0-1.186-.531-1.186-1.186z" clip-rule="evenodd"/>
  </svg>
`;
const Delete = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M10.75 11a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0zM14 10.25a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 1 .75-.75"/><path fill='currentColor' fill-rule="evenodd" d="M11 2.25A2.75 2.75 0 0 0 8.25 5v1.15H4a.85.85 0 0 0 0 1.7h.309l.81 11.346a2.75 2.75 0 0 0 2.743 2.554h8.276a2.75 2.75 0 0 0 2.743-2.554l.81-11.346H20a.85.85 0 1 0 0-1.7h-4.25V5A2.75 2.75 0 0 0 13 2.25zm3.25 3.9V5c0-.69-.56-1.25-1.25-1.25h-2c-.69 0-1.25.56-1.25 1.25v1.15zm3.937 1.7H5.813l.802 11.24a1.25 1.25 0 0 0 1.247 1.16h8.276c.656 0 1.2-.507 1.247-1.16z" clip-rule="evenodd"/>
  </svg>
`;
const DeletePermanently = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8.25 5A2.75 2.75 0 0 1 11 2.25h2A2.75 2.75 0 0 1 15.75 5v1.25H20a.75.75 0 0 1 0 1.5h-.302l-.817 11.446a2.75 2.75 0 0 1-2.743 2.554H7.862a2.75 2.75 0 0 1-2.743-2.554L4.302 7.75H4a.75.75 0 0 1 0-1.5h4.25zm6 0v1.25h-4.5V5c0-.69.56-1.25 1.25-1.25h2c.69 0 1.25.56 1.25 1.25M5.805 7.75h12.39l-.81 11.34a1.25 1.25 0 0 1-1.247 1.16H7.862a1.25 1.25 0 0 1-1.247-1.16zm4.725 3.22a.75.75 0 1 0-1.06 1.06l1.47 1.47-1.47 1.47a.75.75 0 1 0 1.06 1.06L12 14.56l1.47 1.47a.75.75 0 1 0 1.06-1.06l-1.47-1.47 1.47-1.47a.75.75 0 1 0-1.06-1.06L12 12.44z" clip-rule="evenodd"/>
  </svg>
`;
const DeleteTemporarily = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M11 2.25A2.75 2.75 0 0 0 8.25 5v1.25H4a.75.75 0 0 0 0 1.5h.302l.817 11.446a2.75 2.75 0 0 0 2.743 2.554H10.5a.75.75 0 0 0 0-1.5H7.862a1.25 1.25 0 0 1-1.247-1.16l-.81-11.34h12.39l-.229 3.197a.75.75 0 1 0 1.496.106l.236-3.303H20a.75.75 0 0 0 0-1.5h-4.25V5A2.75 2.75 0 0 0 13 2.25zm3.25 4V5c0-.69-.56-1.25-1.25-1.25h-2c-.69 0-1.25.56-1.25 1.25v1.25zM10.75 11a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0zm3.25-.75a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 .75-.75m3 4.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M12.25 18a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0m5.5-1.5a.75.75 0 0 0-1.5 0V18c0 .199.079.39.22.53l1 1a.75.75 0 1 0 1.06-1.06l-.78-.78z" clip-rule="evenodd"/>
  </svg>
`;
const Diagonally_2Lines = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.707 17.435a1 1 0 1 0 1.414 1.414L18.85 6.121a1 1 0 1 0-1.414-1.414zm7.071 1.414a1 1 0 0 0 1.414 1.414l7.072-7.07a1 1 0 0 0-1.415-1.415z" clip-rule="evenodd"/>
  </svg>
`;
const Diamond = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 1.94 22.06 12 12 22.06 1.94 12zM4.06 12 12 19.94 19.94 12 12 4.06z" clip-rule="evenodd"/>
  </svg>
`;
const DirectionPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M19.915 5.294c.431-1.358-.85-2.639-2.208-2.207L3.544 7.585c-1.68.534-1.617 2.932.089 3.377l6.667 1.74 1.74 6.667c.444 1.705 2.842 1.768 3.376.088z"/>
  </svg>
`;
const DirectionSign2Panel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M14 2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V5H8.028a1 1 0 0 0-.85.475l-1.854 3a1 1 0 0 0 0 1.05l1.853 3a1 1 0 0 0 .851.475H12v8a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-8h4a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-4z" clip-rule="evenodd"/>
  </svg>
`;
const DirectionSign3Panel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M13 2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V4H6.888a1 1 0 0 0-.71.297l-1.483 1.5a1 1 0 0 0 0 1.406l1.482 1.5A1 1 0 0 0 6.888 9H11v2H6.888a1 1 0 0 0-.71.297l-1.483 1.5a1 1 0 0 0 0 1.406l1.482 1.5a1 1 0 0 0 .711.297H11v5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-5h4a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-4V9h4a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-4z" clip-rule="evenodd"/>
  </svg>
`;
const DirectionSign4Panel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M13 2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V4H7a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h4v2H7a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h4v5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-5h4.112a1 1 0 0 0 .711-.297l1.482-1.5a1 1 0 0 0 0-1.406l-1.482-1.5a1 1 0 0 0-.711-.297H13V9h4.112a1 1 0 0 0 .711-.297l1.482-1.5a1 1 0 0 0 0-1.406l-1.482-1.5A1 1 0 0 0 17.112 4H13z" clip-rule="evenodd"/>
  </svg>
`;
const DirectionSignPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V5H6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h4v8a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-8h3.972a1 1 0 0 0 .85-.475l1.853-3a1 1 0 0 0 0-1.05l-1.852-3A1 1 0 0 0 15.972 5H12z" clip-rule="evenodd"/>
  </svg>
`;
const Discord = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M18.923 5.882a15.7 15.7 0 0 0-4.067-1.32.08.08 0 0 0-.067.03 14 14 0 0 0-.505 1.082 14.7 14.7 0 0 0-4.571 0 10 10 0 0 0-.515-1.082c-.01-.02-.038-.03-.066-.03-1.429.258-2.79.705-4.067 1.32-.01 0-.02.01-.029.02-2.59 4.038-3.304 7.966-2.952 11.855 0 .02.01.04.029.05 1.714 1.31 3.362 2.103 4.99 2.629.029.01.057 0 .067-.02.38-.546.724-1.12 1.019-1.726.019-.04 0-.08-.038-.09a11.5 11.5 0 0 1-1.562-.773c-.038-.02-.038-.08-.01-.11.105-.079.21-.168.315-.247.019-.02.047-.02.066-.01 3.277 1.557 6.81 1.557 10.048 0a.06.06 0 0 1 .067.01c.105.089.21.168.314.258.038.03.038.089-.01.109-.495.307-1.019.555-1.561.773-.038.01-.048.06-.038.09.304.605.647 1.18 1.019 1.726.028.01.057.02.085.01 1.639-.526 3.286-1.32 5-2.629.02-.01.03-.03.03-.05.418-4.494-.696-8.393-2.953-11.855-.01-.01-.02-.02-.038-.02M8.683 15.386c-.98 0-1.8-.942-1.8-2.103 0-1.16.8-2.103 1.8-2.103 1.01 0 1.81.952 1.8 2.103 0 1.16-.8 2.103-1.8 2.103m6.638 0c-.98 0-1.8-.942-1.8-2.103 0-1.16.8-2.103 1.8-2.103 1.01 0 1.81.952 1.8 2.103 0 1.16-.79 2.103-1.8 2.103"/>
  </svg>
`;
const DiscordDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#5865F2" d="M18.923 5.647a16.2 16.2 0 0 0-4.067-1.267.09.09 0 0 0-.067.029c-.171.314-.371.723-.505 1.038a15.3 15.3 0 0 0-4.571 0 10 10 0 0 0-.515-1.038c-.01-.02-.038-.029-.066-.029-1.429.248-2.79.676-4.067 1.267-.01 0-.02.01-.029.019-2.59 3.876-3.304 7.648-2.952 11.381q0 .032.029.048a16.6 16.6 0 0 0 4.99 2.524c.029.01.057 0 .067-.02.38-.523.724-1.076 1.019-1.657.019-.038 0-.076-.038-.085a12 12 0 0 1-1.562-.743c-.038-.02-.038-.076-.01-.105.105-.076.21-.162.315-.238.019-.02.047-.02.066-.01 3.277 1.496 6.81 1.496 10.048 0a.06.06 0 0 1 .067.01c.105.086.21.162.314.247.038.03.038.086-.01.105a10 10 0 0 1-1.561.743c-.038.01-.048.057-.038.086.304.58.647 1.133 1.019 1.657.028.01.057.02.085.01a16.5 16.5 0 0 0 5-2.524.05.05 0 0 0 .03-.048c.418-4.314-.696-8.057-2.953-11.381-.01-.01-.02-.02-.038-.02M8.683 14.77c-.98 0-1.8-.905-1.8-2.02s.8-2.018 1.8-2.018c1.01 0 1.81.914 1.8 2.019 0 1.114-.8 2.019-1.8 2.019m6.638 0c-.98 0-1.8-.905-1.8-2.02s.8-2.018 1.8-2.018c1.01 0 1.81.914 1.8 2.019 0 1.114-.79 2.019-1.8 2.019"/>
  </svg>
`;
const DiscordPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M18.923 5.647a16.2 16.2 0 0 0-4.067-1.267.09.09 0 0 0-.067.029c-.171.314-.371.723-.505 1.038a15.3 15.3 0 0 0-4.571 0 10 10 0 0 0-.515-1.038c-.01-.02-.038-.029-.066-.029-1.429.248-2.79.676-4.067 1.267-.01 0-.02.01-.029.019-2.59 3.876-3.304 7.648-2.952 11.381q0 .032.029.048a16.6 16.6 0 0 0 4.99 2.524c.029.01.057 0 .067-.02.38-.523.724-1.076 1.019-1.657.019-.038 0-.076-.038-.085a12 12 0 0 1-1.562-.743c-.038-.02-.038-.076-.01-.105.105-.076.21-.162.315-.238.019-.02.047-.02.066-.01 3.277 1.496 6.81 1.496 10.048 0a.06.06 0 0 1 .067.01c.105.086.21.162.314.247.038.03.038.086-.01.105a10 10 0 0 1-1.561.743c-.038.01-.048.057-.038.086.304.58.647 1.133 1.019 1.657.028.01.057.02.085.01a16.5 16.5 0 0 0 5-2.524.05.05 0 0 0 .03-.048c.418-4.314-.696-8.057-2.953-11.381-.01-.01-.02-.02-.038-.02M8.683 14.77c-.98 0-1.8-.905-1.8-2.02s.8-2.018 1.8-2.018c1.01 0 1.81.914 1.8 2.019 0 1.114-.8 2.019-1.8 2.019m6.638 0c-.98 0-1.8-.905-1.8-2.02s.8-2.018 1.8-2.018c1.01 0 1.81.914 1.8 2.019 0 1.114-.79 2.019-1.8 2.019"/>
  </svg>
`;
const DistributeHorizontal = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5 3.25a.75.75 0 0 1 .75.75v16a.75.75 0 0 1-1.5 0V4A.75.75 0 0 1 5 3.25m14 0a.75.75 0 0 1 .75.75v16a.75.75 0 0 1-1.5 0V4a.75.75 0 0 1 .75-.75M10.5 16a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1z" clip-rule="evenodd"/>
  </svg>
`;
const DistributeVertical = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M20.75 5a.75.75 0 0 1-.75.75H4a.75.75 0 0 1 0-1.5h16a.75.75 0 0 1 .75.75m0 14a.75.75 0 0 1-.75.75H4a.75.75 0 0 1 0-1.5h16a.75.75 0 0 1 .75.75M7.5 10.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1z" clip-rule="evenodd"/>
  </svg>
`;
const Divider = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4 4.25a.75.75 0 0 1 .75.75v1c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25V5a.75.75 0 0 1 1.5 0v1A2.75 2.75 0 0 1 18 8.75H6A2.75 2.75 0 0 1 3.25 6V5A.75.75 0 0 1 4 4.25m0 15.5a.75.75 0 0 0 .75-.75v-1c0-.69.56-1.25 1.25-1.25h12c.69 0 1.25.56 1.25 1.25v1a.75.75 0 0 0 1.5 0v-1A2.75 2.75 0 0 0 18 15.25H6A2.75 2.75 0 0 0 3.25 18v1c0 .414.336.75.75.75m-1-8.5a.75.75 0 0 0 0 1.5h1.2a.75.75 0 0 0 0-1.5H3m3.45.75a.75.75 0 0 1 .75-.75h1.2a.75.75 0 0 1 0 1.5H7.2a.75.75 0 0 1-.75-.75m4.95-.75a.75.75 0 0 0 0 1.5h1.2a.75.75 0 0 0 0-1.5h-1.2m3.45.75a.75.75 0 0 1 .75-.75h1.2a.75.75 0 0 1 0 1.5h-1.2a.75.75 0 0 1-.75-.75m4.95-.75a.75.75 0 0 0 0 1.5H21a.75.75 0 0 0 0-1.5h-1.2" clip-rule="evenodd"/>
  </svg>
`;
const Docs = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4 17.593V6.407c0-.903.353-1.77.98-2.409A3.32 3.32 0 0 1 7.35 3h9.302c.448 0 .812.37.812.826v11.186l-.003.075a.83.83 0 0 1-.253.527.8.8 0 0 1-.556.223H7.35q-.241 0-.469.066a1.75 1.75 0 0 0-1.256 1.69c0 .465.181.912.505 1.24.324.33.762.515 1.22.515h11.027V4.686c0-.456.364-.826.812-.826s.812.37.812.826v15.488a.82.82 0 0 1-.812.826H7.348a3.32 3.32 0 0 1-2.367-.998A3.44 3.44 0 0 1 4 17.592m3.772-.826a.82.82 0 0 0-.812.826c0 .456.363.826.812.826h8.456c.449 0 .812-.37.812-.826a.82.82 0 0 0-.812-.826z" clip-rule="evenodd"/>
  </svg>
`;
const DocsDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#6880FF" fill-rule="evenodd" d="M4 17.593V6.407c0-.903.353-1.77.98-2.409A3.32 3.32 0 0 1 7.35 3h9.302c.448 0 .812.37.812.826v11.186l-.003.075a.83.83 0 0 1-.253.527.8.8 0 0 1-.556.223H7.35q-.241 0-.469.066a1.75 1.75 0 0 0-1.256 1.69c0 .465.181.912.505 1.24.324.33.762.515 1.22.515h11.027V4.686c0-.456.364-.826.812-.826s.812.37.812.826v15.488a.82.82 0 0 1-.812.826H7.348a3.32 3.32 0 0 1-2.367-.998A3.44 3.44 0 0 1 4 17.592m3.772-.826a.82.82 0 0 0-.812.826c0 .456.363.826.812.826h8.456c.449 0 .812-.37.812-.826a.82.82 0 0 0-.812-.826z" clip-rule="evenodd"/>
  </svg>
`;
const Done = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M19.53 6.47a.75.75 0 0 1 0 1.06l-10 10a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 1 1 1.06-1.06L9 15.94l9.47-9.47a.75.75 0 0 1 1.06 0" clip-rule="evenodd"/>
  </svg>
`;
const DotDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#F43F48" d="M19 12a7 7 0 1 1-14 0 7 7 0 0 1 14 0"/>
  </svg>
`;
const Download = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12.75 4.75a.75.75 0 0 0-1.5 0v8.69l-2.22-2.22a.75.75 0 0 0-1.06 1.06l3.5 3.5a.75.75 0 0 0 1.06 0l3.5-3.5a.75.75 0 1 0-1.06-1.06l-2.22 2.22zm-8 6A.25.25 0 0 1 5 10.5h1A.75.75 0 0 0 6 9H5a1.75 1.75 0 0 0-1.75 1.75v7A2.75 2.75 0 0 0 6 20.5h12a2.75 2.75 0 0 0 2.75-2.75v-7A1.75 1.75 0 0 0 19 9h-1a.75.75 0 0 0 0 1.5h1a.25.25 0 0 1 .25.25v7c0 .69-.56 1.25-1.25 1.25H6c-.69 0-1.25-.56-1.25-1.25z" clip-rule="evenodd"/>
  </svg>
`;
const DragCursor = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M10.694 3.62c.271-.661.934-1.12 1.693-1.12.993 0 1.823.786 1.823 1.786v.12c.248-.123.528-.192.822-.192.993 0 1.823.786 1.823 1.786v.978c.248-.123.528-.192.822-.192.994 0 1.823.786 1.823 1.785v6c0 3.84-3.198 6.929-7.113 6.929-.96 0-1.884-.131-2.777-.547-.893-.415-1.717-1.098-2.505-2.146l-3.208-4.001a1.755 1.755 0 0 1 .14-2.376 1.845 1.845 0 0 1 2.592.031l.563.653c.308.376.54.631.714.795v-.01c.015-.235.014-.525.013-.875V5.142c0-.999.83-1.785 1.823-1.785.347 0 .674.096.952.264m.87 7.523a.5.5 0 1 1-1 0v-6c0-.42-.354-.786-.822-.786s-.823.365-.823.786v7.865c.001.352.002.683-.015.952-.01.164-.027.329-.062.475a1 1 0 0 1-.236.467.69.69 0 0 1-.64.196 1.2 1.2 0 0 1-.497-.246c-.28-.214-.623-.582-1.046-1.099l-.535-.62a.845.845 0 0 0-1.153.014.756.756 0 0 0-.062 1.028l.003.003 3.214 4.01.01.012c.71.948 1.415 1.513 2.132 1.847.719.334 1.488.453 2.355.453 3.39 0 6.113-2.668 6.113-5.929v-6c0-.42-.355-.785-.823-.785s-.822.365-.822.785V12a.5.5 0 0 1-1 0V6c0-.42-.355-.786-.823-.786s-.822.365-.822.786v5.143a.5.5 0 0 1-1 0V4.286c0-.421-.355-.786-.823-.786s-.823.365-.823.786z" clip-rule="evenodd"/><path fill='currentColor' d="M11.064 11.643a.5.5 0 0 0 .5-.5V4.286c0-.421.355-.786.823-.786s.823.365.823.786v6.857a.5.5 0 1 0 1 0V6c0-.42.354-.786.822-.786s.823.365.823.786v6a.5.5 0 1 0 1 0V8.571c0-.42.355-.785.822-.785.468 0 .823.365.823.785v6c0 3.261-2.724 5.929-6.113 5.929-.867 0-1.636-.119-2.355-.453-.717-.334-1.421-.9-2.132-1.847l-.01-.013-3.214-4.009-.003-.003a.756.756 0 0 1 .062-1.028.845.845 0 0 1 1.153-.014l.535.62c.423.517.766.885 1.046 1.099.138.104.306.209.496.246a.69.69 0 0 0 .641-.196 1 1 0 0 0 .236-.467c.035-.146.052-.31.062-.475.017-.27.016-.6.015-.952V5.143c0-.42.355-.785.823-.785s.822.365.822.786v6a.5.5 0 0 0 .5.5"/><path stroke='currentColor' stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width=".5" d="M10.694 3.62c.271-.661.934-1.12 1.693-1.12.993 0 1.823.786 1.823 1.786v.12c.248-.123.528-.192.822-.192.993 0 1.823.786 1.823 1.786v.978c.248-.123.528-.192.822-.192.994 0 1.823.786 1.823 1.785v6c0 3.84-3.198 6.929-7.113 6.929-.96 0-1.884-.131-2.777-.547-.893-.415-1.717-1.098-2.505-2.146l-3.208-4.001a1.755 1.755 0 0 1 .14-2.376 1.845 1.845 0 0 1 2.592.031l.563.653c.308.376.54.631.714.795v-.01c.015-.235.014-.525.013-.875V5.142c0-.999.83-1.785 1.823-1.785.347 0 .674.096.952.264m.87 7.523a.5.5 0 1 1-1 0v-6c0-.42-.354-.786-.822-.786s-.823.365-.823.786v7.865c.001.352.002.683-.015.952-.01.164-.027.329-.062.475a1 1 0 0 1-.236.467.69.69 0 0 1-.64.196 1.2 1.2 0 0 1-.497-.246c-.28-.214-.623-.582-1.046-1.099l-.535-.62a.845.845 0 0 0-1.153.014.756.756 0 0 0-.062 1.028l.003.003 3.214 4.01.01.012c.71.948 1.415 1.513 2.132 1.847.719.334 1.488.453 2.355.453 3.39 0 6.113-2.668 6.113-5.929v-6c0-.42-.355-.785-.823-.785s-.822.365-.822.785V12a.5.5 0 0 1-1 0V6c0-.42-.355-.786-.823-.786s-.822.365-.822.786v5.143a.5.5 0 0 1-1 0V4.286c0-.421-.355-.786-.823-.786s-.823.365-.823.786z" clip-rule="evenodd"/><path stroke='currentColor' stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width=".5" d="M11.064 11.643a.5.5 0 0 0 .5-.5V4.286c0-.421.355-.786.823-.786s.823.365.823.786v6.857a.5.5 0 1 0 1 0V6c0-.42.354-.786.822-.786s.823.365.823.786v6a.5.5 0 1 0 1 0V8.571c0-.42.355-.785.822-.785.468 0 .823.365.823.785v6c0 3.261-2.724 5.929-6.113 5.929-.867 0-1.636-.119-2.355-.453-.717-.334-1.421-.9-2.132-1.847l-.01-.013-3.214-4.009-.003-.003a.756.756 0 0 1 .062-1.028.845.845 0 0 1 1.153-.014l.535.62c.423.517.766.885 1.046 1.099.138.104.306.209.496.246a.69.69 0 0 0 .641-.196 1 1 0 0 0 .236-.467c.035-.146.052-.31.062-.475.017-.27.016-.6.015-.952V5.143c0-.42.355-.785.823-.785s.822.365.822.786v6a.5.5 0 0 0 .5.5"/>
  </svg>
`;
const DragCursorDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#000" fill-rule="evenodd" d="M10.694 3.62c.271-.661.934-1.12 1.693-1.12.993 0 1.823.786 1.823 1.786v.12c.248-.123.528-.192.822-.192.993 0 1.823.786 1.823 1.786v.978c.248-.123.528-.192.822-.192.994 0 1.823.786 1.823 1.785v6c0 3.84-3.198 6.929-7.113 6.929-.96 0-1.884-.131-2.777-.547-.893-.415-1.717-1.098-2.505-2.146l-3.208-4.001a1.755 1.755 0 0 1 .14-2.376 1.845 1.845 0 0 1 2.592.031l.563.653c.308.376.54.631.714.795v-.01c.015-.235.014-.525.013-.875V5.142c0-.999.83-1.785 1.823-1.785.347 0 .674.096.952.264m.87 7.523a.5.5 0 1 1-1 0v-6c0-.42-.354-.786-.822-.786s-.823.365-.823.786v7.865c.001.352.002.683-.015.952-.01.164-.027.329-.062.475a1 1 0 0 1-.236.467.69.69 0 0 1-.64.196 1.2 1.2 0 0 1-.497-.246c-.28-.214-.623-.582-1.046-1.099l-.535-.62a.845.845 0 0 0-1.153.014.756.756 0 0 0-.062 1.028l.003.003 3.214 4.01.01.012c.71.948 1.415 1.513 2.132 1.847.719.334 1.488.453 2.355.453 3.39 0 6.113-2.668 6.113-5.929v-6c0-.42-.355-.785-.823-.785s-.822.365-.822.785V12a.5.5 0 0 1-1 0V6c0-.42-.355-.786-.823-.786s-.822.365-.822.786v5.143a.5.5 0 0 1-1 0V4.286c0-.421-.355-.786-.823-.786s-.823.365-.823.786z" clip-rule="evenodd"/><path fill="#fff" d="M11.064 11.643a.5.5 0 0 0 .5-.5V4.286c0-.421.355-.786.823-.786s.823.365.823.786v6.857a.5.5 0 1 0 1 0V6c0-.42.354-.786.822-.786s.823.365.823.786v6a.5.5 0 1 0 1 0V8.571c0-.42.355-.785.822-.785.468 0 .823.365.823.785v6c0 3.261-2.724 5.929-6.113 5.929-.867 0-1.636-.119-2.355-.453-.717-.334-1.421-.9-2.132-1.847l-.01-.013-3.214-4.009-.003-.003a.756.756 0 0 1 .062-1.028.845.845 0 0 1 1.153-.014l.535.62c.423.517.766.885 1.046 1.099.138.104.306.209.496.246a.69.69 0 0 0 .641-.196 1 1 0 0 0 .236-.467c.035-.146.052-.31.062-.475.017-.27.016-.6.015-.952V5.143c0-.42.355-.785.823-.785s.822.365.822.786v6a.5.5 0 0 0 .5.5"/><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width=".5" d="M10.694 3.62c.271-.661.934-1.12 1.693-1.12.993 0 1.823.786 1.823 1.786v.12c.248-.123.528-.192.822-.192.993 0 1.823.786 1.823 1.786v.978c.248-.123.528-.192.822-.192.994 0 1.823.786 1.823 1.785v6c0 3.84-3.198 6.929-7.113 6.929-.96 0-1.884-.131-2.777-.547-.893-.415-1.717-1.098-2.505-2.146l-3.208-4.001a1.755 1.755 0 0 1 .14-2.376 1.845 1.845 0 0 1 2.592.031l.563.653c.308.376.54.631.714.795v-.01c.015-.235.014-.525.013-.875V5.142c0-.999.83-1.785 1.823-1.785.347 0 .674.096.952.264m.87 7.523a.5.5 0 1 1-1 0v-6c0-.42-.354-.786-.822-.786s-.823.365-.823.786v7.865c.001.352.002.683-.015.952-.01.164-.027.329-.062.475a1 1 0 0 1-.236.467.69.69 0 0 1-.64.196 1.2 1.2 0 0 1-.497-.246c-.28-.214-.623-.582-1.046-1.099l-.535-.62a.845.845 0 0 0-1.153.014.756.756 0 0 0-.062 1.028l.003.003 3.214 4.01.01.012c.71.948 1.415 1.513 2.132 1.847.719.334 1.488.453 2.355.453 3.39 0 6.113-2.668 6.113-5.929v-6c0-.42-.355-.785-.823-.785s-.822.365-.822.785V12a.5.5 0 0 1-1 0V6c0-.42-.355-.786-.823-.786s-.822.365-.822.786v5.143a.5.5 0 0 1-1 0V4.286c0-.421-.355-.786-.823-.786s-.823.365-.823.786z" clip-rule="evenodd"/><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width=".5" d="M11.064 11.643a.5.5 0 0 0 .5-.5V4.286c0-.421.355-.786.823-.786s.823.365.823.786v6.857a.5.5 0 1 0 1 0V6c0-.42.354-.786.822-.786s.823.365.823.786v6a.5.5 0 1 0 1 0V8.571c0-.42.355-.785.822-.785.468 0 .823.365.823.785v6c0 3.261-2.724 5.929-6.113 5.929-.867 0-1.636-.119-2.355-.453-.717-.334-1.421-.9-2.132-1.847l-.01-.013-3.214-4.009-.003-.003a.756.756 0 0 1 .062-1.028.845.845 0 0 1 1.153-.014l.535.62c.423.517.766.885 1.046 1.099.138.104.306.209.496.246a.69.69 0 0 0 .641-.196 1 1 0 0 0 .236-.467c.035-.146.052-.31.062-.475.017-.27.016-.6.015-.952V5.143c0-.42.355-.785.823-.785s.822.365.822.786v6a.5.5 0 0 0 .5.5"/>
  </svg>
`;
const Drink2Panel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="m12.426 4.628 3.953-.879-.277-1.246-4.953 1.1v3.279H6l.933 14.468h10.134L18 6.882h-5.574zm4.02 6.509H7.554l-.192-2.979h9.276z" clip-rule="evenodd"/>
  </svg>
`;
const DrinkPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6.515 4H5l.214 1.5L7 18h9l1.786-12.5L18 4H6.515m.715 5h8.54l.5-3.5H6.73zM6 20.75h11v-1.5H6z" clip-rule="evenodd"/>
  </svg>
`;
const DropCursor = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M10.695 8.335c.27-.662.933-1.12 1.692-1.12.748 0 1.403.445 1.68 1.091.282-.172.613-.27.965-.27.994 0 1.823.786 1.823 1.785v.086c.248-.124.528-.193.822-.193.994 0 1.823.786 1.823 1.786v3.071c0 3.84-3.198 6.929-7.113 6.929-.959 0-1.884-.131-2.777-.547s-1.72-1.1-2.508-2.151l-2.016-2.634a1.755 1.755 0 0 1 .144-2.371 1.845 1.845 0 0 1 2.562 0l.008.008.119.122v-4.07c0-1 .83-1.786 1.823-1.786.347 0 .674.096.952.264m-.13 1.522c0-.42-.355-.786-.823-.786s-.823.365-.823.786v3.334c.001.471.002.842-.007 1.116-.005.174-.015.33-.034.457a.9.9 0 0 1-.177.442.58.58 0 0 1-.359.2.6.6 0 0 1-.337-.048 1.2 1.2 0 0 1-.317-.228 10 10 0 0 1-.31-.32c-.092-.097-.19-.201-.287-.3a.845.845 0 0 0-1.164.004.756.756 0 0 0-.061 1.028l.01.013L7.9 18.2c.71.948 1.415 1.513 2.132 1.847.72.334 1.488.453 2.355.453 3.39 0 6.113-2.668 6.113-5.929V11.5c0-.42-.355-.786-.823-.786s-.822.365-.822.786v.5a.5.5 0 0 1-1 0V9.821c0-.42-.355-.785-.823-.785s-.822.365-.822.785v1.322a.5.5 0 1 1-1 0V9c0-.42-.355-.786-.823-.786s-.823.365-.823.786v2.143a.5.5 0 1 1-1 0z" clip-rule="evenodd"/><path fill='currentColor' d="M9.742 9.071c.468 0 .822.365.822.786v1.286a.5.5 0 1 0 1 0V9c0-.42.355-.786.823-.786s.823.365.823.786v2.143a.5.5 0 1 0 1 0V9.82c0-.42.354-.785.822-.785s.823.365.823.785V12a.5.5 0 0 0 1 0v-.5c0-.42.355-.786.822-.786.468 0 .823.365.823.786v3.071c0 3.261-2.723 5.929-6.113 5.929-.867 0-1.636-.119-2.355-.453-.717-.334-1.421-.9-2.132-1.847l-2.024-2.645-.01-.013a.756.756 0 0 1 .061-1.028.845.845 0 0 1 1.164-.003c.096.098.195.202.286.299.121.128.23.244.311.32.07.067.183.169.317.228.075.033.194.07.337.049a.58.58 0 0 0 .359-.2.9.9 0 0 0 .177-.443q.027-.194.034-.457c.009-.274.008-.645.008-1.116V9.857c0-.42.354-.786.822-.786"/><path stroke='currentColor' stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width=".5" d="m7.88 14.66.001-.006m4.506-7.44c-.759 0-1.422.459-1.693 1.12a1.85 1.85 0 0 0-.952-.263c-.993 0-1.823.787-1.823 1.786v4.07l-.12-.122-.007-.008a1.845 1.845 0 0 0-2.562 0 1.755 1.755 0 0 0-.144 2.371l2.016 2.634c.788 1.051 1.614 1.735 2.508 2.151s1.818.547 2.777.547c3.915 0 7.113-3.089 7.113-6.929V11.5c0-1-.83-1.786-1.823-1.786-.294 0-.574.07-.822.193V9.82c0-1-.83-1.785-1.823-1.785-.352 0-.683.098-.964.27a1.83 1.83 0 0 0-1.68-1.092M9.742 9.071c.468 0 .822.365.822.786v1.286a.5.5 0 1 0 1 0V9c0-.42.355-.786.823-.786s.823.365.823.786v2.143a.5.5 0 1 0 1 0V9.82c0-.42.354-.785.822-.785s.823.365.823.785V12a.5.5 0 0 0 1 0v-.5c0-.42.355-.786.822-.786.468 0 .823.365.823.786v3.071c0 3.261-2.723 5.929-6.113 5.929-.867 0-1.636-.119-2.355-.453-.717-.334-1.421-.9-2.132-1.847l-2.024-2.645-.01-.013a.756.756 0 0 1 .061-1.028.845.845 0 0 1 1.164-.003c.096.098.195.202.286.299.121.128.23.244.311.32.07.067.183.169.317.228.075.033.194.07.337.049a.58.58 0 0 0 .359-.2.9.9 0 0 0 .177-.443q.027-.194.034-.457c.009-.274.008-.645.008-1.116V9.857c0-.42.354-.786.822-.786"/>
  </svg>
`;
const DropCursorDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#000" fill-rule="evenodd" d="M10.694 8.335c.271-.662.934-1.12 1.693-1.12.748 0 1.402.445 1.68 1.091.282-.172.613-.27.965-.27.993 0 1.823.786 1.823 1.785v.086c.248-.124.528-.193.822-.193.994 0 1.823.786 1.823 1.786v3.071c0 3.84-3.198 6.929-7.113 6.929-.96 0-1.884-.131-2.777-.547s-1.72-1.1-2.509-2.151l-2.015-2.634a1.755 1.755 0 0 1 .144-2.371 1.845 1.845 0 0 1 2.561 0l.009.008.118.122a84 84 0 0 0 .001-1.145V9.857c0-1 .83-1.786 1.823-1.786.347 0 .674.096.952.264m-.13 1.522c0-.42-.354-.786-.822-.786s-.823.365-.823.786v3.334q.003.706-.007 1.116c-.006.174-.015.33-.035.457a.9.9 0 0 1-.176.442.58.58 0 0 1-.359.2.6.6 0 0 1-.337-.048 1.2 1.2 0 0 1-.317-.228 10 10 0 0 1-.31-.32c-.093-.097-.19-.201-.287-.3a.845.845 0 0 0-1.164.004.756.756 0 0 0-.061 1.028l.01.013L7.9 18.2c.71.948 1.415 1.513 2.132 1.847.719.334 1.488.453 2.355.453 3.39 0 6.113-2.668 6.113-5.929V11.5c0-.42-.355-.786-.823-.786s-.822.365-.822.786v.5a.5.5 0 0 1-1 0V9.821c0-.42-.355-.785-.823-.785s-.822.365-.822.785v1.322a.5.5 0 1 1-1 0V9c0-.42-.355-.786-.823-.786s-.823.365-.823.786v2.143a.5.5 0 1 1-1 0z" clip-rule="evenodd"/><path fill="#fff" d="M9.742 9.071c.467 0 .822.365.822.786v1.286a.5.5 0 1 0 1 0V9c0-.42.355-.786.823-.786s.822.365.822.786v2.143a.5.5 0 1 0 1 0V9.82c0-.42.355-.785.823-.785s.823.365.823.785V12a.5.5 0 1 0 1 0v-.5c0-.42.355-.786.822-.786.468 0 .823.365.823.786v3.071c0 3.261-2.724 5.929-6.113 5.929-.867 0-1.636-.119-2.355-.453-.717-.334-1.421-.9-2.132-1.847l-2.025-2.645-.01-.013a.756.756 0 0 1 .062-1.028.845.845 0 0 1 1.164-.003c.096.098.194.202.286.299.121.128.23.244.31.32.072.067.184.169.318.228.075.033.194.07.337.049a.58.58 0 0 0 .359-.2.9.9 0 0 0 .176-.443q.029-.194.035-.457.01-.41.007-1.116V9.857c0-.42.355-.786.823-.786"/><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width=".5" d="m7.88 14.66.001-.006m4.506-7.44c-.759 0-1.422.459-1.693 1.12a1.85 1.85 0 0 0-.952-.263c-.994 0-1.823.787-1.823 1.786v4.07l-.12-.122-.008-.008a1.845 1.845 0 0 0-2.561 0 1.755 1.755 0 0 0-.144 2.371L7.1 18.802c.79 1.051 1.615 1.735 2.51 2.151.892.416 1.817.547 2.776.547 3.915 0 7.113-3.089 7.113-6.929V11.5c0-1-.83-1.786-1.823-1.786-.294 0-.574.07-.822.193V9.82c0-1-.83-1.785-1.823-1.785-.352 0-.683.098-.964.27a1.83 1.83 0 0 0-1.681-1.092M9.742 9.071c.467 0 .822.365.822.786v1.286a.5.5 0 1 0 1 0V9c0-.42.355-.786.823-.786s.822.365.822.786v2.143a.5.5 0 1 0 1 0V9.82c0-.42.355-.785.823-.785s.823.365.823.785V12a.5.5 0 1 0 1 0v-.5c0-.42.355-.786.822-.786.468 0 .823.365.823.786v3.071c0 3.261-2.724 5.929-6.113 5.929-.867 0-1.636-.119-2.355-.453-.717-.334-1.421-.9-2.132-1.847l-2.025-2.645-.01-.013a.756.756 0 0 1 .062-1.028.845.845 0 0 1 1.164-.003c.096.098.194.202.286.299.121.128.23.244.31.32.072.067.184.169.318.228.075.033.194.07.337.049a.58.58 0 0 0 .359-.2.9.9 0 0 0 .176-.443q.029-.194.035-.457.01-.41.007-1.116V9.857c0-.42.355-.786.823-.786"/>
  </svg>
`;
const DualLink = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M10.667 6.2a.75.75 0 0 1 0-1.5H19a.75.75 0 0 1 .75.75v8.333a.75.75 0 0 1-1.5 0V7.261L6.53 18.98a.75.75 0 1 1-1.06-1.061L17.19 6.2z" clip-rule="evenodd"/>
  </svg>
`;
const Duplicate = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6 3.25A2.75 2.75 0 0 0 3.25 6v8A2.75 2.75 0 0 0 6 16.75h1.25V18A2.75 2.75 0 0 0 10 20.75h8A2.75 2.75 0 0 0 20.75 18v-8A2.75 2.75 0 0 0 18 7.25h-1.25V6A2.75 2.75 0 0 0 14 3.25zm4 4h5.25V6c0-.69-.56-1.25-1.25-1.25H6c-.69 0-1.25.56-1.25 1.25v8c0 .69.56 1.25 1.25 1.25h2a.75.75 0 0 1 .75.75v2c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25v-8c0-.69-.56-1.25-1.25-1.25h-8a1.25 1.25 0 0 0-1.17.81.75.75 0 0 1-1.405-.528A2.75 2.75 0 0 1 10 7.25m2.887 3.239a.75.75 0 1 0-1.098 1.022l.688.739H7.8a.75.75 0 0 0 0 1.5h4.677l-.688.739a.75.75 0 0 0 1.098 1.022l1.862-2a.75.75 0 0 0 0-1.022z" clip-rule="evenodd"/>
  </svg>
`;
const Edgeless = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M7.168 4.75a1.868 1.868 0 1 0 0 3.736 1.868 1.868 0 0 0 0-3.736M3.8 6.618a3.368 3.368 0 0 1 6.729-.226c.842 0 1.651.014 2.493.217.933.226 1.865.672 2.975 1.504l.02.015.02.017c1.566 1.35 2.35 3.533 2.354 5.578h1.66a.75.75 0 0 1 .75.75v4.713a.75.75 0 0 1-.75.75h-4.714a.75.75 0 0 1-.75-.75v-4.713a.75.75 0 0 1 .75-.75h1.554c-.004-1.705-.663-3.42-1.815-4.426-.975-.728-1.719-1.064-2.406-1.23-.712-.172-1.407-.175-2.36-.175v-.057a3.38 3.38 0 0 1-2.392 2.068v3.904a3.37 3.37 0 0 1-.75 6.652 3.368 3.368 0 0 1-.75-6.652V9.903A3.37 3.37 0 0 1 3.8 6.618m3.368 8.605a1.868 1.868 0 1 0 0 3.736 1.868 1.868 0 0 0 0-3.736m8.92 3.213v-3.213H19.3v3.213z" clip-rule="evenodd"/>
  </svg>
`;
const Edit = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M18.303 4.498a.85.85 0 0 1 1.2 0c.33.33.33.863 0 1.192l-.43.428-1.196-1.195zm-1.488 1.485 1.197 1.195-7.086 7.072H9.75v-1.216zm3.747-2.547a2.35 2.35 0 0 0-3.318 0L8.47 12.192a.75.75 0 0 0-.22.531V15c0 .414.336.75.75.75h2.236a.75.75 0 0 0 .53-.22l8.796-8.778c.917-.915.917-2.4 0-3.316M4.75 6c0-.69.56-1.25 1.25-1.25h6a.75.75 0 0 0 0-1.5H6A2.75 2.75 0 0 0 3.25 6v12A2.75 2.75 0 0 0 6 20.75h12A2.75 2.75 0 0 0 20.75 18v-6a.75.75 0 0 0-1.5 0v6c0 .69-.56 1.25-1.25 1.25H6c-.69 0-1.25-.56-1.25-1.25z" clip-rule="evenodd"/>
  </svg>
`;
const ElbowedLine = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M11.25 7A2.75 2.75 0 0 1 14 4.25h7a.75.75 0 0 1 0 1.5h-7c-.69 0-1.25.56-1.25 1.25v10A2.75 2.75 0 0 1 10 19.75H3a.75.75 0 0 1 0-1.5h7c.69 0 1.25-.56 1.25-1.25z" clip-rule="evenodd"/>
  </svg>
`;
const Ellipse = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12" clip-rule="evenodd"/>
  </svg>
`;
const Ellipsis = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M7 20a1 1 0 1 1-2 0 1 1 0 0 1 2 0M13 20a1 1 0 1 1-2 0 1 1 0 0 1 2 0M19 20a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
  </svg>
`;
const Email = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M2.25 7A2.75 2.75 0 0 1 5 4.25h14A2.75 2.75 0 0 1 21.75 7v10A2.75 2.75 0 0 1 19 19.75H5A2.75 2.75 0 0 1 2.25 17V7m1.5 2.401V17c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V9.401l-6.725 4.483a2.75 2.75 0 0 1-3.05 0zM20.25 7.6l-7.556 5.037c-.42.28-.967.28-1.387 0L3.75 7.6V7c0-.69.56-1.25 1.25-1.25h14c.69 0 1.25.56 1.25 1.25z" clip-rule="evenodd"/>
  </svg>
`;
const EmailWarning = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5 4.25A2.75 2.75 0 0 0 2.25 7v10A2.75 2.75 0 0 0 5 19.75h11.5a.75.75 0 0 0 0-1.5H5c-.69 0-1.25-.56-1.25-1.25V9.401l6.725 4.483a2.75 2.75 0 0 0 3.05 0l6.725-4.483V10.5a.75.75 0 0 0 1.5 0V7A2.75 2.75 0 0 0 19 4.25zm6.307 8.386L3.75 7.6V7c0-.69.56-1.25 1.25-1.25h14c.69 0 1.25.56 1.25 1.25v.599l-7.556 5.037c-.42.28-.967.28-1.387 0" clip-rule="evenodd"/><path fill='currentColor' d="M20.75 14a.75.75 0 0 0-1.5 0v3.5a.75.75 0 0 0 1.5 0zM20 19.25a.75.75 0 0 0 0 1.5h.01a.75.75 0 0 0 0-1.5z"/>
  </svg>
`;
const Embed = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M3.25 6A2.75 2.75 0 0 1 6 3.25h2.5a.75.75 0 0 1 0 1.5H6c-.69 0-1.25.56-1.25 1.25v2.5a.75.75 0 0 1-1.5 0zM14.75 4a.75.75 0 0 1 .75-.75H18A2.75 2.75 0 0 1 20.75 6v2.5a.75.75 0 0 1-1.5 0V6c0-.69-.56-1.25-1.25-1.25h-2.5a.75.75 0 0 1-.75-.75M11.884 12.116a1.25 1.25 0 0 0-1.768 0l-.55.55a.75.75 0 0 1-1.06-1.06l.55-.55a2.75 2.75 0 1 1 3.889 3.889l-2 2a2.75 2.75 0 0 1-3.89 0 .75.75 0 1 1 1.061-1.061 1.25 1.25 0 0 0 1.768 0l2-2a1.25 1.25 0 0 0 0-1.768"/><path fill='currentColor' d="M8.884 15.116a1.25 1.25 0 0 0-1.768 0l-2 2a1.25 1.25 0 0 0 1.768 1.768l.55-.55a.75.75 0 1 1 1.061 1.06l-.55.55a2.75 2.75 0 1 1-3.89-3.889l2-2a2.75 2.75 0 0 1 3.89 0 .75.75 0 0 1-1.061 1.061M20 14.75a.75.75 0 0 1 .75.75V18A2.75 2.75 0 0 1 18 20.75h-3a.75.75 0 0 1 0-1.5h3c.69 0 1.25-.56 1.25-1.25v-2.5a.75.75 0 0 1 .75-.75"/>
  </svg>
`;
const EmbedWeb = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5 3.25A2.75 2.75 0 0 0 2.25 6v12A2.75 2.75 0 0 0 5 20.75h14A2.75 2.75 0 0 0 21.75 18V6A2.75 2.75 0 0 0 19 3.25zm15.25 5V6c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v2.25zm-16.5 1.5h16.5V18c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25zm6.78 3.28a.75.75 0 1 0-1.06-1.06L7.348 14.09a.75.75 0 0 0 0 1.06l2.122 2.122a.75.75 0 1 0 1.06-1.06L8.94 14.62zm2.94-1.06a.75.75 0 0 0 0 1.06l1.59 1.591-1.59 1.591a.75.75 0 0 0 1.06 1.061l2.122-2.121a.75.75 0 0 0 0-1.06L14.53 11.97a.75.75 0 0 0-1.06 0M6.5 6.55a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m1.75.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5" clip-rule="evenodd"/>
  </svg>
`;
const Empty = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25m3.525 6.22a.75.75 0 0 1 0 1.06l-2.465 2.465 2.475 2.475a.75.75 0 0 1-1.06 1.06l-2.476-2.474-2.473 2.473a.75.75 0 1 1-1.06-1.06l2.473-2.474-2.46-2.459a.75.75 0 1 1 1.062-1.06l2.458 2.459 2.466-2.466a.75.75 0 0 1 1.06 0" clip-rule="evenodd"/>
  </svg>
`;
const EndPointArrow = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M16.47 7.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 1 1-1.06-1.06l2.72-2.72H3a.75.75 0 0 1 0-1.5h16.19l-2.72-2.72a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>
  </svg>
`;
const EndPointCircle = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M18 8.25a3.75 3.75 0 0 0-3.675 3H3a.75.75 0 0 0 0 1.5h11.325A3.751 3.751 0 0 0 21.75 12 3.75 3.75 0 0 0 18 8.25"/>
  </svg>
`;
const EndPointDiamond = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M17.47 8.47a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 0 1-1.06 0l-2.78-2.78H3a.75.75 0 0 1 0-1.5h11.69z"/>
  </svg>
`;
const EndPointTriangle = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M17.53 7.47a.75.75 0 0 0-1.28.53v3.25H3a.75.75 0 0 0 0 1.5h13.25V16a.75.75 0 0 0 1.28.53l4-4a.75.75 0 0 0 0-1.06z"/>
  </svg>
`;
const Enter = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M13.5 5a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v8.5a.75.75 0 0 1-.75.75H6.547l3.352 3.39a.75.75 0 1 1-1.067 1.054l-4.615-4.667a.75.75 0 0 1 0-1.054l4.615-4.667A.75.75 0 0 1 9.9 9.36L6.547 12.75H18v-7h-3.75A.75.75 0 0 1 13.5 5" clip-rule="evenodd"/>
  </svg>
`;
const Eq = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6.5 10.25h11v-1.5h-11zm0 5.5h11v-1.5h-11z" clip-rule="evenodd"/>
  </svg>
`;
const Eraser = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M14.806 4.95a1.23 1.23 0 0 0-.873.362L12.36 6.885l5.954 5.956 1.575-1.575a1.234 1.234 0 0 0 0-1.745l-4.21-4.209a1.24 1.24 0 0 0-.873-.362m2.448 8.952-5.955-5.956-7.188 7.188a1.235 1.235 0 0 0 0 1.745l1.524 1.524c.231.23.546.36.873.36h5.883zm-2.741 4.862h5.113a.75.75 0 0 1 0 1.5H6.508c-.725 0-1.42-.288-1.933-.8L3.05 17.94a2.734 2.734 0 0 1 0-3.867l9.82-9.821a2.734 2.734 0 0 1 3.87 0l4.208 4.208a2.734 2.734 0 0 1 0 3.867z" clip-rule="evenodd"/>
  </svg>
`;
const Expand = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M7.53 9.53a.75.75 0 0 1-1.06-1.06l5-5a.75.75 0 0 1 1.06 0l5 5a.75.75 0 0 1-1.06 1.06L12 5.06zm0 4.94a.75.75 0 0 0-1.06 1.06l5 5a.75.75 0 0 0 1.06 0l5-5a.75.75 0 1 0-1.06-1.06L12 18.94z" clip-rule="evenodd"/>
  </svg>
`;
const ExpandClose = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M20.53 3.47a.75.75 0 0 1 0 1.06l-4.22 4.22h2.19a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75v-4a.75.75 0 0 1 1.5 0v2.19l4.22-4.22a.75.75 0 0 1 1.06 0M5.5 15.25a.75.75 0 0 1 0-1.5h4a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-2.19l-4.22 4.22a.75.75 0 0 1-1.06-1.06l4.22-4.22z" clip-rule="evenodd"/>
  </svg>
`;
const ExpandFull = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M15.25 4a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V5.81l-4.22 4.22a.75.75 0 1 1-1.06-1.06l4.22-4.22H16a.75.75 0 0 1-.75-.75m-5.22 9.97a.75.75 0 0 1 0 1.06l-4.22 4.22H8a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75v-4a.75.75 0 0 1 1.5 0v2.19l4.22-4.22a.75.75 0 0 1 1.06 0" clip-rule="evenodd"/>
  </svg>
`;
const ExpandWide = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.25 5A.75.75 0 0 1 5 4.25h3.5a.75.75 0 0 1 0 1.5H6.81l3.095 3.095a.75.75 0 0 1-1.06 1.06L5.75 6.811V8.5a.75.75 0 0 1-1.5 0zm10.5 0a.75.75 0 0 1 .75-.75H19a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0V6.81l-3.095 3.095a.75.75 0 1 1-1.06-1.06l3.094-3.095H15.5a.75.75 0 0 1-.75-.75m-4.845 9.095a.75.75 0 0 1 0 1.06L6.811 18.25H8.5a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 1.5 0v1.69l3.095-3.095a.75.75 0 0 1 1.06 0m4.19 0a.75.75 0 0 1 1.06 0l3.095 3.094V15.5a.75.75 0 0 1 1.5 0V19a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1 0-1.5h1.69l-3.095-3.095a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>
  </svg>
`;
const Experiment = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M20.624 3.584a.75.75 0 0 1-.208 1.04l-.745.497a8.75 8.75 0 0 1-6.92 12.93v1.199h3.694a.75.75 0 0 1 0 1.5h-8.89a.75.75 0 0 1 0-1.5h3.695v-1.198a8.74 8.74 0 0 1-6.088-3.259l-.746.498a.75.75 0 1 1-.832-1.248l1.333-.89a.75.75 0 0 1 .423-.125.75.75 0 0 1 .63.333 7.25 7.25 0 0 0 12.072-8.036.75.75 0 0 1-.125-.428.75.75 0 0 1 .334-.632l1.333-.889a.75.75 0 0 1 1.04.208M12 5.639a3.694 3.694 0 1 0 0 7.389 3.694 3.694 0 0 0 0-7.39M6.806 9.333a5.194 5.194 0 1 1 10.389 0 5.194 5.194 0 0 1-10.39 0" clip-rule="evenodd"/>
  </svg>
`;
const Explain = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5 5.25a.75.75 0 0 0-.75.75v12c0 .414.336.75.75.75h2a.75.75 0 0 0 0-1.5H5.75V6.75H7a.75.75 0 0 0 0-1.5zm14 0a.75.75 0 0 1 .75.75v12a.75.75 0 0 1-.75.75h-2a.75.75 0 0 1 0-1.5h1.25V6.75H17a.75.75 0 0 1 0-1.5z" clip-rule="evenodd"/>
  </svg>
`;
const Export = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M11.47 3.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1-1.06 1.06l-2.72-2.72V16a.75.75 0 0 1-1.5 0V5.81L8.53 8.53a.75.75 0 0 1-1.06-1.06z"/><path fill='currentColor' d="M4 15.25a.75.75 0 0 1 .75.75v1A2.25 2.25 0 0 0 7 19.25h10A2.25 2.25 0 0 0 19.25 17v-1a.75.75 0 0 1 1.5 0v1A3.75 3.75 0 0 1 17 20.75H7A3.75 3.75 0 0 1 3.25 17v-1a.75.75 0 0 1 .75-.75"/>
  </svg>
`;
const ExportToHtml = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8 2.25A2.75 2.75 0 0 0 5.25 5v3a.75.75 0 0 0 1.5 0V5c0-.69.56-1.25 1.25-1.25h7.522c.386 0 .75.178.987.483l2.478 3.186c.17.22.263.49.263.767V18c0 .69-.56 1.25-1.25 1.25H8c-.69 0-1.25-.56-1.25-1.25v-1.5a.75.75 0 0 0-1.5 0V18A2.75 2.75 0 0 0 8 20.75h10A2.75 2.75 0 0 0 20.75 18V8.186a2.75 2.75 0 0 0-.58-1.688l-2.477-3.186a2.75 2.75 0 0 0-2.171-1.062zM2.769 13.771c0 .381.206.596.569.596.362 0 .57-.215.57-.596v-.97H5.27v.97c0 .381.207.596.57.596.362 0 .57-.215.57-.596v-2.817c0-.382-.208-.596-.57-.596-.363 0-.57.214-.57.596v.942H3.907v-.942c0-.382-.207-.596-.57-.596-.362 0-.568.214-.568.596zm5.051 0c0 .381.207.596.57.596.362 0 .569-.215.569-.596v-2.439h.572c.3 0 .502-.163.502-.453s-.196-.454-.502-.454H7.248c-.306 0-.502.164-.502.454s.201.454.502.454h.572zm3.046.596c-.317 0-.497-.19-.497-.526v-2.737c0-.478.263-.746.738-.746.4 0 .613.158.774.58l.671 1.748h.021l.67-1.748c.16-.422.373-.58.773-.58.475 0 .738.268.738.746v2.737c0 .336-.18.526-.497.526s-.496-.19-.496-.526v-1.786h-.022l-.77 1.942c-.079.196-.202.284-.404.284-.204 0-.335-.091-.41-.284l-.771-1.942h-.022v1.786c0 .336-.18.526-.496.526m4.428-.663c0 .381.207.596.57.596h1.64c.306 0 .502-.164.502-.454s-.201-.454-.502-.454h-1.071v-2.438c0-.382-.207-.596-.57-.596-.362 0-.57.214-.57.596z" clip-rule="evenodd"/>
  </svg>
`;
const ExportToMarkdown = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8 2.25A2.75 2.75 0 0 0 5.25 5v3a.75.75 0 0 0 1.5 0V5c0-.69.56-1.25 1.25-1.25h7.522c.386 0 .75.178.987.483l2.478 3.186c.17.22.263.49.263.767V18c0 .69-.56 1.25-1.25 1.25H8c-.69 0-1.25-.56-1.25-1.25v-1.5a.75.75 0 0 0-1.5 0V18A2.75 2.75 0 0 0 8 20.75h10A2.75 2.75 0 0 0 20.75 18V8.186a2.75 2.75 0 0 0-.58-1.688l-2.477-3.186a2.75 2.75 0 0 0-2.171-1.062H8M2.769 13.84c0 .337.18.527.496.527.317 0 .497-.19.497-.526v-1.786h.022l.77 1.942c.076.193.207.284.411.284.202 0 .325-.088.403-.284l.77-1.942h.022v1.786c0 .336.18.526.497.526s.497-.19.497-.526v-2.737c0-.478-.263-.746-.738-.746-.4 0-.613.158-.774.58l-.669 1.748h-.021l-.671-1.748c-.162-.422-.374-.58-.774-.58-.475 0-.738.268-.738.746zm4.925-.136c0 .381.207.596.57.596H9.35c1.173 0 1.866-.725 1.866-1.966 0-1.24-.69-1.91-1.866-1.91H8.263c-.362 0-.57.216-.57.597zm1.496-.309h-.357V11.33h.357c.545 0 .867.352.867 1.004 0 .715-.298 1.061-.867 1.061" clip-rule="evenodd"/>
  </svg>
`;
const ExportToPdf = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8 2.25A2.75 2.75 0 0 0 5.25 5v3a.75.75 0 0 0 1.5 0V5c0-.69.56-1.25 1.25-1.25h7.522c.386 0 .75.178.987.483l2.478 3.186c.17.22.263.49.263.767V18c0 .69-.56 1.25-1.25 1.25H8c-.69 0-1.25-.56-1.25-1.25v-1.5a.75.75 0 0 0-1.5 0V18A2.75 2.75 0 0 0 8 20.75h10A2.75 2.75 0 0 0 20.75 18V8.186a2.75 2.75 0 0 0-.58-1.688l-2.477-3.186a2.75 2.75 0 0 0-2.171-1.062H8M2.793 13.923c0 .416.226.65.621.65.396 0 .621-.234.621-.65v-.577h.604c.987 0 1.658-.6 1.658-1.533 0-.94-.633-1.54-1.573-1.54h-1.31c-.395 0-.621.234-.621.65zm1.59-1.494h-.348v-1.222h.358c.404 0 .65.208.65.61 0 .404-.246.612-.66.612m2.353 1.42c0 .417.226.651.621.651h1.187c1.28 0 2.036-.791 2.036-2.145 0-1.353-.753-2.082-2.036-2.082H7.357c-.395 0-.62.234-.62.65zm1.632-.336h-.39V11.26h.39c.595 0 .946.384.946 1.095 0 .78-.325 1.158-.946 1.158m2.698.41c0 .416.226.65.621.65.396 0 .622-.234.622-.65v-.92h1.113c.316 0 .51-.17.51-.466s-.2-.466-.51-.466h-1.113v-.808h1.239c.328 0 .548-.179.548-.495 0-.317-.214-.495-.548-.495h-1.86c-.396 0-.622.234-.622.65z" clip-rule="evenodd"/>
  </svg>
`;
const ExportToPng = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8 2.25A2.75 2.75 0 0 0 5.25 5v3a.75.75 0 0 0 1.5 0V5c0-.69.56-1.25 1.25-1.25h7.522c.386 0 .75.178.987.483l2.478 3.186c.17.22.263.49.263.767V18c0 .69-.56 1.25-1.25 1.25H8c-.69 0-1.25-.56-1.25-1.25v-1.5a.75.75 0 0 0-1.5 0V18A2.75 2.75 0 0 0 8 20.75h10A2.75 2.75 0 0 0 20.75 18V8.186a2.75 2.75 0 0 0-.58-1.688l-2.477-3.186a2.75 2.75 0 0 0-2.171-1.062H8M2.793 13.923c0 .416.226.65.621.65.396 0 .621-.234.621-.65v-.577h.604c.987 0 1.658-.6 1.658-1.533 0-.94-.633-1.54-1.573-1.54h-1.31c-.395 0-.621.234-.621.65zm1.59-1.494h-.348v-1.222h.358c.404 0 .65.208.65.61 0 .404-.246.612-.66.612m2.353 1.529c0 .398.214.615.586.615.37 0 .586-.217.586-.615v-1.685h.024l1.444 1.96c.176.24.343.34.58.34.37 0 .571-.202.571-.574v-3.184c0-.399-.213-.616-.586-.616-.369 0-.586.217-.586.616v1.649h-.023l-1.433-1.925c-.178-.237-.351-.34-.577-.34-.38 0-.586.2-.586.574zm4.275-1.576c0 1.403.794 2.191 2.136 2.191 1.26 0 1.957-.773 1.957-1.778 0-.416-.226-.65-.622-.65h-.817c-.281 0-.46.146-.46.413 0 .266.182.413.46.413h.243l-.006.058c-.035.34-.322.566-.726.566-.545 0-.9-.46-.9-1.23 0-.754.31-1.187.838-1.187.3 0 .501.111.7.378a.68.68 0 0 0 .58.296c.317 0 .534-.214.534-.525a.65.65 0 0 0-.085-.32c-.25-.444-.888-.808-1.735-.808-1.303 0-2.097.797-2.097 2.183" clip-rule="evenodd"/>
  </svg>
`;
const ExportToSvg = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8 2.25A2.75 2.75 0 0 0 5.25 5v3a.75.75 0 0 0 1.5 0V5c0-.69.56-1.25 1.25-1.25h7.522c.386 0 .75.178.987.483l2.478 3.186c.17.22.263.49.263.767V18c0 .69-.56 1.25-1.25 1.25H8c-.69 0-1.25-.56-1.25-1.25v-1.5a.75.75 0 0 0-1.5 0V18A2.75 2.75 0 0 0 8 20.75h10A2.75 2.75 0 0 0 20.75 18V8.186a2.75 2.75 0 0 0-.58-1.688l-2.477-3.186a2.75 2.75 0 0 0-2.171-1.062H8M2.787 13.674c.167.379.672.693 1.545.693 1.068 0 1.691-.507 1.691-1.305 0-.628-.392-.97-1.224-1.12l-.39-.07c-.386-.07-.553-.153-.553-.327s.161-.315.478-.315c.245 0 .425.073.55.266.138.207.29.29.532.29.285-.002.473-.177.473-.435a.6.6 0 0 0-.048-.239c-.202-.483-.752-.754-1.52-.754-.921 0-1.593.491-1.593 1.27 0 .601.422.99 1.193 1.128l.39.07c.434.077.585.155.585.338 0 .19-.21.33-.551.33-.255 0-.48-.078-.615-.268-.153-.215-.298-.282-.513-.282-.282 0-.489.188-.489.462q0 .134.06.268m4.354-.024c.177.497.467.717.948.717.478 0 .773-.223.948-.717l.867-2.455a.9.9 0 0 0 .051-.3c0-.32-.236-.537-.588-.537-.309 0-.486.14-.572.448l-.663 2.414H8.11l-.671-2.398c-.089-.32-.274-.464-.596-.464-.363 0-.61.228-.61.558q.002.178.05.32zm3.015-1.292c0 1.287.728 2.01 1.958 2.01 1.155 0 1.794-.71 1.794-1.631 0-.381-.207-.596-.57-.596h-.748c-.258 0-.422.134-.422.379 0 .244.167.378.422.378h.223l-.006.054c-.032.311-.295.518-.666.518-.5 0-.824-.421-.824-1.128 0-.69.284-1.087.768-1.087.274 0 .459.102.642.346.14.185.308.271.531.271.29 0 .49-.196.49-.48a.6.6 0 0 0-.079-.293c-.228-.408-.814-.741-1.59-.741-1.195 0-1.923.73-1.923 2" clip-rule="evenodd"/>
  </svg>
`;
const EyePanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12.5 18c6.276 0 8.807-4.875 9.372-6.181a.8.8 0 0 0 0-.638C21.307 9.875 18.776 5 12.5 5s-8.807 4.875-9.372 6.181a.8.8 0 0 0 0 .638C3.693 13.125 6.224 18 12.5 18m-1.885-6.5a1.885 1.885 0 1 1 3.77 0 1.885 1.885 0 0 1-3.77 0M12.5 8a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7" clip-rule="evenodd"/>
  </svg>
`;
const Facebook = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M22 12.06C22 6.505 17.523 2 12 2S2 6.504 2 12.06c0 5.024 3.656 9.185 8.438 9.94v-7.03h-2.54v-2.91h2.54V9.845c0-2.52 1.492-3.914 3.777-3.914 1.094 0 2.238.197 2.238.197v2.475h-1.262c-1.242 0-1.629.777-1.629 1.572v1.887h2.774l-.443 2.908h-2.33V22c4.78-.755 8.437-4.916 8.437-9.94"/>
  </svg>
`;
const FacebookDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#1877F2" d="M22 12.06C22 6.505 17.523 2 12 2S2 6.504 2 12.06c0 5.024 3.656 9.185 8.438 9.94v-7.03h-2.54v-2.91h2.54V9.845c0-2.52 1.492-3.914 3.777-3.914 1.094 0 2.238.197 2.238.197v2.475h-1.262c-1.242 0-1.629.777-1.629 1.572v1.887h2.774l-.443 2.908h-2.33V22c4.78-.755 8.437-4.916 8.437-9.94"/>
  </svg>
`;
const Favorite = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M10.362 3.22c.57-1.51 2.707-1.51 3.276 0l1.56 4.144a.25.25 0 0 0 .223.162l4.423.203c1.613.075 2.273 2.107 1.012 3.116l-3.459 2.764a.25.25 0 0 0-.085.262l1.173 4.27c.428 1.556-1.3 2.812-2.65 1.925l-3.698-2.435a.25.25 0 0 0-.274 0l-3.699 2.435c-1.348.887-3.077-.369-2.65-1.926l1.174-4.27a.25.25 0 0 0-.085-.26l-3.459-2.765c-1.261-1.009-.6-3.041 1.012-3.116l4.423-.203a.25.25 0 0 0 .223-.162zm1.872.53a.25.25 0 0 0-.468 0l-1.56 4.143a1.75 1.75 0 0 1-1.558 1.131l-4.423.204a.25.25 0 0 0-.144.445l3.458 2.765a1.75 1.75 0 0 1 .595 1.83l-1.173 4.27a.25.25 0 0 0 .378.275l3.699-2.435a1.75 1.75 0 0 1 1.924 0l3.698 2.435a.25.25 0 0 0 .379-.275l-1.173-4.27a1.75 1.75 0 0 1 .595-1.83l3.458-2.765a.25.25 0 0 0-.144-.445l-4.423-.204a1.75 1.75 0 0 1-1.558-1.131z" clip-rule="evenodd"/>
  </svg>
`;
const Favorited = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M13.638 3.22c-.57-1.51-2.707-1.51-3.276 0l-1.56 4.144a.25.25 0 0 1-.223.162l-4.423.203c-1.613.075-2.273 2.107-1.012 3.116l3.459 2.764a.25.25 0 0 1 .085.262l-1.173 4.27c-.428 1.556 1.3 2.812 2.65 1.925l3.698-2.435a.25.25 0 0 1 .274 0l3.699 2.435c1.348.887 3.077-.369 2.65-1.926l-1.174-4.27a.25.25 0 0 1 .085-.26l3.459-2.765c1.261-1.009.6-3.041-1.012-3.116l-4.423-.203a.25.25 0 0 1-.223-.162z" clip-rule="evenodd"/>
  </svg>
`;
const Figma = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path stroke='currentColor' stroke-width="2" d="M11.836 16.321v3.56c0 1.965-1.531 3.56-3.418 3.56-1.886 0-3.417-1.595-3.417-3.56s1.531-3.56 3.417-3.56m3.418 0H8.418m3.418 0V9.202m-3.418 7.12c-1.886 0-3.417-1.595-3.417-3.56s1.531-3.56 3.417-3.56m0 0h3.418m-3.418 0c-1.886 0-3.417-1.594-3.417-3.56 0-1.964 1.531-3.559 3.418-3.559h3.417m0 7.12v-7.12m0 7.12h3.417m-3.417-7.12h3.417c1.886 0 3.417 1.595 3.417 3.56s-1.531 3.56-3.417 3.56m0 0c-1.887 0-3.418 1.594-3.418 3.559s1.531 3.56 3.418 3.56c1.886 0 3.417-1.595 3.417-3.56s-1.531-3.56-3.417-3.56Z"/>
  </svg>
`;
const FigmaDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#0ACF83" d="M8.418 22.503a3.42 3.42 0 0 0 3.418-3.417v-3.417H8.418a3.418 3.418 0 0 0 0 6.834"/><path fill="#A259FF" d="M5.001 12.251a3.42 3.42 0 0 1 3.417-3.417h3.418v6.835H8.418a3.42 3.42 0 0 1-3.417-3.418"/><path fill="#F24E1E" d="M5.001 5.417A3.42 3.42 0 0 1 8.42 2h3.417v6.834H8.419A3.42 3.42 0 0 1 5 5.417"/><path fill="#FF7262" d="M11.836 2h3.417a3.418 3.418 0 0 1 0 6.834h-3.417z"/><path fill="#1ABCFE" d="M18.67 12.251a3.418 3.418 0 0 1-6.834 0 3.418 3.418 0 0 1 6.834 0"/>
  </svg>
`;
const File = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8.17 2.25H13a.75.75 0 0 1 .53.22l6 6c.141.14.22.331.22.53v8.83c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.75 2.75 0 0 1-1.201 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.344.03H8.17c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 4.55 20.25c-.172-.338-.24-.694-.27-1.074-.03-.365-.03-.81-.03-1.345V6.17c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 5.752 2.55c.337-.172.693-.24 1.073-.27.365-.03.81-.03 1.345-.03M6.947 3.775c-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v11.6c0 .572 0 .957.025 1.252.023.288.065.425.111.515.12.236.311.427.547.547.09.046.227.088.514.111.296.024.68.025 1.253.025h7.6c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.547c.046-.09.088-.227.111-.515.024-.295.025-.68.025-1.252V9.75H14A1.75 1.75 0 0 1 12.25 8V3.75H8.2c-.572 0-.957 0-1.253.025M13.75 4.81l3.44 3.439H14a.25.25 0 0 1-.25-.25z" clip-rule="evenodd"/>
  </svg>
`;
const FilePanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6.882 4C5.842 4 5 4.843 5 5.882v12.236C5 19.158 5.843 20 6.882 20h9.412c1.04 0 1.883-.843 1.883-1.882V9.882H13V4H6.882m7.65.333 3.43 4.116a.157.157 0 0 1-.12.257h-3.587V4.433c0-.146.183-.213.277-.1" clip-rule="evenodd"/>
  </svg>
`;
const Filter = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25m-4 6.5a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5zm.25 3.75a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75M11 14.75a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5z" clip-rule="evenodd"/>
  </svg>
`;
const FilterMinus = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.75 11.526a7.776 7.776 0 0 1 15.553 0 .75.75 0 0 0 1.5 0q0-.522-.057-1.03c-.513-4.638-4.444-8.246-9.22-8.246a9.276 9.276 0 0 0-9.276 9.276c0 4.776 3.608 8.707 8.247 9.22q.507.057 1.03.057a.75.75 0 0 0 0-1.5 7.778 7.778 0 0 1-7.776-7.776m3.987-3.118a.75.75 0 1 0 0 1.5h6.847a.75.75 0 0 0 0-1.5zM7.934 12a.75.75 0 0 1 .75-.75H13.5a.75.75 0 0 1 0 1.5H8.684a.75.75 0 0 1-.75-.75m2.645 2.092a.75.75 0 1 0 0 1.5h.826a.75.75 0 0 0 0-1.5zM15.85 17.5a.65.65 0 0 1 .65-.65h1.979a.65.65 0 1 1 0 1.3H16.5a.65.65 0 0 1-.65-.65m-1.7 0a3.35 3.35 0 1 1 6.7 0 3.35 3.35 0 0 1-6.7 0m3.35-4.65a4.65 4.65 0 1 0 0 9.3 4.65 4.65 0 0 0 0-9.3" clip-rule="evenodd"/>
  </svg>
`;
const FilterUndo = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5.575 2.018a.75.75 0 0 0-1.15.964l15.5 18.5a.75.75 0 0 0 1.15-.964zM21.75 12a9.7 9.7 0 0 1-1.634 5.404L19.11 16.19a8.25 8.25 0 0 0-9.91-11.951L8.189 3.023A9.7 9.7 0 0 1 12 2.25c5.385 0 9.75 4.365 9.75 9.75m-8.1 3.874-.931-1.124H11a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 .65-.377M9 13.25h2.475l-1.244-1.5H9a.75.75 0 0 0 0 1.5m7-3h-1.816l-1.244-1.5H16a.75.75 0 0 1 0 1.5m-7.013 0L7.772 8.785A.75.75 0 0 0 8 10.25zM3.75 12c0-2.12.8-4.054 2.115-5.515l-.967-1.166A9.72 9.72 0 0 0 2.25 12c0 5.385 4.365 9.75 9.75 9.75a9.7 9.7 0 0 0 5.252-1.534l-.966-1.165A8.25 8.25 0 0 1 3.75 12" clip-rule="evenodd"/>
  </svg>
`;
const Filtered = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18M8 8.75a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5zm1 3a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5zm1.25 3.75a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75" clip-rule="evenodd"/>
  </svg>
`;
const FirePanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M12 22c4.117 0 7.5-3.263 7.5-7.451 0-1.028-.052-2.13-.622-3.843-.263-.79-.429-1.262-.59-1.645-.187-.445-.897-.327-1.096.112-.515 1.13-1.329 1.67-1.587 1.868 0-.28-.833-3.373-2.096-5.224-.94-1.378-2.138-2.396-3.093-3.16-.329-.263-.838-.025-.879.395-.135 1.395-.506 3.01-.994 3.928-.619 1.162-.735 1.205-1.507 2.07s-1.127 1.133-1.772 2.182c-.646 1.05-.764 2.449-.764 3.477 0 4.188 3.383 7.29 7.5 7.29"/>
  </svg>
`;
const Flag2Panel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5.5 4a.5.5 0 0 0-.5.5v16a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-16a.5.5 0 0 0-.5-.5zm3 1a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h9.762a.5.5 0 0 0 .464-.686l-1.652-4.128a.5.5 0 0 1 0-.372l1.652-4.128A.5.5 0 0 0 18.262 5z" clip-rule="evenodd"/>
  </svg>
`;
const Flag3Panel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6 4a.5.5 0 0 0-.5.5v16a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-16A.5.5 0 0 0 7 4zm2.5 11.154V5.846a.5.5 0 0 1 .741-.438l8.462 4.654a.5.5 0 0 1 0 .876l-8.462 4.654a.5.5 0 0 1-.741-.438" clip-rule="evenodd"/>
  </svg>
`;
const FlagPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5.5 4a.5.5 0 0 0-.5.5v16a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-16a.5.5 0 0 0-.5-.5zm3 1a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>
  </svg>
`;
const FlashPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M16.08 3H8.873c-.446 0-.841.285-.981.708L4.95 12.586a1.033 1.033 0 0 0 .981 1.358H9.2l-1.122 6.96c-.082.509.549.811.894.429l9.474-10.509c.599-.665.127-1.725-.768-1.725h-3.53l2.81-4.52A1.033 1.033 0 0 0 16.079 3"/>
  </svg>
`;
const FlipDirection = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="m5.208 11.106.694-.617a.75.75 0 0 1 .996 1.122l-1.96 1.74a.75.75 0 0 1-1.012-.014L2.08 11.596a.75.75 0 1 1 1.03-1.091l.592.558a8.351 8.351 0 0 1 14.203-4.967.75.75 0 1 1-1.06 1.06 6.851 6.851 0 0 0-11.636 3.95m14.397-.525a.75.75 0 0 1 .531.257l1.826 2.094a.75.75 0 0 1-1.13.986l-.576-.66A8.352 8.352 0 0 1 5.97 17.776a.75.75 0 0 1 1.083-1.038 6.852 6.852 0 0 0 11.702-3.593l-.863.823a.75.75 0 0 1-1.035-1.086l2.196-2.094a.75.75 0 0 1 .552-.207" clip-rule="evenodd"/>
  </svg>
`;
const FlowerPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M9.002 6.027a.48.48 0 0 1-.506.165l-2.541-.726a.464.464 0 0 0-.585.35C5.23 6.495 5 7.746 5 8.659c0 4.281 3.276 6.636 6.186 7.063l-.003.07V21.5a.951.951 0 1 0 1.902 0v-5.707l-.002-.071c2.91-.427 6.185-2.782 6.185-7.063 0-.913-.23-2.164-.37-2.843a.464.464 0 0 0-.584-.35l-2.542.726a.48.48 0 0 1-.506-.165L12.51 2.483a.476.476 0 0 0-.751 0zM5.396 17.102a.713.713 0 1 0-.792 1.187l4.28 2.853a.713.713 0 1 0 .792-1.187zm13.952 0a.713.713 0 1 1 .792 1.187l-4.28 2.853a.713.713 0 1 1-.792-1.187z" clip-rule="evenodd"/>
  </svg>
`;
const Folder = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5 5.25c-.69 0-1.25.56-1.25 1.25V17c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V8.5c0-.69-.56-1.25-1.25-1.25h-6.5a.75.75 0 0 1-.53-.22l-1.415-1.414a1.25 1.25 0 0 0-.883-.366zM2.25 6.5A2.75 2.75 0 0 1 5 3.75h4.672c.729 0 1.428.29 1.944.805l1.195 1.195H19a2.75 2.75 0 0 1 2.75 2.75V17A2.75 2.75 0 0 1 19 19.75H5A2.75 2.75 0 0 1 2.25 17z" clip-rule="evenodd"/>
  </svg>
`;
const Folder2Panel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4 4v4h17V6a1 1 0 0 0-1-1h-8L9.774 3.22A1 1 0 0 0 9.149 3H5a1 1 0 0 0-1 1m0 5.5h17V18a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm12.25 2.75A.75.75 0 0 1 17 13v1.5h1.5a.75.75 0 0 1 0 1.5H17v1.5a.75.75 0 0 1-1.5 0V16H14a.75.75 0 0 1 0-1.5h1.5V13a.75.75 0 0 1 .75-.75" clip-rule="evenodd"/>
  </svg>
`;
const Folder3Panel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4 4v4h17V6a1 1 0 0 0-1-1h-8L9.774 3.22A1 1 0 0 0 9.149 3H5a1 1 0 0 0-1 1m0 5.5h17V18a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm9.404 3.888a1.373 1.373 0 0 1 2.216.44l.055.127.046-.102a1.362 1.362 0 0 1 2.218-.388 1.634 1.634 0 0 1-.034 2.31l-2.127 2.065a.25.25 0 0 1-.353-.005l-2.056-2.117a1.647 1.647 0 0 1 .035-2.33" clip-rule="evenodd"/>
  </svg>
`;
const FolderPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4 8V4a1 1 0 0 1 1-1h4.15a1 1 0 0 1 .624.22L12 5h8a1 1 0 0 1 1 1v2zm17 1.5H4V18a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2z" clip-rule="evenodd"/>
  </svg>
`;
const Font = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M1 18.161c0 .468.387.804.916.804.457 0 .722-.214.895-.702l1.292-3.642h5.809l1.302 3.642c.173.488.437.702.895.702.53 0 .916-.336.916-.804 0-.132-.03-.285-.112-.509L8.183 4.875c-.225-.6-.59-.875-1.15-.875-.6 0-.977.285-1.2.885L1.111 17.652c-.081.224-.112.377-.112.509m8.393-5.097H4.632l2.35-6.694h.06zm4.26 2.767c0 1.903 1.414 3.174 3.52 3.174 1.425 0 2.778-.793 3.408-2.004h.04v1.11c0 .528.347.894.845.894.489 0 .834-.366.834-.895v-6.602c0-2.106-1.566-3.449-4.048-3.449-1.72 0-3.266.763-3.866 1.923a1.53 1.53 0 0 0-.214.732c0 .478.326.794.784.794.335 0 .57-.132.732-.427.59-1.048 1.373-1.465 2.523-1.465 1.465 0 2.32.773 2.32 2.065v.885l-3.042.173c-2.442.142-3.836 1.281-3.836 3.092m6.877-1.027c0 1.526-1.292 2.696-2.96 2.696-1.272 0-2.116-.662-2.116-1.669 0-.997.814-1.627 2.238-1.719l2.838-.173z" clip-rule="evenodd"/>
  </svg>
`;
const FoodPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5.5 8h2L5.247 4.62a.832.832 0 0 0-1.385.924zM11 8H9L7.362 5.544a.832.832 0 0 1 1.385-.923zM5 9a1 1 0 0 0-1 1v1h16v-1a1 1 0 0 0-1-1zm15 3a8 8 0 1 1-16 0z" clip-rule="evenodd"/>
  </svg>
`;
const ForwardPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.5 6.227v11.546c0 .863 1.02 1.32 1.664.747l5.336-4.742v3.995c0 .863 1.02 1.32 1.664.747l6.495-5.773a1 1 0 0 0 0-1.494l-6.495-5.774c-.644-.573-1.664-.115-1.664.748v3.995L6.164 5.48C5.52 4.906 4.5 5.364 4.5 6.227" clip-rule="evenodd"/>
  </svg>
`;
const ForwardThirtySeconds = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.25 12a8.75 8.75 0 0 1 14.584-6.522l.002.002 1.414 1.277V4a.75.75 0 0 1 1.5 0v4.444a.75.75 0 0 1-.75.75h-4.444a.75.75 0 1 1 0-1.5h2.494l-1.217-1.098-.001-.001A7.25 7.25 0 0 0 6.888 17.14a.75.75 0 0 1-1.058 1.064A8.73 8.73 0 0 1 3.25 12" clip-rule="evenodd"/><path fill='currentColor' d="M18.032 20.97c-1.897 0-3.027-1.54-3.027-4.009 0-2.457 1.14-3.992 3.027-3.992 1.882 0 3.017 1.525 3.017 3.987s-1.125 4.013-3.017 4.013m0-1.125c1.04 0 1.631-1.06 1.631-2.884 0-1.801-.602-2.867-1.63-2.867-1.035 0-1.642 1.071-1.642 2.862 0 1.823.597 2.889 1.641 2.889M11.173 20.97c-1.349 0-2.223-.55-2.622-1.322a1.1 1.1 0 0 1-.144-.544c0-.363.229-.592.613-.592.282 0 .453.123.597.405.266.581.73.928 1.572.928.874 0 1.466-.501 1.466-1.2.005-.82-.592-1.279-1.578-1.279h-.437c-.341 0-.544-.207-.544-.511s.203-.512.544-.512h.405c.847 0 1.412-.485 1.412-1.167 0-.666-.437-1.114-1.29-1.114-.724 0-1.145.298-1.401.9-.15.331-.299.454-.618.454-.384 0-.587-.224-.587-.576 0-.192.038-.362.134-.549.362-.762 1.215-1.322 2.467-1.322 1.594 0 2.617.832 2.617 2.02 0 .965-.687 1.61-1.615 1.802v.026c1.136.107 1.887.79 1.887 1.86 0 1.365-1.194 2.292-2.878 2.292"/>
  </svg>
`;
const Frame = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M7 20.75a.75.75 0 0 1-.75-.75v-2.25H4a.75.75 0 0 1 0-1.5h2.25v-8.5H4a.75.75 0 0 1 0-1.5h2.25V4a.75.75 0 0 1 1.5 0v2.25h8.5V4a.75.75 0 0 1 1.5 0v2.25H20a.75.75 0 0 1 0 1.5h-2.25v8.5H20a.75.75 0 0 1 0 1.5h-2.25V20a.75.75 0 0 1-1.5 0v-2.25h-8.5V20a.75.75 0 0 1-.75.75m9.25-4.5v-8.5h-8.5v8.5z" clip-rule="evenodd"/>
  </svg>
`;
const FruitPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="m9.59 2.7-.591-.31-.62 1.181.59.31c.766.402 1.296.878 1.663 1.444q.301.463.482 1.056c-2.335-.678-4.16-.21-5.395 1.074-1.366 1.418-1.842 3.668-1.693 5.82.149 2.166.939 4.41 2.323 5.894.7.749 1.563 1.315 2.579 1.554.945.223 1.978.15 3.07-.263 1.094.414 2.127.486 3.073.263 1.016-.239 1.88-.805 2.579-1.554 1.385-1.483 2.175-3.728 2.324-5.893.148-2.153-.328-4.403-1.694-5.82-1.299-1.35-3.249-1.799-5.759-.962a5.7 5.7 0 0 0-.77-1.894c-.512-.788-1.228-1.41-2.162-1.9"/>
  </svg>
`;
const GamePanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M7.106 2.867A3.224 3.224 0 0 0 3.882 6.09v9.67a3.224 3.224 0 0 0 3.224 3.224h3.727a.57.57 0 0 0 .57-.57V3.437a.57.57 0 0 0-.57-.571zm.107 3.682a.885.885 0 1 0 0 1.77h1.142a.885.885 0 1 0 0-1.77zm1.713 7.734a1.142 1.142 0 1 1-2.284 0 1.142 1.142 0 0 1 2.284 0m7.85-9.267A3.224 3.224 0 0 1 20 8.239v9.67a3.224 3.224 0 0 1-3.224 3.224H13.05a.57.57 0 0 1-.57-.57V5.586a.57.57 0 0 1 .57-.571zm-.772 9.724c.378 0 .685.307.685.685v.457h.457a.685.685 0 0 1 0 1.37h-.457v.456a.685.685 0 1 1-1.37 0v-.456h-.457a.685.685 0 1 1 0-1.37h.457v-.457c0-.378.307-.685.685-.685m1.142-6.165a1.142 1.142 0 1 1-2.283 0 1.142 1.142 0 0 1 2.283 0" clip-rule="evenodd"/>
  </svg>
`;
const GiftPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M6.342 5.026A2.526 2.526 0 0 1 8.868 2.5c1.27 0 2.405.576 3.158 1.482A4.1 4.1 0 0 1 15.184 2.5a2.526 2.526 0 0 1 2.527 2.526c0 .814-.237 1.573-.646 2.21h1.593a1.895 1.895 0 0 1 0 3.79h-5.684v-3.79h.631c1.221 0 2.21-.989 2.21-2.21a.63.63 0 0 0-.63-.631c-1.222 0-2.211.99-2.211 2.21v.632h-1.895v-.632c0-1.22-.99-2.21-2.21-2.21a.63.63 0 0 0-.632.631c0 1.221.99 2.21 2.21 2.21h.632v3.79H5.395a1.895 1.895 0 1 1 0-3.79h1.592a4.1 4.1 0 0 1-.645-2.21M12.974 12.921h6.631v4.737a2.84 2.84 0 0 1-2.842 2.842h-3.79zM11.079 12.921H4.447v4.737A2.84 2.84 0 0 0 7.29 20.5h3.79z"/>
  </svg>
`;
const Github = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 2C6.475 2 2 6.588 2 12.253c0 4.537 2.863 8.369 6.838 9.727.5.09.687-.218.687-.487 0-.243-.013-1.05-.013-1.91C7 20.059 6.35 18.957 6.15 18.38c-.113-.295-.6-1.205-1.025-1.448-.35-.192-.85-.667-.013-.68.788-.012 1.35.744 1.538 1.051.9 1.551 2.338 1.116 2.912.846.088-.666.35-1.115.638-1.371-2.225-.256-4.55-1.14-4.55-5.062 0-1.115.387-2.038 1.025-2.756-.1-.256-.45-1.307.1-2.717 0 0 .837-.269 2.75 1.051.8-.23 1.65-.346 2.5-.346s1.7.115 2.5.346c1.912-1.333 2.75-1.05 2.75-1.05.55 1.409.2 2.46.1 2.716.637.718 1.025 1.628 1.025 2.756 0 3.934-2.337 4.806-4.562 5.062.362.32.675.936.675 1.897 0 1.371-.013 2.473-.013 2.82 0 .268.188.589.688.486a10.04 10.04 0 0 0 4.932-3.74A10.45 10.45 0 0 0 22 12.253C22 6.588 17.525 2 12 2" clip-rule="evenodd"/>
  </svg>
`;
const GithubDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#000" fill-rule="evenodd" d="M12 2C6.475 2 2 6.588 2 12.253c0 4.537 2.863 8.369 6.838 9.727.5.09.687-.218.687-.487 0-.243-.013-1.05-.013-1.91C7 20.059 6.35 18.957 6.15 18.38c-.113-.295-.6-1.205-1.025-1.448-.35-.192-.85-.667-.013-.68.788-.012 1.35.744 1.538 1.051.9 1.551 2.338 1.116 2.912.846.088-.666.35-1.115.638-1.371-2.225-.256-4.55-1.14-4.55-5.062 0-1.115.387-2.038 1.025-2.756-.1-.256-.45-1.307.1-2.717 0 0 .837-.269 2.75 1.051.8-.23 1.65-.346 2.5-.346s1.7.115 2.5.346c1.912-1.333 2.75-1.05 2.75-1.05.55 1.409.2 2.46.1 2.716.637.718 1.025 1.628 1.025 2.756 0 3.934-2.337 4.806-4.562 5.062.362.32.675.936.675 1.897 0 1.371-.013 2.473-.013 2.82 0 .268.188.589.688.486a10.04 10.04 0 0 0 4.932-3.74A10.45 10.45 0 0 0 22 12.253C22 6.588 17.525 2 12 2" clip-rule="evenodd"/>
  </svg>
`;
const GithubPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 3c-4.972 0-9 4.13-9 9.228 0 4.083 2.576 7.532 6.154 8.754.45.081.619-.196.619-.438 0-.22-.012-.946-.012-1.719-2.261.427-2.846-.565-3.026-1.084-.101-.265-.54-1.084-.923-1.303-.315-.173-.764-.6-.01-.612.708-.011 1.214.67 1.383.946.81 1.396 2.104 1.004 2.621.762.079-.6.315-1.004.574-1.235-2.003-.23-4.095-1.026-4.095-4.556 0-1.003.349-1.834.922-2.48-.09-.23-.404-1.176.09-2.445 0 0 .754-.242 2.476.946a8.2 8.2 0 0 1 2.25-.312c.765 0 1.53.104 2.25.312 1.72-1.2 2.474-.946 2.474-.946.495 1.269.18 2.215.09 2.445.574.646.923 1.465.923 2.48 0 3.541-2.104 4.326-4.106 4.556.326.289.607.842.607 1.707 0 1.235-.011 2.227-.011 2.538 0 .242.169.53.619.438a9.04 9.04 0 0 0 4.439-3.366A9.4 9.4 0 0 0 21 12.228C21 7.129 16.973 3 12 3" clip-rule="evenodd"/>
  </svg>
`;
const Gitlab = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="m11.856 20.423 3.367-10.363H8.49zM11.856 20.423 8.488 10.06H3.77zM3.77 10.06l-1.024 3.15a.7.7 0 0 0 .253.779l8.857 6.434zM3.769 10.06h4.72L6.46 3.818a.349.349 0 0 0-.663 0z"/><path fill='currentColor' d="m11.856 20.423 3.367-10.363h4.72zM19.943 10.06l1.023 3.15a.7.7 0 0 1-.253.779l-8.857 6.434z"/><path fill='currentColor' d="M19.943 10.06h-4.72l2.028-6.242a.349.349 0 0 1 .663 0z"/>
  </svg>
`;
const GitlabDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#E24329" d="m11.856 20.423 3.367-10.363H8.49z"/><path fill="#FC6D26" d="M11.856 20.423 8.488 10.06H3.77z"/><path fill="#FCA326" d="m3.77 10.06-1.024 3.15a.7.7 0 0 0 .253.779l8.857 6.434z"/><path fill="#E24329" d="M3.769 10.06h4.72L6.46 3.818a.349.349 0 0 0-.663 0z"/><path fill="#FC6D26" d="m11.856 20.423 3.367-10.363h4.72z"/><path fill="#FCA326" d="m19.943 10.06 1.023 3.15a.7.7 0 0 1-.253.779l-8.857 6.434z"/><path fill="#E24329" d="M19.943 10.06h-4.72l2.028-6.242a.349.349 0 0 1 .663 0z"/>
  </svg>
`;
const GobletPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M4.206 4.769a.5.5 0 0 0-.354.853l7.538 7.55v5.839H8.43a.5.5 0 0 0-.5.5v.22a.5.5 0 0 0 .5.5h7.14a.5.5 0 0 0 .5-.5v-.22a.5.5 0 0 0-.5-.5h-2.96v-5.84l7.538-7.55a.5.5 0 0 0-.354-.852z"/>
  </svg>
`;
const Good = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M10.473 3.104c.24-.527.768-.854 1.337-.854 1.584 0 2.9 1.257 2.9 2.846V8.1c0 .038.036.1.121.1h3.054c2.04 0 3.644 1.783 3.325 3.805l-.939 5.95c-.256 1.622-1.68 2.795-3.325 2.795H5.243c-1.359 0-2.493-1.08-2.493-2.45v-5.95c0-1.37 1.134-2.45 2.493-2.45h2.049c.058 0 .099-.033.114-.066zM8.608 19.25h8.338c.935 0 1.707-.663 1.843-1.53l.94-5.95c.168-1.067-.68-2.07-1.844-2.07H14.83c-.878 0-1.621-.699-1.621-1.6V5.096c0-.72-.6-1.337-1.383-1.346l-3.056 6.706q-.069.15-.163.279zm-1.5-7.85v7.85H5.243c-.566 0-.993-.443-.993-.95v-5.95c0-.507.427-.95.993-.95z" clip-rule="evenodd"/>
  </svg>
`;
const Google = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M21.56 10.05H12v3.9h5.51A5.848 5.848 0 0 1 6.15 12 5.85 5.85 0 0 1 12 6.15c1.491 0 2.848.563 3.881 1.482l2.758-2.758A9.7 9.7 0 0 0 12 2.25c-5.384 0-9.75 4.366-9.75 9.75s4.366 9.75 9.75 9.75 9.75-4.366 9.75-9.75c0-.654-.067-1.332-.19-1.95"/>
  </svg>
`;
const GoogleDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#FFC107" d="M21.56 10.05H12v3.9h5.51A5.848 5.848 0 0 1 6.15 12 5.85 5.85 0 0 1 12 6.15c1.491 0 2.848.563 3.881 1.482l2.758-2.758A9.7 9.7 0 0 0 12 2.25c-5.384 0-9.75 4.366-9.75 9.75s4.366 9.75 9.75 9.75 9.75-4.366 9.75-9.75c0-.654-.067-1.332-.19-1.95"/><path fill="#FF3D00" d="m3.374 7.462 3.203 2.35A5.85 5.85 0 0 1 12 6.15c1.491 0 2.848.563 3.881 1.482l2.758-2.758A9.7 9.7 0 0 0 12 2.25a9.74 9.74 0 0 0-8.626 5.212"/><path fill="#4CAF50" d="M12 21.75a9.7 9.7 0 0 0 6.537-2.531l-3.018-2.554A5.8 5.8 0 0 1 12 17.85a5.85 5.85 0 0 1-5.5-3.874l-3.18 2.45C4.934 19.584 8.21 21.75 12 21.75"/><path fill="#1976D2" d="M21.56 10.05H12v3.9h5.51a5.87 5.87 0 0 1-1.992 2.716h.001l3.018 2.553c-.213.194 3.213-2.344 3.213-7.219 0-.654-.067-1.332-.19-1.95"/>
  </svg>
`;
const GoogleMap = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M9.084 17.075q.81 1.052 1.469 2.207c.374.724.53 1.215.804 2.087.168.482.32.626.646.626.355 0 .516-.245.64-.623.26-.824.462-1.452.782-2.046.629-1.147 1.41-2.166 2.177-3.146.208-.277 1.55-1.891 2.155-3.166 0 0 .743-1.4.743-3.354 0-1.828-.733-3.097-.733-3.097l-2.11.576-1.28 3.44-.318.475-.063.086-.084.108-.148.172-.212.215-1.14.948-2.853 1.679z"/><path fill='currentColor' d="M6.14 12.78c.697 1.62 2.04 3.045 2.948 4.296l4.824-5.826s-.68.906-1.913.906c-1.373 0-2.482-1.118-2.482-2.528 0-.966.57-1.63.57-1.63l-3.275.894zM13.966 3.3a6.5 6.5 0 0 1 3.803 3.262l-3.856 4.684s.57-.676.57-1.636c0-1.443-1.19-2.52-2.478-2.52-1.217 0-1.916.904-1.916.904v-2.95z"/><path fill='currentColor' d="M7.024 5.37C7.981 4.201 9.665 3 11.987 3c1.126 0 1.975.301 1.975.301l-3.877 4.696H7.34z"/><path fill='currentColor' d="M6.14 12.78S5.5 11.5 5.5 9.647c0-1.75.668-3.28 1.524-4.279l3.063 2.628z"/>
  </svg>
`;
const GoogleMapDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#fff" d="m10 15 5-3-5-3z"/><path fill="#34A853" d="M9.084 17.075q.81 1.052 1.469 2.207c.374.724.53 1.215.804 2.087.168.482.32.626.646.626.355 0 .516-.245.64-.623.26-.824.462-1.452.782-2.046.629-1.147 1.41-2.166 2.177-3.146.208-.277 1.55-1.891 2.155-3.166 0 0 .743-1.4.743-3.354 0-1.828-.733-3.097-.733-3.097l-2.11.576-1.28 3.44-.318.475-.063.086-.084.108-.148.172-.212.215-1.14.948-2.853 1.679z"/><path fill="#FBBC04" d="M6.14 12.78c.697 1.62 2.04 3.045 2.948 4.296l4.824-5.826s-.68.906-1.913.906c-1.373 0-2.482-1.118-2.482-2.528 0-.966.57-1.63.57-1.63l-3.275.894z"/><path fill="#4285F4" d="M13.966 3.3a6.5 6.5 0 0 1 3.803 3.262l-3.856 4.684s.57-.676.57-1.636c0-1.443-1.19-2.52-2.478-2.52-1.217 0-1.916.904-1.916.904v-2.95z"/><path fill="#1A73E8" d="M7.024 5.37C7.981 4.201 9.665 3 11.987 3c1.126 0 1.975.301 1.975.301l-3.877 4.696H7.34z"/><path fill="#EA4335" d="M6.14 12.78S5.5 11.5 5.5 9.647c0-1.75.668-3.28 1.524-4.279l3.063 2.628z"/>
  </svg>
`;
const GooglePanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M19.844 10.35H12v3.2h4.521a4.798 4.798 0 0 1-9.321-1.6 4.8 4.8 0 0 1 4.8-4.8c1.224 0 2.337.462 3.184 1.216l2.263-2.263A7.96 7.96 0 0 0 12 3.95a8 8 0 1 0 8 8c0-.536-.055-1.093-.156-1.6"/>
  </svg>
`;
const Grid = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.5 5.5a1 1 0 0 1 1-1H7a1 1 0 0 1 1 1V7a1 1 0 0 1-1 1H5.5a1 1 0 0 1-1-1zm0 12a1 1 0 0 1 1-1H7a1 1 0 0 1 1 1V19a1 1 0 0 1-1 1H5.5a1 1 0 0 1-1-1zm6 0a1 1 0 0 1 1-1H13a1 1 0 0 1 1 1V19a1 1 0 0 1-1 1h-1.5a1 1 0 0 1-1-1zm7-1a1 1 0 0 0-1 1V19a1 1 0 0 0 1 1H19a1 1 0 0 0 1-1v-1.5a1 1 0 0 0-1-1zm-6-12a1 1 0 0 0-1 1V7a1 1 0 0 0 1 1H13a1 1 0 0 0 1-1V5.5a1 1 0 0 0-1-1zm5 1a1 1 0 0 1 1-1H19a1 1 0 0 1 1 1V7a1 1 0 0 1-1 1h-1.5a1 1 0 0 1-1-1zm-11 5a1 1 0 0 0-1 1V13a1 1 0 0 0 1 1H7a1 1 0 0 0 1-1v-1.5a1 1 0 0 0-1-1zm5 1a1 1 0 0 1 1-1H13a1 1 0 0 1 1 1V13a1 1 0 0 1-1 1h-1.5a1 1 0 0 1-1-1zm7-1a1 1 0 0 0-1 1V13a1 1 0 0 0 1 1H19a1 1 0 0 0 1-1v-1.5a1 1 0 0 0-1-1z" clip-rule="evenodd"/>
  </svg>
`;
const Group = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M5.778 4.75c-.564 0-1.028.464-1.028 1.028v1.778a.75.75 0 0 1-1.5 0V5.778A2.533 2.533 0 0 1 5.778 3.25h1.778a.75.75 0 0 1 0 1.5zM15.694 4a.75.75 0 0 1 .75-.75h1.778a2.533 2.533 0 0 1 2.528 2.528v1.778a.75.75 0 0 1-1.5 0V5.778c0-.564-.464-1.028-1.028-1.028h-1.778a.75.75 0 0 1-.75-.75M4 15.694a.75.75 0 0 1 .75.75v1.778c0 .564.464 1.028 1.028 1.028h1.778a.75.75 0 0 1 0 1.5H5.778a2.533 2.533 0 0 1-2.528-2.528v-1.778a.75.75 0 0 1 .75-.75M20 15.694a.75.75 0 0 1 .75.75v1.778a2.533 2.533 0 0 1-2.528 2.528h-1.778a.75.75 0 0 1 0-1.5h1.778c.564 0 1.028-.464 1.028-1.028v-1.778a.75.75 0 0 1 .75-.75"/><path fill='currentColor' fill-rule="evenodd" d="M14.75 11.25V8.8c0-.904-.77-1.55-1.607-1.55H8.857c-.838 0-1.607.646-1.607 1.55v2.4c0 .904.77 1.55 1.607 1.55h.394l-.001.05v2.4c0 .904.77 1.55 1.607 1.55h4.286c.838 0 1.607-.646 1.607-1.55v-2.4c0-.904-.77-1.55-1.607-1.55zm-6-2.45v2.402q.001.004.013.015a.14.14 0 0 0 .094.033h4.286a.14.14 0 0 0 .094-.033l.012-.015.001-.002V8.798l-.013-.015a.14.14 0 0 0-.094-.033H8.857a.14.14 0 0 0-.094.033l-.013.015zm2.107 3.95a.14.14 0 0 0-.094.033l-.012.015-.001.002v2.402l.013.015a.14.14 0 0 0 .094.033h4.286a.14.14 0 0 0 .094-.033l.012-.015.001-.002v-2.402l-.013-.015a.14.14 0 0 0-.094-.033z" clip-rule="evenodd"/>
  </svg>
`;
const GroupPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M4.37 7.637a3.532 3.532 0 1 1 7.065 0 3.532 3.532 0 0 1-7.065 0M7.84 12.052c3.103 0 6.007 2.555 6.337 7.24a.663.663 0 0 1-.66.708H2.161a.66.66 0 0 1-.66-.709c.33-4.684 3.234-7.239 6.337-7.239M15.85 4.104a3.532 3.532 0 1 0 0 7.065 3.532 3.532 0 0 0 0-7.065M15.498 19.198c.02.275-.018.548-.108.802h6.198a.66.66 0 0 0 .66-.709c-.33-4.684-3.234-7.239-6.337-7.239-1.05 0-2.077.292-2.989.86 1.425 1.468 2.388 3.62 2.576 6.286"/>
  </svg>
`;
const Grouping = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M2.75 6A2.75 2.75 0 0 1 5.5 3.25h13A2.75 2.75 0 0 1 21.25 6v12a2.75 2.75 0 0 1-2.75 2.75h-13A2.75 2.75 0 0 1 2.75 18zm11.5-1.25h-4.5v14.5h4.5zm1.5 14.5V4.75h2.75c.69 0 1.25.56 1.25 1.25v12c0 .69-.56 1.25-1.25 1.25zM5.5 4.75h2.75v14.5H5.5c-.69 0-1.25-.56-1.25-1.25V6c0-.69.56-1.25 1.25-1.25" clip-rule="evenodd"/>
  </svg>
`;
const Gt = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M17.25 12a.75.75 0 0 1-.442.684l-10 4.5-.616-1.368L14.672 12l-8.48-3.816.616-1.368 10 4.5a.75.75 0 0 1 .442.684" clip-rule="evenodd"/>
  </svg>
`;
const HamburgerPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.098 9.84C4.7 6.814 8.008 4.5 12 4.5s7.3 2.314 7.902 5.34c.108.541-.35.993-.902.993H5c-.552 0-1.01-.452-.902-.993M19 14.833h-3.333l-1.293 1.293a1 1 0 0 1-1.414 0l-1.293-1.293H5a1 1 0 0 1-1-1v-.666a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v.666a1 1 0 0 1-1 1M4.5 16.5H11l2.008 1.757a1 1 0 0 0 1.317 0l2.008-1.757H19.5a.5.5 0 0 1 .5.5v1.5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V17a.5.5 0 0 1 .5-.5" clip-rule="evenodd"/>
  </svg>
`;
const Hand = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M14.733 20.75a11.3 11.3 0 0 1-4.415-.993l-5.44-2.56a2.238 2.238 0 0 1-1.06-2.967c.251-.533.703-.944 1.256-1.144a2.2 2.2 0 0 1 1.694.081l1.016.479c-.477-1.621-1.431-4.305-2.862-5.873l-.883-.717a2.145 2.145 0 0 1 1.014-3.78 2.14 2.14 0 0 1 1.565.36A12.1 12.1 0 0 1 9.39 6.4c.26-.389.637-.684 1.077-.841a2.15 2.15 0 0 1 1.687.08c.235.11.45.26.636.442.238-.27.542-.475.883-.593a2.02 2.02 0 0 1 1.572.08c.279.126.524.318.715.558q.148-.097.318-.15a1.55 1.55 0 0 1 1.987.938l2.11 5.881a6.5 6.5 0 0 1 0 4.35 5.32 5.32 0 0 1-3.223 3.232c-.78.26-1.598.385-2.42.372m-8.802-6.414c-.128-.027-.32-.035-.417 0a.88.88 0 0 0-.512.461.89.89 0 0 0 .433 1.196l5.404 2.613s3.197 1.488 5.828.54a3.9 3.9 0 0 0 2.438-2.41 5.13 5.13 0 0 0 0-3.445l-2.12-5.881a.22.22 0 0 0-.202-.157.23.23 0 0 0-.222.307l.3.886a.664.664 0 0 1-.397.886.66.66 0 0 1-.883-.399l-.583-1.63a.8.8 0 0 0-.38-.416.71.71 0 0 0-.556 0 .725.725 0 0 0-.468.886l.247.93a.657.657 0 0 1-.45.797.65.65 0 0 1-.812-.407l-.583-1.612a.885.885 0 0 0-1.122-.523.884.884 0 0 0-.52 1.125l.423 1.187a.67.67 0 0 1-.397.886.66.66 0 0 1-.883-.399A10.23 10.23 0 0 0 5.77 4.921a.793.793 0 0 0-1.104.177c-.127.168-.116.326-.091.536.024.21.13.402.293.536l.883.744.061.062C8.223 9.57 9.345 14.637 9.39 14.85a.67.67 0 0 1-.239.664.67.67 0 0 1-.688.08l-1.54-.797c-.385-.21-.466-.282-.991-.46"/>
  </svg>
`;
const HappyPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m3-6a3 3 0 1 1-5.83-1h5.66c.11.313.17.65.17 1m-5-3.5c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S8.448 9 9 9s1 .672 1 1.5m5 1.5c.552 0 1-.672 1-1.5S15.552 9 15 9s-1 .672-1 1.5.448 1.5 1 1.5" clip-rule="evenodd"/>
  </svg>
`;
const HeaderColumn = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5 3.25A2.75 2.75 0 0 0 2.25 6v12A2.75 2.75 0 0 0 5 20.75h14A2.75 2.75 0 0 0 21.75 18V6A2.75 2.75 0 0 0 19 3.25zm4.75 16v-4.5h4.5v4.5zm6 0H19c.69 0 1.25-.56 1.25-1.25v-3.25h-4.5zm0-6h4.5v-3.5h-4.5zm0-5h4.5V6c0-.69-.56-1.25-1.25-1.25h-3.25zm-1.5-3.5v3.5h-4.5v-3.5zm0 5v3.5h-4.5v-3.5z" clip-rule="evenodd"/>
  </svg>
`;
const HeaderRow = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5 3.25A2.75 2.75 0 0 0 2.25 6v12A2.75 2.75 0 0 0 5 20.75h14A2.75 2.75 0 0 0 21.75 18V6A2.75 2.75 0 0 0 19 3.25zm-1.25 10v-3.5h4.5v3.5zm6 0v-3.5h4.5v3.5zm4.5 1.5h-4.5v4.5h4.5zm1.5 4.5v-4.5h4.5V18c0 .69-.56 1.25-1.25 1.25zm0-6v-3.5h4.5v3.5zm-12 1.5h4.5v4.5H5c-.69 0-1.25-.56-1.25-1.25z" clip-rule="evenodd"/>
  </svg>
`;
const Heading1 = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M17.926 6.578v10.898c0 .602.33.963.862.963.541 0 .862-.351.862-.963V5.726c0-.682-.451-1.153-1.093-1.153-.39 0-.742.15-1.373.622l-2.026 1.504c-.4.29-.591.561-.591.852 0 .38.3.692.672.692.22 0 .43-.08.721-.291l1.885-1.374zM4.42 4.903a.77.77 0 0 1 .77.77v5.35h6.168v-5.35a.77.77 0 1 1 1.54 0v12.242a.77.77 0 0 1-1.54 0v-5.351H5.19v5.351a.77.77 0 1 1-1.54 0V5.673a.77.77 0 0 1 .77-.77" clip-rule="evenodd"/>
  </svg>
`;
const Heading2 = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M14.159 16c-.562.638-.725.905-.725 1.248 0 .553.439.886 1.135.886h6.289c.524 0 .829-.276.829-.724 0-.457-.324-.734-.83-.734H15.57v-.114l3.526-4.031c1.715-1.953 2.201-2.859 2.201-4.098 0-2.096-1.648-3.583-3.993-3.583-2.515 0-4.088 1.697-4.088 3.317 0 .514.305.867.772.867.39 0 .658-.258.791-.763.286-1.238 1.191-1.972 2.42-1.972 1.449 0 2.411.896 2.411 2.24 0 .895-.41 1.695-1.486 2.925zM3.419 5.364c.404 0 .731.327.731.731v5.087h5.863V6.095a.732.732 0 1 1 1.464 0v11.637a.732.732 0 0 1-1.464 0v-5.087H4.15v5.087a.732.732 0 1 1-1.463 0V6.095c0-.404.327-.731.732-.731" clip-rule="evenodd"/>
  </svg>
`;
const Heading3 = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.05 5.856a.75.75 0 0 0-1.5 0v11.921a.75.75 0 1 0 1.5 0v-5.21h6.006v5.21a.75.75 0 0 0 1.5 0V5.856a.75.75 0 0 0-1.5 0v5.21H4.05zm9.479 9.234c-.418 0-.713.304-.713.732 0 1.454 1.796 2.936 4.248 2.936 2.642 0 4.486-1.558 4.486-3.782 0-1.635-1.226-3.041-2.832-3.222v-.095c1.321-.228 2.395-1.596 2.395-3.031 0-1.977-1.692-3.393-4.068-3.393-2.338 0-3.925 1.425-3.925 2.898 0 .476.285.79.723.79.37 0 .608-.2.798-.723.38-.979 1.235-1.54 2.366-1.54 1.454 0 2.433.875 2.433 2.177s-1.007 2.242-2.395 2.242h-1.121c-.456 0-.76.295-.76.713 0 .409.323.723.76.723h1.188c1.654 0 2.765.978 2.765 2.432s-1.083 2.386-2.784 2.386c-1.293 0-2.281-.57-2.775-1.587-.247-.485-.456-.656-.789-.656" clip-rule="evenodd"/>
  </svg>
`;
const Heading4 = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M18.793 15.755v1.931c0 .552.286.866.79.866.514 0 .8-.314.8-.866v-1.931h.989c.542 0 .847-.267.847-.723 0-.467-.314-.733-.847-.733h-.99V6.696c0-.885-.485-1.38-1.35-1.38-.657 0-1.095.286-1.657 1.114-2.16 3.235-3.016 4.605-4.377 7.013-.333.609-.447.942-.447 1.294 0 .628.495 1.018 1.237 1.018zm0-1.456H14.15v-.095c1.246-2.16 2.94-4.882 4.558-7.27h.085zM2.95 5.705a.73.73 0 0 1 .73.731v5.079h5.855V6.436a.73.73 0 0 1 1.461 0v11.62a.73.73 0 0 1-1.461 0v-5.08H3.68v5.08a.73.73 0 0 1-1.461 0V6.435a.73.73 0 0 1 .73-.73" clip-rule="evenodd"/>
  </svg>
`;
const Heading5 = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M13.615 15.053c-.409 0-.678.316-.678.78 0 1.302 1.534 2.799 3.988 2.799 2.593 0 4.443-1.822 4.443-4.388 0-2.408-1.664-4.1-4.025-4.1-1.07 0-2.157.447-2.575 1.07h-.093l.353-4.137h5.01c.55 0 .856-.251.856-.698 0-.455-.316-.725-.855-.725h-5.215c-.8 0-1.2.326-1.255 1.014l-.41 5.205c-.046.716.224 1.135.754 1.135.297 0 .483-.112 1.162-.744a2.77 2.77 0 0 1 1.905-.725c1.609 0 2.752 1.152 2.752 2.789 0 1.71-1.18 2.9-2.872 2.9-1.116 0-1.971-.54-2.482-1.534-.242-.474-.447-.641-.763-.641M3.082 5.903c.394 0 .714.32.714.715v4.962h5.72V6.618a.714.714 0 1 1 1.427 0v11.351a.714.714 0 1 1-1.428 0v-4.961H3.796v4.961a.714.714 0 1 1-1.428 0V6.618c0-.395.32-.714.714-.714" clip-rule="evenodd"/>
  </svg>
`;
const Heading6 = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M17.65 5.517c-3.098 0-4.825 2.491-4.825 6.98 0 1.932.318 3.379.961 4.406.766 1.203 2.026 1.857 3.603 1.857 2.594 0 4.349-1.746 4.349-4.312 0-2.436-1.661-4.144-4.032-4.144-1.456 0-2.79.803-3.22 1.941h-.074c.028-3.49 1.129-5.32 3.21-5.32.83 0 1.53.3 2.203.962.336.327.532.43.793.43.401 0 .69-.3.69-.7 0-.43-.373-.943-.989-1.344-.709-.486-1.67-.756-2.669-.756m-.196 11.843c-1.652 0-2.809-1.186-2.809-2.856 0-1.652 1.13-2.81 2.744-2.81 1.661 0 2.744 1.12 2.744 2.82 0 1.717-1.074 2.846-2.679 2.846m-14-11.369c.396 0 .717.321.717.717v4.981h5.742V6.708a.717.717 0 0 1 1.434 0v11.396a.717.717 0 1 1-1.434 0v-4.981H4.171v4.981a.717.717 0 1 1-1.433 0V6.708c0-.396.32-.717.717-.717" clip-rule="evenodd"/>
  </svg>
`;
const Headings = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M7.416 4c.506 0 .916.4.916.894v6.212h7.336V4.894c0-.494.41-.894.916-.894s.916.4.916.894v14.212c0 .494-.41.894-.916.894a.905.905 0 0 1-.916-.894v-6.212H8.332v6.212c0 .494-.41.894-.916.894a.905.905 0 0 1-.916-.894V4.894C6.5 4.4 6.91 4 7.416 4" clip-rule="evenodd"/>
  </svg>
`;
const HeadphonePanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M4.889 11.5a6.611 6.611 0 1 1 13.222 0v.944h-1.889a1.89 1.89 0 0 0-1.889 1.89v3.777c0 1.043.846 1.889 1.89 1.889h1.888A1.89 1.89 0 0 0 20 18.111V11.5a8.5 8.5 0 0 0-7.556-8.448V3H11.5A8.5 8.5 0 0 0 3 11.5v6.611C3 19.154 3.846 20 4.889 20h1.889a1.89 1.89 0 0 0 1.889-1.889v-3.778a1.89 1.89 0 0 0-1.89-1.889H4.89z"/>
  </svg>
`;
const HeartPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M12.035 7.466C10.894 4.826 7.463 4.144 5.4 6.148a4.933 4.933 0 0 0-.104 6.975l6.328 6.518a.5.5 0 0 0 .707.01l6.547-6.355a4.893 4.893 0 0 0 .103-6.918c-2.005-2.065-5.459-1.46-6.643 1.162l-.137.306z"/>
  </svg>
`;
const Heartbreak = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 4.924c-2.048-1.87-5.144-2.367-7.547-.32-2.557 2.178-2.927 5.843-.907 8.434.777.997 2.302 2.503 3.776 3.89a166 166 0 0 0 3.706 3.371l.013.012c.07.061.152.134.23.191.09.069.215.15.38.198.223.067.463.067.685 0 .165-.049.29-.13.381-.198.078-.057.16-.13.23-.191l.012-.012c.733-.647 2.218-1.97 3.707-3.371 1.474-1.387 2.998-2.893 3.775-3.89 2.014-2.583 1.7-6.275-.914-8.44-2.433-2.016-5.484-1.545-7.527.326m1.053 1.068L14.53 7.47a.75.75 0 0 1-.195 1.2l-3.069 1.536 2.264 2.264a.75.75 0 0 1-1.06 1.06l-3-3a.75.75 0 0 1 .195-1.2l3.069-1.535L11.47 6.53l-.04-.042c-1.593-1.857-4.134-2.335-6.004-.742-1.953 1.663-2.217 4.42-.697 6.37.695.891 2.134 2.321 3.62 3.72a165 165 0 0 0 3.645 3.314c.736-.65 2.19-1.947 3.644-3.314 1.486-1.399 2.926-2.829 3.62-3.72 1.528-1.96 1.285-4.728-.688-6.363-1.732-1.435-3.936-1.188-5.517.239" clip-rule="evenodd"/>
  </svg>
`;
const Help = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25m.239 8.733c-.923.725-1.245 1.183-1.245 1.99 0 .437.274.765.773.765.478 0 .656-.273.827-.676.157-.575.383-.814 1.046-1.32.875-.65 1.456-1.23 1.456-2.29 0-1.524-1.251-2.46-3.049-2.46-.97 0-1.716.252-2.215.676-.41.362-.676.84-.676 1.292 0 .376.239.684.67.684.287 0 .45-.13.662-.41.329-.561.78-.814 1.436-.814.752 0 1.347.444 1.347 1.114 0 .602-.37.93-1.033 1.45m-.472 3.726c-.567 0-1.032.396-1.032.964 0 .567.465.964 1.032.964s1.039-.397 1.039-.964c0-.568-.472-.964-1.04-.964" clip-rule="evenodd"/>
  </svg>
`;
const HelpCenter = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12.004 3.8a8.2 8.2 0 0 0-7.348 11.845c.265.533.257 1.202.196 1.755-.065.59-.215 1.224-.377 1.79-.103.363-.214.708-.318 1.01h7.847a8.2 8.2 0 0 0 0-16.4M2.266 20.692l.003-.007.012-.028.045-.114a20 20 0 0 0 .61-1.791c.15-.526.274-1.064.326-1.528.055-.503.008-.772-.039-.867A9.76 9.76 0 0 1 2.203 12c0-5.412 4.388-9.8 9.8-9.8s9.8 4.388 9.8 9.8-4.387 9.8-9.8 9.8H3.006a.8.8 0 0 1-.739-1.108m9.7-11.642a1.2 1.2 0 0 0-1.161.9.8.8 0 0 1-1.55-.4 2.8 2.8 0 0 1 5.512.7c0 .856-.414 1.425-.87 1.865-.186.18-.4.357-.598.521l-.086.072a10 10 0 0 0-.68.608.8.8 0 1 1-1.132-1.132c.278-.277.551-.509.789-.706l.091-.076c.204-.169.365-.303.505-.438.295-.284.38-.465.38-.714a1.2 1.2 0 0 0-1.2-1.2m.011 7.5h-.01a.8.8 0 1 1 0-1.6h.01a.8.8 0 0 1 0 1.6" clip-rule="evenodd"/>
  </svg>
`;
const Hexagon = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="m21.86 12-4.921 8.75H7.06L2.14 12l4.922-8.75h9.878zm-5.799-7.25H7.94L3.86 12l4.079 7.25h8.122L20.14 12z" clip-rule="evenodd"/>
  </svg>
`;
const HidePanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6.558 4a.75.75 0 1 0-1.116 1l13 14.5a.75.75 0 0 0 1.116-1zm15.314 7.819a11 11 0 0 1-2.887 3.884l-2.299-2.548a4.5 4.5 0 0 0-5.402-5.989L9.663 5.368C10.51 5.136 11.453 5 12.5 5c6.276 0 8.807 4.875 9.372 6.181.09.206.09.432 0 .638M8 11.5c0-.584.111-1.143.314-1.655L6.015 7.297a11 11 0 0 0-2.887 3.884.8.8 0 0 0 0 .638C3.693 13.125 6.224 18 12.5 18c1.047 0 1.99-.136 2.838-.368l-1.622-1.798A4.5 4.5 0 0 1 8 11.5" clip-rule="evenodd"/>
  </svg>
`;
const HighHeelPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M19.593 14.094c-2.382-1.429-5.838-1.47-7.763-3.473L7.12 5.725c-.445-.463-1.064-.748-1.698-.642-1.681.28-3.462 1.332-1.683 4.11 2.147 3.355 2.409 7.27 2.27 8.807h1.653v-2.802c0-.653.529-1.182 1.182-1.182h.067c.26 0 .515.087.722.246l3.2 2.47a6.09 6.09 0 0 0 7.406.024l.41-.313a1.073 1.073 0 0 0-.098-1.774z"/>
  </svg>
`;
const HighLightDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#7C3AED" d="m5.83 16.441 2.088 2.089-1.34 1.339a.2.2 0 0 1-.18.055L3.37 19.34a.2.2 0 0 1-.103-.338z"/><path fill="#7A7A7A" fill-rule="evenodd" d="M19.01 3.638a2.86 2.86 0 0 0-3.885-.149l-7.804 6.695a2.86 2.86 0 0 0-.74 3.357l.154.337-1.058 1.058a.96.96 0 0 0 0 1.359l2.387 2.386a.96.96 0 0 0 1.359 0l1.058-1.058.336.154a2.86 2.86 0 0 0 3.358-.74l6.694-7.804a2.86 2.86 0 0 0-.148-3.884zm-2.908.99a1.36 1.36 0 0 1 1.847.07L19.66 6.41a1.36 1.36 0 0 1 .07 1.846l-5.088 5.932-4.472-4.472zM9.03 10.696l-.731.626a1.36 1.36 0 0 0-.352 1.597l.352.77c.137.3.081.665-.164.911l-1.015 1.015 1.624 1.625 1.015-1.015a.81.81 0 0 1 .911-.164l.77.351a1.36 1.36 0 0 0 1.597-.351l.627-.731z" clip-rule="evenodd"/>
  </svg>
`;
const HighLightLinear = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M18.336 5.522a.917.917 0 0 0-1.297 0l-1.062 1.062 1.296 1.296 1.063-1.062a.917.917 0 0 0 0-1.296m1.06 2.357A2.417 2.417 0 1 0 15.98 4.46l-1.592 1.592-8.115 8.115-.056.056c-.646.646-1.044 1.044-1.356 1.506a5.8 5.8 0 0 0-.66 1.32c-.183.527-.263 1.084-.392 1.989l-.05.355a.75.75 0 0 0 .89.841l.477-.096c.813-.164 1.314-.265 1.786-.45a5.8 5.8 0 0 0 1.186-.636c.416-.291.777-.652 1.364-1.239zM16.213 8.94l-1.297-1.296-7.583 7.583c-.72.72-1.008 1.012-1.228 1.34q-.307.456-.488.976c-.09.258-.147.531-.221 1.009.467-.099.724-.165.966-.26q.466-.184.876-.47c.295-.206.56-.467 1.213-1.12zM12.083 19.5a.75.75 0 0 1 .75-.75H19.5a.75.75 0 0 1 0 1.5h-6.667a.75.75 0 0 1-.75-.75" clip-rule="evenodd"/>
  </svg>
`;
const History = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M7.168 6.595h-.001l-1.217 1.1H7.5a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75V5a.75.75 0 0 1 1.5 0v1.757l1.416-1.279a8.75 8.75 0 1 1-2.7 8.466.75.75 0 1 1 1.464-.332 7.25 7.25 0 1 0 2.238-7.017" clip-rule="evenodd"/><path fill='currentColor' fill-rule="evenodd" d="M12 6.75a.75.75 0 0 1 .75.75v4.19l2.78 2.78a.75.75 0 1 1-1.06 1.06l-2.971-2.97a.85.85 0 0 1-.249-.601V7.5a.75.75 0 0 1 .75-.75" clip-rule="evenodd"/>
  </svg>
`;
const Home = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M19.5 19.5v-9.022a.5.5 0 0 0-.193-.394l-7-5.445a.5.5 0 0 0-.614 0l-7 5.445a.5.5 0 0 0-.193.394V19.5a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5M3.772 8.9A2 2 0 0 0 3 10.477V19.5a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-9.022a2 2 0 0 0-.772-1.579l-7-5.444a2 2 0 0 0-2.456 0z" clip-rule="evenodd"/>
  </svg>
`;
const HomePanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M4.8 9.4A2 2 0 0 0 4 11v7a2 2 0 0 0 2 2h4v-5h4v5h4a2 2 0 0 0 2-2v-7a2 2 0 0 0-.8-1.6l-6-4.5a2 2 0 0 0-2.4 0z"/>
  </svg>
`;
const Image = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6 3.25A2.75 2.75 0 0 0 3.25 6v12A2.75 2.75 0 0 0 6 20.75h12A2.75 2.75 0 0 0 20.75 18V6A2.75 2.75 0 0 0 18 3.25zM4.75 18v-1.69l4.366-4.365a1.25 1.25 0 0 1 1.768 0l2.586 2.585 2 2a.75.75 0 1 0 1.06-1.06L15.06 14l1.056-1.056a1.25 1.25 0 0 1 1.768 0l1.366 1.367V18c0 .69-.56 1.25-1.25 1.25H6c-.69 0-1.25-.56-1.25-1.25m7.195-7.116L14 12.939l1.056-1.055a2.75 2.75 0 0 1 3.889 0l.305.305V6c0-.69-.56-1.25-1.25-1.25H6c-.69 0-1.25.56-1.25 1.25v8.19l3.305-3.306a2.75 2.75 0 0 1 3.89 0M14 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>
  </svg>
`;
const ImagePanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M18 5.5H6a.5.5 0 0 0-.5.5v8.083l1.798-1.498a1 1 0 0 1 1.348.06L10.5 14.5l3.886-3.023a1 1 0 0 1 1.228 0l2.886 2.245V6a.5.5 0 0 0-.5-.5M6 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm2.5 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" clip-rule="evenodd"/>
  </svg>
`;
const Import = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M12 3.25a.75.75 0 0 1 .75.75v10.19l2.72-2.72a.75.75 0 1 1 1.06 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 1 1 1.06-1.06l2.72 2.72V4a.75.75 0 0 1 .75-.75"/><path fill='currentColor' d="M4 15.25a.75.75 0 0 1 .75.75v1A2.25 2.25 0 0 0 7 19.25h10A2.25 2.25 0 0 0 19.25 17v-1a.75.75 0 0 1 1.5 0v1A3.75 3.75 0 0 1 17 20.75H7A3.75 3.75 0 0 1 3.25 17v-1a.75.75 0 0 1 .75-.75"/>
  </svg>
`;
const ImproveWriting = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M10.25 3a.75.75 0 0 0-1.5 0v3a.75.75 0 0 0 1.5 0zm0 10a.75.75 0 0 0-1.5 0v3a.75.75 0 0 0 1.5 0zm-3.5-3.5a.75.75 0 0 1-.75.75H3a.75.75 0 0 1 0-1.5h3a.75.75 0 0 1 .75.75m9.25.75a.75.75 0 0 0 0-1.5h-3a.75.75 0 0 0 0 1.5zM7.555 7.555a.75.75 0 0 1-1.06 0l-2.121-2.12a.75.75 0 1 1 1.06-1.061l2.121 2.12a.75.75 0 0 1 0 1.061M18.97 20.03a.75.75 0 1 0 1.06-1.06l-7.525-7.525a.75.75 0 0 0-1.06 1.06zM7.555 11.444a.75.75 0 0 1 0 1.061l-2.12 2.121a.75.75 0 1 1-1.061-1.06l2.12-2.122a.75.75 0 0 1 1.061 0m7.072-6.01a.75.75 0 0 0-1.061-1.06l-2.122 2.12a.75.75 0 1 0 1.061 1.061z" clip-rule="evenodd"/>
  </svg>
`;
const Inbox = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6 3.25A2.75 2.75 0 0 0 3.25 6v12A2.75 2.75 0 0 0 6 20.75h12A2.75 2.75 0 0 0 20.75 18V6A2.75 2.75 0 0 0 18 3.25zm13.25 9V6c0-.69-.56-1.25-1.25-1.25H6c-.69 0-1.25.56-1.25 1.25v6.25h1.836c.464 0 .909.184 1.237.513l2.414 2.414a.25.25 0 0 0 .177.073h3.172a.25.25 0 0 0 .177-.073l2.414-2.414a1.75 1.75 0 0 1 1.237-.513zm-14.5 1.5h1.836a.25.25 0 0 1 .177.073l2.414 2.414a1.75 1.75 0 0 0 1.237.513h3.172c.464 0 .909-.184 1.237-.513l2.414-2.414a.25.25 0 0 1 .177-.073h1.836V18c0 .69-.56 1.25-1.25 1.25H6c-.69 0-1.25-.56-1.25-1.25z" clip-rule="evenodd"/>
  </svg>
`;
const Info = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M20.75 6a.75.75 0 0 1-.75.75h-9.353a2.751 2.751 0 0 1-5.293 0H4a.75.75 0 0 1 0-1.5h1.354a2.751 2.751 0 0 1 5.292 0H20a.75.75 0 0 1 .75.75m0 6a.75.75 0 0 1-.75.75h-1.354a2.751 2.751 0 0 1-5.292 0H4a.75.75 0 0 1 0-1.5h9.354a2.751 2.751 0 0 1 5.293 0H20a.75.75 0 0 1 .75.75m0 6a.75.75 0 0 1-.75.75h-9.353a2.751 2.751 0 0 1-5.293 0H4a.75.75 0 0 1 0-1.5h1.354a2.751 2.751 0 0 1 5.292 0H20a.75.75 0 0 1 .75.75m-3.5-6a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m-8-6a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m0 12a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0" clip-rule="evenodd"/>
  </svg>
`;
const Information = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25M13 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 2.75a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 .75-.75" clip-rule="evenodd"/>
  </svg>
`;
const InformationFillDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25M12 7a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2zm1 4a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0z" clip-rule="evenodd"/>
  </svg>
`;
const InformationPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M20.5 11.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0m-9.611-4.253a1.164 1.164 0 1 1 2.322 0l-.358 5.005a.805.805 0 0 1-1.606 0zM12 16a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>
  </svg>
`;
const InsertAbove = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M9.5 6.75a.75.75 0 0 0 0 1.5h1.75V10a.75.75 0 0 0 1.5 0V8.25h1.75a.75.75 0 0 0 0-1.5h-1.75V5a.75.75 0 0 0-1.5 0v1.75zM3.75 18c0 .966.784 1.75 1.75 1.75h13A1.75 1.75 0 0 0 20.25 18v-4a1.75 1.75 0 0 0-1.75-1.75h-13A1.75 1.75 0 0 0 3.75 14zm1.75.25a.25.25 0 0 1-.25-.25v-4a.25.25 0 0 1 .25-.25h13a.25.25 0 0 1 .25.25v4a.25.25 0 0 1-.25.25z" clip-rule="evenodd"/>
  </svg>
`;
const InsertBelow = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M20.25 6a1.75 1.75 0 0 0-1.75-1.75h-13A1.75 1.75 0 0 0 3.75 6v4c0 .966.784 1.75 1.75 1.75h13A1.75 1.75 0 0 0 20.25 10zm-1.75-.25a.25.25 0 0 1 .25.25v4a.25.25 0 0 1-.25.25h-13a.25.25 0 0 1-.25-.25V6a.25.25 0 0 1 .25-.25zm-4 11.5a.75.75 0 0 0 0-1.5h-1.75V14a.75.75 0 0 0-1.5 0v1.75H9.5a.75.75 0 0 0 0 1.5h1.75V19a.75.75 0 0 0 1.5 0v-1.75z" clip-rule="evenodd"/>
  </svg>
`;
const InsertBleow = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.25 6.5A.75.75 0 0 1 5 5.75h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75m0 3.5A.75.75 0 0 1 5 9.25h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75M13 12.75a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5zM12.25 17a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75m-6-4a.75.75 0 0 0-1.5 0v3c0 .414.336.75.75.75h2.75v.75a.75.75 0 0 0 1.28.53l1.5-1.5a.75.75 0 0 0 0-1.06l-1.5-1.5a.75.75 0 0 0-1.28.53v.75h-2z" clip-rule="evenodd"/>
  </svg>
`;
const InsertBlocks = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6.333 4A2.833 2.833 0 0 0 3.5 6.833v2.06a2.833 2.833 0 0 0 2.833 2.834h2.06a2.833 2.833 0 0 0 2.834-2.833v-2.06A2.833 2.833 0 0 0 8.394 4zM5.045 6.833c0-.71.577-1.288 1.288-1.288h2.06c.712 0 1.289.577 1.289 1.288v2.06c0 .712-.577 1.289-1.288 1.289h-2.06a1.29 1.29 0 0 1-1.289-1.288zm1.288 6.44A2.833 2.833 0 0 0 3.5 16.106v2.06A2.833 2.833 0 0 0 6.333 21h2.06a2.833 2.833 0 0 0 2.834-2.833v-2.06a2.833 2.833 0 0 0-2.833-2.834zm-1.288 2.833c0-.711.577-1.288 1.288-1.288h2.06c.712 0 1.289.577 1.289 1.288v2.06c0 .712-.577 1.288-1.288 1.288h-2.06a1.29 1.29 0 0 1-1.289-1.287zm7.728-9.273A2.833 2.833 0 0 1 15.606 4h2.06A2.833 2.833 0 0 1 20.5 6.833v2.06a2.833 2.833 0 0 1-2.833 2.834h-2.06a2.833 2.833 0 0 1-2.834-2.833zm2.833-1.288c-.711 0-1.288.577-1.288 1.288v2.06c0 .712.577 1.289 1.288 1.289h2.06c.712 0 1.288-.577 1.288-1.288v-2.06c0-.712-.576-1.289-1.287-1.289zm1.803 8.5a.773.773 0 1 0-1.545 0v2.319h-2.318a.773.773 0 0 0 0 1.545h2.318v2.318a.773.773 0 0 0 1.545 0V17.91h2.318a.773.773 0 0 0 0-1.545H17.41z" clip-rule="evenodd"/>
  </svg>
`;
const InsertIntoPage = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.25 6A2.75 2.75 0 0 1 7 3.25h10A2.75 2.75 0 0 1 19.75 6v6a.75.75 0 0 1-1.5 0V6c0-.69-.56-1.25-1.25-1.25H7c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h5a.75.75 0 0 1 0 1.5H7A2.75 2.75 0 0 1 4.25 18zm4 2A.75.75 0 0 1 9 7.25h3a.75.75 0 0 1 0 1.5H9A.75.75 0 0 1 8.25 8m0 3.5a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75m9.427 2.288a.75.75 0 0 1 0 1.06l-1.902 1.902h5.26a.75.75 0 0 1 0 1.5h-5.26l1.902 1.902a.75.75 0 0 1-1.06 1.06l-3.183-3.182a.75.75 0 0 1 0-1.06l3.182-3.182a.75.75 0 0 1 1.06 0M8.25 15a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75" clip-rule="evenodd"/>
  </svg>
`;
const InsertLeft = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M14 3.75a1.75 1.75 0 0 0-1.75 1.75v13c0 .966.784 1.75 1.75 1.75h4a1.75 1.75 0 0 0 1.75-1.75v-13A1.75 1.75 0 0 0 18 3.75zm-.25 1.75a.25.25 0 0 1 .25-.25h4a.25.25 0 0 1 .25.25v13a.25.25 0 0 1-.25.25h-4a.25.25 0 0 1-.25-.25zm-5.5 4a.75.75 0 0 0-1.5 0v1.75H5a.75.75 0 0 0 0 1.5h1.75v1.75a.75.75 0 0 0 1.5 0v-1.75H10a.75.75 0 0 0 0-1.5H8.25z" clip-rule="evenodd"/>
  </svg>
`;
const InsertRight = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6 3.75A1.75 1.75 0 0 0 4.25 5.5v13c0 .966.784 1.75 1.75 1.75h4a1.75 1.75 0 0 0 1.75-1.75v-13A1.75 1.75 0 0 0 10 3.75zM5.75 5.5A.25.25 0 0 1 6 5.25h4a.25.25 0 0 1 .25.25v13a.25.25 0 0 1-.25.25H6a.25.25 0 0 1-.25-.25zm11.5 4a.75.75 0 0 0-1.5 0v1.75H14a.75.75 0 0 0 0 1.5h1.75v1.75a.75.75 0 0 0 1.5 0v-1.75H19a.75.75 0 0 0 0-1.5h-1.75z" clip-rule="evenodd"/>
  </svg>
`;
const InsertTop = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6.25 11a.75.75 0 0 1-1.5 0V8a.75.75 0 0 1 .75-.75h2.75V6.5a.75.75 0 0 1 1.28-.53l1.5 1.5a.75.75 0 0 1 0 1.06l-1.5 1.5a.75.75 0 0 1-1.28-.53v-.75h-2zm6-4a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75m0 3.5a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75M5 13.25a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5zm-.75 4.25a.75.75 0 0 1 .75-.75h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75" clip-rule="evenodd"/>
  </svg>
`;
const Instagram = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="url(#a)" d="M16.648 3.25H7.352A4.1 4.1 0 0 0 3.25 7.352v9.296a4.1 4.1 0 0 0 4.102 4.102h9.296a4.1 4.1 0 0 0 4.102-4.102V7.352a4.1 4.1 0 0 0-4.102-4.102"/><path fill='currentColor' d="M16.648 3.25H7.352A4.1 4.1 0 0 0 3.25 7.352v9.296a4.1 4.1 0 0 0 4.102 4.102h9.296a4.1 4.1 0 0 0 4.102-4.102V7.352a4.1 4.1 0 0 0-4.102-4.102"/><path fill='currentColor' d="M11.937 5c-1.857 0-2.09.008-2.819.041-.728.034-1.225.149-1.66.318-.449.174-.83.408-1.21.788s-.614.762-.79 1.211c-.169.435-.284.932-.317 1.66-.032.728-.04.961-.04 2.818s.007 2.089.04 2.818c.034.728.15 1.225.318 1.66.175.449.408.83.788 1.21s.762.614 1.211.79c.435.168.932.283 1.66.317.729.033.961.041 2.818.041s2.089-.008 2.818-.041c.728-.034 1.225-.149 1.66-.318.45-.174.83-.409 1.21-.789s.614-.761.79-1.21c.167-.435.282-.932.317-1.66.032-.729.041-.961.041-2.818s-.009-2.09-.041-2.819c-.035-.727-.15-1.224-.318-1.659a3.36 3.36 0 0 0-.789-1.21 3.3 3.3 0 0 0-1.21-.789c-.436-.17-.933-.284-1.661-.318-.73-.033-.961-.041-2.818-.041zm-.614 1.232h.614c1.825 0 2.041.006 2.762.04.667.03 1.028.141 1.27.235.318.124.546.272.785.511.24.24.387.467.511.786.094.24.205.602.236 1.269.032.72.04.937.04 2.761s-.008 2.041-.04 2.762c-.03.666-.142 1.028-.236 1.269-.123.319-.272.546-.511.785-.24.24-.467.388-.786.511-.24.094-.602.205-1.269.236-.72.033-.937.04-2.762.04-1.826 0-2.042-.007-2.763-.04-.666-.03-1.028-.142-1.269-.236a2.1 2.1 0 0 1-.786-.511 2.1 2.1 0 0 1-.512-.786c-.093-.24-.205-.602-.235-1.269-.033-.72-.04-.937-.04-2.762 0-1.826.007-2.041.04-2.762.03-.666.142-1.028.235-1.269.124-.319.273-.547.512-.786.24-.24.467-.387.786-.512.241-.094.603-.205 1.27-.235.63-.029.874-.037 2.148-.039zm4.263 1.135a.82.82 0 1 0 0 1.64.82.82 0 0 0 0-1.64m-3.65.958a3.51 3.51 0 1 0 .001 7.022 3.51 3.51 0 0 0 0-7.022m0 1.232a2.279 2.279 0 1 1 0 4.557 2.279 2.279 0 0 1 0-4.557"/><defs><radialGradient id="a" cx="0" cy="0" r="1" gradientTransform="matrix(0 -17.3438 16.1311 0 7.898 22.098)" gradientUnits="userSpaceOnUse"><stop stop-color="#FD5"/><stop offset=".1" stop-color="#FD5"/><stop offset=".5" stop-color="#FF543E"/><stop offset="1" stop-color="#C837AB"/></radialGradient></defs>
  </svg>
`;
const InstagramDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="url(#a)" d="M16.648 3.25H7.352A4.1 4.1 0 0 0 3.25 7.352v9.296a4.1 4.1 0 0 0 4.102 4.102h9.296a4.1 4.1 0 0 0 4.102-4.102V7.352a4.1 4.1 0 0 0-4.102-4.102"/><path fill="url(#b)" d="M16.648 3.25H7.352A4.1 4.1 0 0 0 3.25 7.352v9.296a4.1 4.1 0 0 0 4.102 4.102h9.296a4.1 4.1 0 0 0 4.102-4.102V7.352a4.1 4.1 0 0 0-4.102-4.102"/><path fill="#fff" d="M12.037 5c-1.857 0-2.09.008-2.82.041-.727.034-1.224.149-1.658.318-.45.174-.831.408-1.211.788s-.614.762-.79 1.211c-.169.435-.284.932-.317 1.66-.032.728-.041.961-.041 2.818s.008 2.089.041 2.818c.034.728.149 1.225.318 1.66.175.449.408.83.788 1.21s.761.614 1.21.79c.436.168.933.283 1.66.317.73.033.962.041 2.819.041s2.089-.008 2.818-.041c.728-.034 1.225-.149 1.66-.318.45-.174.83-.409 1.21-.789s.614-.761.789-1.21c.168-.435.283-.932.317-1.66.033-.729.042-.961.042-2.818s-.009-2.09-.041-2.819c-.035-.727-.15-1.224-.318-1.659a3.36 3.36 0 0 0-.79-1.21 3.3 3.3 0 0 0-1.21-.789c-.435-.17-.932-.284-1.66-.318-.73-.033-.961-.041-2.819-.041zm-.614 1.232h.614c1.825 0 2.041.006 2.762.04.666.03 1.028.141 1.27.235.318.124.546.272.785.511.239.24.387.467.511.786.094.24.205.602.236 1.269.032.72.04.937.04 2.761s-.008 2.041-.04 2.762c-.03.666-.142 1.028-.236 1.269-.124.319-.272.546-.511.785-.24.24-.467.388-.786.511-.24.094-.603.205-1.27.236-.72.033-.936.04-2.761.04s-2.042-.007-2.763-.04c-.666-.03-1.028-.142-1.27-.236a2.1 2.1 0 0 1-.785-.511 2.1 2.1 0 0 1-.512-.786c-.093-.24-.205-.602-.235-1.269-.033-.72-.04-.937-.04-2.762 0-1.826.007-2.041.04-2.762.03-.666.142-1.028.235-1.269.124-.319.272-.547.512-.786.239-.24.467-.387.786-.512.24-.094.603-.205 1.27-.235.63-.029.874-.037 2.148-.039zm4.262 1.135a.82.82 0 1 0 0 1.64.82.82 0 0 0 0-1.64m-3.649.958a3.51 3.51 0 1 0 .001 7.022 3.51 3.51 0 0 0 0-7.022m0 1.232a2.279 2.279 0 1 1 0 4.558 2.279 2.279 0 0 1 0-4.558"/><defs><radialGradient id="a" cx="0" cy="0" r="1" gradientTransform="matrix(0 -17.3438 16.1311 0 7.898 22.098)" gradientUnits="userSpaceOnUse"><stop stop-color="#FD5"/><stop offset=".1" stop-color="#FD5"/><stop offset=".5" stop-color="#FF543E"/><stop offset="1" stop-color="#C837AB"/></radialGradient><radialGradient id="b" cx="0" cy="0" r="1" gradientTransform="rotate(78.681 -2.592 2.45)scale(7.75277 31.9572)" gradientUnits="userSpaceOnUse"><stop stop-color="#3771C8"/><stop offset=".128" stop-color="#3771C8"/><stop offset="1" stop-color="#60F" stop-opacity="0"/></radialGradient></defs>
  </svg>
`;
const Insync = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M11 4.75a4.25 4.25 0 0 0-4.147 5.183.75.75 0 0 1-.568.896 3.252 3.252 0 0 0-1.435 5.609.75.75 0 1 1-.992 1.124 4.751 4.751 0 0 1 1.42-7.99A5.75 5.75 0 0 1 16.485 7.27a5.75 5.75 0 0 1 2.966 10.33.75.75 0 1 1-.901-1.2 4.25 4.25 0 0 0-2.635-7.65.75.75 0 0 1-.75-.6A4.25 4.25 0 0 0 11 4.75m-1.29 8.311a2.978 2.978 0 0 1 5.161 1.17.75.75 0 1 0 1.453-.373 4.478 4.478 0 0 0-8.036-1.4l-.57-.242a.3.3 0 0 0-.411.338l.474 2.283a.3.3 0 0 0 .454.192l1.971-1.246a.3.3 0 0 0-.043-.53zm2.063 5.327a2.97 2.97 0 0 0 2.278-1.062l-.453-.191a.3.3 0 0 1-.043-.53l1.971-1.247a.3.3 0 0 1 .454.193l.475 2.283a.3.3 0 0 1-.41.337l-.571-.241a4.47 4.47 0 0 1-3.701 1.958 4.47 4.47 0 0 1-4.336-3.358.75.75 0 1 1 1.453-.374 2.973 2.973 0 0 0 2.883 2.232" clip-rule="evenodd"/>
  </svg>
`;
const Integrations = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.5 5.389c0-1.043.846-1.889 1.889-1.889h3.778c1.043 0 1.889.846 1.889 1.889v3.778a1.89 1.89 0 0 1-1.89 1.889H5.39A1.89 1.89 0 0 1 3.5 9.166zM5.389 5h3.778c.214 0 .389.174.389.389v3.778a.39.39 0 0 1-.39.389H5.39A.39.39 0 0 1 5 9.166V5.39C5 5.174 5.174 5 5.389 5" clip-rule="evenodd"/><path fill='currentColor' d="M16.486 3.5c.391 0 .708.317.708.708V6.57h2.361a.708.708 0 0 1 0 1.417h-2.36v2.361a.708.708 0 0 1-1.417 0v-2.36h-2.361a.708.708 0 0 1 0-1.418h2.36V4.21c0-.392.318-.709.709-.709"/><path fill='currentColor' fill-rule="evenodd" d="M5.389 12.945A1.89 1.89 0 0 0 3.5 14.833v3.778c0 1.043.846 1.889 1.889 1.889h3.778a1.89 1.89 0 0 0 1.889-1.889v-3.778a1.89 1.89 0 0 0-1.89-1.889zm3.778 1.5H5.389a.39.39 0 0 0-.389.388v3.778c0 .215.174.389.389.389h3.778a.39.39 0 0 0 .389-.389v-3.778a.39.39 0 0 0-.39-.389M12.944 14.833c0-1.043.846-1.889 1.89-1.889h3.777c1.043 0 1.889.846 1.889 1.89v3.777A1.89 1.89 0 0 1 18.61 20.5h-3.778a1.89 1.89 0 0 1-1.889-1.889zm1.89-.389h3.777c.215 0 .389.175.389.39v3.777a.39.39 0 0 1-.389.389h-3.778a.39.39 0 0 1-.389-.389v-3.778c0-.214.174-.389.39-.389" clip-rule="evenodd"/>
  </svg>
`;
const Invisible = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.6 7.55a.75.75 0 0 0-1.2.9 10.8 10.8 0 0 0 2.939 2.69l-1.963 2.944a.75.75 0 0 0 1.248.832l2-3a1 1 0 0 0 .044-.075c1.108.489 2.315.796 3.582.883V17.5a.75.75 0 1 0 1.5 0v-4.776a10.7 10.7 0 0 0 3.582-.883q.02.038.044.075l2 3a.75.75 0 0 0 1.248-.832l-1.962-2.944A10.8 10.8 0 0 0 20.6 8.45a.75.75 0 1 0-1.2-.9 9.24 9.24 0 0 1-7.4 3.7 9.24 9.24 0 0 1-7.402-3.7" clip-rule="evenodd"/>
  </svg>
`;
const Issue = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12" clip-rule="evenodd"/><path fill='currentColor' d="M14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0"/>
  </svg>
`;
const Italic = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M14.608 3.25H10.25a.75.75 0 0 0 0 1.5h3.34l-4.758 14.5H5a.75.75 0 0 0 0 1.5h8.75a.75.75 0 0 0 0-1.5h-3.34l4.758-14.5H19a.75.75 0 0 0 0-1.5h-4.392" clip-rule="evenodd"/>
  </svg>
`;
const Journal = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M16.25 4.5H18a.5.5 0 0 1 .5.5v14a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5V5a.5.5 0 0 1 .5-.5h4.25V11a.75.75 0 0 0 1.166.624l1.834-1.223 1.834 1.223A.75.75 0 0 0 16.25 11zM4 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm7.75 4.599V4.75h3v4.849l-1.084-.723a.75.75 0 0 0-.832 0z" clip-rule="evenodd"/>
  </svg>
`;
const Keyboard = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6.997 8.92a1 1 0 1 0-1.993.16 1 1 0 0 0 1.993-.16m8.508 3.16a1 1 0 1 0 1.993-.16 1 1 0 0 0-1.993.16m-1.001-.16a1 1 0 1 0-1.993.16 1 1 0 0 0 1.993-.16M7.999 9.08a1 1 0 1 0 1.993-.16 1 1 0 0 0-1.993.16M2.25 7A2.75 2.75 0 0 1 5 4.25h14A2.75 2.75 0 0 1 21.75 7v10A2.75 2.75 0 0 1 19 19.75H5A2.75 2.75 0 0 1 2.25 17zM5 5.75c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V7c0-.69-.56-1.25-1.25-1.25zm1 9.5a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H6.75a.75.75 0 0 1-.75-.75m5.213-3.958A1 1 0 1 0 9.8 12.708a1 1 0 0 0 1.414-1.416m-3 0a1 1 0 1 0-1.415 1.415 1 1 0 0 0 1.415-1.415m4.49-3a1 1 0 1 0-1.414 1.416 1 1 0 0 0 1.415-1.415m3.001 0a1 1 0 1 0-1.414 1.415 1 1 0 0 0 1.414-1.414m3.001 0a1 1 0 1 0-1.415 1.416 1 1 0 0 0 1.415-1.415" clip-rule="evenodd"/>
  </svg>
`;
const Language = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M9 2.25a.75.75 0 0 1 .75.75v1.25H15a.75.75 0 0 1 0 1.5h-1.625a18.7 18.7 0 0 1-3.51 7.68 9 9 0 0 0 1.085.97.75.75 0 0 1-.9 1.2c-.405-.304-.79-.645-1.153-1.012A18.8 18.8 0 0 1 3.334 18.8a.75.75 0 0 1-.668-1.344 17.3 17.3 0 0 0 5.238-4.01c-1.05-1.36-1.819-2.9-2.211-4.235a.75.75 0 1 1 1.439-.424c.319 1.085.93 2.332 1.747 3.458a17.2 17.2 0 0 0 2.963-6.496H3.5a.75.75 0 1 1 0-1.5h4.75V3A.75.75 0 0 1 9 2.25m7 8a.75.75 0 0 1 .671.415l3.493 6.986.014.028 1.493 2.986a.75.75 0 1 1-1.342.67l-1.292-2.585h-6.073l-1.293 2.585a.75.75 0 1 1-1.342-.67l1.493-2.986.014-.028 3.493-6.986A.75.75 0 0 1 16 10.25m-2.286 7h4.573L16 12.677z" clip-rule="evenodd"/>
  </svg>
`;
const Layer = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M11.754 3.802a.75.75 0 0 1 .631-.01l7.92 3.523a.75.75 0 0 1 .021 1.36l-8.08 3.904a.75.75 0 0 1-.632.01L3.696 9.067a.75.75 0 0 1-.021-1.36zm.34 1.502-6.312 3.05 6.124 2.723 6.312-3.049zm8.581 6.56a.75.75 0 0 1-.349 1.002l-8.08 3.904a.75.75 0 0 1-.632.01l-7.919-3.523a.75.75 0 0 1 .61-1.37l7.601 3.38 7.768-3.752a.75.75 0 0 1 1.001.35m0 4.31a.75.75 0 0 1-.349 1.001l-8.08 3.904a.75.75 0 0 1-.632.01l-7.919-3.522a.75.75 0 0 1 .61-1.371l7.601 3.381 7.768-3.752a.75.75 0 0 1 1.001.349" clip-rule="evenodd"/>
  </svg>
`;
const Layout = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.25 5.74a2.49 2.49 0 0 1 2.49-2.49h3.52a2.49 2.49 0 0 1 2.49 2.49v12.52a2.49 2.49 0 0 1-2.49 2.49H5.74a2.49 2.49 0 0 1-2.49-2.49zm2.49-.99a.99.99 0 0 0-.99.99v12.52c0 .547.443.99.99.99h3.52a.99.99 0 0 0 .99-.99V5.74a.99.99 0 0 0-.99-.99zm7.51.99a2.49 2.49 0 0 1 2.49-2.49h2.52a2.49 2.49 0 0 1 2.49 2.49v3.52a2.49 2.49 0 0 1-2.49 2.49h-2.52a2.49 2.49 0 0 1-2.49-2.49zm2.49-.99a.99.99 0 0 0-.99.99v3.52c0 .547.443.99.99.99h2.52a.99.99 0 0 0 .99-.99V5.74a.99.99 0 0 0-.99-.99zm0 8.5a2.49 2.49 0 0 0-2.49 2.49v2.52a2.49 2.49 0 0 0 2.49 2.49h2.52a2.49 2.49 0 0 0 2.49-2.49v-2.52a2.49 2.49 0 0 0-2.49-2.49zm-.99 2.49a.99.99 0 0 1 .99-.99h2.52a.99.99 0 0 1 .99.99v2.52a.99.99 0 0 1-.99.99h-2.52a.99.99 0 0 1-.99-.99z" clip-rule="evenodd"/>
  </svg>
`;
const LeafPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M20 3.556c-1.482 1.44-5.607 4.39-9.333 5.333-2.549.645-5.511 2.629-3.753 6.688a1 1 0 0 0-.213.079c-2.356 1.226-3.353 3.545-3.572 4.61a.889.889 0 1 0 1.742.358c.147-.714.907-2.484 2.65-3.391a.9.9 0 0 0 .342-.315c1.752 1.509 5.756 2.465 9.47-1.807C18.311 13.987 20 10.222 20 3.556" clip-rule="evenodd"/>
  </svg>
`;
const LeftBracket = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M10.397 3c-.797 0-1.681.263-2.377.686-.661.402-1.373 1.093-1.373 2.042V9.5c0 .709-.726 1.488-1.897 1.488a.75.75 0 0 0 0 1.5c1.17 0 1.897.78 1.897 1.487v3.774c0 .945.708 1.642 1.369 2.05.695.429 1.58.7 2.381.7a.75.75 0 1 0 0-1.5c-.498 0-1.113-.18-1.593-.476-.515-.318-.657-.621-.657-.774v-3.774c0-.928-.456-1.708-1.144-2.237.688-.53 1.144-1.309 1.144-2.238V5.728c0-.15.139-.448.652-.76.48-.292 1.096-.468 1.598-.468a.75.75 0 1 0 0-1.5m3 5a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5zm-.747 3.75a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75M13.4 14a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5z" clip-rule="evenodd"/>
  </svg>
`;
const LiftPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5 6.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v4h8v-4a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V9h1.5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5H19v2.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-4H8v4a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V15H3.5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5H5z" clip-rule="evenodd"/>
  </svg>
`;
const LightMode = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12.75 2.698a.75.75 0 0 0-1.5 0V3.73a.75.75 0 1 0 1.5 0zM5.812 4.75a.75.75 0 0 0-1.06 1.061l.84.842a.75.75 0 0 0 1.061-1.061zm13.437 1.061a.75.75 0 1 0-1.061-1.06l-.841.84a.75.75 0 1 0 1.06 1.062zM2.698 11.25a.75.75 0 0 0 0 1.5H3.73a.75.75 0 0 0 0-1.5zm17.57 0a.75.75 0 0 0 0 1.5h1.034a.75.75 0 0 0 0-1.5zM6.653 18.413a.75.75 0 0 0-1.058-1.063l-.841.837A.75.75 0 0 0 5.81 19.25zm11.754-1.063a.75.75 0 0 0-1.058 1.063l.841.837a.75.75 0 1 0 1.058-1.063zm-5.656 2.919a.75.75 0 0 0-1.5 0v1.033a.75.75 0 1 0 1.5 0zM16.081 12a4.081 4.081 0 1 1-8.162 0 4.081 4.081 0 0 1 8.162 0m1.5 0A5.581 5.581 0 1 1 6.42 12a5.581 5.581 0 0 1 11.162 0" clip-rule="evenodd"/>
  </svg>
`;
const LightPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8.21 10.579 4 6.369l5.895-3.37 1.684 1.685-.518.907q.106.045.202.12l8.42 6.736c.346.276.419.771.169 1.135L16.127 19h1.347a.842.842 0 0 1 0 1.684H6.526a.842.842 0 1 1 0-1.684H7.79v-.842a.842.842 0 1 1 1.685 0V19h4.61l3.936-5.727-7.789-6.23z" clip-rule="evenodd"/>
  </svg>
`;
const LineStyle = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.65 5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3A.75.75 0 0 1 3.65 5m6.1 0a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3A.75.75 0 0 1 9.75 5m7.05-.75a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5zM3.245 12c0-.47.38-.85.85-.85h15.79a.85.85 0 1 1 0 1.7H4.094a.85.85 0 0 1-.85-.85M4.5 17.75a1.25 1.25 0 1 0 0 2.5h15a1.25 1.25 0 1 0 0-2.5z" clip-rule="evenodd"/>
  </svg>
`;
const LinearLogo = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <g clip-path="url(#a)"><path fill='currentColor' d="M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12s5.373 12 12 12 12-5.373 12-12"/><g fill='currentColor' filter="url(#b)"><path d="M5.171 13.613c-.03-.133.128-.216.224-.12l5.112 5.112c.096.096.013.255-.12.223a7.02 7.02 0 0 1-5.216-5.215M5 11.565a.14.14 0 0 0 .04.106l7.29 7.288a.14.14 0 0 0 .105.04 7 7 0 0 0 .975-.129.136.136 0 0 0 .067-.23l-8.116-8.117a.136.136 0 0 0-.231.067 7 7 0 0 0-.13.975M5.59 9.159a.14.14 0 0 0 .029.154l9.068 9.068c.04.04.102.053.154.03q.376-.168.726-.376a.137.137 0 0 0 .026-.216L6.18 8.407a.137.137 0 0 0-.216.026 7 7 0 0 0-.376.726M6.772 7.53a.14.14 0 0 1-.006-.19 7.007 7.007 0 1 1 9.893 9.893.14.14 0 0 1-.19-.005z"/></g></g><defs><filter id="b" width="180.337" height="180.337" x="-78.168" y="-65.173" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="12.995"/><feGaussianBlur stdDeviation="41.584"/><feColorMatrix values="0 0 0 0 0.118924 0 0 0 0 0.158031 0 0 0 0 0.570833 0 0 0 0.7 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_858_5588"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="4.548"/><feGaussianBlur stdDeviation="17.5"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"/><feBlend in2="effect1_dropShadow_858_5588" result="effect2_dropShadow_858_5588"/><feBlend in="SourceGraphic" in2="effect2_dropShadow_858_5588" result="shape"/></filter><clipPath id="a"><path fill='currentColor' d="M0 0H24V24H0z"/></clipPath></defs>
  </svg>
`;
const LinearLogoDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <g clip-path="url(#a)"><path fill="url(#b)" d="M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12s5.373 12 12 12 12-5.373 12-12"/><g filter="url(#c)"><path fill="url(#d)" d="M6.147 13.383c-.027-.114.109-.186.192-.103l4.381 4.381c.083.083.011.219-.103.192a6.02 6.02 0 0 1-4.47-4.47"/><path fill="url(#e)" d="M6 11.627a.12.12 0 0 0 .035.09l6.247 6.248a.12.12 0 0 0 .091.035q.428-.027.836-.111a.117.117 0 0 0 .057-.198L6.31 10.734a.117.117 0 0 0-.198.057 6 6 0 0 0-.11.836"/><path fill="url(#f)" d="M6.505 9.565a.12.12 0 0 0 .025.132l7.773 7.773a.12.12 0 0 0 .132.025 6 6 0 0 0 .623-.323.118.118 0 0 0 .021-.184L7.012 8.92a.118.118 0 0 0-.185.022q-.178.3-.322.623"/><path fill="url(#g)" d="M7.519 8.169a.12.12 0 0 1-.005-.163 6.006 6.006 0 1 1 8.48 8.48.12.12 0 0 1-.163-.005z"/></g></g><defs><filter id="c" width="154.574" height="154.574" x="-65.287" y="-54.148" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="11.139"/><feGaussianBlur stdDeviation="35.644"/><feColorMatrix values="0 0 0 0 0.118924 0 0 0 0 0.158031 0 0 0 0 0.570833 0 0 0 0.7 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_12018_47160"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="3.899"/><feGaussianBlur stdDeviation="15"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"/><feBlend in2="effect1_dropShadow_12018_47160" result="effect2_dropShadow_12018_47160"/><feBlend in="SourceGraphic" in2="effect2_dropShadow_12018_47160" result="shape"/></filter><linearGradient id="b" x1="12" x2="12" y1="0" y2="24" gradientUnits="userSpaceOnUse"><stop stop-color="#5C6BF1"/><stop offset="1" stop-color="#283188"/></linearGradient><linearGradient id="d" x1="6.429" x2="12.686" y1="7.114" y2="16.286" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset="1" stop-color="#fff" stop-opacity=".65"/></linearGradient><linearGradient id="e" x1="6.429" x2="12.686" y1="7.114" y2="16.286" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset="1" stop-color="#fff" stop-opacity=".65"/></linearGradient><linearGradient id="f" x1="6.429" x2="12.686" y1="7.114" y2="16.286" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset="1" stop-color="#fff" stop-opacity=".65"/></linearGradient><linearGradient id="g" x1="6.428" x2="12.686" y1="7.114" y2="16.286" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset="1" stop-color="#fff" stop-opacity=".65"/></linearGradient><clipPath id="a"><path fill="#fff" d="M0 0H24V24H0z"/></clipPath></defs>
  </svg>
`;
const Link = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M18.428 5.572a2.806 2.806 0 0 0-3.967 0l-.978.977a.75.75 0 0 1-1.06-1.06l.977-.978a4.305 4.305 0 1 1 6.089 6.089l-3.556 3.556a4.306 4.306 0 0 1-6.089 0 .75.75 0 0 1 1.061-1.061 2.805 2.805 0 0 0 3.968 0l3.555-3.556a2.806 2.806 0 0 0 0-3.967m-5.333 5.333a2.805 2.805 0 0 0-3.968 0l-3.555 3.556a2.806 2.806 0 0 0 3.967 3.967l.98-.979a.75.75 0 0 1 1.06 1.06l-.979.98A4.305 4.305 0 1 1 4.511 13.4l3.556-3.556a4.306 4.306 0 0 1 6.089 0 .75.75 0 0 1-1.061 1.061" clip-rule="evenodd"/>
  </svg>
`;
const LinkBlock = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M18.428 5.572a2.806 2.806 0 0 0-3.967 0l-.978.977a.75.75 0 0 1-1.06-1.06l.977-.978a4.305 4.305 0 1 1 6.089 6.089l-2.333 2.333-1.414-.707 2.686-2.687a2.806 2.806 0 0 0 0-3.967M8 20.727v-1.512a2.806 2.806 0 0 1-2.428-4.754l3.555-3.556a2.806 2.806 0 0 1 3.963-.005l.436.218a.749.749 0 0 0 .63-1.274 4.306 4.306 0 0 0-6.09 0L4.512 13.4A4.305 4.305 0 0 0 8 20.727"/><path fill='currentColor' fill-rule="evenodd" d="M13.519 12.363c-.2-.1-.437-.1-.638 0l-3.8 1.9a.71.71 0 0 0-.393.637v4.75c0 .27.152.517.393.637l3.8 1.9c.201.1.437.1.638 0l3.8-1.9a.71.71 0 0 0 .393-.637V14.9a.71.71 0 0 0-.393-.637zm-1.031 4.877-2.375-1.187v3.157l2.375 1.187zm3.8 1.97-2.376 1.187V17.24l2.376-1.187zm-.881-4.31L13.2 16.003 10.993 14.9l2.207-1.103z" clip-rule="evenodd"/>
  </svg>
`;
const LinkedEdgeless = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6.5 4.75a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5M3.25 6.5a3.25 3.25 0 0 1 6.49-.25c.794.001 1.56.016 2.357.208.897.217 1.79.645 2.853 1.442l.02.015.02.017c.864.745 1.475 1.75 1.841 2.826a.75.75 0 0 1-1.42.484c-.294-.865-.766-1.62-1.382-2.158-.928-.692-1.633-1.01-2.284-1.167-.675-.163-1.334-.167-2.244-.167A3.26 3.26 0 0 1 7.25 9.663v3.674a3.251 3.251 0 1 1-1.5 0V9.663A3.25 3.25 0 0 1 3.25 6.5m3.25 8.25a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m8-1.5a.75.75 0 0 0 0 1.5h2.69l-3.72 3.72a.75.75 0 1 0 1.06 1.06l3.72-3.72v2.69a.75.75 0 0 0 1.5 0V14a.75.75 0 0 0-.75-.75z" clip-rule="evenodd"/>
  </svg>
`;
const LinkedPage = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.25 6A2.75 2.75 0 0 1 7 3.25h10A2.75 2.75 0 0 1 19.75 6v6a.75.75 0 0 1-1.5 0V6c0-.69-.56-1.25-1.25-1.25H7c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h5a.75.75 0 0 1 0 1.5H7A2.75 2.75 0 0 1 4.25 18zm4 2A.75.75 0 0 1 9 7.25h3a.75.75 0 0 1 0 1.5H9A.75.75 0 0 1 8.25 8M9 10.75a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5zM8.25 15a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75m7.25-.75a.75.75 0 0 0 0 1.5h2.69l-3.72 3.72a.75.75 0 1 0 1.06 1.06l3.72-3.72v2.69a.75.75 0 0 0 1.5 0V15a.75.75 0 0 0-.75-.75z" clip-rule="evenodd"/>
  </svg>
`;
const LocalData = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.75 6.5c0-.69.56-1.25 1.25-1.25h4.672c.331 0 .649.132.883.366L11.97 7.03c.14.141.331.22.53.22H19c.69 0 1.25.56 1.25 1.25V17c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25zM5 3.75A2.75 2.75 0 0 0 2.25 6.5V17A2.75 2.75 0 0 0 5 19.75h14A2.75 2.75 0 0 0 21.75 17V8.5A2.75 2.75 0 0 0 19 5.75h-6.19l-1.194-1.195a2.75 2.75 0 0 0-1.944-.805zm10.48 10.026-3 2.5a.75.75 0 0 1-.96 0l-3-2.5a.75.75 0 1 1 .96-1.152l1.77 1.475v-4.4a.75.75 0 0 1 1.5 0v4.4l1.77-1.475a.75.75 0 1 1 .96 1.152" clip-rule="evenodd"/>
  </svg>
`;
const LocalWorkspace = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M2.75 5.389A2.64 2.64 0 0 1 5.389 2.75H18.61a2.64 2.64 0 0 1 2.639 2.639v9.444a2.64 2.64 0 0 1-2.639 2.64h-3.525l.425 1.7.797.797a.75.75 0 0 1-.53 1.28H8.222a.75.75 0 0 1-.53-1.28l.797-.798.425-1.7H5.39a2.64 2.64 0 0 1-2.639-2.639zm1.5 8.305v1.14c0 .628.51 1.138 1.139 1.138h13.223c.628 0 1.138-.51 1.138-1.139v-1.139zm15.5-1.5H4.25V5.39c0-.63.51-1.139 1.139-1.139H18.61c.63 0 1.139.51 1.139 1.139zm-6.21 5.278h-3.08l-.566 2.265-.003.013h4.218l-.003-.012z" clip-rule="evenodd"/>
  </svg>
`;
const Locate = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 2.25a.75.75 0 0 1 .75.75v1.286a7.75 7.75 0 0 1 6.964 6.964H21a.75.75 0 0 1 0 1.5h-1.286a7.75 7.75 0 0 1-6.964 6.964V21a.75.75 0 0 1-1.5 0v-1.286a7.75 7.75 0 0 1-6.964-6.964H3a.75.75 0 0 1 0-1.5h1.286a7.75 7.75 0 0 1 6.964-6.964V3a.75.75 0 0 1 .75-.75m-.75 3.545a6.25 6.25 0 0 0-5.455 5.455H7a.75.75 0 0 1 0 1.5H5.795a6.25 6.25 0 0 0 5.455 5.456V17a.75.75 0 0 1 1.5 0v1.206a6.25 6.25 0 0 0 5.456-5.456H17a.75.75 0 0 1 0-1.5h1.206a6.25 6.25 0 0 0-5.456-5.455V7a.75.75 0 0 1-1.5 0z" clip-rule="evenodd"/><path fill='currentColor' d="M14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0"/>
  </svg>
`;
const Lock = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6.25 8a5.75 5.75 0 1 1 11.5 0v1.356c.34.058.655.151.953.303a3.75 3.75 0 0 1 1.638 1.638c.227.445.321.925.366 1.471.043.531.043 1.187.043 2v1.464c0 .813 0 1.469-.043 2-.045.546-.14 1.026-.366 1.47a3.75 3.75 0 0 1-1.639 1.64c-.444.226-.924.32-1.47.365-.531.043-1.187.043-2 .043H8.768c-.813 0-1.469 0-2-.043-.546-.045-1.026-.14-1.47-.366a3.75 3.75 0 0 1-1.64-1.639c-.226-.444-.32-.924-.365-1.47-.043-.531-.043-1.187-.043-2v-1.464c0-.813 0-1.469.043-2 .045-.546.14-1.026.366-1.47a3.75 3.75 0 0 1 1.639-1.64c.297-.15.612-.244.952-.302zm1.5 1.254q.465-.005 1.027-.004h6.446q.562-.001 1.027.004V8a4.25 4.25 0 0 0-8.5 0zM8.8 10.75c-.756 0-1.31 0-1.754.027-.551.034-.847.106-1.067.218a2.25 2.25 0 0 0-.984.984c-.1.197-.17.458-.207.912-.037.462-.038 1.056-.038 1.909v1.4c0 .852 0 1.447.038 1.91.037.453.107.714.207.912.216.423.56.767.984.983.197.1.458.17.912.207.462.037 1.057.038 1.909.038h6.4c.852 0 1.447 0 1.91-.038.453-.038.714-.107.912-.207.423-.216.767-.56.983-.983.1-.198.17-.459.207-.913.037-.462.038-1.057.038-1.909v-1.4c0-.853 0-1.447-.038-1.91-.038-.453-.107-.714-.207-.912a2.25 2.25 0 0 0-.983-.983c-.22-.112-.517-.184-1.068-.218a32 32 0 0 0-1.754-.027zm3.2 3a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75" clip-rule="evenodd"/>
  </svg>
`;
const LockPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 3.25A3.25 3.25 0 0 0 8.75 6.5V10H7.5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-1.25V6.5A3.25 3.25 0 0 0 12 3.25M13.75 10V6.5a1.75 1.75 0 1 0-3.5 0V10zM12 12.75a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75" clip-rule="evenodd"/>
  </svg>
`;
const Logo1 = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="m21.602 18.535-1.456-2.523-.497-.86-.846-1.466c-1.49-2.574-4.421-7.67-5.886-10.189-.451-.702-1.497-.647-1.885.08L9.594 6.069l-.496.859-6.409 11.1c-.09.165-.26.434-.345.611-.148.321-.119.72.068 1.017.21.351.605.543 1.007.524h3.832c4.618 0 11.672.003 13.403 0 .84.001 1.368-.92.95-1.645zm-9.94-3.273-.85-1.472a.388.388 0 0 1 .337-.583h1.7c.299 0 .485.324.335.583l-.85 1.472a.388.388 0 0 1-.672 0m-1.424-2.742a5 5 0 0 1-.18-.546l2.811.546zm1.285 3.874q-.18.226-.383.43l-.933-2.708zm2.712-3.05q.287.044.564.117l-1.88 2.162zm-4.35-2.293a7 7 0 0 1-.043-.827l3.714 1.811-3.672-.983zm-.441 2.712.983 3.67a7 7 0 0 1-.696.45zm6.24.01q.38.167.738.377l-3.425 2.311zM9.928 9.055a12 12 0 0 1 .3-1.474l5.642 4.905zm-1.25 9.34c-.47.193-.95.35-1.426.477l1.426-7.337zm8.715-3.587c.4.31.778.65 1.126.997l-7.068 2.433zm-5.147-9.984c1.04 1.805 2.55 4.422 3.99 6.913l-5.372-5.371.89-1.543c.11-.19.383-.19.492 0m-8.39 13.678c.297-.51.703-1.21.793-1.372l3.2-5.542-1.966 7.34h-1.78a.284.284 0 0 1-.246-.425m16.042.428h-7.986l7.341-1.968.89 1.542a.283.283 0 0 1-.244.426z"/>
  </svg>
`;
const Logo1Duotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#000" d="m21.602 18.535-1.456-2.523-.497-.86-.846-1.466c-1.49-2.574-4.421-7.67-5.886-10.189-.451-.702-1.497-.647-1.885.08L9.594 6.069l-.496.859-6.409 11.1c-.09.165-.26.434-.345.611-.148.321-.119.72.068 1.017.21.351.605.543 1.007.524h3.832c4.618 0 11.672.003 13.403 0 .84.001 1.368-.92.95-1.645zm-9.94-3.273-.85-1.472a.388.388 0 0 1 .337-.583h1.7c.299 0 .485.324.335.583l-.85 1.472a.388.388 0 0 1-.672 0m-1.424-2.742a5 5 0 0 1-.18-.546l2.811.546zm1.285 3.874q-.18.226-.383.43l-.933-2.708zm2.712-3.05q.287.044.564.117l-1.88 2.162zm-4.35-2.293a7 7 0 0 1-.043-.827l3.714 1.811-3.672-.983zm-.441 2.712.983 3.67a7 7 0 0 1-.696.45zm6.24.01q.38.167.738.377l-3.425 2.311zM9.928 9.055a12 12 0 0 1 .3-1.474l5.642 4.905zm-1.25 9.34c-.47.193-.95.35-1.426.477l1.426-7.337zm8.715-3.587c.4.31.778.65 1.126.997l-7.068 2.433zm-5.147-9.984c1.04 1.805 2.55 4.422 3.99 6.913l-5.372-5.371.89-1.543c.11-.19.383-.19.492 0m-8.39 13.678c.297-.51.703-1.21.793-1.372l3.2-5.542-1.966 7.34h-1.78a.284.284 0 0 1-.246-.425m16.042.428h-7.986l7.341-1.968.89 1.542a.283.283 0 0 1-.244.426z"/>
  </svg>
`;
const Logo2 = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M3.462 20.18c-.427 0-.824-.22-1.036-.573a1.19 1.19 0 0 1-.073-1.108c.057-.118.147-.272.227-.407q.069-.114.117-.203l8.249-14.263A1.2 1.2 0 0 1 12.003 3c.407 0 .78.203.998.542.88 1.508 2.255 3.89 3.586 6.194l2.235 3.866 1.483 2.564 1.284 2.221c.215.37.215.817-.002 1.193a1.18 1.18 0 0 1-1.03.598H3.515zm14.477-1.458h1.868c.06 0 .116-.031.146-.084a.17.17 0 0 0 0-.168l-1.565-2.705c-1.116-1.243-2.297-2.08-3.513-2.493a1.44 1.44 0 0 1-.194.692l-1.418 2.452a1.4 1.4 0 0 1-.2.267c-.056.083-.176.26-.19.284l-.005.01-.007.008c-.334.41-.702.763-1.122 1.083q-.468.355-1.01.653zM4.83 17.114c-.072.129-.344.598-.607 1.051l-.176.304a.17.17 0 0 0 0 .168c.03.052.084.084.146.084H7.32c1.636-.342 2.953-.945 3.918-1.79a1.44 1.44 0 0 1-.503-.514l-1.418-2.452a1.5 1.5 0 0 1-.132-.305c-.044-.09-.138-.282-.152-.306l-.006-.01-.003-.01a6.5 6.5 0 0 1-.378-1.512c-.05-.387-.07-.79-.062-1.2zm6.975-1.314a.222.222 0 0 0 .355.043l.068-.102 1.383-2.392a.224.224 0 0 0-.14-.329l-.123-.009v.001h-2.766a.224.224 0 0 0-.215.286q.037.072.054.11zm2.306-3.958a6.6 6.6 0 0 1 1.5.43q.542.226 1.07.545c-1.429-2.47-3.296-5.7-4.536-7.848A.17.17 0 0 0 12 4.885a.17.17 0 0 0-.145.084l-1.563 2.703c-.521 1.587-.658 3.028-.407 4.286a1.45 1.45 0 0 1 .698-.178h2.835q.164 0 .33.039c.115.008.313.022.342.022h.013z"/>
  </svg>
`;
const Logo2Duotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#000" d="M3.462 20.18c-.427 0-.824-.22-1.036-.573a1.19 1.19 0 0 1-.073-1.108c.057-.118.147-.272.227-.407q.069-.114.117-.203l8.249-14.263A1.2 1.2 0 0 1 12.003 3c.407 0 .78.203.998.542.88 1.508 2.255 3.89 3.586 6.194l2.235 3.866 1.483 2.564 1.284 2.221c.215.37.215.817-.002 1.193a1.18 1.18 0 0 1-1.03.598H3.515zm14.477-1.458h1.868c.06 0 .116-.031.146-.084a.17.17 0 0 0 0-.168l-1.565-2.705c-1.116-1.243-2.297-2.08-3.513-2.493a1.44 1.44 0 0 1-.194.692l-1.418 2.452a1.4 1.4 0 0 1-.2.267c-.056.083-.176.26-.19.284l-.005.01-.007.008c-.334.41-.702.763-1.122 1.083q-.468.355-1.01.653zM4.83 17.114c-.072.129-.344.598-.607 1.051l-.176.304a.17.17 0 0 0 0 .168c.03.052.084.084.146.084H7.32c1.636-.342 2.953-.945 3.918-1.79a1.44 1.44 0 0 1-.503-.514l-1.418-2.452a1.5 1.5 0 0 1-.132-.305c-.044-.09-.138-.282-.152-.306l-.006-.01-.003-.01a6.5 6.5 0 0 1-.378-1.512c-.05-.387-.07-.79-.062-1.2zm6.975-1.314a.222.222 0 0 0 .355.043l.068-.102 1.383-2.392a.224.224 0 0 0-.14-.329l-.123-.009v.001h-2.766a.224.224 0 0 0-.215.286q.037.072.054.11zm2.306-3.958a6.6 6.6 0 0 1 1.5.43q.542.226 1.07.545c-1.429-2.47-3.296-5.7-4.536-7.848A.17.17 0 0 0 12 4.885a.17.17 0 0 0-.145.084l-1.563 2.703c-.521 1.587-.658 3.028-.407 4.286a1.45 1.45 0 0 1 .698-.178h2.835q.164 0 .33.039c.115.008.313.022.342.022h.013z"/>
  </svg>
`;
const Logo3 = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <g clip-path="url(#a)"><path fill='currentColor' fill-rule="evenodd" d="M5 0a5 5 0 0 0-5 5v14a5 5 0 0 0 5 5h14a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5zM3.653 18.478a1.05 1.05 0 0 0 .951.498H19.46c.374 0 .71-.195.899-.522s.19-.716.002-1.04l-1.12-1.936c-.488-.843-.99-1.71-1.292-2.235L16.42 10.6l-.421-.729c-1.16-2.008-2.36-4.085-3.126-5.4a1.03 1.03 0 0 0-.87-.472c-.389 0-.743.21-.922.546l-7.286 12.6-.007.01-.01.017c-.067.114-.141.24-.188.339-.14.304-.115.684.063.966m13.525-.772h1.628c.053 0 .1-.027.127-.073a.14.14 0 0 0 0-.146l-1.364-2.359c-.973-1.083-2.002-1.814-3.063-2.173a1.25 1.25 0 0 1-.17.604l-1.235 2.137q-.072.124-.174.232l-.166.248-.004.01-.006.006a5.7 5.7 0 0 1-.978.944 7 7 0 0 1-.88.57h6.285M5.749 16.305c-.062.112-.3.52-.529.916l-.154.265a.14.14 0 0 0 0 .146.14.14 0 0 0 .128.073H7.92c1.426-.298 2.574-.823 3.415-1.56a1.26 1.26 0 0 1-.438-.448L9.662 13.56a1.3 1.3 0 0 1-.115-.267l-.017-.034-.115-.233-.006-.009-.003-.007a5.7 5.7 0 0 1-.33-1.319 7 7 0 0 1-.053-1.046zm6.08-1.146a.194.194 0 0 0 .31.038l.06-.09 1.206-2.085a.196.196 0 0 0-.122-.287l-.108-.007h-2.411a.196.196 0 0 0-.187.25l.047.096zm2.011-3.45c.456.074.884.196 1.309.374q.472.197.932.475c-1.246-2.153-2.874-4.97-3.954-6.841a.14.14 0 0 0-.128-.074c-.053 0-.1.028-.126.074L10.51 8.073c-.454 1.384-.574 2.64-.355 3.737.187-.102.395-.155.609-.155h2.471q.143 0 .289.033l.075.005c.094.007.203.015.223.015h.018" clip-rule="evenodd"/></g><defs><clipPath id="a"><path fill='currentColor' d="M0 0H24V24H0z"/></clipPath></defs>
  </svg>
`;
const Logo3Duotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <g clip-path="url(#a)"><path fill="#000" d="M0 5a5 5 0 0 1 5-5h14a5 5 0 0 1 5 5v14a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5z"/><path fill="#fff" stroke="#fff" d="m18.933 17.633.434.25a.65.65 0 0 1-.561.323h-7.914l-.241-.938q.442-.244.819-.53zm0 0 .434.25a.65.65 0 0 0 0-.646h-.001m-.433.396.433-.397m0 0-1.365-2.358-.026-.045-.034-.039c-1.013-1.129-2.111-1.919-3.275-2.312l-.644-.218-.016.68a.76.76 0 0 1-.102.364l-1.236 2.137v.002a.8.8 0 0 1-.105.139l-.027.029-.022.033-.008.01c-.036.053-.116.171-.157.236m7.017 1.342-7.017-1.342m0 0c-.263.318-.55.594-.879.844zm-7.033.16 1.923-3.323.946-1.637.295-.51.082-.14.02-.037.006-.01.001-.002.434.25-.433-.25.933.26q-.01.502.05.973zm0 0-.003.007c-.06.107-.294.51-.525.909l-.154.265-.001.001a.65.65 0 0 0 0 .645l.433-.249m.25-1.577-.25 1.577m0 0-.433.25c.116.202.33.323.56.323h2.78l.05-.01c1.486-.311 2.72-.866 3.643-1.674l.513-.45-.583-.354a.76.76 0 0 1-.265-.27l-1.236-2.138-.433.25m-4.596 4.073 4.596-4.072m0 0 .433-.25a.8.8 0 0 1-.07-.163l-.012-.038-.017-.035-.014-.03-.117-.236m-.203.752.203-.752m0 0a5.2 5.2 0 0 1-.292-1.18zm2.668 2.701-.033.034a.695.695 0 0 1-1.103-.134zm0 0 .025-.04c.029-.043.04-.061.048-.07l.014-.02.012-.022 1.205-2.084a.69.69 0 0 0 .033-.633m-1.337 2.87 1.337-2.87m0 0a.7.7 0 0 0-.468-.39l-.046-.012-.048-.002-.055-.003-.015-.002h-.005l-.03-.003h-2.439a.7.7 0 0 0-.563.288zm-3.76.524-.014-.046a.7.7 0 0 1 .105-.602zm0 0 .022.044m-.022-.043.022.043m0 0 .035.07.01.024m-.045-.094.046.094m0 0 .013.023m-.013-.023.013.023m0 0 1.206 2.084zm5.064-1.196.393.68.433-.25m-.826-.43 1.084.001-.258.428m-.826-.43q.418.185.826.43m-.826-.43.826.43M12.56 5.467a.645.645 0 0 0-1.12 0zm0 0 3.954 6.84m-3.954-6.84 3.954 6.84m-1.558.237a5.2 5.2 0 0 0-1.168-.337l-.038-.002h-.002l-.082-.006-.177-.012-.04-.003-.039-.009a.8.8 0 0 0-.175-.02h-2.471a.76.76 0 0 0-.369.094l-.597.326-.133-.667c-.24-1.204-.103-2.55.37-3.991l.016-.05.026-.044 1.362-2.356zm0 0q.436.183.867.442l.69-.678m-1.557.236 1.558-.236M4.082 18.22l-.006-.01a.54.54 0 0 1-.033-.487c.037-.078.102-.187.175-.312v-.002l.008-.013a77398.244 77398.244 0 0 0 7.287-12.602l.005-.006.003-.007a.54.54 0 0 1 .482-.282.53.53 0 0 1 .444.235 2011 2011 0 0 1 3.119 5.387l.42.726 1.529 2.645 1.293 2.236.473.818.646 1.117v.001a.53.53 0 0 1-.002.539.53.53 0 0 1-.466.271l-2.74.002-5.453-.001h-6.68l-.017.001h-.012a.55.55 0 0 1-.475-.256Zm9.75-6.45.008-.062-.008.048v-.05l-.01.087z"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0H24V24H0z"/></clipPath></defs>
  </svg>
`;
const Logo4 = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <g clip-path="url(#a)"><path fill='currentColor' d="M0 5a5 5 0 0 1 5-5h14a5 5 0 0 1 5 5v14a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5z"/><path fill='currentColor' d="m20.371 17.543-1.27-2.199-.433-.75-.737-1.278c-1.299-2.244-3.855-6.686-5.132-8.883-.393-.612-1.305-.563-1.643.07L9.902 6.676l-.432.748-5.587 9.678c-.08.143-.227.378-.3.532a.95.95 0 0 0 .058.887.97.97 0 0 0 .878.456H7.86c4.026 0 10.175.003 11.684 0a.958.958 0 0 0 .828-1.434zm-8.665-2.853-.741-1.283a.34.34 0 0 1 .293-.508h1.482c.26 0 .423.282.293.508l-.741 1.283a.338.338 0 0 1-.586 0m-1.242-2.39a5 5 0 0 1-.158-.477l2.452.477zm1.12 3.376a5 5 0 0 1-.334.376l-.813-2.361zm2.365-2.658q.25.038.491.102l-1.638 1.885zm-3.794-2a6 6 0 0 1-.036-.72l3.237 1.579zm-.384 2.365.858 3.2a6 6 0 0 1-.607.393zm5.442.009q.33.145.642.329l-2.986 2.014zm-5.02-4.113c.06-.439.151-.87.262-1.285l4.918 4.276zm-1.09 8.143c-.41.167-.829.304-1.243.415l1.243-6.396zm7.597-3.128c.35.27.679.566.982.87l-6.161 2.12zM12.214 5.59c.907 1.574 2.223 3.855 3.478 6.027l-4.683-4.683.776-1.345a.248.248 0 0 1 .429.001M4.9 17.515c.258-.445.612-1.056.69-1.196l2.791-4.832-1.715 6.4H5.114a.248.248 0 0 1-.214-.372m13.985.372h-6.963l6.4-1.715.777 1.345a.247.247 0 0 1-.214.37"/></g><defs><clipPath id="a"><path fill='currentColor' d="M0 0H24V24H0z"/></clipPath></defs>
  </svg>
`;
const Logo4Duotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <g clip-path="url(#a)"><path fill="#000" d="M0 5a5 5 0 0 1 5-5h14a5 5 0 0 1 5 5v14a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5z"/><mask id="b" fill="#fff"><path d="m20.371 17.543-1.27-2.199-.433-.75-.737-1.278c-1.299-2.244-3.855-6.686-5.132-8.883-.393-.612-1.305-.563-1.643.07L9.902 6.676l-.432.748-5.587 9.678c-.08.143-.227.378-.3.532a.95.95 0 0 0 .058.887.97.97 0 0 0 .878.456H7.86c4.026 0 10.175.003 11.684 0a.958.958 0 0 0 .828-1.434zm-8.665-2.853-.741-1.283a.34.34 0 0 1 .293-.508h1.482c.26 0 .423.282.293.508l-.741 1.283a.34.34 0 0 1-.587 0m-1.242-2.39a5 5 0 0 1-.158-.477l2.452.477zm1.12 3.376a5 5 0 0 1-.334.376l-.813-2.361zm2.365-2.658q.25.038.491.102l-1.638 1.885zm-3.794-2a6 6 0 0 1-.036-.72l3.237 1.579-3.201-.858m-.384 2.365.858 3.2a6 6 0 0 1-.607.393zm5.442.009q.33.145.642.329l-2.986 2.014zm-5.02-4.113c.06-.439.151-.87.262-1.285l4.918 4.276zm-1.09 8.143c-.41.167-.829.304-1.243.415l1.243-6.396zm7.597-3.128c.35.27.679.566.982.87l-6.161 2.12zM12.214 5.59c.907 1.574 2.223 3.855 3.478 6.027l-4.683-4.683.776-1.345a.248.248 0 0 1 .429 0zM4.9 17.515c.258-.445.612-1.056.69-1.196l2.791-4.832-1.715 6.4H5.114a.247.247 0 0 1-.214-.372m13.985.372h-6.963l6.4-1.715.777 1.345a.247.247 0 0 1-.214.37"/></mask><path fill="#fff" d="m20.371 17.543-1.27-2.199-.433-.75-.737-1.278c-1.299-2.244-3.855-6.686-5.132-8.883-.393-.612-1.305-.563-1.643.07L9.902 6.676l-.432.748-5.587 9.678c-.08.143-.227.378-.3.532a.95.95 0 0 0 .058.887.97.97 0 0 0 .878.456H7.86c4.026 0 10.175.003 11.684 0a.958.958 0 0 0 .828-1.434zm-8.665-2.853-.741-1.283a.34.34 0 0 1 .293-.508h1.482c.26 0 .423.282.293.508l-.741 1.283a.34.34 0 0 1-.587 0m-1.242-2.39a5 5 0 0 1-.158-.477l2.452.477zm1.12 3.376a5 5 0 0 1-.334.376l-.813-2.361zm2.365-2.658q.25.038.491.102l-1.638 1.885zm-3.794-2a6 6 0 0 1-.036-.72l3.237 1.579-3.201-.858m-.384 2.365.858 3.2a6 6 0 0 1-.607.393zm5.442.009q.33.145.642.329l-2.986 2.014zm-5.02-4.113c.06-.439.151-.87.262-1.285l4.918 4.276zm-1.09 8.143c-.41.167-.829.304-1.243.415l1.243-6.396zm7.597-3.128c.35.27.679.566.982.87l-6.161 2.12zM12.214 5.59c.907 1.574 2.223 3.855 3.478 6.027l-4.683-4.683.776-1.345a.248.248 0 0 1 .429 0zM4.9 17.515c.258-.445.612-1.056.69-1.196l2.791-4.832-1.715 6.4H5.114a.247.247 0 0 1-.214-.372m13.985.372h-6.963l6.4-1.715.777 1.345a.247.247 0 0 1-.214.37"/><path fill="#fff" d="m20.371 17.543-.867.499.471.817.844-.422zm-1.27-2.199-.866.5zm-.433-.75-.866.5zm-.737-1.278.866-.5v-.001zm-5.132-8.883.865-.502-.011-.02-.012-.018zm-1.643.07.866.5.008-.014.008-.014zM9.902 6.676l-.866-.5zm-.432.748.866.5zm-5.587 9.678-.866-.5-.005.008-.005.009zm-.3.532-.904-.43-.004.011zm.058.887.858-.515-.006-.01-.006-.008zm.878.456v-1h-.024l-.025.002zm2.476 0v1zm12.55 0 .001-1h-.003zm.827-1.434.866-.5-.472-.816-.842.422zm-8.666-2.852v1h1.732l-.866-1.5zm-.741-1.283-.867.5zm2.068 0-.866-.502v.002zm-.741 1.283-.866-.5zm-.587 0v-1H9.971l.869 1.5zm-1.24-2.39-.932.365.25.635h.681zm-.159-.477.191-.982-1.574-.306.418 1.549zm2.452.477v1l.19-1.982zm-1.174 3.376.783.622 1.286-1.622h-2.07zm-.334.376-.945.326.523 1.52 1.132-1.142zm-.813-2.361.866-.5-1.811.825zm1.146 1.985-.866.5.289.5h.577zm2.366-2.658.147-.989-.673-.1-.34.59zm.491.102.755.656 1.054-1.213-1.554-.41zm-1.638 1.885-.866-.5 1.62 1.156zm-2.647-3.986.708.707.339-.34-.053-.476zm-.036-.721.438-.9L9.125 8.7l-.006 1.594zm3.237 1.579-.258.966.697-1.865zm-3.201-.858-.707-.707-1.225 1.225 1.673.448zm-.384 2.364.966-.259-.198-.74H9.77zm.858 3.2.591.806.551-.404-.177-.66zm-.607.393-.997.07.11 1.587 1.383-.789zm-.251-3.593v-1H8.698l.075 1.07zm5.442.009.402-.916-.626-.275-.484.483zm.642.329.56.829 1.32-.89-1.376-.803zm-2.986 2.014-.707-.707 1.266 1.536zM10.193 9.28l-.99-.134-.155 1.134h1.145zm.262-1.285.656-.755-1.208-1.05-.414 1.547zm4.918 4.276-.5.866 1.156-1.621zm-5.18-2.991.5-.866-.232-.134h-.268zm-1.09 8.143.38.925.62-.255v-.67zm-1.243.415-.982-.19-.305 1.57 1.545-.414zm1.243-6.396h1l-1.981-.191zm7.597 2.853.612-.791-.53-.41-.582.335zm.982.87.326.945 1.515-.522-1.134-1.132zm-6.161 2.12-.5-.865.825 1.811zm.693-11.694h-1v.268l.133.231zm3.478 6.027-.707.707 1.573-1.207zm-4.683-4.683-.866-.5-.384.665.543.542zm.776-1.345-.865-.501-.001.002zm.429 0h1V5.32l-.135-.232zM4.9 17.515l-.865-.502-.135.233v.269zm.69-1.196-.865-.5-.007.011zm2.791-4.832.966.258-1.832-.758zm-1.715 6.4v1h.767l.199-.742zM4.9 17.514l.865.502.135-.233v-.269zm7.022.372-.259-.966.259 1.966zm6.4-1.715.866-.5-.383-.664-.741.198zm.777 1.345-.866.5v.001zm2.139-.473-1.27-2.2-1.732 1 1.268 2.198zm-1.27-2.2-.434-.75-1.732 1 .433.75zm-.434-.75-.737-1.277-1.733.998.738 1.28zm-.738-1.279c-1.295-2.238-3.855-6.687-5.132-8.884l-1.729 1.005c1.277 2.196 3.829 6.632 5.13 8.88zm-5.155-8.922c-.815-1.268-2.677-1.154-3.367.14l1.764.942-.008.01-.013.01-.013.005q-.003.001-.02-.005a.1.1 0 0 1-.024-.018l-.001-.002v-.001zm-3.351.11L9.036 6.176l1.733 1 1.253-2.172zM9.036 6.176l-.432.748 1.732 1 .433-.749zm-.432.748-5.587 9.678 1.732 1 5.587-9.678zm-5.597 9.695c-.022.04-.242.407-.328.586l1.806.86c.063-.132.137-.232.273-.48zm-.332.596a1.95 1.95 0 0 0 .12 1.84l1.692-1.067.011.023a.03.03 0 0 1 .001.015l-.009.028zm.109 1.82a1.97 1.97 0 0 0 1.785.941l-.099-1.998q-.003 0 .003.002.01.002.026.026zm1.735.942h2.475l.001-2H4.519zm2.476 0h.865v-2h-.865zm.865 0c4.024 0 10.176.003 11.686 0l-.003-2c-1.508.003-7.656 0-11.683 0zm11.682 0c1.51.003 2.444-1.64 1.696-2.934l-1.732 1.001-.004-.011-.002-.018q.002-.015.003-.016 0-.002.014-.012a.1.1 0 0 1 .026-.01h.003zm.382-3.328.895 1.789zm-7.352-2.458-.741-1.283-1.732 1 .74 1.283zm-.741-1.283a.661.661 0 0 1-.573.992v-2a1.34 1.34 0 0 0-1.16 2.007zm-.573.992h1.482v-2h-1.482zm1.482 0a.662.662 0 0 1-.573-.994l1.731 1.003a1.338 1.338 0 0 0-1.158-2.01zm-.573-.992-.741 1.283 1.732 1 .74-1.284zm-.742 1.283a.661.661 0 0 1 1.146-.001L10.84 15.19c.515.89 1.802.893 2.318-.002zm.28 1.5v-2zm-.31-3.756a4 4 0 0 1-.123-.371l-1.931.52q.081.3.192.582zm-1.28.87 2.452.477.382-1.963-2.452-.476zm2.643-1.504h-2.294v2h2.294zM10.8 15.055a4 4 0 0 1-.26.293l1.42 1.408a6 6 0 0 0 .407-.458zm1.396.671-.813-2.361-1.891.651.813 2.362zM9.57 14.19l1.146 1.986 1.732-1-1.146-1.985zm2.012 2.486v-2zm2.218-2.668q.193.028.384.079l.51-1.934a6 6 0 0 0-.599-.124zm-.115-1.544-1.639 1.885 1.51 1.312 1.638-1.885zm-.018 3.04 1.147-1.986-1.732-1-1.147 1.987zm-2.519-4.594a5 5 0 0 1-.03-.608l-2-.008q-.002.413.042.834zm-1.469.286 3.238 1.58.877-1.798-3.238-1.58zm3.935-.285-3.201-.858-.518 1.932 3.201.858zm-2.753.815-1.414-1.414zm-2.057 1.916.858 3.2 1.931-.518-.857-3.2zm1.232 2.135a5 5 0 0 1-.51.33l.991 1.737q.361-.206.702-.455zm.983 1.129-.252-3.593-1.995.14.252 3.593zm-1.25-2.523h.001v-2zm5.04-.076q.272.12.542.278l1.007-1.728a7 7 0 0 0-.744-.381zm.486-1.415-2.986 2.014 1.118 1.658 2.987-2.014zm-1.72 3.55L15.92 14.1l-1.415-1.415-2.343 2.344zm-2.392-7.029c.053-.39.135-.78.237-1.16l-1.932-.517c-.12.448-.221.922-.287 1.409zM9.799 8.75l4.918 4.275 1.312-1.51-4.918-4.275zm6.074 2.654-5.18-2.99-1 1.732 5.18 2.99zm-5.68-3.124v2zm-1.47 8.217c-.363.15-.742.273-1.122.375l.517 1.932c.45-.12.91-.27 1.364-.456zm.118 1.532 1.244-6.397-1.963-.381-1.244 6.396zm-.738-6.587v5.98h2v-5.98zm7.985 3.644c.312.241.61.508.888.786l1.413-1.416a11.5 11.5 0 0 0-1.077-.952zm1.269-.868-6.162 2.122.651 1.891 6.162-2.121zm-5.336 3.934 5.18-2.991-1-1.732-5.18 2.99zm-.674-12.062c.908 1.574 2.224 3.856 3.479 6.028l1.732-1-3.478-6.026zM16.4 10.91l-4.683-4.683-1.414 1.414 4.683 4.683zm-4.525-3.475.778-1.347-1.733-.998-.776 1.344zm.776-1.345c-.29.5-1.011.5-1.301 0l1.73-1.002a1.248 1.248 0 0 0-2.159 0zm-1.436-.501v.001h2v-.001zM5.765 18.016c.254-.438.615-1.06.698-1.209l-1.745-.977c-.074.132-.421.731-.683 1.183zm.692-1.197 2.79-4.832-1.732-1-2.79 4.832zm.958-5.591-1.715 6.4 1.932.517 1.715-6.4zm-.75 5.658H5.115v2h1.552zm-1.55 0c.577 0 .942.627.65 1.13l-1.73-1.002a1.247 1.247 0 0 0 1.08 1.872zm.785.63v-.001h-2zm12.985-.629h-6.963v2h6.963zm-6.704 1.966 6.4-1.715-.517-1.932-6.4 1.715zm5.275-2.18.777 1.344 1.732-1-.777-1.345zm.778 1.345a.753.753 0 0 1 .651-1.13v2a1.247 1.247 0 0 0 1.08-1.873zm.651-1.13v2z" mask="url(#b)"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0H24V24H0z"/></clipPath></defs>
  </svg>
`;
const LongSleevePanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M7.393 20.324v-8.99l-2.472 6.068L2 16.054 6.21 5.203c.589-1.515 2.854-1.555 3.962-.367.574.617 1.2 1.054 1.828 1.101.628-.047 1.254-.484 1.828-1.1 1.108-1.19 3.373-1.149 3.961.366L22 16.053l-2.921 1.35-2.472-6.068v8.988H7.393" clip-rule="evenodd"/>
  </svg>
`;
const Longer = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5 5.75a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5zm0 3.5a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5zm-.75 4.25a.75.75 0 0 1 .75-.75h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75M5 16.25a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5z" clip-rule="evenodd"/>
  </svg>
`;
const LoomLogo = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M22 10.888h-5.848l5.065-2.924-1.113-1.927L15.04 8.96l2.924-5.065-1.927-1.113-2.924 5.065V2h-2.224v5.848L7.963 2.783 6.036 3.896 8.961 8.96 3.896 6.037 2.783 7.963l5.065 2.924H2v2.225h5.848l-5.065 2.924 1.113 1.927L8.96 15.04l-2.924 5.064 1.927 1.113 2.924-5.065V22h2.225v-5.848l2.923 5.065 1.927-1.113-2.924-5.065 5.065 2.924 1.113-1.927-5.065-2.923H22v-2.225zm-10 4.138a3.037 3.037 0 1 1 0-6.074 3.037 3.037 0 0 1 0 6.074"/>
  </svg>
`;
const LoomLogoDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#625DF5" d="M22 10.888h-5.848l5.065-2.924-1.113-1.927L15.04 8.96l2.924-5.065-1.927-1.113-2.924 5.065V2h-2.224v5.848L7.963 2.783 6.036 3.896 8.961 8.96 3.896 6.037 2.783 7.963l5.065 2.924H2v2.225h5.848l-5.065 2.924 1.113 1.927L8.96 15.04l-2.924 5.064 1.927 1.113 2.924-5.065V22h2.225v-5.848l2.923 5.065 1.927-1.113-2.924-5.065 5.065 2.924 1.113-1.927-5.065-2.923H22v-2.225zm-10 4.138a3.037 3.037 0 1 1 0-6.074 3.037 3.037 0 0 1 0 6.074"/>
  </svg>
`;
const Lt = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="m7.192 11.316 10-4.5.616 1.368L9.328 12l8.48 3.816-.616 1.368-10-4.5a.75.75 0 0 1 0-1.368" clip-rule="evenodd"/>
  </svg>
`;
const MailPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5.389 5.417A1.89 1.89 0 0 0 3.5 7.306v.655l8.5 4.675 8.5-4.675v-.655a1.89 1.89 0 0 0-1.889-1.89zM20.5 9.578l-8.159 4.487a.71.71 0 0 1-.682 0L3.5 9.578v8.117c0 1.043.846 1.888 1.889 1.888H18.61a1.89 1.89 0 0 0 1.889-1.888z" clip-rule="evenodd"/>
  </svg>
`;
const MailboxPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5 4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm0 4h14v11a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1zm4 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5V12H9z" clip-rule="evenodd"/>
  </svg>
`;
const MakeItReal = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M2.274 10.907c-.641.776-.047 1.943.958 1.88l3.617-.225 1.945 3.059c.54.85 1.833.644 2.084-.33l.686-2.666 7.406 7.405a.75.75 0 0 0 1.06-1.06l-7.405-7.406 2.666-.687c.975-.25 1.18-1.544.33-2.084l-3.058-1.944.225-3.618c.062-1.004-1.104-1.599-1.88-.958L8.113 4.581 4.743 3.25c-.937-.37-1.862.556-1.493 1.492l1.332 3.37zm4.688.145-3.018.188L5.87 8.909a1.15 1.15 0 0 0 .183-1.155L4.942 4.94l2.812 1.111c.39.154.832.084 1.155-.182l2.332-1.926-.188 3.018a1.15 1.15 0 0 0 .53 1.042l2.553 1.622-2.929.754a1.15 1.15 0 0 0-.826.827l-.755 2.928-1.622-2.552a1.15 1.15 0 0 0-1.042-.53" clip-rule="evenodd"/>
  </svg>
`;
const MapPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="m13.8 5.551-3.6-1.2V17.95l3.6 1.2zM15.6 19.149l3.862-1.288A2.25 2.25 0 0 0 21 15.728V6.873a2.25 2.25 0 0 0-2.962-2.135l-2.438.813zM4.538 5.638 8.4 4.351V17.95l-2.438.813A2.25 2.25 0 0 1 3 16.627V7.773c0-.968.62-1.828 1.538-2.135"/>
  </svg>
`;
const MathPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6.962 4a1 1 0 0 1 1 1v1.962h1.963a1 1 0 1 1 0 2H7.962v1.963a1 1 0 1 1-2 0V8.962H4a1 1 0 1 1 0-2h1.962V5a1 1 0 0 1 1-1m5.733 3.962a1 1 0 0 1 1-1h5.925a1 1 0 1 1 0 2h-5.925a1 1 0 0 1-1-1m0 10.234a1 1 0 0 1 1-1h5.925a1 1 0 1 1 0 2h-5.925a1 1 0 0 1-1-1m1-4.231a1 1 0 1 0 0 2h5.925a1 1 0 1 0 0-2zm-8.12.083a1 1 0 1 0-1.414 1.414l1.387 1.388-1.387 1.387a1 1 0 1 0 1.414 1.415l1.387-1.388 1.388 1.388a1 1 0 0 0 1.414-1.415L8.377 16.85l1.387-1.388a1 1 0 0 0-1.414-1.414l-1.388 1.387z" clip-rule="evenodd"/>
  </svg>
`;
const Meeting = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3 6.643C3 5.459 3.96 4.5 5.143 4.5h8.571c1.184 0 2.143.96 2.143 2.143v2.425l4.283-2.49c.714-.415 1.61.1 1.61.927v8.99c0 .826-.896 1.342-1.61.926l-4.283-2.49v2.426c0 1.184-.96 2.143-2.143 2.143H5.143A2.143 2.143 0 0 1 3 17.357zM5.143 6h8.571c.355 0 .643.288.643.643v10.714a.643.643 0 0 1-.643.643H5.143a.643.643 0 0 1-.643-.643V6.643c0-.355.288-.643.643-.643M16 13.28v-2.56l4.25-2.47v7.5z" clip-rule="evenodd"/>
  </svg>
`;
const Member = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M16.402 19.06a8.2 8.2 0 0 1-4.352 1.24 8.2 8.2 0 0 1-4.315-1.217 4.73 4.73 0 0 1 4.338-2.807 4.73 4.73 0 0 1 4.329 2.784m1.218-.924a6.24 6.24 0 0 0-5.547-3.36 6.24 6.24 0 0 0-5.561 3.389 8.25 8.25 0 1 1 11.109-.03m4.18-6.086c0 5.385-4.365 9.75-9.75 9.75S2.3 17.435 2.3 12.05 6.665 2.3 12.05 2.3s9.75 4.365 9.75 9.75M9.692 10.1c0-1.29 1.059-2.35 2.381-2.35 1.323 0 2.382 1.06 2.382 2.35s-1.059 2.35-2.382 2.35c-1.322 0-2.381-1.059-2.381-2.35m2.381-3.85c-2.136 0-3.881 1.717-3.881 3.85s1.745 3.85 3.881 3.85c2.137 0 3.882-1.716 3.882-3.85 0-2.133-1.745-3.85-3.882-3.85" clip-rule="evenodd"/>
  </svg>
`;
const Menubar = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="m8.717 14.427 2.197-6.216c.105-.301.236-.531.42-.685.186-.157.416-.226.7-.226.283 0 .513.067.7.223.182.154.312.385.414.688l2.198 6.218c.065.197.104.367.104.53a.65.65 0 0 1-.206.493.77.77 0 0 1-.527.18.72.72 0 0 1-.501-.172c-.134-.119-.227-.297-.297-.53l-.528-1.582h-2.75l-.528 1.582c-.072.236-.164.414-.295.532a.7.7 0 0 1-.497.17.77.77 0 0 1-.515-.175.63.63 0 0 1-.206-.48c0-.158.04-.323.117-.549m2.306-2.299h1.987l-.991-3.056z" clip-rule="evenodd"/><path fill='currentColor' fill-rule="evenodd" d="M3 6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.5h14a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V6a.5.5 0 0 1 .5-.5" clip-rule="evenodd"/>
  </svg>
`;
const MicPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12.25 2a3.26 3.26 0 0 0-3.26 3.26v5.76a3.26 3.26 0 0 0 6.52 0V5.26c0-1.8-1.46-3.26-3.26-3.26M7.63 9.934a.815.815 0 1 0-1.63 0v1.087a6.25 6.25 0 0 0 5.435 6.197v2.77h-1.359a.815.815 0 1 0 0 1.63h4.348a.815.815 0 0 0 0-1.63h-1.359v-2.77a6.25 6.25 0 0 0 5.435-6.197V9.934a.815.815 0 0 0-1.63 0v1.087a4.62 4.62 0 0 1-9.24 0z" clip-rule="evenodd"/>
  </svg>
`;
const Microphone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M9.149 5.84a2.851 2.851 0 1 1 5.702 0v5.553a2.851 2.851 0 0 1-5.702 0z" clip-rule="evenodd"/><path fill='currentColor' d="M7.147 10.794a.75.75 0 0 1 .815.679l.002.02.016.104a4.638 4.638 0 0 0 .613 1.635c.527.852 1.496 1.73 3.407 1.73 1.91 0 2.88-.878 3.408-1.73a4.6 4.6 0 0 0 .628-1.738l.002-.022v-.002a.75.75 0 0 1 1.494.138v.01l-.002.015a3 3 0 0 1-.03.21 6.142 6.142 0 0 1-.817 2.178c-.684 1.105-1.896 2.188-3.934 2.403v2.802H15a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1 0-1.5h2.25v-2.802C9.212 16.209 8 15.126 7.317 14.02a6.1 6.1 0 0 1-.847-2.388l-.001-.015v-.006l-.001-.004a.75.75 0 0 1 .68-.814"/>
  </svg>
`;
const Mindmap = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M10.458 5.95H8.5c-.69 0-1.25.56-1.25 1.25V10c0 .45-.108.875-.3 1.25h3.467a2.5 2.5 0 0 1 2.333-1.6h5.5a2.5 2.5 0 0 1 0 5h-5.5a2.5 2.5 0 0 1-2.427-1.9H6.95c.192.375.3.8.3 1.25v2.809c0 .69.56 1.25 1.25 1.25h1.914a2.5 2.5 0 0 1 2.336-1.609h5.5a2.5 2.5 0 0 1 0 5h-5.5a2.5 2.5 0 0 1-2.425-1.891H8.5a2.75 2.75 0 0 1-2.75-2.75V14c0-.69-.56-1.25-1.25-1.25H2v-1.5h2.512A1.25 1.25 0 0 0 5.75 10V7.2A2.75 2.75 0 0 1 8.5 4.45h1.8a2.5 2.5 0 0 1 2.45-2h5.5a2.5 2.5 0 0 1 0 5h-5.5a2.5 2.5 0 0 1-2.292-1.5m1.292-1a1 1 0 0 1 1-1h5.5a1 1 0 1 1 0 2h-5.5a1 1 0 0 1-1-1m0 7.2a1 1 0 0 1 1-1h5.5a1 1 0 1 1 0 2h-5.5a1 1 0 0 1-1-1m1 5.8a1 1 0 1 0 0 2h5.5a1 1 0 1 0 0-2z" clip-rule="evenodd"/>
  </svg>
`;
const MindmapNode = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12.75 4.5c-1.138 0-2.098.76-2.4 1.8H8.764a2.75 2.75 0 0 0-2.75 2.75v1c0 .69-.56 1.25-1.25 1.25H2v1.5h2.765c.69 0 1.25.56 1.25 1.25v1a2.75 2.75 0 0 0 2.75 2.75h1.616a2.5 2.5 0 0 0 2.369 1.7h5.5a2.5 2.5 0 0 0 0-5h-5.5c-1.138 0-2.098.76-2.4 1.8H8.764c-.69 0-1.25-.56-1.25-1.25v-1c0-.788-.332-1.499-.863-2a2.74 2.74 0 0 0 .863-2v-1c0-.69.56-1.25 1.25-1.25h1.616a2.5 2.5 0 0 0 2.369 1.7h5.5a2.5 2.5 0 0 0 0-5zm-1 2.5a1 1 0 0 1 1-1h5.5a1 1 0 1 1 0 2h-5.5a1 1 0 0 1-1-1m0 10a1 1 0 0 1 1-1h5.5a1 1 0 1 1 0 2h-5.5a1 1 0 0 1-1-1" clip-rule="evenodd"/>
  </svg>
`;
const Minus = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.5 12c0-.46.373-.833.833-.833h13.334a.833.833 0 0 1 0 1.666H5.333A.833.833 0 0 1 4.5 12" clip-rule="evenodd"/>
  </svg>
`;
const MoonPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 20a8 8 0 0 0 7.954-8.867c-.023-.208-.324-.23-.412-.04a5 5 0 1 1-6.635-6.635c.19-.088.168-.39-.04-.412A8 8 0 1 0 12 20" clip-rule="evenodd"/>
  </svg>
`;
const MoreHorizontal = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.5 12a1.73 1.73 0 1 0 3.462 0A1.73 1.73 0 0 0 4.5 12m7.5 1.73a1.73 1.73 0 1 1 0-3.46 1.73 1.73 0 0 1 0 3.46m5.77 0a1.73 1.73 0 1 1 0-3.46 1.73 1.73 0 0 1 0 3.46" clip-rule="evenodd"/>
  </svg>
`;
const MoreVertical = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M13.5 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M12 19.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" clip-rule="evenodd"/>
  </svg>
`;
const MountainPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M3.129 17.595 11.007 4.3a1.262 1.262 0 0 1 2.17 0l7.88 13.295A1.262 1.262 0 0 1 19.97 19.5H4.214a1.262 1.262 0 0 1-1.085-1.905"/>
  </svg>
`;
const MousePanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="m3.785 4.37 5.68 13.995c.143.35.592.45.87.194l3.116-2.88 3.672 3.973a1.082 1.082 0 1 0 1.59-1.469L15.04 14.21l3.117-2.88a.54.54 0 0 0-.125-.882L4.528 3.682a.541.541 0 0 0-.743.687" clip-rule="evenodd"/>
  </svg>
`;
const MoveLeft = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.75 4a.75.75 0 0 0-1.5 0v16a.75.75 0 0 0 1.5 0zm8.405 4.57a.75.75 0 1 0-.976-1.14l-4.667 4a.75.75 0 0 0 0 1.14l4.667 4a.75.75 0 1 0 .976-1.14l-3.128-2.68H20a.75.75 0 0 0 0-1.5h-9.973z" clip-rule="evenodd"/>
  </svg>
`;
const MoveRight = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M20.75 4a.75.75 0 0 0-1.5 0v16a.75.75 0 0 0 1.5 0zm-9.905 4.57a.75.75 0 1 1 .976-1.14l4.667 4a.75.75 0 0 1 0 1.14l-4.667 4a.75.75 0 1 1-.976-1.14l3.128-2.68H4a.75.75 0 0 1 0-1.5h9.973z" clip-rule="evenodd"/>
  </svg>
`;
const MoveTo = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.25 4A.75.75 0 0 1 5 3.25h14a.75.75 0 0 1 .75.75v16a.75.75 0 0 1-.75.75H5a.75.75 0 0 1-.75-.75v-3a.75.75 0 0 1 1.5 0v2.25h12.5V4.75H5.75V7.5a.75.75 0 0 1-1.5 0zm8 4a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5H13a.75.75 0 0 1-.75-.75m.75 2.75a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5zM12.25 15a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75M8.03 8.47a.75.75 0 0 0-1.06 1.06l1.72 1.72H2.5a.75.75 0 0 0 0 1.5h6.19l-1.72 1.72a.75.75 0 1 0 1.06 1.06l3-3a.75.75 0 0 0 0-1.06z" clip-rule="evenodd"/>
  </svg>
`;
const MoveToLeftDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M7.5 4.75A.75.75 0 0 0 6.75 4h-1A1.75 1.75 0 0 0 4 5.75v13c0 .966.784 1.75 1.75 1.75h1a.75.75 0 0 0 0-1.5h-1a.25.25 0 0 1-.25-.25v-13a.25.25 0 0 1 .25-.25h1a.75.75 0 0 0 .75-.75m2.397 4.924a.75.75 0 0 1 .096 1.056l-.642.77h3.399a.75.75 0 0 1 0 1.5H9.351l.642.77a.75.75 0 1 1-1.152.96l-1.667-2a.75.75 0 0 1 0-.96l1.667-2a.75.75 0 0 1 1.056-.096M14.75 4A1.75 1.75 0 0 0 13 5.75V8.5a.75.75 0 0 0 1.5 0V5.75a.25.25 0 0 1 .25-.25h3a.25.25 0 0 1 .25.25v13a.25.25 0 0 1-.25.25h-3a.25.25 0 0 1-.25-.25V16a.75.75 0 0 0-1.5 0v2.75c0 .966.784 1.75 1.75 1.75h3a1.75 1.75 0 0 0 1.75-1.75v-13A1.75 1.75 0 0 0 17.75 4z" clip-rule="evenodd"/>
  </svg>
`;
const MoveToRightDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8.75 4c.966 0 1.75.784 1.75 1.75V8.5a.75.75 0 0 1-1.5 0V5.75a.25.25 0 0 0-.25-.25h-3a.25.25 0 0 0-.25.25v13c0 .138.112.25.25.25h3a.25.25 0 0 0 .25-.25V16a.75.75 0 0 1 1.5 0v2.75a1.75 1.75 0 0 1-1.75 1.75h-3A1.75 1.75 0 0 1 4 18.75v-13C4 4.784 4.784 4 5.75 4zm7.25.75a.75.75 0 0 1 .75-.75h1c.966 0 1.75.784 1.75 1.75v13a1.75 1.75 0 0 1-1.75 1.75h-1a.75.75 0 0 1 0-1.5h1a.25.25 0 0 0 .25-.25v-13a.25.25 0 0 0-.25-.25h-1a.75.75 0 0 1-.75-.75m-2.397 4.924a.75.75 0 0 0-.096 1.056l.642.77H10.75a.75.75 0 0 0 0 1.5h3.399l-.642.77a.75.75 0 1 0 1.152.96l1.667-2a.75.75 0 0 0 0-.96l-1.667-2a.75.75 0 0 0-1.056-.096" clip-rule="evenodd"/>
  </svg>
`;
const MoviePanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M2.393 4.794c0-.617.5-1.117 1.117-1.117h16.765c.617 0 1.118.5 1.118 1.117v13.412c0 .617-.5 1.118-1.118 1.118H3.51c-.617 0-1.117-.5-1.117-1.118zM7.98 5.912h7.824v4.47H7.98zm7.824 6.706H7.98v4.47h7.824zM3.51 5.912h2.236v2.235H3.51zm16.765 0H18.04v2.235h2.235zM3.51 10.382h2.236v2.236H3.51zm16.765 0H18.04v2.236h2.235zM3.51 14.853h2.236v2.235H3.51zm16.765 0H18.04v2.235h2.235z" clip-rule="evenodd"/>
  </svg>
`;
const MultiCursorDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#6E52DF" d="M3.03 5.302c-.278-1.606 1.41-2.832 2.851-2.07l13.518 7.14c1.542.815 1.336 3.086-.328 3.609l-5.526 1.736a1.96 1.96 0 0 0-1.01.734L9.17 21.174c-1.012 1.421-3.236.915-3.534-.804z"/><path stroke="#000" stroke-opacity=".1" d="M3.523 5.217c-.207-1.197 1.05-2.11 2.125-1.543l13.518 7.14c1.149.607.995 2.3-.245 2.69l-5.526 1.736c-.512.16-.957.484-1.268.921l-3.364 4.723c-.754 1.06-2.411.682-2.633-.6z"/>
  </svg>
`;
const MultiPeople = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8.562 3.985a3.834 3.834 0 1 0 0 7.668 3.834 3.834 0 0 0 0-7.668M6.228 7.819a2.334 2.334 0 1 1 4.668 0 2.334 2.334 0 0 1-4.668 0M8.562 12.466a6.15 6.15 0 0 0-5.9 4.414 1.84 1.84 0 0 0 .42 1.785c.403.44.997.698 1.625.698h7.71a2 2 0 0 0 .339-.023h6.6c.564 0 1.1-.232 1.463-.63.375-.41.564-1 .381-1.623a5.33 5.33 0 0 0-8.266-2.795 6.13 6.13 0 0 0-4.372-1.826m-4.46 4.836a4.65 4.65 0 0 1 8.92 0 .34.34 0 0 1-.087.35.7.7 0 0 1-.518.21h-7.71a.7.7 0 0 1-.518-.21.34.34 0 0 1-.087-.35m9.75-1.823c.258.436.464.905.61 1.401.098.335.098.661.025.96h4.87c.16 0 .288-.068.356-.142a.2.2 0 0 0 .053-.091.2.2 0 0 0-.005-.097 3.83 3.83 0 0 0-5.91-2.03" clip-rule="evenodd"/><path fill='currentColor' fill-rule="evenodd" d="M16.086 6.064a3.367 3.367 0 1 0 0 6.734 3.367 3.367 0 0 0 0-6.734m-1.867 3.367a1.867 1.867 0 1 1 3.734 0 1.867 1.867 0 0 1-3.734 0" clip-rule="evenodd"/>
  </svg>
`;
const MultiSelect = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M7.53 6.03a.75.75 0 0 0-1.06-1.06l-1.5 1.5-.406-.464a.75.75 0 1 0-1.128.988l.933 1.067a.75.75 0 0 0 1.095.036zm0 5.5a.75.75 0 1 0-1.06-1.06l-1.5 1.5-.406-.464a.75.75 0 0 0-1.128.988l.933 1.066a.75.75 0 0 0 1.095.037zm0 4.44a.75.75 0 0 1 0 1.06l-2.066 2.067a.75.75 0 0 1-1.095-.037l-.933-1.066a.75.75 0 0 1 1.128-.988l.406.463 1.5-1.5a.75.75 0 0 1 1.06 0M10.5 5.25a.75.75 0 0 0 0 1.5h9.6a.75.75 0 0 0 0-1.5zM9.75 12a.75.75 0 0 1 .75-.75h9.6a.75.75 0 0 1 0 1.5h-9.6a.75.75 0 0 1-.75-.75m.75 5.25a.75.75 0 0 0 0 1.5h9.6a.75.75 0 0 0 0-1.5z" clip-rule="evenodd"/>
  </svg>
`;
const Ne = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="m9.488 15.75-1.164 2.425 1.352.65 1.476-3.075H17.5v-1.5h-5.628l1.92-4H17.5v-1.5h-2.988l1.164-2.425-1.352-.65-1.476 3.075H6.5v1.5h5.628l-1.92 4H6.5v1.5z" clip-rule="evenodd"/>
  </svg>
`;
const New = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M7.435 5.118a2.868 2.868 0 0 1 4.986-1.934 2.868 2.868 0 0 1 4.639 3.301h2.831c.967 0 1.75.784 1.75 1.75v2.236a1.75 1.75 0 0 1-1.059 1.608V19a2.75 2.75 0 0 1-2.75 2.75H7.01A2.75 2.75 0 0 1 4.259 19v-6.921a1.75 1.75 0 0 1-1.06-1.608V8.235c.001-.966.784-1.75 1.751-1.75h2.832a2.86 2.86 0 0 1-.347-1.367m2.868 1.367h1.367V5.118a1.368 1.368 0 1 0-1.367 1.367m2.867-1.367v1.367h1.368a1.368 1.368 0 1 0-1.367-1.367M4.95 7.985a.25.25 0 0 0-.25.25v2.236c0 .138.112.25.25.25H19.89a.25.25 0 0 0 .25-.25V8.235a.25.25 0 0 0-.25-.25zm.809 4.236V19c0 .69.56 1.25 1.25 1.25h4.662v-8.03zm7.412 0v8.029h4.661c.69 0 1.25-.56 1.25-1.25v-6.78z" clip-rule="evenodd"/>
  </svg>
`;
const NewPage = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 4.75a.75.75 0 0 1 .75.75v5.75h5.75a.75.75 0 0 1 0 1.5h-5.75v5.75a.75.75 0 0 1-1.5 0v-5.75H5.5a.75.75 0 0 1 0-1.5h5.75V5.5a.75.75 0 0 1 .75-.75" clip-rule="evenodd"/>
  </svg>
`;
const NewXxxEdgeless = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6.5 4.75a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5M3.25 6.5a3.25 3.25 0 0 1 6.49-.25c.794.001 1.56.016 2.357.208.897.217 1.79.645 2.853 1.442l.02.015.02.017c.864.745 1.475 1.75 1.841 2.826a.75.75 0 0 1-1.42.484c-.294-.865-.766-1.62-1.382-2.158-.928-.692-1.633-1.01-2.284-1.168-.675-.162-1.334-.166-2.244-.166A3.26 3.26 0 0 1 7.25 9.663v3.674a3.251 3.251 0 1 1-1.5 0V9.663A3.25 3.25 0 0 1 3.25 6.5m3.25 8.25a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m11-1a.75.75 0 0 0-1.5 0V16h-2.25a.75.75 0 0 0 0 1.5H16v2.25a.75.75 0 0 0 1.5 0V17.5h2.25a.75.75 0 0 0 0-1.5H17.5z" clip-rule="evenodd"/>
  </svg>
`;
const NewXxxPage = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.25 6A2.75 2.75 0 0 1 7 3.25h10A2.75 2.75 0 0 1 19.75 6v6a.75.75 0 0 1-1.5 0V6c0-.69-.56-1.25-1.25-1.25H7c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h5a.75.75 0 0 1 0 1.5H7A2.75 2.75 0 0 1 4.25 18zm4 2A.75.75 0 0 1 9 7.25h3a.75.75 0 0 1 0 1.5H9A.75.75 0 0 1 8.25 8M9 10.75a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5zM8.25 15a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75m11.25 0a.75.75 0 0 0-1.5 0v2.25h-2.25a.75.75 0 0 0 0 1.5H18V21a.75.75 0 0 0 1.5 0v-2.25h2.25a.75.75 0 0 0 0-1.5H19.5z" clip-rule="evenodd"/>
  </svg>
`;
const NightPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M18.522 12.783A3.48 3.48 0 0 0 22 9.304c0-.187-.28-.22-.386-.067a2.174 2.174 0 1 1-3.025-3.025c.154-.106.12-.386-.067-.386a3.48 3.48 0 0 0-3.475 3.313 4 4 0 0 1 2.945 3.604q.26.04.53.04M5.478 18a3.478 3.478 0 0 1 0-6.957 4.348 4.348 0 0 1 8.613-.849 3.044 3.044 0 0 1 2.653 3.51q.228-.052.473-.052a2.174 2.174 0 0 1 0 4.348z" clip-rule="evenodd"/>
  </svg>
`;
const NoNetwork = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5.06 4.185A.75.75 0 0 0 4 5.246l1.398 1.399a14.1 14.1 0 0 0-3.212 2.41.75.75 0 0 0 1.06 1.06 12.6 12.6 0 0 1 3.263-2.36l2.24 2.242a9.6 9.6 0 0 0-3.414 2.207.75.75 0 1 0 1.061 1.06 8.1 8.1 0 0 1 3.54-2.08l2.467 2.466A5.64 5.64 0 0 0 8.17 15.3a.75.75 0 1 0 1.061 1.06 4.15 4.15 0 0 1 5.869 0 1 1 0 0 0 .092.08l2.744 2.742a.75.75 0 0 0 1.06-1.06zm4.492 2.507c4.035-.85 8.402.292 11.533 3.423a.75.75 0 0 0 1.06-1.06 14.1 14.1 0 0 0-12.902-3.83.75.75 0 0 0 .31 1.467m3.752 2.75a.75.75 0 0 0-.176 1.49 8.12 8.12 0 0 1 4.807 2.333.75.75 0 0 0 1.06-1.06 9.62 9.62 0 0 0-5.691-2.763m-1.139 8.842a.75.75 0 1 0 0 1.5h.01a.75.75 0 0 0 0-1.5z" clip-rule="evenodd"/>
  </svg>
`;
const NoteShadowDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#7A7A7A" fill-rule="evenodd" d="M3.25 5A2.75 2.75 0 0 1 6 2.25h9A2.75 2.75 0 0 1 17.75 5v10.857a2.75 2.75 0 0 1-2.75 2.75H6a2.75 2.75 0 0 1-2.75-2.75zM6 3.75c-.69 0-1.25.56-1.25 1.25v10.857c0 .69.56 1.25 1.25 1.25h9c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25z" clip-rule="evenodd"/><path fill="#B3B3B3" d="M6.25 18.607H15a2.75 2.75 0 0 0 2.75-2.75V5.25H18A2.75 2.75 0 0 1 20.75 8v10.857a2.75 2.75 0 0 1-2.75 2.75H9a2.75 2.75 0 0 1-2.75-2.75z"/>
  </svg>
`;
const Notification = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M9.255 4.832a2.75 2.75 0 0 1 5.49 0A6.75 6.75 0 0 1 18.75 11v3.159c0 .34.135.665.375.906l1.064 1.063c.598.599.175 1.622-.672 1.622H15.75V18a3.75 3.75 0 0 1-7.5 0v-.25H4.483c-.846 0-1.27-1.023-.672-1.622l1.064-1.063c.24-.24.375-.567.375-.906V11a6.75 6.75 0 0 1 4.005-6.168M9.75 17.75V18a2.25 2.25 0 0 0 4.5 0v-.25zm2.25-14c-.69 0-1.25.56-1.25 1.25v.341a.75.75 0 0 1-.5.708A5.25 5.25 0 0 0 6.75 11v3.159c0 .737-.293 1.445-.815 1.966l-.124.125h12.378l-.124-.125a2.78 2.78 0 0 1-.815-1.966V11c0-2.285-1.46-4.23-3.5-4.951a.75.75 0 0 1-.5-.708V5c0-.69-.56-1.25-1.25-1.25" clip-rule="evenodd"/>
  </svg>
`;
const Notion = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M6.268 6.199c.568.46.78.426 1.845.355L18.16 5.95c.214 0 .036-.214-.035-.25l-1.668-1.205c-.32-.248-.746-.533-1.562-.462l-9.728.71c-.354.035-.425.213-.284.355zM6.87 8.54v10.569c0 .568.284.78.923.745l11.04-.638c.638-.035.71-.426.71-.887V7.83c0-.46-.178-.71-.568-.674L7.439 7.83c-.426.035-.568.248-.568.71m10.899.567c.07.319 0 .639-.32.675l-.533.106v7.802c-.462.249-.887.39-1.242.39-.568 0-.71-.177-1.136-.709l-3.48-5.462v5.285l1.102.248s0 .639-.889.639l-2.449.142c-.07-.142 0-.496.249-.568l.639-.177V10.49l-.888-.07c-.07-.32.107-.781.604-.817l2.627-.176 3.62 5.532v-4.893l-.923-.107c-.07-.39.214-.673.569-.71zM4.35 3.787l10.117-.745c1.242-.107 1.562-.035 2.343.532l3.23 2.27c.532.39.71.496.71.922v12.45c0 .78-.284 1.241-1.278 1.312l-11.75.71c-.745.035-1.1-.071-1.491-.568l-2.378-3.086c-.426-.568-.603-.993-.603-1.49V5.028c0-.639.283-1.17 1.1-1.241"/>
  </svg>
`;
const NotionDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#000" d="M6.268 6.199c.568.46.78.426 1.845.355L18.16 5.95c.214 0 .036-.214-.035-.25l-1.668-1.205c-.32-.248-.746-.533-1.562-.462l-9.728.71c-.354.035-.425.213-.284.355zM6.87 8.54v10.569c0 .568.284.78.923.745l11.04-.638c.638-.035.71-.426.71-.887V7.83c0-.46-.178-.71-.568-.674L7.439 7.83c-.426.035-.568.248-.568.71m10.899.567c.07.319 0 .639-.32.675l-.533.106v7.802c-.462.249-.887.39-1.242.39-.568 0-.71-.177-1.136-.709l-3.48-5.462v5.285l1.102.248s0 .639-.889.639l-2.449.142c-.07-.142 0-.496.249-.568l.639-.177V10.49l-.888-.07c-.07-.32.107-.781.604-.817l2.627-.176 3.62 5.532v-4.893l-.923-.107c-.07-.39.214-.673.569-.71zM4.35 3.787l10.117-.745c1.242-.107 1.562-.035 2.343.532l3.23 2.27c.532.39.71.496.71.922v12.45c0 .78-.284 1.241-1.278 1.312l-11.75.71c-.745.035-1.1-.071-1.491-.568l-2.378-3.086c-.426-.568-.603-.993-.603-1.49V5.028c0-.639.283-1.17 1.1-1.241"/>
  </svg>
`;
const Now = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6.114 3.678a.75.75 0 0 1 0 1.06L4.28 6.573a.75.75 0 0 1-1.06-1.06l1.833-1.834a.75.75 0 0 1 1.06 0m11.772 0a.75.75 0 0 1 1.061 0l1.833 1.833a.75.75 0 0 1-1.06 1.061l-1.834-1.833a.75.75 0 0 1 0-1.061M12 5.875a6.583 6.583 0 1 0 0 13.167 6.583 6.583 0 0 0 0-13.167m-8.083 6.583a8.083 8.083 0 1 1 16.166 0 8.083 8.083 0 0 1-16.166 0" clip-rule="evenodd"/><path fill='currentColor' fill-rule="evenodd" d="M15.197 10.359a.75.75 0 0 1 0 1.06l-3.555 3.556a.75.75 0 0 1-1.061 0l-1.778-1.778a.75.75 0 0 1 1.06-1.06l1.248 1.247 3.025-3.025a.75.75 0 0 1 1.061 0" clip-rule="evenodd"/>
  </svg>
`;
const Number = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M11.182 3.272a.75.75 0 0 1 .546.91L10.71 8.25h4.453l1.108-4.432a.75.75 0 0 1 1.456.364L16.71 8.25H20a.75.75 0 0 1 0 1.5h-3.664l-1.125 4.5H18a.75.75 0 1 1 0 1.5h-3.164l-1.108 4.432a.75.75 0 0 1-1.456-.364l1.017-4.068H8.836l-1.108 4.432a.75.75 0 0 1-1.456-.364L7.29 15.75H4a.75.75 0 0 1 0-1.5h3.664l1.125-4.5H6a.75.75 0 0 1 0-1.5h3.164l1.108-4.432a.75.75 0 0 1 .91-.546m-.846 6.478-1.125 4.5h4.453l1.125-4.5z" clip-rule="evenodd"/>
  </svg>
`;
const NumberedList = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.129 5.762a.6.6 0 0 0 .15-.08l.255-.177V7.64c0 .188.063.35.181.466a.66.66 0 0 0 .47.177c.186 0 .35-.061.468-.177a.64.64 0 0 0 .182-.466V4.934a.7.7 0 0 0-.197-.52c-.13-.13-.316-.195-.534-.195-.221 0-.434.022-.675.183l-.677.452a.53.53 0 0 0-.252.46c0 .273.203.472.464.472a.5.5 0 0 0 .165-.024m5.277-.16a.768.768 0 0 0 0 1.536h10.326a.768.768 0 1 0 0-1.536zm0 5.632a.768.768 0 0 0 0 1.536h10.326a.768.768 0 1 0 0-1.535zm0 5.633a.768.768 0 1 0 0 1.536h10.326a.768.768 0 1 0 0-1.536zm-2.782-5.753q.018-.099.018-.21c0-.678-.58-1.136-1.486-1.136-.652 0-1.176.277-1.373.721.197-.444.721-.72 1.373-.72.907 0 1.486.457 1.486 1.134q0 .112-.018.211m-1.5 1.64v.02h1.184c.274 0 .43.163.43.414 0-.25-.156-.414-.43-.414H5.126zm-1.384.237c.035-.14.126-.26.284-.393l1.026-.878c.338-.29.48-.453.523-.622-.042.17-.185.331-.523.622l-1.026.879c-.158.131-.25.253-.284.392m.763-1.81a.8.8 0 0 0 .251-.254.7.7 0 0 1 .184-.193.36.36 0 0 1 .202-.054c.113 0 .199.034.255.085.056.05.09.12.09.21 0 .17-.079.304-.502.667l-1.026.878c-.219.184-.336.365-.336.608 0 .156.045.303.152.412.108.108.265.164.463.164h2.073a.54.54 0 0 0 .389-.145.51.51 0 0 0 .142-.371.5.5 0 0 0-.142-.374.54.54 0 0 0-.39-.142h-.932l.496-.428c.287-.25.506-.447.651-.65.15-.207.221-.419.221-.691 0-.37-.16-.684-.442-.902-.281-.217-.677-.335-1.146-.335-.676 0-1.248.288-1.467.783a.7.7 0 0 0-.057.283c0 .155.05.29.152.387.1.095.24.142.4.142a.6.6 0 0 0 .32-.08m-.832 4.897c.152-.414.67-.853 1.557-.853.457 0 .865.096 1.16.29a1 1 0 0 1 .478.865c0 .483-.308.804-.692.941.234.05.43.143.576.279.184.17.285.404.285.687 0 .405-.174.737-.49.966-.313.228-.762.352-1.311.352-.96 0-1.495-.458-1.641-.868a.7.7 0 0 1-.04-.228.5.5 0 0 1 .155-.387.6.6 0 0 1 .413-.142q.174-.001.305.064.13.066.223.203a.8.8 0 0 0 .236.245c.09.055.206.087.377.087.278 0 .46-.165.46-.379a.33.33 0 0 0-.14-.288c-.096-.066-.242-.104-.444-.104H5.11a.48.48 0 0 1-.35-.122.44.44 0 0 1-.12-.323c0-.124.039-.236.12-.317.082-.08.2-.125.35-.125h.028c.178 0 .311-.038.399-.102a.32.32 0 0 0 .131-.268.32.32 0 0 0-.112-.258.5.5 0 0 0-.322-.098.57.57 0 0 0-.286.068.53.53 0 0 0-.198.207.7.7 0 0 1-.241.27.64.64 0 0 1-.343.082.55.55 0 0 1-.401-.144.5.5 0 0 1-.136-.363c0-.085.012-.153.042-.237" clip-rule="evenodd"/>
  </svg>
`;
const Octobase = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M19.552 5.67c.25-.25.654-.25.904 0l-.001.002c.25.25.25.654 0 .904a3.52 3.52 0 0 1-2.524 1.036q-.233 0-.472-.028c-1.155-.137-2.32-.762-3.364-1.807l-1.808 1.808 3.127 3.127a.64.64 0 1 1-.904.905L11.383 8.49l-1.809 1.808 3.127 3.127a.64.64 0 1 1-.904.904L8.67 11.202 6.862 13.01l3.127 3.127a.64.64 0 1 1-.904.904l-3.127-3.127-.004-.004A6.394 6.394 0 0 1 15 4.872c1.6 1.6 3.43 1.921 4.552.799M6.132 9.643a.986.986 0 1 0 1.394-1.395.986.986 0 0 0-1.393 1.395M9.336 6.44a.986.986 0 1 0 1.393-1.395.986.986 0 0 0-1.393 1.395m5.223.709 3.138 3.138a6.393 6.393 0 0 1-9.053 9.03c-1.6-1.6-3.429-1.92-4.551-.798a.64.64 0 1 1-.905-.904c.786-.786 1.85-1.144 2.996-1.008 1.156.136 2.32.761 3.364 1.806l1.808-1.808-3.126-3.127a.639.639 0 1 1 .904-.904L12.26 15.7l1.808-1.809-3.127-3.126a.639.639 0 1 1 .904-.905l3.127 3.127 1.808-1.808-3.127-3.127a.64.64 0 1 1 .905-.904m-1.643 11.995a.986.986 0 1 0 1.394-1.395.986.986 0 0 0-1.394 1.395m3.202-3.202a.986.986 0 1 0 1.394-1.395.986.986 0 0 0-1.394 1.395" clip-rule="evenodd"/>
  </svg>
`;
const OpenInNew = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M13.25 4a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0V5.81l-8.72 8.72a.75.75 0 1 1-1.06-1.06l8.72-8.72H14a.75.75 0 0 1-.75-.75M6 6.75c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25v-4a.75.75 0 0 1 1.5 0v4A2.75 2.75 0 0 1 16 20.75H6A2.75 2.75 0 0 1 3.25 18V8A2.75 2.75 0 0 1 6 5.25h4a.75.75 0 0 1 0 1.5z" clip-rule="evenodd"/>
  </svg>
`;
const Other = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M11.665 2.33a.75.75 0 0 1 .67 0l8 4a.75.75 0 0 1 .415.67v10a.75.75 0 0 1-.415.67l-8 4a.75.75 0 0 1-.67 0l-8-4A.75.75 0 0 1 3.25 17V7a.75.75 0 0 1 .415-.67zM4.75 8.213l6.5 3.25v8.323l-6.5-3.25zm8 11.573 6.5-3.25V8.214l-6.5 3.25zM12 10.162 18.323 7 12 3.839 5.677 7z" clip-rule="evenodd"/>
  </svg>
`;
const Page = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M7 3.25A2.75 2.75 0 0 0 4.25 6v12A2.75 2.75 0 0 0 7 20.75h10A2.75 2.75 0 0 0 19.75 18V6A2.75 2.75 0 0 0 17 3.25zM5.75 6c0-.69.56-1.25 1.25-1.25h10c.69 0 1.25.56 1.25 1.25v12c0 .69-.56 1.25-1.25 1.25H7c-.69 0-1.25-.56-1.25-1.25zM9 7.25a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zm-.75 4.25a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75M9 14.25a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5z" clip-rule="evenodd"/>
  </svg>
`;
const Palette = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75a3.9 3.9 0 0 0 3.9-3.9v-.585c0-.4.003-.486.012-.543a.975.975 0 0 1 .81-.81c.057-.009.143-.012.543-.012h.585a3.9 3.9 0 0 0 3.9-3.9c0-5.385-4.365-9.75-9.75-9.75M9.075 7.613a1.462 1.462 0 1 1 2.925 0 1.462 1.462 0 0 1-2.925 0m4.875.974a1.463 1.463 0 1 1 2.925 0 1.463 1.463 0 0 1-2.925 0M7.613 10.05a1.463 1.463 0 1 0 0 2.925 1.463 1.463 0 0 0 0-2.925" clip-rule="evenodd"/>
  </svg>
`;
const Parallelogram = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="m8.276 5.5-4.213 13h11.661l4.213-13zM7.186 4 2 20h14.815L22 4z" clip-rule="evenodd"/>
  </svg>
`;
const Paste = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8.8 2.489a.75.75 0 0 0-.75.75V4.25H7A2.75 2.75 0 0 0 4.25 7v12A2.75 2.75 0 0 0 7 21.75h10A2.75 2.75 0 0 0 19.75 19V7A2.75 2.75 0 0 0 17 4.25h-.95V3.239a.75.75 0 0 0-.75-.75zm7.25 3.261v.928a.75.75 0 0 1-.75.75H8.8a.75.75 0 0 1-.75-.75V5.75H7c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V7c0-.69-.56-1.25-1.25-1.25zm-6.5.178v-1.94h5v1.94z" clip-rule="evenodd"/>
  </svg>
`;
const PausePanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M20.5 11.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0M10 8a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1m5 1a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0z" clip-rule="evenodd"/>
  </svg>
`;
const Payment = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M2.25 7A2.75 2.75 0 0 1 5 4.25h14A2.75 2.75 0 0 1 21.75 7v10A2.75 2.75 0 0 1 19 19.75H5A2.75 2.75 0 0 1 2.25 17zM5 5.75c-.69 0-1.25.56-1.25 1.25v1.25h16.5V7c0-.69-.56-1.25-1.25-1.25zm15.25 4H3.75V17c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25zm-6 5.25a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75" clip-rule="evenodd"/>
  </svg>
`;
const PeacePanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m-3-8c.552 0 1-.672 1-1.5S9.552 9 9 9s-1 .672-1 1.5.448 1.5 1 1.5m7-1.5c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5.448-1.5 1-1.5 1 .672 1 1.5m-7 3.75a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5z" clip-rule="evenodd"/>
  </svg>
`;
const Pen = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M19.279 4.721a1.614 1.614 0 0 0-2.28 0l-.885.883 2.278 2.273.887-.885a1.603 1.603 0 0 0 0-2.271M17.33 8.937l-2.277-2.273L4.25 17.445v2.305h2.245zm-1.39-5.278a3.114 3.114 0 0 1 4.398 0 3.103 3.103 0 0 1 0 4.395L7.335 21.03a.75.75 0 0 1-.53.22H3.5a.75.75 0 0 1-.75-.75v-3.367c0-.2.08-.39.22-.53z" clip-rule="evenodd"/>
  </svg>
`;
const PenThick = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M18 12a6 6 0 1 1-12 0 6 6 0 0 1 12 0"/>
  </svg>
`;
const PenThin = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0"/>
  </svg>
`;
const PersonPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M12 3a4.026 4.026 0 1 0 0 8.053A4.026 4.026 0 0 0 12 3M12 12.395c-4.13 0-7.02 3.05-7.379 6.871A.67.67 0 0 0 5.29 20h13.422a.67.67 0 0 0 .668-.734c-.36-3.82-3.249-6.871-7.379-6.871"/>
  </svg>
`;
const PhonePanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M13.95 6H15v12H8V6h1.05c.155.537.65.93 1.237.93h2.426c.587 0 1.082-.393 1.237-.93M6 6a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2z" clip-rule="evenodd"/>
  </svg>
`;
const PickerPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M17.342 3.468a2 2 0 0 1 2.936 2.717l-2.037 2.202 1.468 1.358a1 1 0 0 1 .055 1.413l-.68.734a1 1 0 0 1-1.413.055L11.8 6.514a1 1 0 0 1-.055-1.413l.68-.734a1 1 0 0 1 1.413-.055l1.468 1.358zm-1.818 7.855-2.936-2.717-7.777 8.405a1 1 0 0 0-.229.41L3.73 20.47a.5.5 0 0 0 .653.604l2.973-1.085c.15-.055.283-.144.391-.26z" clip-rule="evenodd"/>
  </svg>
`;
const Pill = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M15 6.5H9a5.5 5.5 0 1 0 0 11h6a5.5 5.5 0 1 0 0-11M9 5a7 7 0 0 0 0 14h6a7 7 0 1 0 0-14z" clip-rule="evenodd"/>
  </svg>
`;
const Pin = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M13.591 3.692a2.75 2.75 0 0 1 3.89 0l2.827 2.828a2.75 2.75 0 0 1 0 3.889l-5.328 5.329.884.884a.75.75 0 0 1-1.06 1.06L11.09 13.97l-4.925 4.924a.75.75 0 0 1-1.06-1.06l4.924-4.925-3.712-3.712a.75.75 0 0 1 1.06-1.06l.884.883zM9.323 10.08l4.596 4.596 5.329-5.329a1.25 1.25 0 0 0 0-1.767l-2.829-2.829a1.25 1.25 0 0 0-1.767 0z" clip-rule="evenodd"/>
  </svg>
`;
const Pined = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M17.48 3.692a2.75 2.75 0 0 0-3.889 0L8.262 9.02l-.883-.884a.75.75 0 0 0-1.061 1.06l1.414 1.415 2.298 2.298-4.924 4.925a.75.75 0 1 0 1.06 1.06l4.925-4.924 2.298 2.298 1.414 1.414a.75.75 0 0 0 1.06-1.06l-.883-.884 5.328-5.329a2.75 2.75 0 0 0 0-3.89z" clip-rule="evenodd"/>
  </svg>
`;
const PlanetPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M4.956 15.825c1.723 3.169 5.435 4.874 9.061 3.903 3.626-.972 5.988-4.305 5.895-7.91-.302.168-.625.332-.96.49-1.62.769-3.855 1.563-6.327 2.225s-4.804 1.092-6.592 1.237q-.555.046-1.077.055M9.876 4.272c3.475-.93 7.028.597 8.834 3.514.473.001.894.035 1.235.113.211.048.425.12.608.235.186.117.378.305.454.587.091.34-.032.644-.169.852-.138.21-.337.402-.556.575-.441.35-1.079.714-1.843 1.076-1.538.729-3.7 1.5-6.124 2.15-2.425.65-4.683 1.062-6.38 1.2-.842.069-1.577.072-2.134-.01a2.6 2.6 0 0 1-.769-.22c-.222-.112-.48-.313-.572-.653a1 1 0 0 1 .1-.736c.1-.19.25-.36.409-.507.256-.238.603-.478 1.013-.716.105-3.43 2.419-6.529 5.894-7.46"/>
  </svg>
`;
const Play = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="m10.104 5.01 6.339 3.566c.782.44 1.415.796 1.883 1.119.47.324.88.684 1.102 1.175a2.75 2.75 0 0 1 0 2.26c-.222.491-.633.851-1.102 1.175-.468.323-1.1.679-1.883 1.119l-6.34 3.566c-.755.425-1.368.77-1.872.995-.508.227-1.015.387-1.54.328a2.75 2.75 0 0 1-1.921-1.124c-.31-.428-.419-.949-.47-1.503-.05-.55-.05-1.252-.05-2.12V8.435c0-.867 0-1.57.05-2.12.051-.554.16-1.075.47-1.503A2.75 2.75 0 0 1 6.69 3.687c.525-.06 1.032.1 1.54.328.504.226 1.117.57 1.873.995m-2.485.374c-.437-.195-.642-.22-.76-.206a1.25 1.25 0 0 0-.873.51c-.069.096-.148.287-.192.763-.043.473-.044 1.106-.044 2.02v7.057c0 .915 0 1.548.044 2.021.044.476.123.667.192.763.206.285.524.47.874.51.117.014.322-.01.759-.206.433-.194.985-.504 1.782-.952l6.273-3.529c.824-.463 1.396-.785 1.8-1.064.408-.282.538-.45.586-.557a1.25 1.25 0 0 0 0-1.027c-.048-.108-.178-.276-.586-.558-.404-.278-.976-.601-1.8-1.064L9.401 6.336c-.797-.448-1.35-.758-1.782-.952" clip-rule="evenodd"/>
  </svg>
`;
const PlayFill = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="m10.217 4.787 6.358 3.576c.774.436 1.415.797 1.893 1.126.48.331.938.723 1.188 1.278a3 3 0 0 1 0 2.465c-.25.556-.708.948-1.188 1.28-.478.328-1.119.689-1.893 1.124l-6.358 3.577c-.748.42-1.37.77-1.883 1-.52.233-1.079.415-1.671.348a3 3 0 0 1-2.096-1.226c-.349-.483-.464-1.06-.516-1.626C4 17.148 4 16.435 4 15.577V8.423c0-.858 0-1.57.051-2.132.052-.567.167-1.143.516-1.627A3 3 0 0 1 6.663 3.44c.592-.067 1.15.115 1.67.348.515.23 1.136.58 1.884 1" clip-rule="evenodd"/>
  </svg>
`;
const PlayPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 20a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17m-.703-11.413a.5.5 0 0 0-.797.402v5.022a.5.5 0 0 0 .797.402l3.407-2.51a.5.5 0 0 0 0-.806z" clip-rule="evenodd"/>
  </svg>
`;
const Plugin = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M9.902 5.384q.027.116.074.226l.003.006c.276.666-.151 1.534-1.004 1.534H6.55a1.8 1.8 0 0 0-1.8 1.8v1.124q.017 0 .035-.003h.003a2.714 2.714 0 1 1 0 5.408h-.003l-.035-.003v1.974a1.8 1.8 0 0 0 1.8 1.8h1.974l-.003-.035v-.003a2.713 2.713 0 1 1 5.408 0v.003l-.003.035h1.124a1.8 1.8 0 0 0 1.8-1.8v-2.425c0-.85.866-1.284 1.536-1.003l.004.002q.11.047.226.074a1.353 1.353 0 1 0-.003-2.645c-.067.015-.141.04-.23.076-.666.276-1.533-.152-1.533-1.004V8.95a1.8 1.8 0 0 0-1.8-1.8h-1.575c-.85 0-1.284-.866-1.003-1.536l.002-.004q.047-.11.074-.226a1.353 1.353 0 1 0-2.646 0m-1.477.266c-.337-1.695.945-3.4 2.8-3.4 1.856 0 3.137 1.705 2.8 3.4h1.025a3.3 3.3 0 0 1 3.3 3.3v1.025c1.695-.337 3.4.944 3.4 2.8s-1.705 3.137-3.4 2.8v1.875a3.3 3.3 0 0 1-3.3 3.3h-1.609c-.825 0-1.24-.807-1.05-1.444q.035-.122.043-.22a1.214 1.214 0 1 0-2.418 0q.008.098.044.217v.002c.19.633-.223 1.445-1.05 1.445H6.55a3.3 3.3 0 0 1-3.3-3.3v-2.459c0-.825.807-1.24 1.444-1.05q.122.035.22.043a1.214 1.214 0 1 0 0-2.418q-.098.008-.217.044h-.002c-.633.19-1.445-.223-1.445-1.05V8.95a3.3 3.3 0 0 1 3.3-3.3z" clip-rule="evenodd"/>
  </svg>
`;
const Plus = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 4.5c.46 0 .833.373.833.833v5.834h5.834a.833.833 0 0 1 0 1.666h-5.834v5.834a.833.833 0 0 1-1.666 0v-5.834H5.333a.833.833 0 0 1 0-1.666h5.834V5.333c0-.46.373-.833.833-.833" clip-rule="evenodd"/>
  </svg>
`;
const PlusThick = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 5a1 1 0 0 1 1 1v5h5a1 1 0 1 1 0 2h-5v5a1 1 0 1 1-2 0v-5H6a1 1 0 1 1 0-2h5V6a1 1 0 0 1 1-1" clip-rule="evenodd"/>
  </svg>
`;
const Ppt = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M2.25 6.5A2.25 2.25 0 0 1 4.5 4.25h15a2.25 2.25 0 0 1 2.25 2.25v11a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25zm2.25-.75a.75.75 0 0 0-.75.75v11c0 .414.336.75.75.75h15a.75.75 0 0 0 .75-.75v-11a.75.75 0 0 0-.75-.75zM5.75 8.5a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75m.75 2.75a.75.75 0 0 0 0 1.5H13a.75.75 0 0 0 0-1.5zm8.25.75a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75M6.5 14.75a.75.75 0 0 0 0 1.5h11a.75.75 0 0 0 0-1.5z" clip-rule="evenodd"/>
  </svg>
`;
const Presentation = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.174 3.952c0-.426.346-.772.772-.772h15.957a.772.772 0 0 1 0 1.544h-.368v9.853h.367a.772.772 0 0 1 0 1.545h-7.206v1.661l3.942 2.252a.772.772 0 1 1-.766 1.341l-3.176-1.815v1.487a.772.772 0 0 1-1.544 0v-1.421l-3.062 1.75a.772.772 0 1 1-.766-1.341l3.828-2.188v-1.726H3.946a.772.772 0 1 1 0-1.545h.368V4.724h-.368a.77.77 0 0 1-.772-.772m2.684.772h12.133v9.853H5.858zm3.42 4.357a.772.772 0 0 0-1.545 0v2.28a.772.772 0 0 0 1.544 0zm2.646-2.482c.427 0 .772.346.772.772v3.99a.772.772 0 0 1-1.544 0V7.37c0-.426.346-.772.772-.772m4.192 3.622a.772.772 0 0 0-1.545 0v1.14a.772.772 0 1 0 1.545 0z" clip-rule="evenodd"/>
  </svg>
`;
const Presentation2Panel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4 5.25a.75.75 0 0 0 0 1.5h1V16a1 1 0 0 0 1 1h4.229l-1.71 1.424a.75.75 0 0 0 .961 1.152l2.52-2.1 2.52 2.1a.75.75 0 0 0 .96-1.152L13.771 17H18a1 1 0 0 0 1-1V6.75h1a.75.75 0 0 0 0-1.5zM11.5 8a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5zm-3 3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zm5.5-.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5z" clip-rule="evenodd"/>
  </svg>
`;
const PresentationPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4 5.25a.75.75 0 0 0 0 1.5h1V16a1 1 0 0 0 1 1h4.229l-1.71 1.424a.75.75 0 0 0 .961 1.152l2.52-2.1 2.52 2.1a.75.75 0 1 0 .96-1.152L13.771 17H18a1 1 0 0 0 1-1V6.75h1a.75.75 0 0 0 0-1.5zm12.53 4.78a.75.75 0 1 0-1.06-1.06L13 11.44l-1.47-1.47a.75.75 0 0 0-1.06 0l-2.5 2.5a.75.75 0 1 0 1.06 1.06L11 11.56l1.47 1.47a.75.75 0 0 0 1.06 0z" clip-rule="evenodd"/>
  </svg>
`;
const Printer = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8.574 2.25h6.852c.258 0 .494 0 .692.016.213.018.446.057.677.175.329.168.596.435.764.765.118.23.157.463.175.676.016.198.016.434.016.692V6.25h.08c.535 0 .98 0 1.345.03.38.03.736.098 1.073.27a2.75 2.75 0 0 1 1.202 1.202c.172.337.24.693.27 1.073.03.365.03.81.03 1.345v4.66c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.75 2.75 0 0 1-1.201 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.344.03h-.081v.676c0 .258 0 .494-.016.692a1.8 1.8 0 0 1-.175.677 1.75 1.75 0 0 1-.765.764c-.23.118-.463.157-.676.175-.198.016-.434.016-.692.016H8.574c-.258 0-.494 0-.692-.016a1.8 1.8 0 0 1-.676-.175 1.75 1.75 0 0 1-.765-.765 1.8 1.8 0 0 1-.175-.676c-.016-.198-.016-.434-.016-.692v-.676h-.08c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 2.55 17.25c-.172-.338-.24-.694-.27-1.074-.03-.365-.03-.81-.03-1.345v-4.66c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 0 1 3.752 6.55c.337-.172.693-.24 1.073-.27.365-.03.81-.03 1.345-.03h.08V4.574c0-.258 0-.494.016-.692.018-.213.057-.446.175-.676a1.75 1.75 0 0 1 .765-.765c.23-.118.463-.157.676-.175.198-.016.434-.016.692-.016m-.824 4h8.5V4.6c0-.292 0-.467-.011-.596a.6.6 0 0 0-.018-.12.25.25 0 0 0-.105-.105.6.6 0 0 0-.12-.018 8 8 0 0 0-.596-.011H8.6c-.292 0-.467 0-.596.011a.6.6 0 0 0-.12.018.25.25 0 0 0-.105.104.6.6 0 0 0-.018.121c-.01.13-.011.304-.011.596zm.03-2.37v.002zm.1-.1h.002zm8.24 0h-.002zm.1.1v.002zM7.75 19.4c0 .292 0 .467.011.596a.6.6 0 0 0 .018.12.25.25 0 0 0 .104.105.6.6 0 0 0 .121.018c.13.01.304.011.596.011h6.8c.292 0 .467 0 .596-.011a.6.6 0 0 0 .12-.018.25.25 0 0 0 .105-.105.6.6 0 0 0 .018-.12c.01-.13.011-.304.011-.596v-2.8c0-.292 0-.467-.011-.596a.6.6 0 0 0-.018-.12.25.25 0 0 0-.105-.105.6.6 0 0 0-.12-.018 8 8 0 0 0-.596-.011H8.6c-.292 0-.467 0-.596.011a.6.6 0 0 0-.12.018.25.25 0 0 0-.105.104.6.6 0 0 0-.018.121c-.01.13-.011.304-.011.596zm.03-3.52v.002zm.1-.1h.002zm8.24 0h-.002zm.1.1v.002zm1.53 1.37v-.676c0-.258 0-.494-.016-.692a1.8 1.8 0 0 0-.175-.676 1.75 1.75 0 0 0-.765-.765 1.8 1.8 0 0 0-.676-.175c-.198-.016-.434-.016-.692-.016H8.574c-.258 0-.494 0-.692.016a1.8 1.8 0 0 0-.676.175 1.75 1.75 0 0 0-.765.765c-.118.23-.157.463-.175.676-.016.198-.016.434-.016.692v.676H6.2c-.572 0-.957 0-1.253-.025-.287-.023-.424-.065-.514-.111a1.25 1.25 0 0 1-.547-.547c-.046-.09-.088-.227-.111-.515-.024-.295-.025-.68-.025-1.252v-4.6c0-.572 0-.957.025-1.253.023-.287.065-.424.111-.514a1.25 1.25 0 0 1 .547-.547c.09-.046.227-.088.514-.111.296-.024.68-.025 1.253-.025h11.6c.572 0 .957 0 1.252.025.288.023.425.065.515.111.236.12.427.311.547.547.046.09.088.227.111.514.024.296.025.68.025 1.253v4.6c0 .572 0 .957-.025 1.252-.023.288-.065.425-.111.515a1.25 1.25 0 0 1-.547.547c-.09.046-.227.088-.515.111-.295.024-.68.025-1.252.025zm-1.63 2.97h-.002zm-8.24 0h.002zm-.1-.1v-.002zM6.25 11a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75" clip-rule="evenodd"/>
  </svg>
`;
const ProductHunt = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <g clip-path="url(#a)"><path fill='currentColor' d="M24.003 12c0 6.63-5.37 12-12 12s-12-5.37-12-12 5.37-12 12-12c6.629 0 12 5.37 12 12"/><path fill='currentColor' d="M13.603 12h-3.4V8.41h3.4c.99 0 1.8.81 1.8 1.8 0 .991-.81 1.801-1.8 1.801m0-6H7.802v12h2.4v-3.6h3.4a4.2 4.2 0 1 0 0-8.4"/></g><defs><clipPath id="a"><path fill='currentColor' d="M0 0H24V24H0z"/></clipPath></defs>
  </svg>
`;
const ProductHuntDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <g clip-path="url(#a)"><path fill="#DA552F" d="M24.003 12c0 6.63-5.37 12-12 12s-12-5.37-12-12 5.37-12 12-12c6.629 0 12 5.37 12 12"/><path fill="#fff" d="M13.603 12h-3.4V8.41h3.4c.99 0 1.8.81 1.8 1.8 0 .991-.81 1.801-1.8 1.801m0-6H7.802v12h2.4v-3.6h3.4a4.2 4.2 0 1 0 0-8.4"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0H24V24H0z"/></clipPath></defs>
  </svg>
`;
const Progress = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M15 4.25a.75.75 0 0 1 .75.75v1.25H19A2.75 2.75 0 0 1 21.75 9v6A2.75 2.75 0 0 1 19 17.75h-3.25V19a.75.75 0 0 1-1.5 0v-1.25H5A2.75 2.75 0 0 1 2.25 15V9A2.75 2.75 0 0 1 5 6.25h9.25V5a.75.75 0 0 1 .75-.75M5 7.75h9.25v8.5H5c-.69 0-1.25-.56-1.25-1.25V9c0-.69.56-1.25 1.25-1.25m10.75 0v8.5H19c.69 0 1.25-.56 1.25-1.25V9c0-.69-.56-1.25-1.25-1.25zm-3 2.25a.75.75 0 0 0-1.5 0v4a.75.75 0 0 0 1.5 0zM9 9.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4A.75.75 0 0 1 9 9.25M6.75 10a.75.75 0 0 0-1.5 0v4a.75.75 0 0 0 1.5 0z" clip-rule="evenodd"/>
  </svg>
`;
const Property = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.5 6.25a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5zm0 5a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5zM2.75 17a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75M9 6.25a.75.75 0 0 0 0 1.5h11a.75.75 0 0 0 0-1.5zM8.25 12a.75.75 0 0 1 .75-.75h11a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75M9 16.25a.75.75 0 0 0 0 1.5h11a.75.75 0 0 0 0-1.5z" clip-rule="evenodd"/>
  </svg>
`;
const Publish = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.035 11.25h3.209c.083-2.207.529-4.22 1.232-5.75q.215-.471.478-.9a8.01 8.01 0 0 0-4.92 6.65M12 2.5a9.5 9.5 0 1 0 0 19 9.5 9.5 0 0 0 0-19M12 4c-.64 0-1.459.596-2.161 2.126-.6 1.306-1.012 3.097-1.094 5.124h6.51c-.082-2.027-.494-3.818-1.094-5.124C13.46 4.596 12.64 4 12 4m4.756 7.25c-.083-2.207-.529-4.22-1.232-5.75a9 9 0 0 0-.478-.9 8.01 8.01 0 0 1 4.92 6.65zm-1.5 1.5H8.744c.082 2.027.494 3.818 1.094 5.124C10.54 19.404 11.36 20 12 20s1.459-.596 2.161-2.126c.6-1.306 1.012-3.097 1.094-5.124m-.21 6.65a9 9 0 0 0 .478-.9c.704-1.53 1.15-3.543 1.232-5.75h3.21a8.01 8.01 0 0 1-4.92 6.65m-6.092 0a9 9 0 0 1-.478-.9c-.703-1.53-1.15-3.543-1.232-5.75h-3.21a8.01 8.01 0 0 0 4.92 6.65" clip-rule="evenodd"/>
  </svg>
`;
const QrCodePanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6 9V6h3v3zM4 5a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm2 13v-3h3v3zm-2-4a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm11-8v3h3V6zm-1-2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm2 9h-3v3h2v1h-2v3h3v-2h1v2h3v-3h-2v-1h2v-3h-3v2h-1z" clip-rule="evenodd"/>
  </svg>
`;
const Quote = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5 10.966v4.095c0 .565.458 1.024 1.024 1.024h4.095c.566 0 1.024-.459 1.024-1.024v-4.095c0-.566-.459-1.024-1.024-1.024H6.704A3.35 3.35 0 0 1 9.845 7.75v-1.5A4.845 4.845 0 0 0 5 10.966m8 0v4.095c0 .565.458 1.024 1.024 1.024h4.095c.566 0 1.024-.459 1.024-1.024v-4.095c0-.566-.459-1.024-1.024-1.024h-3.415a3.35 3.35 0 0 1 3.141-2.192v-1.5A4.845 4.845 0 0 0 13 10.966" clip-rule="evenodd"/>
  </svg>
`;
const Radiant = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M2.25 5A.75.75 0 0 1 3 4.25h1A4.25 4.25 0 0 1 8.25 8.5 2.75 2.75 0 0 0 11 11.25h2a2.75 2.75 0 0 0 2.75-2.75A4.25 4.25 0 0 1 20 4.25h1a.75.75 0 0 1 0 1.5h-1a2.75 2.75 0 0 0-2.75 2.75c0 1.049-.38 2.009-1.01 2.75H21a.75.75 0 0 1 0 1.5h-4.76a4.23 4.23 0 0 1 1.01 2.75A2.75 2.75 0 0 0 20 18.25h1a.75.75 0 0 1 0 1.5h-1a4.25 4.25 0 0 1-4.25-4.25A2.75 2.75 0 0 0 13 12.75h-2a2.75 2.75 0 0 0-2.75 2.75A4.25 4.25 0 0 1 4 19.75H3a.75.75 0 0 1 0-1.5h1a2.75 2.75 0 0 0 2.75-2.75c0-1.049.38-2.009 1.01-2.75H3a.75.75 0 0 1 0-1.5h4.76A4.23 4.23 0 0 1 6.75 8.5 2.75 2.75 0 0 0 4 5.75H3A.75.75 0 0 1 2.25 5" clip-rule="evenodd"/>
  </svg>
`;
const RainPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6.6 14.7a3.6 3.6 0 0 1 0-7.2 4.5 4.5 0 0 1 8.914-.88 3.15 3.15 0 0 1 2.746 3.634 2.25 2.25 0 1 1 .49 4.446zm-2.122 4.535 1.875-3A.5.5 0 0 1 6.777 16h.137a.5.5 0 0 1 .424.765l-1.875 3A.5.5 0 0 1 5.04 20h-.137a.5.5 0 0 1-.424-.765m6.875-3-1.875 3a.5.5 0 0 0 .424.765h.137a.5.5 0 0 0 .424-.235l1.875-3a.5.5 0 0 0-.424-.765h-.137a.5.5 0 0 0-.424.235m3.125 3 1.875-3a.5.5 0 0 1 .424-.235h.137a.5.5 0 0 1 .424.765l-1.875 3a.5.5 0 0 1-.424.235h-.137a.5.5 0 0 1-.424-.765" clip-rule="evenodd"/>
  </svg>
`;
const Readwise = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M20.6 19.756c-1.074-.128-1.598-.482-2.242-1.553l-3.649-5.935c2.718-.457 4.067-1.782 4.067-4.557 0-3.668-2.59-4.711-7.55-4.711H3v1.07c1.574.129 1.885.307 1.885 1.783v12.121c0 1.45-.359 1.654-1.885 1.782v1.071h7.993v-1.07c-1.526-.129-1.885-.33-1.885-1.783V12.55h1.238l4.96 8.278H20.6zM14.642 9.33s-.65-3.647-.229-4.42l-5.372 5.934c1.314-1.093 5.289-1.11 5.289-1.11a.395.395 0 0 0 .312-.404" clip-rule="evenodd"/>
  </svg>
`;
const ReadwiseLogoDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#000" fill-rule="evenodd" d="M20.6 19.756c-1.074-.128-1.598-.482-2.242-1.553l-3.649-5.935c2.718-.457 4.067-1.782 4.067-4.557 0-3.668-2.59-4.711-7.55-4.711H3v1.07c1.574.129 1.885.307 1.885 1.783v12.121c0 1.45-.359 1.654-1.885 1.782v1.071h7.993v-1.07c-1.526-.129-1.885-.33-1.885-1.783V12.55h1.238l4.96 8.278H20.6zM14.642 9.33s-.65-3.647-.229-4.42l-5.372 5.934c1.314-1.093 5.289-1.11 5.289-1.11a.395.395 0 0 0 .312-.404" clip-rule="evenodd"/>
  </svg>
`;
const Reauthentication = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M4 9.75A.75.75 0 0 0 4.75 9V6c0-.69.56-1.25 1.25-1.25h3a.75.75 0 0 0 0-1.5H6A2.75 2.75 0 0 0 3.25 6v3c0 .414.336.75.75.75M4.75 15a.75.75 0 0 0-1.5 0v3A2.75 2.75 0 0 0 6 20.75h3a.75.75 0 0 0 0-1.5H6c-.69 0-1.25-.56-1.25-1.25zM19.25 15a.75.75 0 0 1 1.5 0v3A2.75 2.75 0 0 1 18 20.75h-3a.75.75 0 0 1 0-1.5h3c.69 0 1.25-.56 1.25-1.25zM19.25 9a.75.75 0 0 0 1.5 0V6A2.75 2.75 0 0 0 18 3.25h-3a.75.75 0 0 0 0 1.5h3c.69 0 1.25.56 1.25 1.25z"/><path fill='currentColor' fill-rule="evenodd" d="M12.406 12.75A3.001 3.001 0 0 1 6.5 12a3 3 0 0 1 5.906-.75H16.5a.75.75 0 0 1 .67.415l.5 1a.75.75 0 1 1-1.34.67l-.293-.585zM9.5 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" clip-rule="evenodd"/>
  </svg>
`;
const Recent = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25M12.75 7a.75.75 0 0 0-1.5 0v5.5c0 .414.336.75.75.75h4.5a.75.75 0 0 0 0-1.5h-3.75z" clip-rule="evenodd"/>
  </svg>
`;
const Reddit = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"/><path fill='currentColor' d="M18.652 12.095c0-.81-.655-1.454-1.454-1.454-.378 0-.74.145-1.013.405-1.002-.715-2.373-1.18-3.899-1.24l.668-3.123 2.17.465a1.037 1.037 0 1 0 1.037-1.085c-.406 0-.763.238-.93.584l-2.42-.513a.25.25 0 0 0-.191.036.23.23 0 0 0-.107.167l-.74 3.481c-1.55.048-2.944.513-3.958 1.24a1.46 1.46 0 0 0-1.013-.405 1.452 1.452 0 0 0-.596 2.778 2.6 2.6 0 0 0-.036.44c0 2.242 2.611 4.066 5.83 4.066s5.83-1.812 5.83-4.065a3 3 0 0 0-.036-.441c.5-.227.858-.74.858-1.336m-9.99 1.037a1.038 1.038 0 1 1 1.037 1.038c-.572.011-1.037-.465-1.037-1.038m5.806 2.754c-.715.716-2.075.764-2.468.764-.405 0-1.764-.06-2.468-.764a.267.267 0 0 1 0-.381.267.267 0 0 1 .382 0c.453.453 1.406.608 2.086.608s1.645-.155 2.086-.608a.267.267 0 0 1 .382 0 .29.29 0 0 1 0 .381m-.191-1.704a1.038 1.038 0 1 1 1.037-1.037c0 .56-.464 1.037-1.037 1.037"/>
  </svg>
`;
const RedditDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#FF4500" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"/><path fill="#fff" d="M18.652 12.095c0-.81-.655-1.454-1.454-1.454-.378 0-.74.145-1.013.405-1.002-.715-2.373-1.18-3.899-1.24l.668-3.123 2.17.465a1.037 1.037 0 1 0 1.037-1.085c-.406 0-.763.238-.93.584l-2.42-.513a.25.25 0 0 0-.191.036.23.23 0 0 0-.107.167l-.74 3.481c-1.55.048-2.944.513-3.958 1.24a1.46 1.46 0 0 0-1.013-.405 1.452 1.452 0 0 0-.596 2.778 2.6 2.6 0 0 0-.036.44c0 2.242 2.611 4.066 5.83 4.066s5.83-1.812 5.83-4.065a3 3 0 0 0-.036-.441c.5-.227.858-.74.858-1.336m-9.99 1.037a1.038 1.038 0 1 1 1.037 1.038c-.572.011-1.037-.465-1.037-1.038m5.806 2.754c-.715.716-2.075.764-2.468.764-.405 0-1.764-.06-2.468-.764a.267.267 0 0 1 0-.381.267.267 0 0 1 .382 0c.453.453 1.406.608 2.086.608s1.645-.155 2.086-.608a.267.267 0 0 1 .382 0 .29.29 0 0 1 0 .381m-.191-1.704a1.038 1.038 0 1 1 1.037-1.037c0 .56-.464 1.037-1.037 1.037"/>
  </svg>
`;
const Redo = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M15.47 4.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 1 1-1.06-1.06l2.72-2.72H13.6c-1.692 0-2.917 0-3.88.08-.954.077-1.585.228-2.103.492a5.25 5.25 0 0 0-2.295 2.295c-.264.518-.415 1.15-.493 2.103-.078.963-.079 2.187-.079 3.88a.75.75 0 0 1-1.5 0v-.034c0-1.651 0-2.937.084-3.968.086-1.047.262-1.897.652-2.662a6.75 6.75 0 0 1 2.95-2.95c.765-.39 1.615-.566 2.662-.652 1.031-.084 2.317-.084 3.968-.084h4.623l-2.72-2.72a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>
  </svg>
`;
const ReleaseFromGroup = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5.778 4.75c-.564 0-1.028.464-1.028 1.028v1.778a.75.75 0 0 1-1.5 0V5.778A2.533 2.533 0 0 1 5.778 3.25h1.778a.75.75 0 0 1 0 1.5zM15.694 4a.75.75 0 0 1 .75-.75h1.778a2.533 2.533 0 0 1 2.528 2.528v1.778a.75.75 0 0 1-1.5 0V5.778c0-.564-.464-1.028-1.028-1.028h-1.778a.75.75 0 0 1-.75-.75M4 15.694a.75.75 0 0 1 .75.75v1.778c0 .564.464 1.028 1.028 1.028h1.778a.75.75 0 0 1 0 1.5H5.778a2.533 2.533 0 0 1-2.528-2.528v-1.778a.75.75 0 0 1 .75-.75M8.75 8.8v2.4019999999999997q.001.004.013.015a.14.14 0 0 0 .094.033h4.286a.14.14 0 0 0 .094-.033l.012-.015.001-.002V8.798l-.013-.015a.14.14 0 0 0-.094-.033H8.857a.14.14 0 0 0-.094.033l-.013.015zm-1.5 0c0-.904.77-1.55 1.607-1.55h4.286c.838 0 1.607.646 1.607 1.55v2.4c0 .904-.77 1.55-1.607 1.55H8.857c-.838 0-1.607-.646-1.607-1.55zM15.75 15.8v2.4019999999999997l.013.015a.14.14 0 0 0 .094.033h4.286a.14.14 0 0 0 .094-.033l.013-.015v-2.4039999999999995l-.013-.015a.14.14 0 0 0-.094-.033h-4.286a.14.14 0 0 0-.094.033l-.012.015zm-1.5 0c0-.904.77-1.55 1.607-1.55h4.286c.838 0 1.607.646 1.607 1.55v2.4c0 .904-.77 1.55-1.607 1.55h-4.286c-.838 0-1.607-.646-1.607-1.55z" clip-rule="evenodd"/>
  </svg>
`;
const Remove = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12m6 0a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75" clip-rule="evenodd"/>
  </svg>
`;
const RemoveFolder = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5 5.25c-.69 0-1.25.56-1.25 1.25V17c0 .69.56 1.25 1.25 1.25h7a.75.75 0 0 1 0 1.5H5A2.75 2.75 0 0 1 2.25 17V6.5A2.75 2.75 0 0 1 5 3.75h4.672c.729 0 1.428.29 1.944.805l1.195 1.195H19a2.75 2.75 0 0 1 2.75 2.75V11a.75.75 0 0 1-1.5 0V8.5c0-.69-.56-1.25-1.25-1.25h-6.5a.75.75 0 0 1-.53-.22l-1.415-1.414a1.25 1.25 0 0 0-.883-.366zm9.47 8.22a.75.75 0 0 1 1.06 0L18 15.94l2.47-2.47a.75.75 0 1 1 1.06 1.06L19.06 17l2.47 2.47a.75.75 0 1 1-1.06 1.06L18 18.06l-2.47 2.47a.75.75 0 1 1-1.06-1.06L16.94 17l-2.47-2.47a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>
  </svg>
`;
const Replace = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M17.777 13.505a.75.75 0 0 1-1.115-.007l-2.223-2.5a.75.75 0 0 1 1.122-.996l.911 1.025V6a.25.25 0 0 0-.25-.25H10a.75.75 0 0 1 0-1.5h6.222c.967 0 1.75.784 1.75 1.75v5.063l.974-1.068a.75.75 0 0 1 1.108 1.01zm-11.054-3.01a.75.75 0 0 1 1.115.007l2.223 2.5a.75.75 0 0 1-1.122.996l-.911-1.025V18c0 .138.112.25.25.25H14.5a.75.75 0 0 1 0 1.5H8.278A1.75 1.75 0 0 1 6.528 18v-5.063l-.974 1.068a.75.75 0 1 1-1.108-1.01z" clip-rule="evenodd"/>
  </svg>
`;
const Reset = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M3.25 12a8.75 8.75 0 0 1 14.584-6.522l.002.002 1.414 1.277V4a.75.75 0 0 1 1.5 0v4.444a.75.75 0 0 1-.75.75h-4.444a.75.75 0 1 1 0-1.5h2.494l-1.217-1.098-.001-.001a7.25 7.25 0 1 0 2.238 7.017.75.75 0 1 1 1.463.332A8.75 8.75 0 0 1 3.25 12"/>
  </svg>
`;
const ResizeTidyUp = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.368 5.55c0-.856.694-1.55 1.55-1.55h3.543c.856 0 1.55.694 1.55 1.55v3.543a1.55 1.55 0 0 1-1.55 1.55H5.918a1.55 1.55 0 0 1-1.55-1.55zm1.55-.221c-.122 0-.221.099-.221.221v3.543c0 .122.099.221.221.221h3.543c.122 0 .221-.099.221-.221V5.55c0-.122-.099-.221-.221-.221zm7.307.221c0-.856.694-1.55 1.55-1.55h3.543c.856 0 1.55.694 1.55 1.55v3.543a1.55 1.55 0 0 1-1.55 1.55h-3.543a1.55 1.55 0 0 1-1.55-1.55zm1.55-.221c-.122 0-.221.099-.221.221v3.543c0 .122.099.221.221.221h3.543c.122 0 .221-.099.221-.221V5.55c0-.122-.099-.221-.221-.221zM4.368 14.407c0-.856.694-1.55 1.55-1.55h3.543c.856 0 1.55.694 1.55 1.55v3.543a1.55 1.55 0 0 1-1.55 1.55H5.918a1.55 1.55 0 0 1-1.55-1.55zm1.55-.221c-.122 0-.221.099-.221.221v3.543c0 .122.099.221.221.221h3.543c.122 0 .221-.099.221-.221v-3.543c0-.122-.099-.221-.221-.221zm7.307.221c0-.856.694-1.55 1.55-1.55h3.543c.856 0 1.55.694 1.55 1.55v3.543a1.55 1.55 0 0 1-1.55 1.55h-3.543a1.55 1.55 0 0 1-1.55-1.55zm1.55-.221c-.122 0-.221.099-.221.221v3.543c0 .122.099.221.221.221h3.543c.122 0 .221-.099.221-.221v-3.543c0-.122-.099-.221-.221-.221z" clip-rule="evenodd"/>
  </svg>
`;
const RewindFifteenSeconds = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M20.75 12A8.75 8.75 0 0 0 6.166 5.478l-.002.002L4.75 6.757V4a.75.75 0 0 0-1.5 0v4.444c0 .415.336.75.75.75h4.444a.75.75 0 1 0 0-1.5H5.95l1.217-1.098.001-.001a7.25 7.25 0 0 1 9.944 10.546.75.75 0 1 0 1.058 1.064A8.73 8.73 0 0 0 20.75 12" clip-rule="evenodd"/><path fill='currentColor' d="M11.344 20.972c-1.19 0-2.22-.568-2.6-1.41a1.2 1.2 0 0 1-.123-.525c0-.36.23-.585.595-.585.29 0 .466.113.611.397.263.627.777.997 1.523.997.917 0 1.565-.649 1.565-1.565 0-.89-.648-1.523-1.56-1.523-.488 0-.911.198-1.206.488-.322.321-.456.391-.772.391-.445 0-.665-.316-.655-.692 0-.032 0-.053.006-.085l.246-2.923c.049-.61.36-.857.966-.857h3.335c.354 0 .584.225.584.563 0 .343-.23.568-.584.568h-3.126l-.204 2.29h.027c.327-.483.965-.784 1.742-.784 1.48 0 2.537 1.046 2.537 2.526 0 1.62-1.19 2.73-2.907 2.73M5.988 20.924c-.402 0-.681-.279-.681-.697V14.42H5.28l-1.25.869a.6.6 0 0 1-.39.134c-.29 0-.5-.21-.5-.515 0-.215.086-.375.317-.536l1.582-1.11c.343-.242.557-.29.847-.29.488 0 .783.295.783.772v6.483c0 .418-.279.697-.681.697"/>
  </svg>
`;
const RightBracket = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M19.75 3c-.797 0-1.681.263-2.377.686C16.712 4.088 16 4.78 16 5.728V9.5c0 .709-.726 1.488-1.897 1.488a.75.75 0 0 0 0 1.5c1.17 0 1.897.78 1.897 1.487v3.774c0 .945.708 1.642 1.369 2.05.695.429 1.58.7 2.381.7a.75.75 0 0 0 0-1.5c-.498 0-1.113-.18-1.593-.476-.515-.318-.657-.621-.657-.774v-3.774c0-.928-.456-1.708-1.144-2.237.688-.53 1.144-1.309 1.144-2.238V5.728c0-.15.139-.448.652-.76.48-.292 1.096-.468 1.598-.468a.75.75 0 0 0 0-1.5m-15 5a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5zm.75 3.75a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75M5.25 14a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5z" clip-rule="evenodd"/>
  </svg>
`;
const RightLayout = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M11.25 8.5a4.25 4.25 0 0 1 4.25-4.25H21a.75.75 0 0 1 0 1.5h-5.5a2.75 2.75 0 0 0-2.75 2.75c0 1.049-.38 2.009-1.01 2.75H21a.75.75 0 0 1 0 1.5h-9.26a4.23 4.23 0 0 1 1.01 2.75 2.75 2.75 0 0 0 2.75 2.75H21a.75.75 0 0 1 0 1.5h-5.5a4.25 4.25 0 0 1-4.25-4.25 2.75 2.75 0 0 0-2.75-2.75H3a.75.75 0 0 1 0-1.5h5.5a2.75 2.75 0 0 0 2.75-2.75" clip-rule="evenodd"/>
  </svg>
`;
const RightSidebar = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M15.25 6h3.25a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-3.25zm-1.5 0H5.5a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h8.25zM3.5 6.5a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2z" clip-rule="evenodd"/>
  </svg>
`;
const RightTab = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M9.09 5.884a.75.75 0 0 1 .75-.75h10.146a.75.75 0 0 1 0 1.5H9.84a.75.75 0 0 1-.75-.75M9.09 10.196a.75.75 0 0 1 .75-.75h10.146a.75.75 0 0 1 0 1.5H9.84a.75.75 0 0 1-.75-.75M9.84 13.758a.75.75 0 0 0 0 1.5h10.146a.75.75 0 0 0 0-1.5zM9.09 18.82a.75.75 0 0 1 .75-.75h5.099a.75.75 0 0 1 0 1.5H9.84a.75.75 0 0 1-.75-.75M3 10.514v3.597c0 .441.486.71.86.476l2.877-1.798a.562.562 0 0 0 0-.953L3.86 10.038a.562.562 0 0 0-.86.476"/>
  </svg>
`;
const Rotate = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M5.235 21.318C3.748 21.318 3 20.612 3 19.087v-8.62c0-1.525.748-2.24 2.235-2.24h8.62c1.488 0 2.236.715 2.236 2.24v8.62c0 1.525-.748 2.231-2.236 2.231zm.027-1.403h8.567c.6 0 .861-.244.861-.854v-8.576c0-.61-.26-.854-.86-.854H5.261c-.592 0-.862.244-.862.854v8.576c0 .61.27.854.862.854M20.424 10.682a.57.57 0 0 1-.567-.571V8.73c0-1.962-1.252-3.343-3.236-3.343h-.183v1.179c0 .663-.512.82-1.024.442L13.11 5.313c-.394-.285-.384-.617 0-.902l2.304-1.704c.512-.386 1.024-.23 1.024.452v1.16h.192c2.624 0 4.37 1.777 4.37 4.41v1.382a.58.58 0 0 1-.576.57"/>
  </svg>
`;
const RotateAnticlockwise = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12.631 5.357a7.012 7.012 0 0 0-6.57 9.467l.794-2.327a.679.679 0 1 1 1.284.438l-1.225 3.592a.68.68 0 0 1-.861.424L2.46 15.725a.679.679 0 0 1 .438-1.284l1.805.616a8.369 8.369 0 1 1 7.928 5.681.679.679 0 0 1 0-1.357 7.012 7.012 0 1 0 0-14.024" clip-rule="evenodd"/>
  </svg>
`;
const RoundedRectangle = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M2.25 7A2.75 2.75 0 0 1 5 4.25h14A2.75 2.75 0 0 1 21.75 7v10A2.75 2.75 0 0 1 19 19.75H5A2.75 2.75 0 0 1 2.25 17zM5 5.75c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V7c0-.69-.56-1.25-1.25-1.25z" clip-rule="evenodd"/>
  </svg>
`;
const RoundedSquare = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.25 6A2.75 2.75 0 0 1 6 3.25h12A2.75 2.75 0 0 1 20.75 6v12A2.75 2.75 0 0 1 18 20.75H6A2.75 2.75 0 0 1 3.25 18zM6 4.75c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25V6c0-.69-.56-1.25-1.25-1.25z" clip-rule="evenodd"/>
  </svg>
`;
const RulerPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v19a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-.585h4v-1H8v-.846h2.154v-1H8v-.846h2.154v-1H8v-.846h4v-1H8v-.846h2.154v-1H8v-.846h2.154v-1H8v-.847h4v-1H8v-.846h2.154v-1H8v-.846h2.154v-1H8V4.3h4v-1H8z" clip-rule="evenodd"/>
  </svg>
`;
const SadPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m-3-8c.552 0 1-.672 1-1.5S9.552 9 9 9s-1 .672-1 1.5.448 1.5 1 1.5m7-1.5c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5.448-1.5 1-1.5 1 .672 1 1.5m-7.624 4.916a.75.75 0 0 0 1.04.208 4.66 4.66 0 0 1 5.168 0 .75.75 0 1 0 .832-1.248 6.16 6.16 0 0 0-6.832 0 .75.75 0 0 0-.208 1.04" clip-rule="evenodd"/>
  </svg>
`;
const Save = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6 4.75c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25V7.828c0-.331-.132-.649-.366-.883l-1.829-1.829a1.25 1.25 0 0 0-.883-.366h-.422V7A1.75 1.75 0 0 1 14 8.75h-4A1.75 1.75 0 0 1 8.25 7V4.75zm6 0h2.25V7a.25.25 0 0 1-.25.25h-4A.25.25 0 0 1 9.75 7V4.75zm4.172-1.5H6A2.75 2.75 0 0 0 3.25 6v12A2.75 2.75 0 0 0 6 20.75h12A2.75 2.75 0 0 0 20.75 18V7.828c0-.729-.29-1.428-.805-1.944l-1.829-1.829a2.75 2.75 0 0 0-1.944-.805M9.75 14a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M12 10.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5" clip-rule="evenodd"/>
  </svg>
`;
const Scale = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.25 6A2.75 2.75 0 0 1 6 3.25h5a.75.75 0 0 1 0 1.5H6c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25v-5a.75.75 0 0 1 1.5 0v5A2.75 2.75 0 0 1 18 20.75H6A2.75 2.75 0 0 1 3.25 18z" clip-rule="evenodd"/><path fill='currentColor' fill-rule="evenodd" d="M15 4.75a.75.75 0 0 1 0-1.5h5a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0V5.81l-7.44 7.44H15a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75V9a.75.75 0 0 1 1.5 0v3.19l7.44-7.44z" clip-rule="evenodd"/>
  </svg>
`;
const ScaleAlt = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M13.25 4a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0V4.75H14a.75.75 0 0 1-.75-.75M10.75 20a.75.75 0 0 1-.75.75H4a.75.75 0 0 1-.75-.75v-6a.75.75 0 0 1 1.5 0v5.25H10a.75.75 0 0 1 .75.75" clip-rule="evenodd"/><path fill='currentColor' fill-rule="evenodd" d="m3.47 19.47 16-16 1.06 1.06-16 16z" clip-rule="evenodd"/>
  </svg>
`;
const Scissors = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6.667 4.75a1.917 1.917 0 1 0 0 3.833 1.917 1.917 0 0 0 0-3.833M3.25 6.667A3.417 3.417 0 1 1 9.568 8.47l2.721 2.51 7.202-6.643A.75.75 0 0 1 20.51 5.44L9.569 15.53a3.417 3.417 0 1 1-1.053-1.07L11.183 12 8.515 9.54A3.417 3.417 0 0 1 3.25 6.666m10.865 7.017a.75.75 0 0 1 1.06-.042l5.333 4.918a.75.75 0 1 1-1.016 1.103l-5.334-4.919a.75.75 0 0 1-.043-1.06m-7.448 1.733a1.917 1.917 0 1 0 0 3.833 1.917 1.917 0 0 0 0-3.833" clip-rule="evenodd"/>
  </svg>
`;
const Search = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.75 9.5a5.75 5.75 0 1 1 11.5 0 5.75 5.75 0 0 1-11.5 0M9.5 2.25a7.25 7.25 0 1 0 4.569 12.88l5.4 5.4a.75.75 0 1 0 1.061-1.06l-5.4-5.401A7.25 7.25 0 0 0 9.5 2.25" clip-rule="evenodd"/>
  </svg>
`;
const Select = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.012 4.35c-.17-1.5 1.514-2.496 2.748-1.625l13.222 9.336c1.383.976.712 3.15-.98 3.179l-6.661.11a.25.25 0 0 0-.213.127L9.066 20.88c-.836 1.475-3.071 1.019-3.261-.666zm1.883-.4a.25.25 0 0 0-.393.232l1.793 15.863a.25.25 0 0 0 .466.095l3.061-5.403a1.75 1.75 0 0 1 1.494-.887l6.66-.11a.25.25 0 0 0 .141-.454z" clip-rule="evenodd"/>
  </svg>
`;
const SelectArea = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3 6a3 3 0 0 1 5.92-.692h6.16a3.001 3.001 0 1 1 3.612 3.612v6.16a3.001 3.001 0 1 1-3.612 3.612H8.92a3.001 3.001 0 1 1-3.612-3.612V8.92A3 3 0 0 1 3 6m3.692 2.92v6.16a3 3 0 0 1 2.228 2.228h6.16a3 3 0 0 1 2.228-2.228V8.92a3 3 0 0 1-2.228-2.228H8.92A3 3 0 0 1 6.692 8.92M6 4.385a1.615 1.615 0 1 0 0 3.23 1.615 1.615 0 0 0 0-3.23m12 0a1.615 1.615 0 1 0 0 3.23 1.615 1.615 0 0 0 0-3.23m-12 12a1.615 1.615 0 1 0 0 3.23 1.615 1.615 0 0 0 0-3.23m12 0a1.615 1.615 0 1 0 0 3.23 1.615 1.615 0 0 0 0-3.23" clip-rule="evenodd"/>
  </svg>
`;
const SelectText = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 3a.657.657 0 0 0 0 1.317h2.625v15.366H12A.657.657 0 0 0 12 21h6.563a.657.657 0 0 0 0-1.317h-2.625V4.317h2.624a.657.657 0 0 0 0-1.317zM5 7.39a.44.44 0 0 0-.437.44v8.78c0 .242.195.439.437.439h7.656a.657.657 0 0 1 0 1.317H5c-.966 0-1.75-.786-1.75-1.756V7.83c0-.97.784-1.757 1.75-1.757h7.656a.657.657 0 0 1 0 1.317zm14 9.659a.44.44 0 0 0 .438-.44V7.83A.44.44 0 0 0 19 7.39h-1.094a.657.657 0 0 1 0-1.317H19c.966 0 1.75.786 1.75 1.756v8.78c0 .97-.784 1.757-1.75 1.757h-1.094a.657.657 0 0 1 0-1.317z" clip-rule="evenodd"/>
  </svg>
`;
const Selection = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6 3.25A2.75 2.75 0 0 0 3.25 6v12A2.75 2.75 0 0 0 6 20.75h5a.75.75 0 0 0 0-1.5H6c-.69 0-1.25-.56-1.25-1.25V6c0-.69.56-1.25 1.25-1.25h12c.69 0 1.25.56 1.25 1.25v5a.75.75 0 0 0 1.5 0V6A2.75 2.75 0 0 0 18 3.25zm7.939 10.041a.5.5 0 0 0-.648.648l2.957 7.556a.5.5 0 0 0 .936-.012l1.061-2.937a.5.5 0 0 1 .3-.3l2.938-1.062a.5.5 0 0 0 .012-.936z" clip-rule="evenodd"/>
  </svg>
`;
const Selfhost = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5.25 5.063h13.5a.75.75 0 0 1 .75.75v3.375a.75.75 0 0 1-.75.75H5.25a.75.75 0 0 1-.75-.75V5.812a.75.75 0 0 1 .75-.75M3 5.813a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 5.813v3.375a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 9.188zm2.25 8.25h13.5a.75.75 0 0 1 .75.75v3.374a.75.75 0 0 1-.75.75H5.25a.75.75 0 0 1-.75-.75v-3.375a.75.75 0 0 1 .75-.75m-2.25.75a2.25 2.25 0 0 1 2.25-2.25h13.5a2.25 2.25 0 0 1 2.25 2.25v3.374a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18.188zM6.75 16.5a.75.75 0 0 1 .75-.75h2.813a.75.75 0 0 1 0 1.5H7.5a.75.75 0 0 1-.75-.75m.75-9.75a.75.75 0 0 0 0 1.5h2.813a.75.75 0 0 0 0-1.5z" clip-rule="evenodd"/>
  </svg>
`;
const Send = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M20.088 4.143s1.804-.703 1.653 1.005c-.05.704-.5 3.166-.851 5.828l-1.203 7.888s-.1 1.156-1.002 1.357c-.902.2-2.255-.703-2.506-.904-.2-.151-3.757-2.412-5.01-3.517-.351-.302-.752-.905.05-1.608l5.26-5.025c.602-.602 1.203-2.009-1.302-.3l-7.015 4.772s-.802.503-2.305.05L2.6 12.685s-1.203-.753.852-1.507c5.01-2.361 11.174-4.772 16.635-7.034z"/>
  </svg>
`;
const Settings = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M9.596 4.14c.612-2.52 4.196-2.52 4.808 0a.974.974 0 0 0 1.454.602c2.215-1.35 4.75 1.186 3.4 3.4a.974.974 0 0 0 .602 1.454c2.52.612 2.52 4.196 0 4.808a.974.974 0 0 0-.602 1.454c1.35 2.215-1.185 4.75-3.4 3.4a.974.974 0 0 0-1.454.602c-.612 2.52-4.196 2.52-4.808 0a.974.974 0 0 0-1.454-.602c-2.214 1.35-4.75-1.185-3.4-3.4a.974.974 0 0 0-.602-1.454c-2.52-.612-2.52-4.196 0-4.808a.974.974 0 0 0 .602-1.454c-1.35-2.214 1.186-4.75 3.4-3.4a.974.974 0 0 0 1.454-.602m3.35.354c-.24-.992-1.652-.992-1.892 0a2.474 2.474 0 0 1-3.692 1.53c-.872-.532-1.87.466-1.339 1.338.872 1.43.1 3.296-1.529 3.691-.992.241-.992 1.653 0 1.893a2.474 2.474 0 0 1 1.53 3.692c-.532.872.466 1.87 1.338 1.339a2.474 2.474 0 0 1 3.691 1.529c.241.992 1.653.992 1.893 0a2.474 2.474 0 0 1 3.692-1.53c.872.532 1.87-.466 1.339-1.338a2.474 2.474 0 0 1 1.529-3.692c.992-.24.992-1.652 0-1.892a2.474 2.474 0 0 1-1.53-3.692c.532-.872-.466-1.87-1.338-1.339-1.43.872-3.296.1-3.692-1.529M12 9.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M8.25 12a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0" clip-rule="evenodd"/>
  </svg>
`;
const SettingsPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M14.473 5.08c.178.178.42.278.671.278h2.549c.524 0 .949.425.949.949v2.549c0 .252.1.493.278.67l1.802 1.803c.37.37.37.971 0 1.342l-1.802 1.802a.95.95 0 0 0-.278.671v2.55a.95.95 0 0 1-.949.948h-2.549a.95.95 0 0 0-.67.278l-1.803 1.802a.95.95 0 0 1-1.342 0L9.527 18.92a.95.95 0 0 0-.671-.278H6.307a.95.95 0 0 1-.949-.949v-2.549c0-.251-.1-.493-.278-.67L3.278 12.67a.95.95 0 0 1 0-1.342L5.08 9.527a.95.95 0 0 0 .278-.671V6.307c0-.524.425-.949.949-.949h2.549c.252 0 .493-.1.67-.278l1.803-1.802a.95.95 0 0 1 1.342 0zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6" clip-rule="evenodd"/>
  </svg>
`;
const Shape = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 3.25a.75.75 0 0 1 .651.378l3.556 6.222a.75.75 0 0 1-.651 1.122H8.444a.75.75 0 0 1-.65-1.122l3.555-6.222A.75.75 0 0 1 12 3.25M9.737 9.472h4.526L12 5.512zM7.11 14.528a2.361 2.361 0 1 0 0 4.722 2.361 2.361 0 0 0 0-4.722m-3.861 2.36a3.861 3.861 0 1 1 7.722 0 3.861 3.861 0 0 1-7.722 0m9.778-3.11a.75.75 0 0 1 .75-.75H20a.75.75 0 0 1 .75.75V20a.75.75 0 0 1-.75.75h-6.222a.75.75 0 0 1-.75-.75zm1.5.75v4.722h4.722v-4.722z" clip-rule="evenodd"/>
  </svg>
`;
const Share = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M18 3.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M14.25 6a3.75 3.75 0 1 1 .799 2.314l-5.427 2.713a3.75 3.75 0 0 1 0 1.946l5.427 2.713a3.75 3.75 0 1 1-.671 1.341L8.95 14.314a3.75 3.75 0 1 1 0-4.628l5.427-2.713A3.8 3.8 0 0 1 14.25 6M6 9.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5m12 6a2.25 2.25 0 1 0-.002 4.5 2.25 2.25 0 0 0 .002-4.5" clip-rule="evenodd"/>
  </svg>
`;
const Shared = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M14.601 3.315a.75.75 0 0 1 .807.128l6.095 5.5a.75.75 0 0 1 0 1.114l-6.095 5.5A.75.75 0 0 1 14.156 15v-2.735c-2.614.106-4.1.76-4.92 1.345-.45.322-.715.633-.862.847a2 2 0 0 0-.166.29v.002A.75.75 0 0 1 6.75 14.5c0-3.006 1.322-4.981 3.035-6.177 1.4-.978 3.035-1.42 4.37-1.539V4a.75.75 0 0 1 .446-.685m-5.996 8.911c1.227-.793 3.191-1.476 6.3-1.476a.75.75 0 0 1 .75.75v1.813L19.882 9.5l-4.225-3.813V7.5a.75.75 0 0 1-.75.75c-1.202 0-2.894.347-4.262 1.302-.866.605-1.619 1.462-2.039 2.675" clip-rule="evenodd"/><path fill='currentColor' fill-rule="evenodd" d="M6 5.75c-.69 0-1.25.56-1.25 1.25v11c0 .69.56 1.25 1.25 1.25h11c.69 0 1.25-.56 1.25-1.25v-2a.75.75 0 0 1 1.5 0v2A2.75 2.75 0 0 1 17 20.75H6A2.75 2.75 0 0 1 3.25 18V7A2.75 2.75 0 0 1 6 4.25h4a.75.75 0 0 1 0 1.5z" clip-rule="evenodd"/>
  </svg>
`;
const ShareiOs = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M11.47 1.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1-1.06 1.06l-2.72-2.72V15a.75.75 0 0 1-1.5 0V3.81L8.53 6.53a.75.75 0 0 1-1.06-1.06zM4 11.25a.75.75 0 0 1 .75.75v8A1.25 1.25 0 0 0 6 21.25h12A1.25 1.25 0 0 0 19.25 20v-8a.75.75 0 0 1 1.5 0v8A2.75 2.75 0 0 1 18 22.75H6A2.75 2.75 0 0 1 3.25 20v-8a.75.75 0 0 1 .75-.75" clip-rule="evenodd"/>
  </svg>
`;
const ShoesPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M3 13.353V15a1 1 0 0 0 1 1h11.455a10 10 0 0 0 2.552-.335l.332-.088a3.43 3.43 0 0 0 2.506-2.786.858.858 0 0 0-.848-.991h-2.03L12.39 8.567a1.24 1.24 0 0 0-1.452.15L9.069 10.4H6.842l-.91-1.079a1 1 0 0 0-1.704.302L3.121 12.67a2 2 0 0 0-.121.684"/>
  </svg>
`;
const ShortPantsPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M16.097 5H7.903a.5.5 0 0 0-.48.362l-3.74 13a.5.5 0 0 0 .481.638h5.65a.5.5 0 0 0 .487-.387l1.212-5.201c.12-.516.854-.516.974 0l1.212 5.201a.5.5 0 0 0 .487.387h5.65a.5.5 0 0 0 .48-.638l-3.738-13a.5.5 0 0 0-.48-.362"/>
  </svg>
`;
const Shorter = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5 5.75a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5zm0 3.5a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5z" clip-rule="evenodd"/>
  </svg>
`;
const SiblingNode = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M10.35 7.25a2.5 2.5 0 0 1 2.4-1.8h5.5a2.5 2.5 0 0 1 0 5h-5.5c-1.1 0-2.036-.712-2.37-1.7H7.237c.47.627.75 1.406.75 2.25v2a2.25 2.25 0 0 0 2.25 2.25h.113a2.5 2.5 0 0 1 2.401-1.8h5.5a2.5 2.5 0 1 1 0 5h-5.5c-1.1 0-2.036-.712-2.37-1.7h-.145A3.75 3.75 0 0 1 6.485 13v-2a2.25 2.25 0 0 0-2.25-2.25H2v-1.5zm2.4-.3a1 1 0 1 0 0 2h5.5a1 1 0 1 0 0-2zm0 8a1 1 0 1 0 0 2h5.5a1 1 0 0 0 0-2z" clip-rule="evenodd"/>
  </svg>
`;
const Sidebar = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.5 6.5a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2zm6.75-.5h8.25a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-8.25zm-1.5 0H5.5a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h3.25z" clip-rule="evenodd"/>
  </svg>
`;
const SidebarDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#7A7A7A" fill-rule="evenodd" d="M19 9.493V17.5a.5.5 0 0 1-.5.5h-8.25V6h4.316a4.3 4.3 0 0 1 0-1.5H5.5a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2V9.124a4.2 4.2 0 0 1-1.5.369M5.5 6h3.25v12H5.5a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5" clip-rule="evenodd"/><path fill="#1E96EB" d="M21.75 5.25a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>
  </svg>
`;
const SignOut = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8 2.25A2.75 2.75 0 0 0 5.25 5v14A2.75 2.75 0 0 0 8 21.75h5A2.75 2.75 0 0 0 15.75 19v-1.5a.75.75 0 0 0-1.5 0V19c0 .69-.56 1.25-1.25 1.25H8c-.69 0-1.25-.56-1.25-1.25V5c0-.69.56-1.25 1.25-1.25h5c.69 0 1.25.56 1.25 1.25v1.5a.75.75 0 0 0 1.5 0V5A2.75 2.75 0 0 0 13 2.25zm10.03 6.22a.75.75 0 1 0-1.06 1.06l1 1 .72.72H11a.75.75 0 0 0 0 1.5h7.69l-.72.72-1 1a.75.75 0 1 0 1.06 1.06l1-1 2-2a.75.75 0 0 0 0-1.06l-2-2z" clip-rule="evenodd"/>
  </svg>
`;
const Signal = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M18.5 6.5h-13v6.119l6.5 4.55 6.5-4.55zm1.5 6.9L12 19l-8-5.6V5h16z" clip-rule="evenodd"/>
  </svg>
`;
const SignalPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M16.5 4.5a.5.5 0 0 0-.5.5v14a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5zM10 9a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zm-6 4a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-3A.5.5 0 0 1 4 19z" clip-rule="evenodd"/>
  </svg>
`;
const SingleSelect = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25m-2.47 8.22a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06L12 12.94z" clip-rule="evenodd"/>
  </svg>
`;
const SingleSelectCheckSolid = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25m4.626 7.214a.75.75 0 0 0-1.102-1.017l-5.156 5.589-1.955-1.956a.75.75 0 0 0-1.06 1.06l2.507 2.508a.75.75 0 0 0 1.081-.021z" clip-rule="evenodd"/>
  </svg>
`;
const SingleSelectSelectLinear = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12" clip-rule="evenodd"/><path fill='currentColor' fill-rule="evenodd" d="M16.53 9.53a.75.75 0 0 0-1.06-1.06l-4.97 4.97-1.47-1.47a.75.75 0 0 0-1.06 1.06l2 2a.75.75 0 0 0 1.06 0z" clip-rule="evenodd"/>
  </svg>
`;
const SingleSelectUn = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12" clip-rule="evenodd"/>
  </svg>
`;
const SkateboardPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M1.116 8.616a1.25 1.25 0 0 1 1.768 0l.828.829a2.75 2.75 0 0 0 1.945.805h12.686c.73 0 1.429-.29 1.945-.805l.828-.829a1.25 1.25 0 0 1 1.768 1.768l-.829.828a5.25 5.25 0 0 1-3.712 1.538h-.374a2 2 0 1 1-1.938 0H7.969a2 2 0 1 1-1.938 0h-.374a5.25 5.25 0 0 1-3.712-1.538l-.829-.828a1.25 1.25 0 0 1 0-1.768" clip-rule="evenodd"/>
  </svg>
`;
const SkirtPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.914 5a.2.2 0 0 0-.2.2v2.171c0 .11.09.2.2.2h13.6a.2.2 0 0 0 .2-.2V5.2a.2.2 0 0 0-.2-.2zm.01 3.429h13.72a.2.2 0 0 1 .195.158L21 18.714a28.46 28.46 0 0 1-18 0l1.728-10.12a.2.2 0 0 1 .197-.165" clip-rule="evenodd"/>
  </svg>
`;
const Smile = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 3.75A8.213 8.213 0 0 0 3.75 12 8.213 8.213 0 0 0 12 20.25 8.213 8.213 0 0 0 20.25 12 8.213 8.213 0 0 0 12 3.75M2.25 12A9.713 9.713 0 0 1 12 2.25 9.713 9.713 0 0 1 21.75 12 9.713 9.713 0 0 1 12 21.75 9.713 9.713 0 0 1 2.25 12M8.5 7.75a.75.75 0 0 1 .75.75V10a.75.75 0 0 1-1.5 0V8.5a.75.75 0 0 1 .75-.75m7 0a.75.75 0 0 1 .75.75V10a.75.75 0 0 1-1.5 0V8.5a.75.75 0 0 1 .75-.75m-8.682 5.522a.75.75 0 0 1 .91.546C8.134 15.443 9.683 16.75 12 16.75s3.866-1.307 4.272-2.932a.75.75 0 0 1 1.456.364c-.594 2.376-2.812 4.068-5.728 4.068s-5.134-1.692-5.728-4.068a.75.75 0 0 1 .546-.91" clip-rule="evenodd"/>
  </svg>
`;
const SmilePanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m3-6c0 1.105-1.343 2-3 2s-3-.895-3-2zm-5-3.5c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S8.448 9 9 9s1 .672 1 1.5m5 1.5c.552 0 1-.672 1-1.5S15.552 9 15 9s-1 .672-1 1.5.448 1.5 1 1.5" clip-rule="evenodd"/>
  </svg>
`;
const Snow2Panel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3 11.1a3.6 3.6 0 0 0 3.6 3.6h12.15a2.25 2.25 0 1 0-.49-4.446q.04-.247.04-.504a3.15 3.15 0 0 0-2.786-3.13A4.502 4.502 0 0 0 6.6 7.5 3.6 3.6 0 0 0 3 11.1M8 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-8 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0M5 21a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>
  </svg>
`;
const SnowMountainPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M18.675 17.5H5.51l2.85-4.811.923.737c.419.336 1.015.336 1.434 0l.64-.512a1.15 1.15 0 0 1 1.336-.07l1.03.658c.453.29 1.049.226 1.43-.155l.666-.666zm-15.546.095L11.007 4.3a1.262 1.262 0 0 1 2.17 0l7.88 13.295A1.262 1.262 0 0 1 19.97 19.5H4.214a1.262 1.262 0 0 1-1.085-1.905" clip-rule="evenodd"/>
  </svg>
`;
const SnowPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12.1 2a1 1 0 0 1 1 1v1.636l.993-.993a1 1 0 1 1 1.414 1.414L13.1 7.464v2.804l2.258-1.303 1.193-3.581a1 1 0 1 1 1.898.632l-.48 1.441 1.408-.813a1 1 0 1 1 1 1.732l-1.612.93 1.652.368a1 1 0 1 1-.434 1.952l-3.78-.84-2.093 1.208 2.107 1.217 3.766-.837a1 1 0 1 1 .434 1.952l-1.637.364 1.634.944a1 1 0 1 1-1 1.732l-1.45-.838.485 1.456a1 1 0 0 1-1.898.632l-1.198-3.595-2.253-1.3v2.815l2.407 2.407a1 1 0 0 1-1.414 1.414l-.993-.993V21a1 1 0 1 1-2 0v-1.636l-.993.993a1 1 0 0 1-1.414-1.414l2.407-2.407v-2.804l-2.258 1.304-1.193 3.58a1 1 0 1 1-1.898-.632l.48-1.441-1.407.813a1 1 0 1 1-1-1.732l1.611-.93-1.652-.368a1 1 0 0 1 .434-1.952l3.78.84 2.113-1.22-2.098-1.211-3.795.843a1 1 0 1 1-.434-1.952l1.667-.37-1.624-.938a1 1 0 0 1 1-1.732l1.4.809-.475-1.427a1 1 0 1 1 1.898-.632L8.837 8.95l2.263 1.306V7.464L8.693 5.057a1 1 0 0 1 1.414-1.414l.993.993V3a1 1 0 0 1 1-1" clip-rule="evenodd"/>
  </svg>
`;
const SocketPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M9 1.25a.75.75 0 0 1 .75.75v4.905h3.94V2a.75.75 0 0 1 1.5 0v4.905H19a.75.75 0 0 1 0 1.5h-1v5.88c0 1.5-1.215 2.715-2.714 2.715H12.58v.835a2.643 2.643 0 0 0 2.643 2.643h1.132a.75.75 0 0 1 0 1.5h-1.132a4.143 4.143 0 0 1-4.143-4.143V17H7.715A2.714 2.714 0 0 1 5 14.286v-5.88H4a.75.75 0 1 1 0-1.5h4.25V2A.75.75 0 0 1 9 1.25" clip-rule="evenodd"/>
  </svg>
`;
const SoloView = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M5.75 4.25A.75.75 0 0 0 5 5v3a.75.75 0 0 0 1.5 0V5.75h2.25a.75.75 0 0 0 0-1.5zM5.75 19.75A.75.75 0 0 1 5 19v-3a.75.75 0 0 1 1.5 0v2.25h2.25a.75.75 0 0 1 0 1.5zM19.5 5a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0 0 1.5H18V8a.75.75 0 0 0 1.5 0zM18.75 19.75a.75.75 0 0 0 .75-.75v-3a.75.75 0 0 0-1.5 0v2.25h-2.25a.75.75 0 0 0 0 1.5z"/>
  </svg>
`;
const Sort = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M17.75 16.688a.75.75 0 0 1-1.5 0V6.123l-3.22 3.22a.75.75 0 1 1-1.06-1.06l4.5-4.5a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 0 1-1.06 1.06l-3.22-3.22zm-10-9.375a.75.75 0 0 0-1.5 0v10.564l-3.22-3.22a.75.75 0 0 0-1.06 1.06l4.5 4.5a.75.75 0 0 0 1.06 0l4.5-4.5a.75.75 0 1 0-1.06-1.06l-3.22 3.22z" clip-rule="evenodd"/>
  </svg>
`;
const SortDown = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M9.05 6a.75.75 0 0 0-1.5 0v10.19l-2.72-2.72a.75.75 0 0 0-1.06 1.06l4 4a.75.75 0 0 0 1.06 0l4-4a.75.75 0 1 0-1.06-1.06l-2.72 2.72zm4.95.75h6a.75.75 0 1 0 0-1.5h-6a.75.75 0 0 0 0 1.5m1 4a.75.75 0 0 0 0 1.5h5a.75.75 0 1 0 0-1.5zm5 7h-4a.75.75 0 0 1 0-1.5h4a.75.75 0 1 1 0 1.5" clip-rule="evenodd"/>
  </svg>
`;
const SortUp = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M14 6.75h6a.75.75 0 1 0 0-1.5h-6a.75.75 0 0 0 0 1.5m1 4a.75.75 0 0 0 0 1.5h5a.75.75 0 1 0 0-1.5zm5 7h-4a.75.75 0 0 1 0-1.5h4a.75.75 0 1 1 0 1.5M9.05 18a.75.75 0 0 1-1.5 0V7.81l-2.72 2.72a.75.75 0 1 1-1.06-1.06l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 1 1-1.06 1.06L9.05 7.81z" clip-rule="evenodd"/>
  </svg>
`;
const SplitView = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5.75 4A1.75 1.75 0 0 0 4 5.75v12c0 .966.784 1.75 1.75 1.75h12a1.75 1.75 0 0 0 1.75-1.75v-12A1.75 1.75 0 0 0 17.75 4h-12M11 5.5H5.75a.25.25 0 0 0-.25.25v12c0 .138.112.25.25.25H11zM12.5 18V5.5h5.25a.25.25 0 0 1 .25.25v12a.25.25 0 0 1-.25.25z" clip-rule="evenodd"/>
  </svg>
`;
const Square = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.25 3.25h17.5v17.5H3.25zm1.5 1.5v14.5h14.5V4.75z" clip-rule="evenodd"/>
  </svg>
`;
const Star = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M14.855 9.3 12 2 9.145 9.3 1 9.64l6.38 4.85L5.202 22 12 17.7l6.798 4.3-2.178-7.51L23 9.64zm3.924 1.664-4.964-.207L12 6.117l-1.815 4.64-4.964.207 3.886 2.956-1.362 4.696L12 15.924l4.255 2.692-1.362-4.696z" clip-rule="evenodd"/>
  </svg>
`;
const StarPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M11.024 3.5c.347-.889 1.605-.889 1.952 0l1.573 4.03c.149.381.506.64.915.664l4.318.251c.953.056 1.342 1.252.604 1.857l-3.347 2.74c-.316.26-.453.68-.35 1.076l1.097 4.185c.241.923-.776 1.662-1.58 1.147l-3.64-2.335a1.05 1.05 0 0 0-1.132 0l-3.64 2.335c-.804.515-1.821-.224-1.58-1.147l1.096-4.185a1.05 1.05 0 0 0-.35-1.075l-3.345-2.741c-.739-.605-.35-1.801.603-1.857l4.318-.25c.409-.024.766-.284.915-.665z"/>
  </svg>
`;
const StartNumbering = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M19.218 12.75a.75.75 0 0 0 .559-.245l2.277-2.5a.75.75 0 1 0-1.108-1.01l-.974 1.068V5a1.75 1.75 0 0 0-1.75-1.75H12a.75.75 0 0 0 0 1.5h6.222a.25.25 0 0 1 .25.25v5.027l-.911-1.025a.75.75 0 0 0-1.122.996l2.223 2.5a.75.75 0 0 0 .556.252m-14.936-1.5a.75.75 0 0 0-.559.245l-2.277 2.5a.75.75 0 1 0 1.108 1.01l.974-1.068V19c0 .966.783 1.75 1.75 1.75H11.5a.75.75 0 0 0 0-1.5H5.278a.25.25 0 0 1-.25-.25v-5.027l.911 1.025a.75.75 0 0 0 1.122-.996l-2.223-2.5a.75.75 0 0 0-.556-.252M13.25 9a.75.75 0 0 0-.987-.712l-1.5.5a.75.75 0 0 0 .474 1.423l.513-.17v4.209H10.5a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5h-1.25z" clip-rule="evenodd"/>
  </svg>
`;
const StartPoint = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M2.25 12a.75.75 0 0 1 .75-.75h18a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75" clip-rule="evenodd"/>
  </svg>
`;
const StartPointArrow = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M7.53 7.47a.75.75 0 0 1 0 1.06l-2.72 2.72H21a.75.75 0 0 1 0 1.5H4.81l2.72 2.72a.75.75 0 1 1-1.06 1.06l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 0" clip-rule="evenodd"/>
  </svg>
`;
const StartPointCircle = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M6 8.25a3.75 3.75 0 1 0 3.675 4.5H21a.75.75 0 0 0 0-1.5H9.675A3.75 3.75 0 0 0 6 8.25"/>
  </svg>
`;
const StartPointDiamond = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5.47 8.47a.75.75 0 0 1 1.06 0l2.78 2.78H21a.75.75 0 0 1 0 1.5H9.31l-2.78 2.78a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 0-1.06z" clip-rule="evenodd"/>
  </svg>
`;
const StartPointTriangle = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M7.75 8a.75.75 0 0 0-1.28-.53l-4 4a.75.75 0 0 0 0 1.06l4 4A.75.75 0 0 0 7.75 16v-3.25H21a.75.75 0 0 0 0-1.5H7.75z"/>
  </svg>
`;
const Stop = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12M10 8.25a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75m4.75.75a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0z" clip-rule="evenodd"/>
  </svg>
`;
const StopAi = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M20.5 12a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0m1.5 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10M10 8a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2z" clip-rule="evenodd"/>
  </svg>
`;
const StraightLine = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M20.53 3.47a.75.75 0 0 1 0 1.06l-16 16a.75.75 0 0 1-1.06-1.06l16-16a.75.75 0 0 1 1.06 0" clip-rule="evenodd"/>
  </svg>
`;
const StrikeThrough = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8.406 7.464a3.468 3.468 0 0 1 6.59-1.513.77.77 0 0 0 1.385-.673 5.009 5.009 0 0 0-9.05 4.3h1.793a3.45 3.45 0 0 1-.718-2.114m6.512 8.476c0-.795-.268-1.528-.718-2.113h1.792a5.008 5.008 0 0 1-9.05 4.299.77.77 0 1 1 1.387-.673 3.468 3.468 0 0 0 6.589-1.513M4.297 10.905a.797.797 0 0 0 0 1.594h15.406a.797.797 0 0 0 0-1.594z" clip-rule="evenodd"/>
  </svg>
`;
const Style = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.25 5.45c0-1.204.964-2.2 2.178-2.2h11.144c1.214 0 2.178.996 2.178 2.2v5.394c0 1.478-.84 2.83-2.166 3.468l-1.842.884a1.274 1.274 0 0 0-.683 1.41l.054.26c.414 1.987-1.077 3.884-3.113 3.884s-3.527-1.897-3.113-3.884l.054-.26a1.27 1.27 0 0 0-.683-1.41l-1.842-.884a3.84 3.84 0 0 1-2.166-3.468zm1.503 5.522a2.34 2.34 0 0 0 1.313 1.988l1.841.883a2.77 2.77 0 0 1 1.503 3.068l-.055.26c-.226 1.085.59 2.079 1.645 2.079s1.87-.994 1.645-2.079l-.055-.26a2.77 2.77 0 0 1 1.503-3.068l1.842-.883a2.34 2.34 0 0 0 1.312-1.988zm12.497-1.5H5.75V5.45c0-.398.314-.7.678-.7h2.197v2.806a.75.75 0 0 0 1.5 0V4.75h3.75v1.917a.75.75 0 0 0 1.5 0V4.75h2.197a.69.69 0 0 1 .678.7z" clip-rule="evenodd"/>
  </svg>
`;
const StyleGeneral = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.47 3.47a.75.75 0 0 0 0 1.06l16 16a.75.75 0 1 0 1.06-1.06l-16-16a.75.75 0 0 0-1.06 0" clip-rule="evenodd"/>
  </svg>
`;
const StyleScribble = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.27 3.831a.75.75 0 0 1 .899-.562c6.615 1.527 12.547 4.893 15.306 7.15.361.296.66.6.846.919.195.335.305.77.109 1.21-.175.393-.523.617-.806.75-.3.142-.659.242-1.032.319-.75.155-1.715.25-2.739.336l-.756.063c-.817.066-1.667.135-2.514.23-2.243.249-4.035.569-5.13.952-.443.155-.694.295-.82.39.41.486 1.095.97 1.966 1.428.891.468 1.915.875 2.895 1.212a36 36 0 0 0 3.59 1.023l.056.012.014.003h.003a.75.75 0 0 1-.314 1.467L15 20l-.157.733h-.002l-.005-.001-.017-.004-.062-.014a28 28 0 0 1-1.072-.262c-.7-.183-1.656-.454-2.679-.805-1.02-.35-2.121-.787-3.105-1.303-.97-.51-1.89-1.13-2.487-1.876-.188-.235-.339-.535-.343-.888a1.34 1.34 0 0 1 .337-.889c.352-.414.94-.696 1.549-.909 1.267-.443 3.203-.777 5.46-1.027a88 88 0 0 1 2.573-.236l.737-.06c1.034-.088 1.913-.177 2.56-.31.288-.06.5-.123.645-.184a3 3 0 0 0-.407-.384c-2.587-2.117-8.31-5.377-14.694-6.85a.75.75 0 0 1-.562-.9" clip-rule="evenodd"/>
  </svg>
`;
const SubNode = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M10.354 11.25a2.75 2.75 0 0 1 2.646-2h5a2.75 2.75 0 1 1 0 5.5h-5a2.75 2.75 0 0 1-2.646-2H2a.75.75 0 0 1 0-1.5zm2.646-.5a1.25 1.25 0 1 0 0 2.5h5a1.25 1.25 0 1 0 0-2.5z" clip-rule="evenodd"/>
  </svg>
`;
const Sucessful = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m14.678-3.735a1 1 0 0 1 .057 1.413l-5.539 6a1 1 0 0 1-1.47 0l-2.46-2.666a1 1 0 1 1 1.469-1.357l1.726 1.87 4.804-5.203a1 1 0 0 1 1.413-.057" clip-rule="evenodd"/>
  </svg>
`;
const SucessfulDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#84CFFF" d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0" opacity=".14"/><path fill="#84CFFF" fill-rule="evenodd" d="M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m14.678-3.735a1 1 0 0 1 .057 1.413l-5.539 6a1 1 0 0 1-1.47 0l-2.46-2.666a1 1 0 1 1 1.469-1.357l1.726 1.87 4.804-5.203a1 1 0 0 1 1.413-.057" clip-rule="evenodd"/>
  </svg>
`;
const SuitcasePanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M11.111 4.778a.89.89 0 0 0-.889.889h3.556a.89.89 0 0 0-.89-.89zm4.445.889A2.667 2.667 0 0 0 12.889 3H11.11a2.667 2.667 0 0 0-2.667 2.667H6.667A2.667 2.667 0 0 0 4 8.333v8.89a2.667 2.667 0 0 0 2.667 2.666.889.889 0 0 0 1.777 0h7.112a.889.889 0 1 0 1.777 0A2.667 2.667 0 0 0 20 17.222V8.333a2.667 2.667 0 0 0-2.667-2.666zM9.333 9.222c.491 0 .89.398.89.89v5.332a.889.889 0 1 1-1.779 0v-5.333c0-.49.398-.889.89-.889m5.334 0c.49 0 .889.398.889.89v5.332a.889.889 0 1 1-1.778 0v-5.333c0-.49.398-.889.889-.889" clip-rule="evenodd"/>
  </svg>
`;
const Summarize = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M11.5 5c.064 0 .117.048.124.11.046.405.169.7.368.902s.486.327.894.363a.125.125 0 0 1 0 .25c-.401.034-.696.16-.899.362-.203.203-.328.498-.363.899a.125.125 0 0 1-.248 0c-.037-.408-.162-.696-.364-.894-.203-.2-.497-.322-.901-.368a.125.125 0 0 1 0-.248c.41-.048.699-.17.897-.368s.32-.487.368-.897A.125.125 0 0 1 11.5 5M8.073 6.244a.275.275 0 0 0-.546 0c-.104.903-.374 1.538-.81 1.973-.435.436-1.07.706-1.974.81a.275.275 0 0 0 .001.546c.888.1 1.537.37 1.983.809.444.436.72 1.07.8 1.967a.275.275 0 0 0 .547 0c.076-.882.352-1.53.798-1.977.447-.446 1.095-.722 1.977-.798a.275.275 0 0 0 0-.548c-.896-.08-1.531-.355-1.967-.8-.438-.445-.708-1.094-.809-1.982m6.427.506a.75.75 0 0 0 0 1.5H19a.75.75 0 0 0 0-1.5zm-1.5 3.5a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5zM4.25 14.5a.75.75 0 0 1 .75-.75h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75M5 17.25a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5z" clip-rule="evenodd"/>
  </svg>
`;
const SunPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M13 4a1 1 0 1 0-2 0 1 1 0 0 0 2 0m4.6 7.95a5.65 5.65 0 1 1-11.3 0 5.65 5.65 0 0 1 11.3 0M21 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-2.929-4.657a1 1 0 1 0-1.414-1.414 1 1 0 0 0 1.414 1.414m0 10.728a1 1 0 1 1-1.414-1.414 1 1 0 0 1 1.414 1.414M13 20a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-8-8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m2.343 6.071a1 1 0 1 0-1.414-1.414 1 1 0 0 0 1.414 1.414m0-10.728A1 1 0 1 1 5.93 5.93a1 1 0 0 1 1.414 1.414" clip-rule="evenodd"/>
  </svg>
`;
const SunglassPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M7 7.833A4.16 4.16 0 0 0 3.666 9.5h-.833a.833.833 0 0 0 0 1.667h.084q-.083.405-.084.833a4.167 4.167 0 1 0 8.085-1.421A2.5 2.5 0 0 1 12 10.333c.388 0 .755.088 1.082.246a4.167 4.167 0 1 0 8.001.588h.084a.833.833 0 0 0 0-1.667h-.834A4.16 4.16 0 0 0 17 7.833a4.16 4.16 0 0 0-3.043 1.321A4.15 4.15 0 0 0 12 8.667a4.15 4.15 0 0 0-1.957.487A4.16 4.16 0 0 0 7 7.834"/>
  </svg>
`;
const TShirtPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M6.964 20.836V11.01l-.519 1.273L3 11.19l2.671-6.884c.643-1.656 3.12-1.7 4.33-.4.629.673 1.312 1.151 1.999 1.203.687-.052 1.37-.53 1.998-1.203 1.212-1.3 3.688-1.256 4.33.4L21 11.19l-3.445 1.093-.519-1.274v9.827H6.964"/>
  </svg>
`;
const Table = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M2.25 6A2.75 2.75 0 0 1 5 3.25h14A2.75 2.75 0 0 1 21.75 6v12A2.75 2.75 0 0 1 19 20.75H5A2.75 2.75 0 0 1 2.25 18zM5 4.75c-.69 0-1.25.56-1.25 1.25v2.25h4.5v-3.5zm-1.25 5h4.5v3.5h-4.5zm6 0v3.5h4.5v-3.5zm6 0v3.5h4.5v-3.5zm-1.5 5h-4.5v4.5h4.5zm1.5 4.5v-4.5h4.5V18c0 .69-.56 1.25-1.25 1.25zm0-11v-3.5H19c.69 0 1.25.56 1.25 1.25v2.25zm-1.5-3.5v3.5h-4.5v-3.5zm-10.5 10h4.5v4.5H5c-.69 0-1.25-.56-1.25-1.25z" clip-rule="evenodd"/>
  </svg>
`;
const Tag = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.564 7.467a3.017 3.017 0 0 1 2.903-2.903l4.606-.17c.323-.013.636.11.864.338l6.647 6.648a1.16 1.16 0 0 1 0 1.64l-6.563 6.564a1.16 1.16 0 0 1-1.641 0l-6.648-6.647a1.16 1.16 0 0 1-.339-.864zm2.851-4.295a4.41 4.41 0 0 0-4.243 4.243l-.17 4.607c-.027.71.244 1.397.746 1.9l6.647 6.647a2.553 2.553 0 0 0 3.61 0l6.564-6.564a2.553 2.553 0 0 0 0-3.61L13.92 3.748a2.55 2.55 0 0 0-1.9-.746zm.847 5.09A.928.928 0 1 0 6.95 6.95a.928.928 0 0 0 1.313 1.313" clip-rule="evenodd"/>
  </svg>
`;
const TagPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.09 6A1.09 1.09 0 0 0 3 7.09v9.82c0 .602.488 1.09 1.09 1.09h12.238c.336 0 .653-.155.86-.42l3.833-4.909a1.09 1.09 0 0 0 0-1.342l-3.833-4.91a1.09 1.09 0 0 0-.86-.419zm11.456 7.636a1.636 1.636 0 1 0 0-3.272 1.636 1.636 0 0 0 0 3.272" clip-rule="evenodd"/>
  </svg>
`;
const Tags = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8.263 2.48a.735.735 0 1 0 .054 1.47l4.276-.159c.34-.012.67.117.911.358l6.307 6.307a.735.735 0 1 0 1.039-1.04L14.543 3.11a2.7 2.7 0 0 0-2.005-.788zm-.536 4.242a3.185 3.185 0 0 0-3.065 3.065l-.126 3.41c-.013.34.117.67.358.91l5.618 5.619a1.225 1.225 0 0 0 1.732 0l5.422-5.422a1.225 1.225 0 0 0 0-1.732l-5.618-5.618c-.241-.24-.572-.37-.912-.358zm-4.534 3.01a4.654 4.654 0 0 1 4.48-4.479l3.409-.126a2.7 2.7 0 0 1 2.005.788l5.618 5.618a2.695 2.695 0 0 1 0 3.81l-5.422 5.422a2.695 2.695 0 0 1-3.81 0l-5.619-5.618a2.7 2.7 0 0 1-.787-2.005zm4.673-.976a.828.828 0 1 1-1.17 1.17.828.828 0 0 1 1.17-1.17" clip-rule="evenodd"/>
  </svg>
`;
const TeX = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="m21.63 7.299-2.115 3.107 3.142 4.671c.284.41.428.481 1.343.481v.351c-.347-.028-1.061-.028-1.43-.028-.472 0-1.17 0-1.628.028v-.35c.5-.03.628-.28.628-.395 0-.043 0-.087-.112-.247l-2.486-3.714-2.286 3.39a.62.62 0 0 0-.142.395c0 .234.128.524.57.568v.35c-.356-.027-1.027-.027-1.413-.027h-.106l-.446 3.187H7.713v-.35c1.014 0 1.174 0 1.174-.654v-7.837c0-.653-.162-.653-1.174-.653v-.4h.752c-.183-2.354-.412-2.766-2.58-2.766h-.784c-.257.06-.257.234-.257.554v7.906c0 .525.042.685 1.228.685h.399v.35h-.015c-.68-.013-1.392-.027-2.085-.027s-1.4.014-2.079.027H2.27v-.35h.405c1.204 0 1.247-.16 1.247-.685V6.96c0-.334 0-.51-.273-.554H2.86c-2.216 0-2.418.421-2.603 2.827H0L.241 6.02h8.251l.23 3.152h6.226l.343 3.212h-.257c-.2-1.92-.458-2.813-2.67-2.813h-1.953c-.57 0-.598.073-.598.563v3.6h1.349c1.347 0 1.476-.493 1.476-1.698h.23v3.778h-.23c0-1.226-.128-1.728-1.476-1.728H9.814v4.06c0 .5.026.573.597.573h1.984c2.318 0 2.655-.996 2.939-2.84-.294.002-.621.008-.846.027v-.351c.273 0 1.202-.016 1.815-.919l2.486-3.69-2.757-4.115c-.315-.451-.572-.481-1.357-.481V6c.345.028 1.06.028 1.43.028.47 0 1.17 0 1.627-.028v.35c-.473.014-.63.262-.63.392 0 .044.015.09.114.248l2.114 3.145 1.887-2.78c.1-.145.17-.262.17-.436 0-.234-.112-.525-.57-.568V6c.357.028.943.028 1.414.028.343 0 .886 0 1.213-.028v.35c-1.168.016-1.6.639-1.812.945z" clip-rule="evenodd"/>
  </svg>
`;
const TeXDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#000" fill-rule="evenodd" d="m21.63 7.299-2.115 3.107 3.142 4.671c.284.41.428.481 1.343.481v.351c-.347-.028-1.061-.028-1.43-.028-.472 0-1.17 0-1.628.028v-.35c.5-.03.628-.28.628-.395 0-.043 0-.087-.112-.247l-2.486-3.714-2.286 3.39a.62.62 0 0 0-.142.395c0 .234.128.524.57.568v.35c-.356-.027-1.027-.027-1.413-.027h-.106l-.446 3.187H7.713v-.35c1.014 0 1.174 0 1.174-.654v-7.837c0-.653-.162-.653-1.174-.653v-.4h.752c-.183-2.354-.412-2.766-2.58-2.766h-.784c-.257.06-.257.234-.257.554v7.906c0 .525.042.685 1.228.685h.399v.35h-.015c-.68-.013-1.392-.027-2.085-.027s-1.4.014-2.079.027H2.27v-.35h.405c1.204 0 1.247-.16 1.247-.685V6.96c0-.334 0-.51-.273-.554H2.86c-2.216 0-2.418.421-2.603 2.827H0L.241 6.02h8.251l.23 3.152h6.226l.343 3.212h-.257c-.2-1.92-.458-2.813-2.67-2.813h-1.953c-.57 0-.598.073-.598.563v3.6h1.349c1.347 0 1.476-.493 1.476-1.698h.23v3.778h-.23c0-1.226-.128-1.728-1.476-1.728H9.814v4.06c0 .5.026.573.597.573h1.984c2.318 0 2.655-.996 2.939-2.84-.294.002-.621.008-.846.027v-.351c.273 0 1.202-.016 1.815-.919l2.486-3.69-2.757-4.115c-.315-.451-.572-.481-1.357-.481V6c.345.028 1.06.028 1.43.028.47 0 1.17 0 1.627-.028v.35c-.473.014-.63.262-.63.392 0 .044.015.09.114.248l2.114 3.145 1.887-2.78c.1-.145.17-.262.17-.436 0-.234-.112-.525-.57-.568V6c.357.028.943.028 1.414.028.343 0 .886 0 1.213-.028v.35c-1.168.016-1.6.639-1.812.945z" clip-rule="evenodd"/>
  </svg>
`;
const TeamWorkspace = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5.397 3.25h7.873c.227 0 .44 0 .62.015.194.015.413.052.632.164.308.157.559.407.716.716.111.218.148.438.164.632.015.18.015.393.015.62v3.936a.75.75 0 0 1-1.5 0v-3.91c0-.262 0-.413-.01-.524a1 1 0 0 0-.01-.082.14.14 0 0 0-.047-.047 1 1 0 0 0-.083-.01 7 7 0 0 0-.523-.01H5.422c-.261 0-.412 0-.523.01a1 1 0 0 0-.082.01.14.14 0 0 0-.047.047 1 1 0 0 0-.01.082c-.01.111-.01.262-.01.523V19.25h2.056v-1.917a2.528 2.528 0 0 1 5.055 0V20a.75.75 0 0 1-.75.75H4a.75.75 0 0 1-.75-.75V5.397c0-.227 0-.44.015-.62a1.7 1.7 0 0 1 .164-.632c.157-.309.407-.56.716-.716a1.7 1.7 0 0 1 .632-.164c.18-.015.393-.015.62-.015m2.909 16h2.055v-1.917a1.028 1.028 0 0 0-2.055 0zM5.916 7.556a.75.75 0 0 1 .75-.75h.89a.75.75 0 0 1 0 1.5h-.89a.75.75 0 0 1-.75-.75m4.445 0a.75.75 0 0 1 .75-.75H12a.75.75 0 0 1 0 1.5h-.889a.75.75 0 0 1-.75-.75m-4.444 2.666a.75.75 0 0 1 .75-.75h.889a.75.75 0 1 1 0 1.5h-.89a.75.75 0 0 1-.75-.75m4.444 0a.75.75 0 0 1 .75-.75H12a.75.75 0 1 1 0 1.5h-.889a.75.75 0 0 1-.75-.75m7.15 2.528a.583.583 0 1 0 0 1.167.583.583 0 0 0 0-1.167m-2.083.583a2.083 2.083 0 1 1 4.166 0 2.083 2.083 0 0 1-4.166 0m-9.511-.444a.75.75 0 0 1 .75-.75h.889a.75.75 0 0 1 0 1.5h-.89a.75.75 0 0 1-.75-.75m4.444 0a.75.75 0 0 1 .75-.75H12a.75.75 0 0 1 0 1.5h-.889a.75.75 0 0 1-.75-.75m5.087 6.361h4.215a1.47 1.47 0 0 0-1.44-1.167h-1.334c-.708 0-1.3.5-1.44 1.167m-1.531.306a2.97 2.97 0 0 1 2.972-2.973h1.333a2.97 2.97 0 0 1 2.972 2.973V20a.75.75 0 0 1-.75.75h-5.777a.75.75 0 0 1-.75-.75z" clip-rule="evenodd"/>
  </svg>
`;
const Telegram = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.93 5.134c1.873-1.952 4.418-3.05 7.07-3.05s5.197 1.098 7.07 3.05C20.945 7.087 22 9.738 22 12.5s-1.055 5.413-2.93 7.366c-1.873 1.953-4.418 3.05-7.07 3.05s-5.197-1.097-7.07-3.05C3.055 17.913 2 15.262 2 12.5c0-2.763 1.054-5.412 2.93-7.366m7.428 4.64q-1.458.63-5.831 2.616-.711.294-.744.575c-.039.317.342.442.86.612l.22.073c.51.173 1.198.375 1.554.383q.487.01 1.085-.417 4.087-2.872 4.218-2.904c.063-.015.149-.034.207.02.06.055.053.157.047.185-.037.167-1.527 1.61-2.303 2.361-.244.236-.417.404-.452.442q-.12.127-.236.243c-.474.476-.83.833.02 1.416.412.283.741.516 1.07.75.353.25.706.5 1.162.812q.175.121.338.244c.414.307.786.584 1.246.54.267-.026.544-.288.683-1.068.33-1.845.982-5.842 1.132-7.49a2 2 0 0 0-.015-.41.46.46 0 0 0-.142-.282c-.12-.1-.305-.122-.388-.12-.376.006-.953.215-3.731 1.418" clip-rule="evenodd"/>
  </svg>
`;
const TelegramDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#2AABEE" d="M12 2a9.999 9.999 0 0 0-7.07 17.071A9.999 9.999 0 1 0 19.07 4.93 10 10 0 0 0 12 2"/><path fill="#fff" d="M6.527 11.894q4.374-1.905 5.83-2.511c2.78-1.156 3.356-1.356 3.732-1.363.083-.001.267.02.388.116a.43.43 0 0 1 .142.271c.012.078.03.255.015.394-.15 1.581-.801 5.418-1.132 7.19-.14.749-.416 1-.683 1.024-.581.054-1.022-.383-1.585-.752-.88-.577-1.376-.936-2.23-1.499-.988-.65-.348-1.008.215-1.593.147-.153 2.706-2.48 2.755-2.691.006-.026.012-.125-.047-.177s-.144-.034-.207-.02q-.132.03-4.218 2.788-.598.411-1.085.4c-.356-.007-1.043-.201-1.554-.367-.625-.204-1.124-.311-1.08-.657q.033-.27.744-.553"/>
  </svg>
`;
const Template = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.5 7.25A2.25 2.25 0 0 0 2.25 9.5v9a2.25 2.25 0 0 0 2.25 2.25h13.36a2.25 2.25 0 0 0 2.168-1.648l1.667-6a2.25 2.25 0 0 0-1.05-2.556q.105-.508.105-1.046a5.25 5.25 0 0 0-8.586-4.054l-.91-1.874c-.45-.927-1.765-.942-2.236-.026L7.114 7.25zm0 1.5a.75.75 0 0 0-.75.75v4.998l.722-2.6c.146-.524.47-.962.896-1.254l.974-1.894zm-.25 9.55a.75.75 0 0 0 .723.95H17.86a.75.75 0 0 0 .723-.55l1.167-4.202.5-1.797a.746.746 0 0 0-.5-.917.8.8 0 0 0-.223-.034H6.64a.75.75 0 0 0-.723.55l-.393 1.416zm5.874-13.623.22.455.741 1.525.288.593.548 1.128.18.372.73 1.5H7.257l.771-1.5.771-1.5zM18.75 7.63a3.748 3.748 0 0 0-5.904-.78l.194.4.728 1.5.729 1.5h4.677a3.77 3.77 0 0 0-.424-2.62" clip-rule="evenodd"/>
  </svg>
`;
const TemplateColored = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#29A3FA" fill-rule="evenodd" d="M19.563 10.75a4.25 4.25 0 0 0-7.315-3.987l1.937 3.987h5.378" clip-rule="evenodd"/><path fill="#FB7081" fill-rule="evenodd" d="M10.792 4.909a.75.75 0 0 0-1.342-.016l-3.018 5.87q.102-.013.208-.013h6.989z" clip-rule="evenodd"/><path fill="#FCD34D" fill-rule="evenodd" d="M5.436 12.165a1.25 1.25 0 0 1 1.205-.915h12.886a1.25 1.25 0 0 1 1.204 1.585l-1.666 6a1.25 1.25 0 0 1-1.205.915H4.974a1.25 1.25 0 0 1-1.205-1.585z" clip-rule="evenodd"/><path fill="#FCD34D" fill-rule="evenodd" d="m7.162 8.25-1.41 2.743c-.381.224-.673.59-.798 1.039l-1.666 6q-.024.083-.038.164V9.5c0-.69.56-1.25 1.25-1.25z" clip-rule="evenodd"/>
  </svg>
`;
const TemplateOutline = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M9.018 3.546c.472-.916 1.786-.9 2.236.026l2.478 5.1a.75.75 0 0 1-1.35.656l-2.258-4.65-2.4 4.665a.75.75 0 0 1-1.334-.686zM15.5 5.75c-.44 0-.86.075-1.25.213a.75.75 0 1 1-.5-1.414 5.25 5.25 0 0 1 6.968 4.369.75.75 0 0 1-1.49.164A3.75 3.75 0 0 0 15.5 5.75"/><path fill='currentColor' fill-rule="evenodd" d="M4.5 8.75a.75.75 0 0 0-.75.75v4.998l.722-2.6A2.25 2.25 0 0 1 6.64 10.25h12.887a2.25 2.25 0 0 1 2.168 2.852l-1.667 6a2.25 2.25 0 0 1-2.168 1.648H4.5a2.25 2.25 0 0 1-2.25-2.25v-9A2.25 2.25 0 0 1 4.5 7.25H5a.75.75 0 0 1 0 1.5zm13.36 10.5H4.973a.75.75 0 0 1-.722-.95l1.666-6a.75.75 0 0 1 .723-.55h12.887a.75.75 0 0 1 .722.95l-1.666 6a.75.75 0 0 1-.723.55" clip-rule="evenodd"/>
  </svg>
`;
const Text = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.25 4A.75.75 0 0 1 4 3.25h16a.75.75 0 0 1 .75.75v2.667a.75.75 0 0 1-1.5 0V4.75h-6.5v14.5H16a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1 0-1.5h3.25V4.75h-6.5v1.917a.75.75 0 0 1-1.5 0z" clip-rule="evenodd"/>
  </svg>
`;
const TextAlignBottom = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.25 14a.75.75 0 0 1 .75-.75h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75M4.25 18a.75.75 0 0 1 .75-.75h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75" clip-rule="evenodd"/>
  </svg>
`;
const TextAlignCenter = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.75 6a.75.75 0 0 1 .75-.75h15a.75.75 0 0 1 0 1.5h-15A.75.75 0 0 1 3.75 6m3.5 6a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75M6 17.25a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5z" clip-rule="evenodd"/>
  </svg>
`;
const TextAlignLeft = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M20.75 6a.75.75 0 0 0-.75-.75H5a.75.75 0 0 0 0 1.5h15a.75.75 0 0 0 .75-.75m-7 6a.75.75 0 0 0-.75-.75H5a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 .75-.75m3 6a.75.75 0 0 0-.75-.75H5a.75.75 0 0 0 0 1.5h11a.75.75 0 0 0 .75-.75" clip-rule="evenodd"/>
  </svg>
`;
const TextAlignMedium = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.25 10A.75.75 0 0 1 5 9.25h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75M4.25 14a.75.75 0 0 1 .75-.75h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75" clip-rule="evenodd"/>
  </svg>
`;
const TextAlignRight = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.25 6A.75.75 0 0 1 5 5.25h15a.75.75 0 0 1 0 1.5H5A.75.75 0 0 1 4.25 6m7 6a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5h-8a.75.75 0 0 1-.75-.75m-3 6a.75.75 0 0 1 .75-.75h11a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75" clip-rule="evenodd"/>
  </svg>
`;
const TextAlignTop = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.25 6A.75.75 0 0 1 5 5.25h14a.75.75 0 0 1 0 1.5H5A.75.75 0 0 1 4.25 6M4.25 10A.75.75 0 0 1 5 9.25h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75" clip-rule="evenodd"/>
  </svg>
`;
const TextBackgroundDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#FCE5E6" fill-rule="evenodd" d="M3.15 5.5A2.35 2.35 0 0 1 5.5 3.15h13a2.35 2.35 0 0 1 2.35 2.35v13a2.35 2.35 0 0 1-2.35 2.35h-13a2.35 2.35 0 0 1-2.35-2.35z" clip-rule="evenodd"/><path fill="#000" fill-opacity=".1" fill-rule="evenodd" d="M3.15 5.5A2.35 2.35 0 0 1 5.5 3.15h13a2.35 2.35 0 0 1 2.35 2.35v13a2.35 2.35 0 0 1-2.35 2.35h-13a2.35 2.35 0 0 1-2.35-2.35zM5.5 3.85A1.65 1.65 0 0 0 3.85 5.5v13c0 .911.739 1.65 1.65 1.65h13a1.65 1.65 0 0 0 1.65-1.65v-13a1.65 1.65 0 0 0-1.65-1.65z" clip-rule="evenodd"/><path fill="#141414" fill-rule="evenodd" d="M10.622 7.505a1.471 1.471 0 0 1 2.756 0l3.324 8.865a.75.75 0 0 1-1.404.527l-.94-2.505H9.642l-.94 2.505a.75.75 0 1 1-1.404-.527zm-.418 5.387h3.592L12 8.102z" clip-rule="evenodd"/>
  </svg>
`;
const TextColor = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#7A7A7A" fill-rule="evenodd" d="M10.453 4.622a1.652 1.652 0 0 1 3.094 0l4.155 11.081a.75.75 0 0 1-1.404.527l-1.22-3.253H8.922l-1.22 3.253a.75.75 0 0 1-1.404-.527zm-.969 6.855h5.031L12.142 5.15a.152.152 0 0 0-.284 0z" clip-rule="evenodd"/><rect width="16" height="2.5" x="4" y="18" fill="#FB7081" rx="1"/>
  </svg>
`;
const TextType = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8.667 4.707c-.73 0-1.381.462-1.622 1.15l-2.286 6.531-.329.94-1.325 3.786a.886.886 0 1 0 1.672.585l1.118-3.193h5.543l1.118 3.193a.886.886 0 1 0 1.672-.585l-1.325-3.787-.329-.939-2.285-6.53a1.72 1.72 0 0 0-1.622-1.151m0 1.88 2.15 6.147H6.516zm4.363-1.67a.805.805 0 1 0 0 1.61h7.22a.805.805 0 0 0 0-1.61zm1.805 5.887a.805.805 0 1 0 0 1.61h5.415a.805.805 0 0 0 0-1.61zm.398 6.692c0-.445.36-.805.805-.805h4.212a.805.805 0 0 1 0 1.61h-4.212a.805.805 0 0 1-.805-.805" clip-rule="evenodd"/>
  </svg>
`;
const Thinking = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6.97 10.713a13.3 13.3 0 0 1-1.108-2.187c-.339-.881-.466-1.591-.453-2.103.012-.5.15-.701.231-.783s.283-.219.783-.231c.512-.013 1.222.114 2.103.453a13.3 13.3 0 0 1 2.187 1.109 24 24 0 0 0-1.972 1.77 24 24 0 0 0-1.77 1.972m-1.087 1.48c-2.18-3.255-2.863-6.36-1.456-7.766 1.407-1.407 4.511-.723 7.765 1.456 3.255-2.18 6.359-2.863 7.766-1.456s.723 4.511-1.456 7.765c2.179 3.255 2.863 6.359 1.456 7.766s-4.511.723-7.766-1.456c-3.254 2.179-6.358 2.863-7.765 1.456s-.723-4.511 1.456-7.766m4.83 5.221c-.766.475-1.505.846-2.187 1.109-.881.339-1.591.466-2.103.453-.5-.012-.701-.15-.783-.231s-.219-.284-.231-.783c-.013-.512.114-1.222.453-2.103.263-.682.634-1.421 1.109-2.188a24 24 0 0 0 1.77 1.973 24 24 0 0 0 1.972 1.77m1.48-1.02a22 22 0 0 1-2.239-1.963 22 22 0 0 1-1.962-2.239c.568-.745 1.224-1.5 1.962-2.238a22 22 0 0 1 2.238-1.962 22 22 0 0 1 2.239 1.962 22 22 0 0 1 1.962 2.238c-.568.746-1.224 1.5-1.962 2.239a22 22 0 0 1-2.239 1.962m1.478 1.02c.767.475 1.506.846 2.188 1.109.88.338 1.59.466 2.103.453.5-.012.701-.15.783-.231s.219-.284.231-.783c.013-.512-.114-1.222-.453-2.103a13.3 13.3 0 0 0-1.109-2.188 24 24 0 0 1-1.77 1.973 24 24 0 0 1-1.973 1.77m3.743-6.7c.475-.767.846-1.506 1.109-2.188.338-.881.466-1.591.453-2.103-.012-.5-.15-.701-.231-.783s-.284-.219-.783-.231c-.512-.013-1.222.114-2.103.453-.683.263-1.421.634-2.188 1.109a24 24 0 0 1 1.973 1.77 24 24 0 0 1 1.77 1.972" clip-rule="evenodd"/>
  </svg>
`;
const TimePanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m.75-13a.75.75 0 0 0-1.5 0v5c0 .414.336.75.75.75h4a.75.75 0 0 0 0-1.5h-3.25z" clip-rule="evenodd"/>
  </svg>
`;
const Timeline = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M7.25 7A2.75 2.75 0 0 1 10 4.25h3a.75.75 0 0 1 0 1.5h-3c-.69 0-1.25.56-1.25 1.25v4.25h6.5V7A2.75 2.75 0 0 1 18 4.25h3a.75.75 0 0 1 0 1.5h-3c-.69 0-1.25.56-1.25 1.25v4.25H21a.75.75 0 0 1 0 1.5h-7.25V17c0 .69.56 1.25 1.25 1.25h3a.75.75 0 0 1 0 1.5h-3A2.75 2.75 0 0 1 12.25 17v-4.25H3a.75.75 0 0 1 0-1.5h4.25z" clip-rule="evenodd"/>
  </svg>
`;
const Title = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M2.84 5.25a.75.75 0 0 0-.75.75v2a.75.75 0 0 0 1.5 0V6.75H7v10.5H5.023a.75.75 0 0 0 0 1.5h5.454a.75.75 0 0 0 0-1.5H8.5V6.75h3.409V8a.75.75 0 0 0 1.5 0V6a.75.75 0 0 0-.75-.75H2.841m12.764 0a.75.75 0 0 0 0 1.5h5.455a.75.75 0 0 0 0-1.5zm-.75 6.75a.75.75 0 0 1 .75-.75h5.455a.75.75 0 0 1 0 1.5h-5.455a.75.75 0 0 1-.75-.75m.75 5.25a.75.75 0 0 0 0 1.5h5.455a.75.75 0 0 0 0-1.5z" clip-rule="evenodd"/>
  </svg>
`;
const Toc = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M4 5.25a.75.75 0 0 0 0 1.5h15.023a.75.75 0 0 0 0-1.5zM9 9.25a.75.75 0 0 0 0 1.5h10a.75.75 0 0 0 0-1.5zM4.25 14a.75.75 0 0 1 .75-.75h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75M9 17.25a.75.75 0 0 0 0 1.5h10a.75.75 0 0 0 0-1.5z"/>
  </svg>
`;
const Today = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8.205 2.787c.393 0 .712.319.712.712v.711h6.166V3.5a.712.712 0 0 1 1.423 0v.711h2.135a2.61 2.61 0 0 1 2.609 2.61v11.384a2.61 2.61 0 0 1-2.609 2.609H5.359a2.61 2.61 0 0 1-2.609-2.61V6.82A2.61 2.61 0 0 1 5.359 4.21h2.135V3.5c0-.393.318-.712.711-.712m6.878 2.846v.712a.712.712 0 0 0 1.423 0v-.712h2.135c.655 0 1.186.531 1.186 1.186v1.66H4.173V6.82c0-.655.531-1.186 1.186-1.186h2.135v.712a.712.712 0 1 0 1.423 0v-.712zm4.744 4.27H4.173v8.3c0 .656.531 1.187 1.186 1.187h13.282c.655 0 1.186-.531 1.186-1.186zm-12.57 1.47a.474.474 0 0 0-.475.475v1.423c0 .262.212.474.474.474H8.68a.474.474 0 0 0 .475-.474v-1.424a.474.474 0 0 0-.475-.474zm-.475 4.174c0-.261.212-.474.474-.474H8.68c.262 0 .475.213.475.474v1.424a.474.474 0 0 1-.475.474H7.256a.474.474 0 0 1-.474-.474zm4.459-4.174a.474.474 0 0 0-.474.475v1.423c0 .262.212.474.474.474h1.423a.474.474 0 0 0 .475-.474v-1.424a.474.474 0 0 0-.475-.474zm-.474 4.174c0-.261.212-.474.474-.474h1.423c.262 0 .475.213.475.474v1.424a.474.474 0 0 1-.475.474h-1.423a.474.474 0 0 1-.474-.474zm4.554-4.174a.474.474 0 0 0-.475.475v1.423c0 .262.213.474.474.474h1.424a.474.474 0 0 0 .474-.474v-1.424a.474.474 0 0 0-.474-.474z" clip-rule="evenodd"/>
  </svg>
`;
const ToggleDown = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M13.15 15.132a.757.757 0 0 1-1.3 0L8.602 9.605c-.29-.491.072-1.105.65-1.105h6.497c.577 0 .938.614.65 1.105z"/>
  </svg>
`;
const ToggleLeft = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M9.368 12.65a.757.757 0 0 1 0-1.3l5.527-3.248c.491-.29 1.105.072 1.105.65v6.497c0 .577-.614.938-1.105.65z"/>
  </svg>
`;
const ToggleRight = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M15.632 11.35a.757.757 0 0 1 0 1.3l-5.527 3.248c-.491.29-1.105-.072-1.105-.65V8.752c0-.577.614-.938 1.105-.65z"/>
  </svg>
`;
const ToggleUp = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M11.85 8.868a.757.757 0 0 1 1.3 0l3.248 5.527c.29.491-.072 1.105-.65 1.105H9.252c-.577 0-.938-.614-.65-1.105z"/>
  </svg>
`;
const Tomorrow = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8.42 3.205a.68.68 0 0 1 .68.68v.68h5.888v-.68a.68.68 0 1 1 1.358 0v.68h2.039a2.49 2.49 0 0 1 2.491 2.49v5.435a.68.68 0 0 1-1.359 0V10H4.57v7.926c0 .626.507 1.133 1.132 1.133h5.888a.68.68 0 1 1 0 1.359H5.702a2.49 2.49 0 0 1-2.491-2.492V7.055a2.49 2.49 0 0 1 2.491-2.49H7.74v-.68a.68.68 0 0 1 .68-.68m6.568 2.718v.68a.68.68 0 1 0 1.358 0v-.68h2.039c.625 0 1.132.507 1.132 1.132v1.586H4.57V7.055c0-.625.507-1.132 1.132-1.132H7.74v.68a.68.68 0 1 0 1.36 0v-.68zm3.641 10.672a.68.68 0 1 1 .961-.96l1.922 1.92a.68.68 0 0 1 0 .962l-1.922 1.922a.68.68 0 0 1-.96-.961l1.44-1.442zm-4.238-.96a.68.68 0 0 0 0 .96l1.44 1.441-1.44 1.442a.68.68 0 0 0 .96.96l1.922-1.921a.68.68 0 0 0 0-.961l-1.921-1.922a.68.68 0 0 0-.961 0" clip-rule="evenodd"/>
  </svg>
`;
const Tone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="m9.17 8.506-1.112 2.877a.85.85 0 0 1-.793.544H4a.75.75 0 0 1 0-1.5h2.82l1.699-4.4c.3-.776 1.422-.703 1.618.107l1.96 8.08 1.797-5.67a.85.85 0 0 1 1.483-.263l1.658 2.146H20a.75.75 0 0 1 0 1.5h-3.284a.85.85 0 0 1-.673-.33L14.95 10.18l-2.126 6.705c-.26.82-1.434.78-1.636-.056z" clip-rule="evenodd"/>
  </svg>
`;
const TranscriptWithAi = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M17.25 11.5a.54.54 0 0 0-.538.48c-.107.923-.378 1.536-.787 1.945s-1.022.68-1.945.787a.542.542 0 0 0 0 1.076c.908.103 1.536.375 1.956.788.417.409.694 1.02.774 1.93a.542.542 0 0 0 1.08-.001c.077-.895.353-1.52.774-1.941.42-.42 1.046-.697 1.941-.774a.542.542 0 0 0 .001-1.08c-.91-.08-1.521-.357-1.93-.774-.413-.42-.685-1.048-.788-1.955a.54.54 0 0 0-.537-.481" clip-rule="evenodd"/><path fill='currentColor' fill-rule="evenodd" d="M3 7.75A2.75 2.75 0 0 1 5.75 5h11a2.75 2.75 0 0 1 2.75 2.75v2a.75.75 0 0 1-1.5 0v-2c0-.69-.56-1.25-1.25-1.25h-11c-.69 0-1.25.56-1.25 1.25v8c0 .69.56 1.25 1.25 1.25h7a.75.75 0 0 1 0 1.5h-7A2.75 2.75 0 0 1 3 15.75z" clip-rule="evenodd"/><path fill='currentColor' fill-rule="evenodd" d="M6.5 9.75A.75.75 0 0 1 7.25 9h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75M6.5 12.75a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75" clip-rule="evenodd"/>
  </svg>
`;
const TreePanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M7.623 6.87a.503.503 0 0 0 .016.694l.73.73a.503.503 0 0 1 0 .712l-2.803 2.803a.503.503 0 0 0 .242.846l.659.152a.503.503 0 0 1 .26.827L4.26 16.36a.503.503 0 0 0 .373.84H11.1V21a.95.95 0 0 0 1.9 0v-3.8h6.467a.503.503 0 0 0 .373-.84l-2.466-2.726a.503.503 0 0 1 .26-.827l.658-.152a.503.503 0 0 0 .242-.846l-2.803-2.803a.503.503 0 0 1 0-.712l.73-.73a.503.503 0 0 0 .017-.694l-4.056-4.46a.503.503 0 0 0-.744 0z" clip-rule="evenodd"/>
  </svg>
`;
const Triangle = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="m12 2.5 9.96 17.25H2.04zm0 3L4.64 18.25H19.36z" clip-rule="evenodd"/>
  </svg>
`;
const TriangleRulerPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M20.333 20H3v-2l1.433-1.368.95.95.707-.707-.933-.934 4.644-4.433 1.056 1.056.707-.707-1.04-1.04 4.411-4.21.94.94.707-.708-.923-.922L17.667 4h2.666zm-3.193-2.772v-8.21l-8.21 8.21z" clip-rule="evenodd"/>
  </svg>
`;
const Twitter = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M17.463 3.542h2.914l-6.365 7.578L21.5 21.43h-5.863l-4.592-6.253L5.79 21.43H2.875l6.809-8.107L2.5 3.543h6.012l4.15 5.717zm-1.022 16.073h1.614L7.635 5.263H5.903z"/>
  </svg>
`;
const TwitterDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#000" d="M17.463 3.4h2.914l-6.365 7.275 7.488 9.899h-5.863l-4.592-6.004-5.255 6.004H2.875l6.809-7.782L2.5 3.4h6.012l4.15 5.488zm-1.022 15.43h1.614L7.635 5.052H5.903z"/>
  </svg>
`;
const UmbrellaPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M13 2.8a1 1 0 0 0-2 0v1.262a8.004 8.004 0 0 0-6.938 6.94c-.068.548.386.998.938.998h6v6.3a1.2 1.2 0 0 1-2.4 0v-1a1 1 0 1 0-2 0v1a3.2 3.2 0 0 0 6.4 0V12h6c.552 0 1.007-.45.938-.998A8.004 8.004 0 0 0 13 4.062z" clip-rule="evenodd"/>
  </svg>
`;
const UnderLine = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M7.744 3.968a.808.808 0 1 0-1.616 0v7.003a5.656 5.656 0 1 0 11.313 0V3.968a.808.808 0 1 0-1.616 0v7.003a4.04 4.04 0 1 1-8.08 0zM4.458 19.32a.808.808 0 0 0 0 1.616h15.084a.808.808 0 1 0 0-1.616z" clip-rule="evenodd"/>
  </svg>
`;
const Undo = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8.53 4.47a.75.75 0 0 1 0 1.06L5.81 8.25h4.624c1.651 0 2.937 0 3.968.084 1.047.086 1.897.262 2.662.652a6.75 6.75 0 0 1 2.95 2.95c.39.765.566 1.615.652 2.662.084 1.031.084 2.317.084 3.968v.034a.75.75 0 0 1-1.5 0c0-1.693 0-2.917-.08-3.88-.077-.954-.228-1.585-.492-2.104a5.25 5.25 0 0 0-2.295-2.294c-.518-.264-1.15-.415-2.103-.493-.963-.078-2.187-.079-3.88-.079H5.81l2.72 2.72a.75.75 0 1 1-1.06 1.06l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 0" clip-rule="evenodd"/>
  </svg>
`;
const Ungroup = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5.286 4.75c-.346 0-.536.25-.536.45v3.6c0 .2.19.45.536.45h6.428c.346 0 .536-.25.536-.45V5.2c0-.2-.19-.45-.536-.45zM3.25 5.2c0-1.125.961-1.95 2.036-1.95h6.428c1.075 0 2.036.825 2.036 1.95v3.6c0 1.125-.961 1.95-2.036 1.95H5.286c-1.075 0-2.036-.825-2.036-1.95zM12.286 14.75c-.346 0-.536.25-.536.45v3.6c0 .2.19.45.536.45h6.428c.346 0 .536-.25.536-.45v-3.6c0-.2-.19-.45-.536-.45zm-2.036.45c0-1.125.961-1.95 2.036-1.95h6.428c1.075 0 2.036.825 2.036 1.95v3.6c0 1.125-.961 1.95-2.036 1.95h-6.428c-1.075 0-2.036-.825-2.036-1.95z" clip-rule="evenodd"/>
  </svg>
`;
const Unlink = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M14.522 5.35a2.919 2.919 0 1 1 4.128 4.128l-3.669 3.669a.75.75 0 1 0 1.06 1.06l3.67-3.669a4.419 4.419 0 1 0-6.25-6.249l-1.008 1.009a.75.75 0 1 0 1.06 1.06zM9.019 10.853a.75.75 0 0 0-1.061-1.06L4.289 13.46a4.419 4.419 0 1 0 6.25 6.25l1.01-1.01a.75.75 0 1 0-1.06-1.061l-1.011 1.01a2.919 2.919 0 0 1-4.128-4.128zM9.395 4.494a.75.75 0 1 0-1.461.337l.4 1.734a.75.75 0 1 0 1.462-.337zM4.83 7.934a.75.75 0 1 0-.336 1.461l1.734.4a.75.75 0 1 0 .337-1.46zM17.772 14.204a.75.75 0 0 0-.337 1.462l1.734.4a.75.75 0 1 0 .337-1.461zM15.666 17.435a.75.75 0 1 0-1.462.337l.4 1.734a.75.75 0 0 0 1.462-.337z"/>
  </svg>
`;
const Unlock = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6.25 8a5.75 5.75 0 0 1 11.021-2.3.75.75 0 1 1-1.374.6A4.251 4.251 0 0 0 7.75 8v1.254q.465-.005 1.027-.004h6.446c.728 0 1.328 0 1.823.03.626.038 1.164.128 1.657.379a3.75 3.75 0 0 1 1.638 1.638c.227.445.321.925.366 1.471.043.531.043 1.187.043 2v1.464c0 .813 0 1.469-.043 2-.045.546-.14 1.026-.366 1.47a3.75 3.75 0 0 1-1.639 1.64c-.444.226-.924.32-1.47.365-.531.043-1.187.043-2 .043H8.768c-.813 0-1.469 0-2-.043-.546-.045-1.026-.14-1.47-.366a3.75 3.75 0 0 1-1.64-1.639c-.226-.444-.32-.924-.365-1.47-.043-.531-.043-1.187-.043-2v-1.464c0-.813 0-1.469.043-2 .045-.546.14-1.026.366-1.47a3.75 3.75 0 0 1 1.639-1.64c.297-.15.612-.244.952-.302zm2.55 2.75c-.756 0-1.31 0-1.754.027-.551.034-.847.106-1.067.218a2.25 2.25 0 0 0-.984.984c-.1.197-.17.458-.207.912-.037.462-.038 1.056-.038 1.909v1.4c0 .852 0 1.447.038 1.91.037.453.107.714.207.912.216.423.56.767.984.983.197.1.458.17.912.207.462.037 1.057.038 1.909.038h6.4c.852 0 1.447 0 1.91-.038.453-.038.714-.107.912-.207.423-.216.767-.56.983-.983.1-.198.17-.459.207-.913.037-.462.038-1.057.038-1.909v-1.4c0-.853 0-1.447-.038-1.91-.038-.453-.107-.714-.207-.912a2.25 2.25 0 0 0-.983-.983c-.22-.112-.517-.184-1.068-.218a32 32 0 0 0-1.754-.027zm3.2 3a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75" clip-rule="evenodd"/>
  </svg>
`;
const Unpin = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <g clip-path="url(#a)"><path fill='currentColor' fill-rule="evenodd" d="M13.591 3.692a2.75 2.75 0 0 1 3.89 0l2.827 2.828a2.75 2.75 0 0 1 0 3.889l-1.06 1.06a.75.75 0 1 1-1.06-1.06l1.06-1.06a1.25 1.25 0 0 0 0-1.768l-2.829-2.829a1.25 1.25 0 0 0-1.767 0l-1.061 1.06a.75.75 0 0 1-1.06-1.06zm-6.364-.708a.75.75 0 0 1 1.06 0l12.729 12.728a.75.75 0 0 1-1.061 1.061l-3.005-3.005-1.97 1.97.884.884a.75.75 0 1 1-1.06 1.06L11.09 13.97l-4.925 4.924a.75.75 0 1 1-1.06-1.06l4.924-4.925-3.712-3.712a.75.75 0 0 1 1.06-1.06l.884.883 1.97-1.97-3.005-3.005a.75.75 0 0 1 0-1.06m4.066 5.127-1.97 1.97 4.596 4.596 1.97-1.97z" clip-rule="evenodd"/></g><defs><clipPath id="a"><path fill='currentColor' d="M0 0H24V24H0z"/></clipPath></defs>
  </svg>
`;
const Unsucessful = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M2.293 2.293a1 1 0 0 1 1.414 0l4 4 14 14a1 1 0 0 1-1.414 1.414L16.586 18H16.5a1 1 0 0 1-.997-1.082l-1.542-1.543A6 6 0 0 1 9 18H7A6 6 0 0 1 4.946 6.36L2.293 3.708a1 1 0 0 1 0-1.414m4.312 5.726A4 4 0 0 0 7 16h2a4 4 0 0 0 3.509-2.077l-1.572-1.572A1 1 0 0 1 9 12q.001-.732.169-1.417zM15 8c-.556 0-1.084.113-1.562.316a1 1 0 1 1-.783-1.84A6 6 0 0 1 15 6h2a6 6 0 0 1 4.615 9.835 1 1 0 0 1-1.538-1.279A4 4 0 0 0 17 8z" clip-rule="evenodd"/>
  </svg>
`;
const UnsucessfulDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#84CFFF" d="M2 12a5 5 0 0 1 5-5h2a5 5 0 0 1 0 10H7a5 5 0 0 1-5-5" opacity=".14"/><path fill="#84CFFF" fill-rule="evenodd" d="M2.293 2.293a1 1 0 0 1 1.414 0l4 4 14 14a1 1 0 0 1-1.414 1.414L16.586 18H16.5a1 1 0 0 1-.997-1.082l-1.542-1.543A6 6 0 0 1 9 18H7A6 6 0 0 1 4.946 6.36L2.293 3.708a1 1 0 0 1 0-1.414m4.312 5.726A4 4 0 0 0 7 16h2a4 4 0 0 0 3.509-2.077l-1.572-1.572A1 1 0 0 1 9 12q.001-.732.169-1.417zM15 8c-.556 0-1.084.113-1.562.316a1 1 0 1 1-.783-1.84A6 6 0 0 1 15 6h2a6 6 0 0 1 4.615 9.835 1 1 0 0 1-1.538-1.279A4 4 0 0 0 17 8z" clip-rule="evenodd"/>
  </svg>
`;
const Unsync = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M11 5.75a4.25 4.25 0 0 0-4.147 5.183.75.75 0 0 1-.568.896A3.252 3.252 0 0 0 7 18.25h9a4.25 4.25 0 1 0-.085-8.5.75.75 0 0 1-.75-.6A4.25 4.25 0 0 0 11 5.75M5.25 10a5.75 5.75 0 0 1 11.235-1.73A5.75 5.75 0 0 1 16 19.75H7a4.75 4.75 0 0 1-1.722-9.178A6 6 0 0 1 5.25 10m6.45-.75a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75m.05 7.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5" clip-rule="evenodd"/>
  </svg>
`;
const Updated = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8 2.75a.75.75 0 0 1 .75.75v.75h6.5V3.5a.75.75 0 0 1 1.5 0v.75H19A2.75 2.75 0 0 1 21.75 7v5a.75.75 0 0 1-1.5 0v-1.75H3.75V19c0 .69.56 1.25 1.25 1.25h7a.75.75 0 0 1 0 1.5H5A2.75 2.75 0 0 1 2.25 19V7A2.75 2.75 0 0 1 5 4.25h2.25V3.5A.75.75 0 0 1 8 2.75m7.25 3v.75a.75.75 0 0 0 1.5 0v-.75H19c.69 0 1.25.56 1.25 1.25v1.75H3.75V7c0-.69.56-1.25 1.25-1.25h2.25v.75a.75.75 0 0 0 1.5 0v-.75z" clip-rule="evenodd"/><path fill='currentColor' d="M15.434 15.593a3.03 3.03 0 0 1 5.253 1.188.75.75 0 0 0 1.453-.374 4.53 4.53 0 0 0-8.128-1.418l-.596-.252a.3.3 0 0 0-.41.337l.483 2.329a.3.3 0 0 0 .454.193l2.01-1.272a.3.3 0 0 0-.043-.53zM17.534 21.008c.931 0 1.765-.42 2.32-1.082l-.476-.202a.3.3 0 0 1-.043-.53l2.01-1.272a.3.3 0 0 1 .454.193l.485 2.329a.3.3 0 0 1-.411.337l-.596-.252a4.52 4.52 0 0 1-3.743 1.979 4.525 4.525 0 0 1-4.385-3.397.75.75 0 0 1 1.453-.374 3.025 3.025 0 0 0 2.933 2.27"/>
  </svg>
`;
const Upgrade = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5m-4.621 7.72 4.09-4.091a.75.75 0 0 1 1.061 0l4.091 4.09a.75.75 0 1 1-1.06 1.061L12.75 9.72v6.78a.75.75 0 0 1-1.5 0V9.72l-2.81 2.81a.75.75 0 0 1-1.061-1.06" clip-rule="evenodd"/>
  </svg>
`;
const Upload = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M5 10.75a.25.25 0 0 0-.25.25v7c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25v-7a.25.25 0 0 0-.25-.25h-1a.75.75 0 0 1 0-1.5h1c.966 0 1.75.784 1.75 1.75v7A2.75 2.75 0 0 1 18 20.75H6A2.75 2.75 0 0 1 3.25 18v-7c0-.966.784-1.75 1.75-1.75h1a.75.75 0 0 1 0 1.5z" clip-rule="evenodd"/><path fill='currentColor' fill-rule="evenodd" d="M12 2.75a.75.75 0 0 1 .53.22l4 4a.75.75 0 0 1-1.06 1.06l-2.72-2.72V15.5a.75.75 0 0 1-1.5 0V5.31L8.53 8.03a.75.75 0 0 1-1.06-1.06l4-4a.75.75 0 0 1 .53-.22" clip-rule="evenodd"/>
  </svg>
`;
const UsbPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M9 2.75A1.75 1.75 0 0 0 7.25 4.5v5H5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1h-2.25v-5A1.75 1.75 0 0 0 15 2.75zm6.25 6.75v-5a.25.25 0 0 0-.25-.25H9a.25.25 0 0 0-.25.25v5zm-5.525-2v-2h1.55v2zm3-2v2h1.55v-2z" clip-rule="evenodd"/>
  </svg>
`;
const User = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#B3B3B3" fill-rule="evenodd" d="M12 2C6.477 2 2 6.477 2 12a9.97 9.97 0 0 0 3.2 7.333A9.97 9.97 0 0 0 12 22a9.97 9.97 0 0 0 6.8-2.667A9.97 9.97 0 0 0 22 12c0-5.523-4.477-10-10-10M6.284 18.291a.46.46 0 0 1-.048-.631C7.568 16.03 9.575 15 12 15s4.432 1.03 5.764 2.66a.46.46 0 0 1-.048.631A8.47 8.47 0 0 1 12 20.5c-2.2 0-4.206-.837-5.716-2.209M15 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0" clip-rule="evenodd"/>
  </svg>
`;
const UserGuide = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.75 6.672v11.326c1.102-.479 2.388-.748 3.75-.748s2.648.27 3.75.748V6.672c-.997-.567-2.302-.922-3.75-.922s-2.753.355-3.75.922m9 0v11.326c1.102-.479 2.388-.748 3.75-.748s2.648.27 3.75.748V6.672c-.997-.567-2.302-.922-3.75-.922s-2.753.355-3.75.922m-.75-1.3c-1.247-.71-2.816-1.122-4.5-1.122-1.877 0-3.61.511-4.915 1.378a.75.75 0 0 0-.335.625v13a.75.75 0 0 0 1.165.625c1.031-.686 2.469-1.128 4.085-1.128s3.054.442 4.085 1.128a.75.75 0 0 0 .83 0c1.031-.686 2.469-1.128 4.085-1.128s3.054.442 4.085 1.128a.75.75 0 0 0 1.165-.625v-13a.75.75 0 0 0-.335-.625C20.11 4.761 18.377 4.25 16.5 4.25c-1.684 0-3.253.412-4.5 1.123" clip-rule="evenodd"/>
  </svg>
`;
const VerticalCylinder = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.422 4.715C5.875 4.307 8.187 4 11.75 4s5.875.307 7.328.715c.724.204 1.27.442 1.655.704.354.24.716.601.764 1.092l.003.036v10.406c-.025.506-.387.88-.738 1.124-.381.265-.924.504-1.646.707-1.449.409-3.769.716-7.366.716s-5.917-.307-7.366-.716c-.722-.203-1.265-.442-1.646-.707-.35-.244-.713-.618-.737-1.124L2 16.935V6.547l.003-.036c.048-.49.41-.852.764-1.092.386-.262.93-.5 1.655-.704M3.5 8.162v8.61q.03.028.094.073c.195.136.564.317 1.197.496 1.261.355 3.427.659 6.959.659s5.698-.304 6.959-.66c.633-.178 1.002-.36 1.197-.495q.064-.045.094-.073v-8.61q-.372.155-.846.289c-1.445.409-3.772.716-7.404.716S5.79 8.86 4.346 8.45a8 8 0 0 1-.846-.289m16.542-1.751-.006.008zm-.249.187c-.219-.129-.574-.285-1.12-.438-1.268-.356-3.427-.66-6.923-.66s-5.655.304-6.922.66c-.547.153-.902.31-1.121.438.206.12.539.266 1.047.41 1.255.355 3.428.659 6.996.659s5.74-.304 6.996-.66c.508-.143.84-.289 1.047-.409M3.458 6.411l.006.008z" clip-rule="evenodd"/>
  </svg>
`;
const View = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 5.75a9.25 9.25 0 0 0-8.635 5.926.9.9 0 0 0 0 .648 9.254 9.254 0 0 0 17.27 0 .9.9 0 0 0 0-.648A9.25 9.25 0 0 0 12 5.75M1.966 11.137C3.516 7.11 7.424 4.25 12 4.25s8.484 2.86 10.035 6.887c.214.555.214 1.17 0 1.726-1.55 4.027-5.458 6.887-10.034 6.887s-8.484-2.86-10.035-6.887a2.4 2.4 0 0 1 0-1.726M12 9.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M8.25 12a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0" clip-rule="evenodd"/>
  </svg>
`;
const ViewBar = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.25 20a.75.75 0 0 1-.75-.75V4.75a.75.75 0 0 1 1.5 0v14.5a.75.75 0 0 1-.75.75M9.665 8.44a.75.75 0 0 1 .062 1.058L8.17 11.25h7.66l-1.557-1.752a.75.75 0 0 1 1.12-.996l2.668 3a.75.75 0 0 1 0 .996l-2.667 3a.75.75 0 1 1-1.121-.996l1.557-1.752H8.17l1.557 1.752a.75.75 0 0 1-1.12.996l-2.668-3a.75.75 0 0 1 0-.996l2.667-3a.75.75 0 0 1 1.059-.063M21.5 4.75a.75.75 0 0 0-1.5 0v14.5a.75.75 0 0 0 1.5 0z" clip-rule="evenodd"/>
  </svg>
`;
const ViewLayers = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M9 4.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5zM6.25 8A.75.75 0 0 1 7 7.25h10a.75.75 0 0 1 0 1.5H7A.75.75 0 0 1 6.25 8m-2 5A2.75 2.75 0 0 1 7 10.25h10A2.75 2.75 0 0 1 19.75 13v5A2.75 2.75 0 0 1 17 20.75H7A2.75 2.75 0 0 1 4.25 18zM7 11.75c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25v-5c0-.69-.56-1.25-1.25-1.25z" clip-rule="evenodd"/>
  </svg>
`;
const Voice = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 3.75a.75.75 0 0 1 .75.75v15a.75.75 0 0 1-1.5 0v-15a.75.75 0 0 1 .75-.75m-3.5 2.5a.75.75 0 0 1 .75.75v10a.75.75 0 0 1-1.5 0V7a.75.75 0 0 1 .75-.75m7 0a.75.75 0 0 1 .75.75v10a.75.75 0 0 1-1.5 0V7a.75.75 0 0 1 .75-.75M5 9.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4A.75.75 0 0 1 5 9.25m14 0a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75" clip-rule="evenodd"/>
  </svg>
`;
const VolumnPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M9.215 7.7h-2.79C5.638 7.7 5 8.338 5 9.125v5.7c0 .787.638 1.425 1.425 1.425h2.803c.306 0 .605.098.85.281l4.759 3.54c.94.7 2.275.03 2.275-1.143V4.893c0-1.182-1.356-1.85-2.293-1.13l-4.735 3.641c-.25.192-.554.296-.869.296"/>
  </svg>
`;
const WalletPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M7.111 4A3.11 3.11 0 0 0 4 7.111v9.333A3.556 3.556 0 0 0 7.556 20h10.666c.982 0 1.778-.796 1.778-1.778v-8c0-.982-.796-1.778-1.778-1.778h-1.778V5.556c0-.86-.696-1.556-1.555-1.556zm7.556 4.444V5.778H7.11a1.333 1.333 0 1 0 0 2.666zm.444 6.89a1.111 1.111 0 1 0 0-2.223 1.111 1.111 0 0 0 0 2.222" clip-rule="evenodd"/>
  </svg>
`;
const Warning = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 4.75a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5M3.25 12a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0M12 7.694a.75.75 0 0 1 .75.75V12a.75.75 0 0 1-1.5 0V8.444a.75.75 0 0 1 .75-.75m-.75 7.862a.75.75 0 0 1 .75-.75h.009a.75.75 0 1 1 0 1.5H12a.75.75 0 0 1-.75-.75" clip-rule="evenodd"/>
  </svg>
`;
const WaveRectangle = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M19.5 7.5h-15v8.134c.157.102.368.218.627.332.67.297 1.549.534 2.469.534a4.9 4.9 0 0 0 3.506-1.417c.275-.26.833-.789 1.667-1.238.947-.51 2.206-.904 3.865-.904 1.15 0 2.09.176 2.866.461zm1.5 8.762-.075-.081c-.298-.326-.716-.782-1.425-1.145-.658-.337-1.568-.595-2.866-.595-2.664 0-3.919 1.183-4.501 1.732l-.095.09A6.4 6.4 0 0 1 7.596 18c-2.33 0-4.34-1.186-4.596-1.738V6h18z" clip-rule="evenodd"/>
  </svg>
`;
const Web = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.784 11.25H8.26c.06-2.25.39-4.298.907-5.851.161-.483.345-.932.552-1.33a8.26 8.26 0 0 0-5.935 7.181m8.216-9c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25m0 1.5c-.086 0-.287.052-.579.421-.285.362-.574.932-.83 1.702-.459 1.374-.77 3.255-.83 5.377h4.478c-.06-2.122-.371-4.003-.83-5.377-.256-.77-.545-1.34-.83-1.702-.292-.37-.493-.421-.579-.421m3.74 7.5c-.06-2.25-.39-4.298-.907-5.851a9 9 0 0 0-.552-1.33 8.26 8.26 0 0 1 5.935 7.181zm-1.5 1.5H9.76c.06 2.122.372 4.003.83 5.377.257.77.546 1.34.831 1.701.292.37.493.422.579.422s.287-.052.579-.422c.285-.361.574-.93.83-1.701.459-1.374.77-3.255.83-5.377m.041 7.18c.207-.397.39-.846.552-1.329.518-1.553.847-3.6.907-5.851h4.476a8.26 8.26 0 0 1-5.935 7.18m-4.562 0a9 9 0 0 1-.552-1.329c-.517-1.553-.847-3.6-.907-5.851H3.784a8.26 8.26 0 0 0 5.935 7.18" clip-rule="evenodd"/>
  </svg>
`;
const WindmillPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12.45 11.978c-.247.024-.45-.18-.45-.429V3.431c0-.25.203-.454.45-.429a4.51 4.51 0 0 1 0 8.976m-.428.473c-.024-.248.18-.45.43-.45h8.117c.25 0 .454.202.43.45a4.51 4.51 0 0 1-8.977 0M11.55 12c.25 0 .453-.203.429-.451a4.51 4.51 0 0 0-8.976 0c-.025.248.18.45.429.45zm0 .021c.249-.024.451.18.451.43v8.117c0 .25-.202.454-.45.43a4.51 4.51 0 0 1 0-8.977" clip-rule="evenodd"/>
  </svg>
`;
const WindowPanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M18.5 10h-13v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zM4 10V6q0-.207.04-.403A2 2 0 0 1 6 4h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm3.5-3.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m1.25.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m2.75-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0" clip-rule="evenodd"/>
  </svg>
`;
const Wrap = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M11.046 5a.75.75 0 0 1 .75-.75h2.882a6.072 6.072 0 1 1 0 12.144h-8.89l3.027 3.08a.75.75 0 0 1-1.07 1.052l-4.28-4.356a.75.75 0 0 1 0-1.051l4.28-4.356a.75.75 0 1 1 1.07 1.052l-3.026 3.08h8.889a4.572 4.572 0 1 0 0-9.145h-2.882a.75.75 0 0 1-.75-.75" clip-rule="evenodd"/>
  </svg>
`;
const Yesterday = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8.335 3.095c.38 0 .688.308.688.688v.688h5.963v-.688a.688.688 0 0 1 1.376 0v.688h2.065a2.523 2.523 0 0 1 2.522 2.523v5.504a.688.688 0 1 1-1.376 0v-2.43H4.437v7.934c0 .634.513 1.147 1.146 1.147h5.963a.688.688 0 0 1 0 1.376H5.583a2.523 2.523 0 0 1-2.522-2.523V6.994A2.523 2.523 0 0 1 5.583 4.47h2.064v-.688c0-.38.308-.688.688-.688m6.651 2.752v.688a.688.688 0 0 0 1.376 0v-.688h2.065c.633 0 1.146.514 1.146 1.147v1.514H4.437V6.994c0-.633.513-1.147 1.146-1.147h2.064v.688a.688.688 0 1 0 1.376 0v-.688zm1.68 9.834a.69.69 0 0 1 0 .973l-1.46 1.46 1.46 1.46a.688.688 0 1 1-.974.972L13.746 18.6a.69.69 0 0 1 0-.973l1.946-1.946a.69.69 0 0 1 .973 0m4.193.973a.688.688 0 1 0-.973-.973l-1.946 1.946a.69.69 0 0 0 0 .973l1.946 1.946a.688.688 0 1 0 .973-.973l-1.46-1.46z" clip-rule="evenodd"/>
  </svg>
`;
const Youtube = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M0 0H24V24H0z"/><path fill='currentColor' d="M21.08 7.192a2.55 2.55 0 0 0-.616-1.12 2.36 2.36 0 0 0-1.065-.649C17.925 5 11.991 5 11.991 5s-5.935.013-7.41.436c-.402.115-.77.338-1.064.649-.295.31-.508.696-.617 1.12-.446 2.757-.619 6.957.012 9.603.11.423.322.81.617 1.12s.662.534 1.065.649C6.068 19 12.003 19 12.003 19s5.934 0 7.408-.423c.403-.115.77-.338 1.065-.649.295-.31.508-.697.617-1.12.47-2.76.615-6.958-.012-9.616"/><path fill='currentColor' d="m10 15 5-3-5-3z"/>
  </svg>
`;
const YoutubeDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="red" d="M21.08 7.192a2.55 2.55 0 0 0-.616-1.12 2.36 2.36 0 0 0-1.065-.649C17.925 5 11.991 5 11.991 5s-5.935.013-7.41.436c-.402.115-.77.338-1.064.649-.295.31-.508.696-.617 1.12-.446 2.757-.619 6.957.012 9.603.11.423.322.81.617 1.12s.662.534 1.065.649C6.068 19 12.003 19 12.003 19s5.934 0 7.408-.423c.403-.115.77-.338 1.065-.649.295-.31.508-.697.617-1.12.47-2.76.615-6.958-.012-9.616"/><path fill="#fff" d="m10 15 5-3-5-3z"/>
  </svg>
`;
const YoutubePanel = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M20.464 6.072c.295.31.508.697.617 1.12.627 2.658.482 6.855.012 9.616-.11.423-.322.81-.617 1.12s-.662.534-1.065.649C17.937 19 12.003 19 12.003 19s-5.935 0-7.41-.423a2.36 2.36 0 0 1-1.064-.649 2.55 2.55 0 0 1-.617-1.12c-.63-2.646-.458-6.846-.012-9.603.109-.424.322-.81.617-1.12s.662-.534 1.065-.65C6.056 5.014 11.99 5 11.99 5s5.934 0 7.408.423c.403.115.77.338 1.065.649M15 12l-5 3V9z" clip-rule="evenodd"/>
  </svg>
`;
const Zendesk = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' d="M12.546 5v10l8.272-10zM7.136 9.455c2.263 0 4.137-2.281 4.137-4.455H3c0 2.174 1.873 4.455 4.136 4.455M12.546 19c0-2.174 1.873-4.454 4.136-4.454s4.136 2.28 4.136 4.454zM11.273 19V9L3 19z"/>
  </svg>
`;
const ZendeskDuotone = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill="#07363D" d="M12.546 5v10l8.272-10zM7.136 9.455c2.263 0 4.137-2.281 4.137-4.455H3c0 2.174 1.873 4.455 4.136 4.455M12.546 19c0-2.174 1.873-4.454 4.136-4.454s4.136 2.28 4.136 4.454zM11.273 19V9L3 19z"/>
  </svg>
`;
const Zip = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.75 6.5c0-.69.56-1.25 1.25-1.25h4.672c.331 0 .649.132.883.366L11.97 7.03c.14.141.331.22.53.22h1.868v1.956h2v2h-2v2h2v2h-2v2h2v1.044H5c-.69 0-1.25-.56-1.25-1.25zm14.618 11.75v-1.044h-2v-2h2v-2h-2v-2h2v-2h-2V7.25H19c.69 0 1.25.56 1.25 1.25V17c0 .69-.56 1.25-1.25 1.25zM5 3.75A2.75 2.75 0 0 0 2.25 6.5V17A2.75 2.75 0 0 0 5 19.75h14A2.75 2.75 0 0 0 21.75 17V8.5A2.75 2.75 0 0 0 19 5.75h-6.19l-1.194-1.195a2.75 2.75 0 0 0-1.944-.805z" clip-rule="evenodd"/>
  </svg>
`;
const ZoomDown = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M11.115 4.885a6.23 6.23 0 1 0 0 12.461 6.23 6.23 0 0 0 0-12.461M3.5 11.115a7.615 7.615 0 1 1 13.468 4.874l4.33 4.33a.692.692 0 1 1-.98.978l-4.33-4.33A7.615 7.615 0 0 1 3.5 11.116m4.154 0c0-.382.31-.692.692-.692h5.539a.692.692 0 1 1 0 1.385H8.346a.69.69 0 0 1-.692-.693" clip-rule="evenodd"/>
  </svg>
`;
const ZoomUp = ({ width = "1em", height = "1em", style = "" } = {}) => html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${"user-select:none;flex-shrink:0;" + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M11.115 4.885a6.23 6.23 0 1 0 4.408 10.634 6.23 6.23 0 0 0-4.408-10.634m5.854 11.102a7.615 7.615 0 1 0-.979.98l4.328 4.33a.692.692 0 1 0 .98-.979zm-5.854-8.333c.383 0 .693.31.693.692v2.077h2.077a.692.692 0 1 1 0 1.385h-2.077v2.077a.692.692 0 1 1-1.385 0v-2.077H8.346a.692.692 0 0 1 0-1.385h2.077V8.346c0-.382.31-.692.692-.692" clip-rule="evenodd"/>
  </svg>
`;
export {
  AccountBan as AccountBanIcon,
  AccountEnable as AccountEnableIcon,
  Account as AccountIcon,
  AddCollection as AddCollectionIcon,
  AddComment as AddCommentIcon,
  AddCursorDuotone as AddCursorDuotoneIcon,
  AddCursor as AddCursorIcon,
  AddOrganize as AddOrganizeIcon,
  AddTag as AddTagIcon,
  AddText as AddTextIcon,
  Admin as AdminIcon,
  AfFiNe as AfFiNeIcon,
  Ai as AiIcon,
  AiOutline as AiOutlineIcon,
  AiThinking as AiThinkingIcon,
  Alias as AliasIcon,
  AlignBottom as AlignBottomIcon,
  AlignHorizontalCenter as AlignHorizontalCenterIcon,
  AlignLeft as AlignLeftIcon,
  AlignRight as AlignRightIcon,
  AlignTop as AlignTopIcon,
  AlignVerticalCenter as AlignVerticalCenterIcon,
  AllDocs as AllDocsIcon,
  Appearance as AppearanceIcon,
  AppleDuotone as AppleDuotoneIcon,
  Apple as AppleIcon,
  ArrowDownBigBottom as ArrowDownBigBottomIcon,
  ArrowDownBig as ArrowDownBigIcon,
  ArrowDownSmall as ArrowDownSmallIcon,
  ArrowLeftBig as ArrowLeftBigIcon,
  ArrowLeftSmall as ArrowLeftSmallIcon,
  ArrowLeftSmallPlus as ArrowLeftSmallPlusIcon,
  ArrowRightBig as ArrowRightBigIcon,
  ArrowRightSmall as ArrowRightSmallIcon,
  ArrowRightSmallPlus as ArrowRightSmallPlusIcon,
  ArrowShape as ArrowShapeIcon,
  ArrowUpBig as ArrowUpBigIcon,
  ArrowUpBigTop as ArrowUpBigTopIcon,
  ArrowUpSmall as ArrowUpSmallIcon,
  ArrowsLeft as ArrowsLeftIcon,
  ArrowsRight as ArrowsRightIcon,
  At as AtIcon,
  Attachment as AttachmentIcon,
  AutoHeight as AutoHeightIcon,
  AutoSize as AutoSizeIcon,
  AutoTidyUp as AutoTidyUpIcon,
  BackwardPanel as BackwardPanelIcon,
  BagPanel as BagPanelIcon,
  Ban as BanIcon,
  BaseballPanel as BaseballPanelIcon,
  BasketballPanel as BasketballPanelIcon,
  BitcoinPanel as BitcoinPanelIcon,
  Block as BlockIcon,
  BlockLink as BlockLinkIcon,
  Blocksuite as BlocksuiteIcon,
  Bold as BoldIcon,
  BookPanel as BookPanelIcon,
  Bookmark as BookmarkIcon,
  BrokenImage as BrokenImageIcon,
  Broom as BroomIcon,
  Brush as BrushIcon,
  Bubble as BubbleIcon,
  BulletedList01 as BulletedList01Icon,
  BulletedList02 as BulletedList02Icon,
  BulletedList03 as BulletedList03Icon,
  BulletedList04 as BulletedList04Icon,
  BulletedList as BulletedListIcon,
  CalFullDuotone as CalFullDuotoneIcon,
  CalTimeDuotone as CalTimeDuotoneIcon,
  CalendarPanel as CalendarPanelIcon,
  CalendarXmark as CalendarXmarkIcon,
  Camera as CameraIcon,
  CameraPanel as CameraPanelIcon,
  CancelWrap as CancelWrapIcon,
  Caption as CaptionIcon,
  CardPanel as CardPanelIcon,
  Cart2Panel as Cart2PanelIcon,
  CartPanel as CartPanelIcon,
  CategoryPanel as CategoryPanelIcon,
  CenterPeek as CenterPeekIcon,
  ChartPanel as ChartPanelIcon,
  ChatPanel as ChatPanelIcon,
  ChatWithAi as ChatWithAiIcon,
  CheckBoxCheckLinear as CheckBoxCheckLinearIcon,
  CheckBoxCheckSolid as CheckBoxCheckSolidIcon,
  CheckBoxIntermediate as CheckBoxIntermediateIcon,
  CheckBoxUn as CheckBoxUnIcon,
  ChemicalPanel as ChemicalPanelIcon,
  CirclePanel as CirclePanelIcon,
  Client as ClientIcon,
  Close as CloseIcon,
  CloudBubble as CloudBubbleIcon,
  CloudWorkspace as CloudWorkspaceIcon,
  Cloudy2Panel as Cloudy2PanelIcon,
  CloudyPanel as CloudyPanelIcon,
  CodeBlock as CodeBlockIcon,
  Code as CodeIcon,
  CodePanel as CodePanelIcon,
  CoinPanel as CoinPanelIcon,
  Collaboration as CollaborationIcon,
  Collapse as CollapseIcon,
  CollapseTab as CollapseTabIcon,
  CollectPanel as CollectPanelIcon,
  Collections as CollectionsIcon,
  ColorPanel as ColorPanelIcon,
  ColorPicker as ColorPickerIcon,
  CommentDuodone as CommentDuodoneIcon,
  Comment as CommentIcon,
  Compress as CompressIcon,
  Computer2Panel as Computer2PanelIcon,
  ComputerPanel as ComputerPanelIcon,
  ConfusePanel as ConfusePanelIcon,
  ConnectorC as ConnectorCIcon,
  ConnectorE as ConnectorEIcon,
  ConnectorL as ConnectorLIcon,
  ContactWithUs as ContactWithUsIcon,
  Convert as ConvertIcon,
  CopyAsImgae as CopyAsImgaeIcon,
  Copy as CopyIcon,
  Corner as CornerIcon,
  Created as CreatedIcon,
  Crop as CropIcon,
  CrossedCircle as CrossedCircleIcon,
  CubePanel as CubePanelIcon,
  CurveLine as CurveLineIcon,
  CustomSize as CustomSizeIcon,
  CustomizedHeight as CustomizedHeightIcon,
  Cylinder as CylinderIcon,
  DarkMode as DarkModeIcon,
  DashLine as DashLineIcon,
  Data2Panel as Data2PanelIcon,
  DataPanel as DataPanelIcon,
  DatabaseKanbanView as DatabaseKanbanViewIcon,
  DatabaseListView as DatabaseListViewIcon,
  DatabaseTableView as DatabaseTableViewIcon,
  DateTime as DateTimeIcon,
  Delete as DeleteIcon,
  DeletePermanently as DeletePermanentlyIcon,
  DeleteTemporarily as DeleteTemporarilyIcon,
  Diagonally_2Lines as Diagonally_2LinesIcon,
  Diamond as DiamondIcon,
  DirectionPanel as DirectionPanelIcon,
  DirectionSign2Panel as DirectionSign2PanelIcon,
  DirectionSign3Panel as DirectionSign3PanelIcon,
  DirectionSign4Panel as DirectionSign4PanelIcon,
  DirectionSignPanel as DirectionSignPanelIcon,
  DiscordDuotone as DiscordDuotoneIcon,
  Discord as DiscordIcon,
  DiscordPanel as DiscordPanelIcon,
  DistributeHorizontal as DistributeHorizontalIcon,
  DistributeVertical as DistributeVerticalIcon,
  Divider as DividerIcon,
  DocsDuotone as DocsDuotoneIcon,
  Docs as DocsIcon,
  Done as DoneIcon,
  DotDuotone as DotDuotoneIcon,
  Download as DownloadIcon,
  DragCursorDuotone as DragCursorDuotoneIcon,
  DragCursor as DragCursorIcon,
  Drink2Panel as Drink2PanelIcon,
  DrinkPanel as DrinkPanelIcon,
  DropCursorDuotone as DropCursorDuotoneIcon,
  DropCursor as DropCursorIcon,
  DualLink as DualLinkIcon,
  Duplicate as DuplicateIcon,
  Edgeless as EdgelessIcon,
  Edit as EditIcon,
  ElbowedLine as ElbowedLineIcon,
  Ellipse as EllipseIcon,
  Ellipsis as EllipsisIcon,
  Email as EmailIcon,
  EmailWarning as EmailWarningIcon,
  Embed as EmbedIcon,
  EmbedWeb as EmbedWebIcon,
  Empty as EmptyIcon,
  EndPointArrow as EndPointArrowIcon,
  EndPointCircle as EndPointCircleIcon,
  EndPointDiamond as EndPointDiamondIcon,
  EndPointTriangle as EndPointTriangleIcon,
  Enter as EnterIcon,
  Eq as EqIcon,
  Eraser as EraserIcon,
  ExpandClose as ExpandCloseIcon,
  ExpandFull as ExpandFullIcon,
  Expand as ExpandIcon,
  ExpandWide as ExpandWideIcon,
  Experiment as ExperimentIcon,
  Explain as ExplainIcon,
  Export as ExportIcon,
  ExportToHtml as ExportToHtmlIcon,
  ExportToMarkdown as ExportToMarkdownIcon,
  ExportToPdf as ExportToPdfIcon,
  ExportToPng as ExportToPngIcon,
  ExportToSvg as ExportToSvgIcon,
  EyePanel as EyePanelIcon,
  FacebookDuotone as FacebookDuotoneIcon,
  Facebook as FacebookIcon,
  Favorite as FavoriteIcon,
  Favorited as FavoritedIcon,
  FigmaDuotone as FigmaDuotoneIcon,
  Figma as FigmaIcon,
  File as FileIcon,
  FilePanel as FilePanelIcon,
  Filter as FilterIcon,
  FilterMinus as FilterMinusIcon,
  FilterUndo as FilterUndoIcon,
  Filtered as FilteredIcon,
  FirePanel as FirePanelIcon,
  Flag2Panel as Flag2PanelIcon,
  Flag3Panel as Flag3PanelIcon,
  FlagPanel as FlagPanelIcon,
  FlashPanel as FlashPanelIcon,
  FlipDirection as FlipDirectionIcon,
  FlowerPanel as FlowerPanelIcon,
  Folder2Panel as Folder2PanelIcon,
  Folder3Panel as Folder3PanelIcon,
  Folder as FolderIcon,
  FolderPanel as FolderPanelIcon,
  Font as FontIcon,
  FoodPanel as FoodPanelIcon,
  ForwardPanel as ForwardPanelIcon,
  ForwardThirtySeconds as ForwardThirtySecondsIcon,
  Frame as FrameIcon,
  FruitPanel as FruitPanelIcon,
  GamePanel as GamePanelIcon,
  GiftPanel as GiftPanelIcon,
  GithubDuotone as GithubDuotoneIcon,
  Github as GithubIcon,
  GithubPanel as GithubPanelIcon,
  GitlabDuotone as GitlabDuotoneIcon,
  Gitlab as GitlabIcon,
  GobletPanel as GobletPanelIcon,
  Good as GoodIcon,
  GoogleDuotone as GoogleDuotoneIcon,
  Google as GoogleIcon,
  GoogleMapDuotone as GoogleMapDuotoneIcon,
  GoogleMap as GoogleMapIcon,
  GooglePanel as GooglePanelIcon,
  Grid as GridIcon,
  Group as GroupIcon,
  GroupPanel as GroupPanelIcon,
  Grouping as GroupingIcon,
  Gt as GtIcon,
  HamburgerPanel as HamburgerPanelIcon,
  Hand as HandIcon,
  HappyPanel as HappyPanelIcon,
  HeaderColumn as HeaderColumnIcon,
  HeaderRow as HeaderRowIcon,
  Heading1 as Heading1Icon,
  Heading2 as Heading2Icon,
  Heading3 as Heading3Icon,
  Heading4 as Heading4Icon,
  Heading5 as Heading5Icon,
  Heading6 as Heading6Icon,
  Headings as HeadingsIcon,
  HeadphonePanel as HeadphonePanelIcon,
  HeartPanel as HeartPanelIcon,
  Heartbreak as HeartbreakIcon,
  HelpCenter as HelpCenterIcon,
  Help as HelpIcon,
  Hexagon as HexagonIcon,
  HidePanel as HidePanelIcon,
  HighHeelPanel as HighHeelPanelIcon,
  HighLightDuotone as HighLightDuotoneIcon,
  HighLightLinear as HighLightLinearIcon,
  History as HistoryIcon,
  Home as HomeIcon,
  HomePanel as HomePanelIcon,
  Image as ImageIcon,
  ImagePanel as ImagePanelIcon,
  Import as ImportIcon,
  ImproveWriting as ImproveWritingIcon,
  Inbox as InboxIcon,
  Info as InfoIcon,
  InformationFillDuotone as InformationFillDuotoneIcon,
  Information as InformationIcon,
  InformationPanel as InformationPanelIcon,
  InsertAbove as InsertAboveIcon,
  InsertBelow as InsertBelowIcon,
  InsertBleow as InsertBleowIcon,
  InsertBlocks as InsertBlocksIcon,
  InsertIntoPage as InsertIntoPageIcon,
  InsertLeft as InsertLeftIcon,
  InsertRight as InsertRightIcon,
  InsertTop as InsertTopIcon,
  InstagramDuotone as InstagramDuotoneIcon,
  Instagram as InstagramIcon,
  Insync as InsyncIcon,
  Integrations as IntegrationsIcon,
  Invisible as InvisibleIcon,
  Issue as IssueIcon,
  Italic as ItalicIcon,
  Journal as JournalIcon,
  Keyboard as KeyboardIcon,
  Language as LanguageIcon,
  Layer as LayerIcon,
  Layout as LayoutIcon,
  LeafPanel as LeafPanelIcon,
  LeftBracket as LeftBracketIcon,
  LiftPanel as LiftPanelIcon,
  LightMode as LightModeIcon,
  LightPanel as LightPanelIcon,
  LineStyle as LineStyleIcon,
  LinearLogoDuotone as LinearLogoDuotoneIcon,
  LinearLogo as LinearLogoIcon,
  LinkBlock as LinkBlockIcon,
  Link as LinkIcon,
  LinkedEdgeless as LinkedEdgelessIcon,
  LinkedPage as LinkedPageIcon,
  LocalData as LocalDataIcon,
  LocalWorkspace as LocalWorkspaceIcon,
  Locate as LocateIcon,
  Lock as LockIcon,
  LockPanel as LockPanelIcon,
  Logo1Duotone as Logo1DuotoneIcon,
  Logo1 as Logo1Icon,
  Logo2Duotone as Logo2DuotoneIcon,
  Logo2 as Logo2Icon,
  Logo3Duotone as Logo3DuotoneIcon,
  Logo3 as Logo3Icon,
  Logo4Duotone as Logo4DuotoneIcon,
  Logo4 as Logo4Icon,
  LongSleevePanel as LongSleevePanelIcon,
  Longer as LongerIcon,
  LoomLogoDuotone as LoomLogoDuotoneIcon,
  LoomLogo as LoomLogoIcon,
  Lt as LtIcon,
  MailPanel as MailPanelIcon,
  MailboxPanel as MailboxPanelIcon,
  MakeItReal as MakeItRealIcon,
  MapPanel as MapPanelIcon,
  MathPanel as MathPanelIcon,
  Meeting as MeetingIcon,
  Member as MemberIcon,
  Menubar as MenubarIcon,
  MicPanel as MicPanelIcon,
  Microphone as MicrophoneIcon,
  Mindmap as MindmapIcon,
  MindmapNode as MindmapNodeIcon,
  Minus as MinusIcon,
  MoonPanel as MoonPanelIcon,
  MoreHorizontal as MoreHorizontalIcon,
  MoreVertical as MoreVerticalIcon,
  MountainPanel as MountainPanelIcon,
  MousePanel as MousePanelIcon,
  MoveLeft as MoveLeftIcon,
  MoveRight as MoveRightIcon,
  MoveTo as MoveToIcon,
  MoveToLeftDuotone as MoveToLeftDuotoneIcon,
  MoveToRightDuotone as MoveToRightDuotoneIcon,
  MoviePanel as MoviePanelIcon,
  MultiCursorDuotone as MultiCursorDuotoneIcon,
  MultiPeople as MultiPeopleIcon,
  MultiSelect as MultiSelectIcon,
  Ne as NeIcon,
  New as NewIcon,
  NewPage as NewPageIcon,
  NewXxxEdgeless as NewXxxEdgelessIcon,
  NewXxxPage as NewXxxPageIcon,
  NightPanel as NightPanelIcon,
  NoNetwork as NoNetworkIcon,
  NoteShadowDuotone as NoteShadowDuotoneIcon,
  Notification as NotificationIcon,
  NotionDuotone as NotionDuotoneIcon,
  Notion as NotionIcon,
  Now as NowIcon,
  Number as NumberIcon,
  NumberedList as NumberedListIcon,
  Octobase as OctobaseIcon,
  OpenInNew as OpenInNewIcon,
  Other as OtherIcon,
  Page as PageIcon,
  Palette as PaletteIcon,
  Parallelogram as ParallelogramIcon,
  Paste as PasteIcon,
  PausePanel as PausePanelIcon,
  Payment as PaymentIcon,
  PeacePanel as PeacePanelIcon,
  Pen as PenIcon,
  PenThick as PenThickIcon,
  PenThin as PenThinIcon,
  PersonPanel as PersonPanelIcon,
  PhonePanel as PhonePanelIcon,
  PickerPanel as PickerPanelIcon,
  Pill as PillIcon,
  Pin as PinIcon,
  Pined as PinedIcon,
  PlanetPanel as PlanetPanelIcon,
  PlayFill as PlayFillIcon,
  Play as PlayIcon,
  PlayPanel as PlayPanelIcon,
  Plugin as PluginIcon,
  Plus as PlusIcon,
  PlusThick as PlusThickIcon,
  Ppt as PptIcon,
  Presentation2Panel as Presentation2PanelIcon,
  Presentation as PresentationIcon,
  PresentationPanel as PresentationPanelIcon,
  Printer as PrinterIcon,
  ProductHuntDuotone as ProductHuntDuotoneIcon,
  ProductHunt as ProductHuntIcon,
  Progress as ProgressIcon,
  Property as PropertyIcon,
  Publish as PublishIcon,
  QrCodePanel as QrCodePanelIcon,
  Quote as QuoteIcon,
  Radiant as RadiantIcon,
  RainPanel as RainPanelIcon,
  Readwise as ReadwiseIcon,
  ReadwiseLogoDuotone as ReadwiseLogoDuotoneIcon,
  Reauthentication as ReauthenticationIcon,
  Recent as RecentIcon,
  RedditDuotone as RedditDuotoneIcon,
  Reddit as RedditIcon,
  Redo as RedoIcon,
  ReleaseFromGroup as ReleaseFromGroupIcon,
  RemoveFolder as RemoveFolderIcon,
  Remove as RemoveIcon,
  Replace as ReplaceIcon,
  Reset as ResetIcon,
  ResizeTidyUp as ResizeTidyUpIcon,
  RewindFifteenSeconds as RewindFifteenSecondsIcon,
  RightBracket as RightBracketIcon,
  RightLayout as RightLayoutIcon,
  RightSidebar as RightSidebarIcon,
  RightTab as RightTabIcon,
  RotateAnticlockwise as RotateAnticlockwiseIcon,
  Rotate as RotateIcon,
  RoundedRectangle as RoundedRectangleIcon,
  RoundedSquare as RoundedSquareIcon,
  RulerPanel as RulerPanelIcon,
  SadPanel as SadPanelIcon,
  Save as SaveIcon,
  ScaleAlt as ScaleAltIcon,
  Scale as ScaleIcon,
  Scissors as ScissorsIcon,
  Search as SearchIcon,
  SelectArea as SelectAreaIcon,
  Select as SelectIcon,
  SelectText as SelectTextIcon,
  Selection as SelectionIcon,
  Selfhost as SelfhostIcon,
  Send as SendIcon,
  Settings as SettingsIcon,
  SettingsPanel as SettingsPanelIcon,
  Shape as ShapeIcon,
  Share as ShareIcon,
  Shared as SharedIcon,
  ShareiOs as ShareiOsIcon,
  ShoesPanel as ShoesPanelIcon,
  ShortPantsPanel as ShortPantsPanelIcon,
  Shorter as ShorterIcon,
  SiblingNode as SiblingNodeIcon,
  SidebarDuotone as SidebarDuotoneIcon,
  Sidebar as SidebarIcon,
  SignOut as SignOutIcon,
  Signal as SignalIcon,
  SignalPanel as SignalPanelIcon,
  SingleSelectCheckSolid as SingleSelectCheckSolidIcon,
  SingleSelect as SingleSelectIcon,
  SingleSelectSelectLinear as SingleSelectSelectLinearIcon,
  SingleSelectUn as SingleSelectUnIcon,
  SkateboardPanel as SkateboardPanelIcon,
  SkirtPanel as SkirtPanelIcon,
  Smile as SmileIcon,
  SmilePanel as SmilePanelIcon,
  Snow2Panel as Snow2PanelIcon,
  SnowMountainPanel as SnowMountainPanelIcon,
  SnowPanel as SnowPanelIcon,
  SocketPanel as SocketPanelIcon,
  SoloView as SoloViewIcon,
  SortDown as SortDownIcon,
  Sort as SortIcon,
  SortUp as SortUpIcon,
  SplitView as SplitViewIcon,
  Square as SquareIcon,
  Star as StarIcon,
  StarPanel as StarPanelIcon,
  StartNumbering as StartNumberingIcon,
  StartPointArrow as StartPointArrowIcon,
  StartPointCircle as StartPointCircleIcon,
  StartPointDiamond as StartPointDiamondIcon,
  StartPoint as StartPointIcon,
  StartPointTriangle as StartPointTriangleIcon,
  StopAi as StopAiIcon,
  Stop as StopIcon,
  StraightLine as StraightLineIcon,
  StrikeThrough as StrikeThroughIcon,
  StyleGeneral as StyleGeneralIcon,
  Style as StyleIcon,
  StyleScribble as StyleScribbleIcon,
  SubNode as SubNodeIcon,
  SucessfulDuotone as SucessfulDuotoneIcon,
  Sucessful as SucessfulIcon,
  SuitcasePanel as SuitcasePanelIcon,
  Summarize as SummarizeIcon,
  SunPanel as SunPanelIcon,
  SunglassPanel as SunglassPanelIcon,
  TShirtPanel as TShirtPanelIcon,
  Table as TableIcon,
  Tag as TagIcon,
  TagPanel as TagPanelIcon,
  Tags as TagsIcon,
  TeXDuotone as TeXDuotoneIcon,
  TeX as TeXIcon,
  TeamWorkspace as TeamWorkspaceIcon,
  TelegramDuotone as TelegramDuotoneIcon,
  Telegram as TelegramIcon,
  TemplateColored as TemplateColoredIcon,
  Template as TemplateIcon,
  TemplateOutline as TemplateOutlineIcon,
  TextAlignBottom as TextAlignBottomIcon,
  TextAlignCenter as TextAlignCenterIcon,
  TextAlignLeft as TextAlignLeftIcon,
  TextAlignMedium as TextAlignMediumIcon,
  TextAlignRight as TextAlignRightIcon,
  TextAlignTop as TextAlignTopIcon,
  TextBackgroundDuotone as TextBackgroundDuotoneIcon,
  TextColor as TextColorIcon,
  Text as TextIcon,
  TextType as TextTypeIcon,
  Thinking as ThinkingIcon,
  TimePanel as TimePanelIcon,
  Timeline as TimelineIcon,
  Title as TitleIcon,
  Toc as TocIcon,
  Today as TodayIcon,
  ToggleDown as ToggleDownIcon,
  ToggleLeft as ToggleLeftIcon,
  ToggleRight as ToggleRightIcon,
  ToggleUp as ToggleUpIcon,
  Tomorrow as TomorrowIcon,
  Tone as ToneIcon,
  TranscriptWithAi as TranscriptWithAiIcon,
  TreePanel as TreePanelIcon,
  Triangle as TriangleIcon,
  TriangleRulerPanel as TriangleRulerPanelIcon,
  TwitterDuotone as TwitterDuotoneIcon,
  Twitter as TwitterIcon,
  UmbrellaPanel as UmbrellaPanelIcon,
  UnderLine as UnderLineIcon,
  Undo as UndoIcon,
  Ungroup as UngroupIcon,
  Unlink as UnlinkIcon,
  Unlock as UnlockIcon,
  Unpin as UnpinIcon,
  UnsucessfulDuotone as UnsucessfulDuotoneIcon,
  Unsucessful as UnsucessfulIcon,
  Unsync as UnsyncIcon,
  Updated as UpdatedIcon,
  Upgrade as UpgradeIcon,
  Upload as UploadIcon,
  UsbPanel as UsbPanelIcon,
  UserGuide as UserGuideIcon,
  User as UserIcon,
  VerticalCylinder as VerticalCylinderIcon,
  ViewBar as ViewBarIcon,
  View as ViewIcon,
  ViewLayers as ViewLayersIcon,
  Voice as VoiceIcon,
  VolumnPanel as VolumnPanelIcon,
  WalletPanel as WalletPanelIcon,
  Warning as WarningIcon,
  WaveRectangle as WaveRectangleIcon,
  Web as WebIcon,
  WindmillPanel as WindmillPanelIcon,
  WindowPanel as WindowPanelIcon,
  Wrap as WrapIcon,
  Yesterday as YesterdayIcon,
  YoutubeDuotone as YoutubeDuotoneIcon,
  Youtube as YoutubeIcon,
  YoutubePanel as YoutubePanelIcon,
  ZendeskDuotone as ZendeskDuotoneIcon,
  Zendesk as ZendeskIcon,
  Zip as ZipIcon,
  ZoomDown as ZoomDownIcon,
  ZoomUp as ZoomUpIcon
};
//# sourceMappingURL=lit.mjs.map
